module.exports = {
	"type": "Topology",
	"arcs": [
		[
			[
				122103,
				52046
			],
			[
				96,
				186
			],
			[
				94,
				182
			],
			[
				101,
				195
			],
			[
				121,
				235
			],
			[
				114,
				221
			],
			[
				94,
				181
			],
			[
				0,
				93
			],
			[
				0,
				200
			],
			[
				0,
				137
			],
			[
				0,
				379
			],
			[
				0,
				232
			],
			[
				0,
				221
			],
			[
				0,
				228
			]
		],
		[
			[
				122103,
				52046
			],
			[
				-160,
				-196
			],
			[
				-180,
				-222
			],
			[
				-189,
				-233
			],
			[
				-122,
				-150
			],
			[
				-194,
				-238
			],
			[
				-160,
				-198
			],
			[
				-166,
				-216
			],
			[
				-150,
				-196
			],
			[
				-194,
				-271
			],
			[
				-126,
				-176
			],
			[
				-198,
				-275
			],
			[
				-124,
				-173
			],
			[
				-19,
				-10
			],
			[
				-177,
				13
			],
			[
				-173,
				13
			],
			[
				-221,
				16
			],
			[
				-25,
				0
			],
			[
				-64,
				-17
			],
			[
				-39,
				-15
			],
			[
				-159,
				-47
			],
			[
				-29,
				-12
			],
			[
				-132,
				-74
			],
			[
				-135,
				-88
			],
			[
				-71,
				-67
			],
			[
				-55,
				-97
			],
			[
				-23,
				-69
			],
			[
				-25,
				-31
			],
			[
				-42,
				-26
			],
			[
				-282,
				-66
			],
			[
				-81,
				-9
			],
			[
				-132,
				-52
			],
			[
				-71,
				-88
			],
			[
				-20,
				-44
			]
		],
		[
			[
				113230,
				71188
			],
			[
				66,
				70
			],
			[
				1,
				57
			],
			[
				114,
				135
			],
			[
				-1,
				13
			],
			[
				-31,
				35
			]
		],
		[
			[
				114073,
				72167
			],
			[
				-43,
				5
			],
			[
				-53,
				40
			],
			[
				-10,
				35
			],
			[
				-16,
				12
			],
			[
				-38,
				5
			],
			[
				-71,
				18
			],
			[
				-83,
				-61
			],
			[
				-35,
				-101
			],
			[
				-7,
				-47
			],
			[
				-28,
				-99
			],
			[
				10,
				-61
			],
			[
				4,
				-79
			],
			[
				8,
				-65
			],
			[
				-8,
				-38
			],
			[
				-16,
				-21
			],
			[
				5,
				-15
			],
			[
				14,
				-5
			],
			[
				46,
				17
			],
			[
				47,
				-17
			],
			[
				46,
				-34
			],
			[
				4,
				-21
			],
			[
				-33,
				-13
			],
			[
				-76,
				-51
			],
			[
				-55,
				-58
			],
			[
				-14,
				-54
			],
			[
				-36,
				-116
			],
			[
				5,
				-23
			],
			[
				18,
				-14
			],
			[
				125,
				12
			],
			[
				113,
				47
			],
			[
				85,
				49
			],
			[
				27,
				-3
			]
		],
		[
			[
				113787,
				72735
			],
			[
				74,
				6
			],
			[
				56,
				-10
			],
			[
				66,
				-3
			],
			[
				53,
				36
			],
			[
				25,
				108
			],
			[
				30,
				17
			],
			[
				16,
				-25
			]
		],
		[
			[
				114226,
				72447
			],
			[
				9,
				39
			],
			[
				36,
				66
			],
			[
				36,
				72
			],
			[
				-20,
				40
			],
			[
				-7,
				34
			],
			[
				-2,
				41
			],
			[
				25,
				38
			],
			[
				-12,
				47
			],
			[
				-19,
				47
			],
			[
				-14,
				24
			],
			[
				0,
				43
			],
			[
				9,
				33
			],
			[
				12,
				51
			]
		],
		[
			[
				113074,
				74369
			],
			[
				-25,
				-7
			],
			[
				-40,
				23
			],
			[
				-24,
				7
			],
			[
				-23,
				-22
			],
			[
				-25,
				-15
			],
			[
				-23,
				-7
			],
			[
				-20,
				-2
			],
			[
				-33,
				-16
			],
			[
				-39,
				4
			],
			[
				-57,
				13
			],
			[
				-33,
				-32
			],
			[
				-7,
				4
			],
			[
				-5,
				80
			],
			[
				-21,
				32
			],
			[
				-26,
				18
			],
			[
				-38,
				-7
			],
			[
				-50,
				2
			],
			[
				-37,
				14
			],
			[
				-73,
				-23
			],
			[
				-59,
				-24
			],
			[
				-43,
				-24
			],
			[
				-32,
				2
			],
			[
				-56,
				21
			],
			[
				-41,
				25
			],
			[
				-5,
				21
			]
		],
		[
			[
				141370,
				74724
			],
			[
				8,
				-10
			],
			[
				26,
				-19
			],
			[
				28,
				-10
			],
			[
				33,
				19
			],
			[
				41,
				15
			],
			[
				22,
				-8
			],
			[
				3,
				-26
			],
			[
				-25,
				-117
			],
			[
				2,
				-46
			],
			[
				41,
				-96
			],
			[
				53,
				-155
			],
			[
				51,
				-146
			],
			[
				29,
				-96
			],
			[
				29,
				-39
			],
			[
				122,
				-40
			],
			[
				100,
				-32
			],
			[
				60,
				-54
			],
			[
				66,
				-52
			],
			[
				46,
				-32
			],
			[
				22,
				-40
			],
			[
				4,
				-37
			],
			[
				-4,
				-25
			],
			[
				-25,
				-32
			],
			[
				-115,
				-83
			],
			[
				-14,
				-27
			],
			[
				-3,
				-35
			],
			[
				22,
				-103
			],
			[
				14,
				-65
			],
			[
				4,
				-131
			],
			[
				8,
				-124
			],
			[
				41,
				-57
			],
			[
				33,
				-37
			]
		],
		[
			[
				140885,
				74406
			],
			[
				-11,
				-40
			],
			[
				-20,
				-58
			],
			[
				-70,
				-44
			],
			[
				-70,
				-31
			],
			[
				-17,
				-19
			],
			[
				-5,
				-25
			],
			[
				-34,
				-50
			],
			[
				-66,
				-42
			],
			[
				-55,
				4
			],
			[
				-34,
				13
			],
			[
				-184,
				-73
			],
			[
				-85,
				2
			],
			[
				-66,
				-48
			],
			[
				-49,
				-43
			],
			[
				-99,
				-47
			],
			[
				-67,
				0
			],
			[
				-99,
				28
			],
			[
				-122,
				53
			],
			[
				-49,
				31
			],
			[
				-45,
				-2
			],
			[
				-107,
				8
			],
			[
				-106,
				26
			],
			[
				-126,
				31
			],
			[
				-62,
				14
			],
			[
				-127,
				27
			],
			[
				-83,
				-36
			],
			[
				-75,
				-33
			],
			[
				-62,
				-23
			],
			[
				-50,
				-103
			],
			[
				-21,
				-36
			],
			[
				-25,
				-52
			],
			[
				-11,
				-36
			],
			[
				10,
				-44
			],
			[
				74,
				-30
			],
			[
				31,
				-43
			],
			[
				4,
				-37
			],
			[
				-26,
				-38
			],
			[
				-23,
				-31
			],
			[
				1,
				-26
			],
			[
				11,
				-27
			],
			[
				18,
				-20
			],
			[
				105,
				-13
			],
			[
				63,
				0
			],
			[
				24,
				-11
			],
			[
				3,
				-36
			],
			[
				-23,
				-49
			],
			[
				-89,
				-40
			],
			[
				-50,
				-41
			],
			[
				-16,
				-56
			],
			[
				1,
				-44
			],
			[
				17,
				-29
			],
			[
				43,
				-34
			],
			[
				39,
				-38
			],
			[
				12,
				-31
			],
			[
				-4,
				-43
			],
			[
				-16,
				-59
			],
			[
				-44,
				-68
			],
			[
				-36,
				-49
			],
			[
				-3,
				-17
			],
			[
				9,
				-26
			],
			[
				29,
				-38
			],
			[
				50,
				-56
			],
			[
				62,
				-46
			],
			[
				40,
				-12
			],
			[
				13,
				-11
			],
			[
				12,
				-53
			],
			[
				5,
				-55
			],
			[
				-16,
				-42
			]
		],
		[
			[
				150308,
				68344
			],
			[
				52,
				0
			],
			[
				72,
				-11
			],
			[
				55,
				-14
			],
			[
				44,
				1
			],
			[
				80,
				64
			],
			[
				36,
				3
			],
			[
				42,
				12
			],
			[
				18,
				12
			],
			[
				13,
				-9
			],
			[
				46,
				-8
			],
			[
				48,
				3
			],
			[
				42,
				18
			],
			[
				43,
				28
			],
			[
				76,
				57
			],
			[
				15,
				33
			],
			[
				0,
				30
			],
			[
				-14,
				20
			],
			[
				-15,
				10
			],
			[
				6,
				26
			],
			[
				32,
				44
			],
			[
				116,
				67
			],
			[
				99,
				82
			],
			[
				55,
				62
			],
			[
				25,
				74
			],
			[
				31,
				81
			],
			[
				29,
				32
			],
			[
				71,
				21
			],
			[
				196,
				29
			],
			[
				62,
				33
			],
			[
				92,
				61
			],
			[
				46,
				47
			],
			[
				25,
				39
			],
			[
				3,
				42
			],
			[
				61,
				14
			],
			[
				53,
				69
			],
			[
				64,
				70
			],
			[
				113,
				59
			],
			[
				100,
				79
			],
			[
				35,
				-12
			],
			[
				37,
				-38
			],
			[
				19,
				-41
			],
			[
				4,
				-21
			],
			[
				128,
				-26
			],
			[
				20,
				4
			],
			[
				94,
				-37
			],
			[
				87,
				-45
			],
			[
				48,
				-12
			],
			[
				23,
				2
			],
			[
				20,
				14
			],
			[
				24,
				39
			],
			[
				24,
				29
			],
			[
				15,
				12
			],
			[
				-1,
				45
			],
			[
				126,
				89
			],
			[
				113,
				63
			],
			[
				97,
				47
			],
			[
				28,
				-19
			],
			[
				32,
				-36
			],
			[
				43,
				-89
			],
			[
				26,
				-22
			],
			[
				66,
				12
			],
			[
				12,
				-10
			],
			[
				-10,
				-32
			],
			[
				-45,
				-40
			],
			[
				-58,
				-36
			],
			[
				-38,
				-29
			],
			[
				12,
				-98
			],
			[
				-2,
				-34
			],
			[
				16,
				-11
			],
			[
				119,
				97
			],
			[
				58,
				20
			],
			[
				20,
				-24
			],
			[
				6,
				-52
			],
			[
				47,
				-107
			],
			[
				20,
				-54
			],
			[
				-119,
				-130
			],
			[
				-44,
				-67
			],
			[
				1,
				-23
			],
			[
				-2,
				-23
			],
			[
				-31,
				-34
			],
			[
				2,
				-13
			],
			[
				25,
				-21
			],
			[
				30,
				-16
			],
			[
				14,
				1
			],
			[
				25,
				31
			],
			[
				113,
				44
			],
			[
				33,
				-8
			],
			[
				79,
				-68
			],
			[
				37,
				-4
			],
			[
				96,
				-20
			],
			[
				61,
				25
			],
			[
				45,
				-23
			],
			[
				93,
				-86
			],
			[
				22,
				-15
			]
		],
		[
			[
				113317,
				49262
			],
			[
				167,
				210
			],
			[
				155,
				193
			],
			[
				133,
				167
			],
			[
				119,
				149
			]
		],
		[
			[
				174048,
				77303
			],
			[
				-23,
				-13
			],
			[
				-39,
				-69
			],
			[
				-36,
				-88
			],
			[
				-35,
				-48
			],
			[
				-41,
				-26
			],
			[
				-43,
				-16
			],
			[
				-87,
				-6
			],
			[
				-78,
				6
			],
			[
				-25,
				9
			],
			[
				-107,
				-5
			],
			[
				-30,
				-7
			],
			[
				-154,
				7
			],
			[
				-81,
				-7
			],
			[
				-51,
				-17
			],
			[
				-52,
				-36
			],
			[
				-45,
				-53
			],
			[
				-40,
				-58
			],
			[
				-80,
				-104
			],
			[
				-57,
				-51
			],
			[
				0,
				-74
			],
			[
				-1,
				-22
			],
			[
				-20,
				-16
			]
		],
		[
			[
				85493,
				68259
			],
			[
				-87,
				0
			],
			[
				2,
				-35
			],
			[
				19,
				-69
			],
			[
				7,
				-58
			],
			[
				-9,
				-36
			],
			[
				-9,
				-46
			],
			[
				4,
				-43
			],
			[
				14,
				-48
			],
			[
				13,
				-49
			],
			[
				0,
				-33
			],
			[
				-26,
				-25
			],
			[
				-61,
				-14
			],
			[
				-73,
				-11
			],
			[
				-53,
				0
			],
			[
				-80,
				8
			],
			[
				-50,
				-2
			],
			[
				-44,
				0
			],
			[
				-39,
				-8
			],
			[
				-48,
				-31
			],
			[
				-53,
				-49
			],
			[
				-67,
				-66
			],
			[
				-40,
				-41
			],
			[
				-53,
				-9
			],
			[
				-53,
				0
			],
			[
				-53,
				33
			],
			[
				-33,
				17
			],
			[
				-22,
				-2
			],
			[
				-36,
				-23
			],
			[
				-43,
				-16
			],
			[
				-40,
				0
			],
			[
				-67,
				33
			],
			[
				-80,
				49
			],
			[
				-47,
				25
			],
			[
				-67,
				8
			],
			[
				-66,
				16
			],
			[
				-47,
				-8
			],
			[
				-60,
				0
			],
			[
				-80,
				-33
			],
			[
				-67,
				-24
			],
			[
				-73,
				-25
			],
			[
				-84,
				-23
			],
			[
				21,
				-74
			],
			[
				28,
				-40
			],
			[
				0,
				-50
			],
			[
				-13,
				-42
			],
			[
				-40,
				-41
			],
			[
				-46,
				-52
			],
			[
				-27,
				-41
			],
			[
				-26,
				-58
			],
			[
				-20,
				-33
			],
			[
				-35,
				-54
			],
			[
				-30,
				-67
			],
			[
				-10,
				-42
			],
			[
				-12,
				-48
			],
			[
				-24,
				-15
			],
			[
				-81,
				-13
			],
			[
				-52,
				-17
			],
			[
				-45,
				-16
			],
			[
				-17,
				-28
			],
			[
				-3,
				-5
			],
			[
				-12,
				-58
			],
			[
				0,
				-41
			],
			[
				-13,
				-33
			],
			[
				-20,
				-82
			],
			[
				-26,
				-75
			],
			[
				-19,
				-99
			],
			[
				-19,
				-82
			],
			[
				-26,
				-132
			],
			[
				-26,
				-123
			],
			[
				-32,
				-116
			],
			[
				-26,
				-74
			],
			[
				-20,
				-42
			],
			[
				-45,
				-49
			],
			[
				-39,
				-33
			],
			[
				-45,
				-42
			],
			[
				-51,
				-41
			],
			[
				-71,
				-49
			],
			[
				-59,
				-42
			],
			[
				-24,
				-18
			],
			[
				-28,
				-23
			],
			[
				-45,
				-57
			],
			[
				-38,
				-83
			],
			[
				-26,
				-66
			],
			[
				-45,
				-107
			],
			[
				-33,
				-58
			],
			[
				-19,
				-32
			],
			[
				-52,
				-33
			],
			[
				-58,
				-25
			],
			[
				-65,
				-33
			],
			[
				-51,
				-33
			],
			[
				-71,
				-33
			],
			[
				-45,
				-33
			],
			[
				-33,
				-49
			],
			[
				-26,
				-58
			],
			[
				-32,
				-83
			],
			[
				-26,
				-90
			],
			[
				-13,
				-58
			],
			[
				-39,
				-199
			],
			[
				-13,
				-115
			],
			[
				-12,
				-74
			],
			[
				-20,
				-91
			],
			[
				-13,
				-140
			],
			[
				0,
				-115
			],
			[
				-13,
				-66
			],
			[
				-6,
				-50
			],
			[
				-32,
				-57
			],
			[
				-26,
				-41
			],
			[
				-45,
				-58
			],
			[
				-39,
				-33
			],
			[
				-13,
				-33
			],
			[
				-39,
				-41
			],
			[
				-39,
				-67
			],
			[
				-32,
				-41
			],
			[
				6,
				-33
			],
			[
				7,
				-58
			],
			[
				-20,
				-58
			],
			[
				-19,
				-66
			],
			[
				-52,
				-82
			],
			[
				-58,
				-41
			],
			[
				-84,
				-8
			],
			[
				-116,
				0
			],
			[
				-90,
				8
			],
			[
				-110,
				0
			],
			[
				-97,
				16
			],
			[
				-91,
				17
			],
			[
				-109,
				8
			],
			[
				-78,
				0
			],
			[
				-97,
				-16
			],
			[
				-252,
				0
			],
			[
				-97,
				-9
			],
			[
				-142,
				-33
			],
			[
				-34,
				-8
			]
		],
		[
			[
				114312,
				49261
			],
			[
				-48,
				68
			],
			[
				-54,
				87
			],
			[
				-4,
				118
			],
			[
				15,
				128
			],
			[
				13,
				42
			],
			[
				-7,
				42
			],
			[
				2,
				58
			],
			[
				-30,
				54
			],
			[
				-179,
				62
			],
			[
				-29,
				-5
			],
			[
				-30,
				-23
			],
			[
				-34,
				-16
			],
			[
				-24,
				15
			],
			[
				-15,
				23
			],
			[
				0,
				38
			],
			[
				3,
				29
			]
		],
		[
			[
				10494,
				85443
			],
			[
				115,
				-41
			],
			[
				110,
				-40
			],
			[
				121,
				-38
			],
			[
				126,
				-39
			],
			[
				112,
				-35
			],
			[
				135,
				-30
			],
			[
				70,
				-5
			],
			[
				98,
				26
			],
			[
				121,
				68
			],
			[
				38,
				57
			],
			[
				-16,
				47
			],
			[
				-32,
				73
			],
			[
				-7,
				26
			],
			[
				-6,
				50
			],
			[
				15,
				39
			],
			[
				128,
				65
			],
			[
				6,
				18
			],
			[
				-16,
				29
			],
			[
				-99,
				80
			],
			[
				-84,
				62
			]
		],
		[
			[
				150308,
				68344
			],
			[
				-2,
				34
			],
			[
				8,
				101
			],
			[
				-23,
				23
			],
			[
				-73,
				25
			],
			[
				-81,
				33
			],
			[
				-39,
				35
			],
			[
				-22,
				12
			],
			[
				-31,
				-6
			],
			[
				-49,
				-37
			],
			[
				-46,
				-43
			],
			[
				-37,
				-4
			],
			[
				-38,
				21
			],
			[
				-36,
				26
			],
			[
				-123,
				37
			],
			[
				-56,
				6
			],
			[
				-98,
				-6
			],
			[
				-81,
				7
			],
			[
				-12,
				12
			],
			[
				0,
				20
			],
			[
				12,
				41
			],
			[
				7,
				40
			],
			[
				-10,
				22
			],
			[
				-82,
				28
			],
			[
				-75,
				20
			],
			[
				-80,
				8
			],
			[
				-54,
				-14
			],
			[
				-52,
				-32
			],
			[
				-43,
				-56
			],
			[
				-63,
				-24
			],
			[
				-75,
				-42
			],
			[
				-36,
				-39
			],
			[
				-55,
				-84
			],
			[
				-80,
				-103
			],
			[
				-72,
				-101
			],
			[
				-38,
				-98
			],
			[
				-49,
				-61
			],
			[
				-51,
				-45
			],
			[
				-36,
				-122
			]
		],
		[
			[
				106355,
				87937
			],
			[
				5,
				6
			],
			[
				-3,
				70
			],
			[
				25,
				15
			],
			[
				38,
				11
			],
			[
				55,
				-4
			],
			[
				47,
				-11
			],
			[
				56,
				-32
			],
			[
				18,
				5
			],
			[
				96,
				61
			],
			[
				99,
				91
			],
			[
				28,
				52
			],
			[
				25,
				24
			],
			[
				86,
				13
			],
			[
				75,
				5
			],
			[
				48,
				-1
			],
			[
				117,
				9
			],
			[
				69,
				10
			],
			[
				60,
				16
			],
			[
				130,
				6
			],
			[
				202,
				-11
			],
			[
				133,
				0
			],
			[
				90,
				-9
			],
			[
				221,
				-48
			],
			[
				82,
				-9
			],
			[
				38,
				-25
			],
			[
				73,
				-10
			],
			[
				134,
				-26
			],
			[
				116,
				-13
			],
			[
				78,
				5
			],
			[
				44,
				-7
			],
			[
				83,
				-114
			],
			[
				17,
				-14
			],
			[
				33,
				-2
			],
			[
				68,
				10
			],
			[
				96,
				-4
			],
			[
				57,
				-24
			],
			[
				-8,
				-68
			],
			[
				15,
				-10
			],
			[
				26,
				4
			],
			[
				31,
				38
			],
			[
				26,
				40
			],
			[
				19,
				12
			],
			[
				98,
				-27
			],
			[
				45,
				5
			],
			[
				42,
				30
			],
			[
				25,
				5
			],
			[
				70,
				-21
			],
			[
				86,
				-15
			],
			[
				69,
				-1
			],
			[
				43,
				-17
			],
			[
				32,
				-71
			],
			[
				27,
				-14
			],
			[
				27,
				-5
			],
			[
				40,
				64
			],
			[
				36,
				24
			],
			[
				51,
				18
			],
			[
				32,
				8
			],
			[
				23,
				23
			],
			[
				31,
				21
			],
			[
				26,
				2
			],
			[
				22,
				-8
			],
			[
				25,
				-30
			],
			[
				36,
				-69
			],
			[
				45,
				-70
			],
			[
				30,
				-25
			],
			[
				80,
				21
			],
			[
				54,
				22
			],
			[
				99,
				4
			],
			[
				131,
				15
			],
			[
				100,
				20
			],
			[
				62,
				-3
			],
			[
				38,
				-22
			],
			[
				58,
				-43
			],
			[
				16,
				-61
			],
			[
				75,
				-42
			],
			[
				61,
				-8
			],
			[
				21,
				44
			],
			[
				36,
				31
			],
			[
				-13,
				42
			],
			[
				-6,
				53
			],
			[
				-27,
				50
			],
			[
				-18,
				53
			],
			[
				33,
				77
			],
			[
				36,
				67
			],
			[
				18,
				36
			],
			[
				57,
				67
			],
			[
				58,
				48
			],
			[
				87,
				76
			],
			[
				64,
				26
			],
			[
				58,
				-12
			],
			[
				32,
				-10
			],
			[
				82,
				45
			],
			[
				147,
				3
			],
			[
				123,
				-6
			]
		],
		[
			[
				114279,
				73022
			],
			[
				-19,
				-14
			],
			[
				-34,
				-38
			],
			[
				-34,
				-30
			],
			[
				-70,
				-48
			],
			[
				-15,
				-28
			]
		],
		[
			[
				114279,
				73022
			],
			[
				29,
				27
			],
			[
				8,
				29
			],
			[
				26,
				28
			],
			[
				36,
				23
			],
			[
				8,
				19
			],
			[
				-5,
				11
			],
			[
				-36,
				20
			],
			[
				-19,
				37
			],
			[
				17,
				54
			],
			[
				11,
				16
			],
			[
				21,
				26
			],
			[
				48,
				39
			],
			[
				37,
				7
			],
			[
				32,
				0
			],
			[
				54,
				-3
			],
			[
				42,
				-7
			],
			[
				11,
				10
			],
			[
				-1,
				13
			],
			[
				-52,
				32
			],
			[
				-3,
				26
			],
			[
				13,
				27
			],
			[
				37,
				44
			],
			[
				43,
				31
			],
			[
				23,
				6
			],
			[
				50,
				64
			],
			[
				32,
				72
			],
			[
				-52,
				174
			],
			[
				-31,
				28
			],
			[
				-51,
				24
			],
			[
				-31,
				3
			],
			[
				-2,
				12
			],
			[
				40,
				44
			],
			[
				29,
				38
			],
			[
				-32,
				37
			],
			[
				-56,
				17
			],
			[
				-21,
				-38
			],
			[
				-73,
				-3
			],
			[
				-113,
				0
			]
		],
		[
			[
				113510,
				35548
			],
			[
				23,
				5
			],
			[
				16,
				-9
			],
			[
				10,
				-14
			],
			[
				1,
				-24
			],
			[
				-7,
				-24
			],
			[
				-17,
				-18
			],
			[
				-23,
				-7
			],
			[
				-14,
				15
			],
			[
				3,
				44
			],
			[
				8,
				32
			]
		],
		[
			[
				142927,
				80244
			],
			[
				16,
				15
			],
			[
				17,
				23
			],
			[
				-3,
				32
			],
			[
				-32,
				103
			],
			[
				-17,
				98
			],
			[
				-11,
				88
			],
			[
				2,
				33
			],
			[
				24,
				57
			],
			[
				31,
				52
			],
			[
				112,
				48
			],
			[
				74,
				15
			],
			[
				4,
				31
			],
			[
				-61,
				20
			],
			[
				-43,
				32
			],
			[
				-8,
				18
			],
			[
				2,
				20
			],
			[
				10,
				19
			],
			[
				76,
				35
			],
			[
				71,
				35
			],
			[
				87,
				-21
			],
			[
				17,
				13
			],
			[
				5,
				36
			],
			[
				-19,
				35
			],
			[
				-17,
				57
			],
			[
				-40,
				30
			],
			[
				-2,
				35
			],
			[
				25,
				61
			],
			[
				-34,
				114
			],
			[
				-37,
				99
			],
			[
				-63,
				171
			],
			[
				-42,
				49
			],
			[
				-23,
				79
			],
			[
				-26,
				41
			],
			[
				2,
				61
			],
			[
				4,
				43
			],
			[
				-6,
				85
			],
			[
				-12,
				92
			],
			[
				12,
				94
			],
			[
				23,
				62
			],
			[
				-6,
				23
			],
			[
				12,
				18
			],
			[
				35,
				6
			],
			[
				17,
				25
			],
			[
				-17,
				26
			],
			[
				-61,
				20
			],
			[
				-68,
				31
			],
			[
				-82,
				-3
			],
			[
				-85,
				-6
			],
			[
				-42,
				23
			],
			[
				-36,
				30
			],
			[
				-3,
				19
			],
			[
				51,
				50
			],
			[
				71,
				51
			],
			[
				109,
				23
			],
			[
				120,
				34
			],
			[
				61,
				24
			],
			[
				81,
				18
			],
			[
				94,
				7
			],
			[
				48,
				-5
			],
			[
				120,
				33
			],
			[
				191,
				64
			],
			[
				172,
				53
			],
			[
				58,
				32
			],
			[
				44,
				-32
			],
			[
				20,
				-70
			],
			[
				50,
				-36
			],
			[
				50,
				-18
			],
			[
				29,
				1
			],
			[
				86,
				27
			],
			[
				93,
				20
			],
			[
				36,
				-11
			],
			[
				48,
				-35
			],
			[
				53,
				-32
			],
			[
				27,
				1
			],
			[
				25,
				25
			],
			[
				24,
				50
			],
			[
				16,
				63
			],
			[
				3,
				67
			],
			[
				-9,
				42
			],
			[
				-19,
				15
			],
			[
				-85,
				24
			],
			[
				-80,
				39
			],
			[
				-10,
				37
			],
			[
				2,
				25
			],
			[
				21,
				63
			],
			[
				53,
				116
			],
			[
				53,
				160
			],
			[
				28,
				126
			],
			[
				89,
				188
			],
			[
				69,
				196
			],
			[
				113,
				282
			],
			[
				19,
				56
			],
			[
				11,
				89
			],
			[
				6,
				36
			],
			[
				39,
				20
			],
			[
				66,
				-19
			],
			[
				162,
				-64
			],
			[
				123,
				-54
			],
			[
				52,
				-19
			],
			[
				77,
				-19
			],
			[
				118,
				-22
			],
			[
				69,
				6
			],
			[
				60,
				14
			],
			[
				80,
				1
			],
			[
				125,
				-17
			],
			[
				38,
				-1
			],
			[
				48,
				-2
			],
			[
				35,
				-27
			],
			[
				17,
				-62
			],
			[
				26,
				-28
			],
			[
				46,
				11
			],
			[
				100,
				54
			],
			[
				63,
				43
			],
			[
				80,
				62
			],
			[
				78,
				9
			],
			[
				84,
				13
			],
			[
				29,
				31
			],
			[
				31,
				72
			],
			[
				51,
				55
			],
			[
				9,
				69
			],
			[
				-19,
				49
			],
			[
				-35,
				79
			],
			[
				1,
				54
			],
			[
				-17,
				155
			],
			[
				-23,
				139
			],
			[
				23,
				112
			],
			[
				42,
				126
			],
			[
				16,
				38
			],
			[
				26,
				51
			],
			[
				37,
				60
			],
			[
				52,
				19
			],
			[
				146,
				13
			],
			[
				135,
				26
			],
			[
				70,
				26
			],
			[
				71,
				15
			],
			[
				43,
				20
			],
			[
				74,
				88
			],
			[
				35,
				51
			],
			[
				26,
				134
			],
			[
				-19,
				65
			],
			[
				16,
				58
			],
			[
				35,
				33
			],
			[
				50,
				34
			],
			[
				34,
				6
			],
			[
				71,
				10
			],
			[
				118,
				-3
			],
			[
				60,
				-17
			]
		],
		[
			[
				106277,
				89934
			],
			[
				48,
				-16
			],
			[
				113,
				-7
			],
			[
				90,
				20
			],
			[
				46,
				2
			],
			[
				41,
				-6
			],
			[
				62,
				11
			],
			[
				57,
				5
			],
			[
				29,
				-25
			],
			[
				52,
				-23
			],
			[
				104,
				33
			],
			[
				92,
				39
			],
			[
				95,
				-4
			],
			[
				14,
				19
			],
			[
				23,
				100
			],
			[
				29,
				21
			],
			[
				114,
				-10
			],
			[
				42,
				18
			],
			[
				44,
				49
			],
			[
				67,
				31
			],
			[
				56,
				0
			],
			[
				59,
				34
			],
			[
				29,
				-23
			],
			[
				14,
				-41
			],
			[
				-20,
				-33
			],
			[
				9,
				-13
			],
			[
				40,
				-16
			],
			[
				70,
				1
			],
			[
				44,
				13
			],
			[
				10,
				19
			],
			[
				0,
				34
			],
			[
				-11,
				32
			],
			[
				-29,
				27
			],
			[
				-55,
				14
			],
			[
				-39,
				1
			],
			[
				-6,
				17
			],
			[
				13,
				38
			],
			[
				34,
				68
			],
			[
				42,
				63
			],
			[
				25,
				23
			],
			[
				5,
				22
			],
			[
				-5,
				37
			],
			[
				-1,
				68
			],
			[
				38,
				95
			],
			[
				50,
				71
			],
			[
				68,
				23
			],
			[
				83,
				12
			],
			[
				53,
				34
			],
			[
				27,
				39
			],
			[
				10,
				33
			],
			[
				12,
				28
			],
			[
				27,
				13
			],
			[
				200,
				-8
			],
			[
				30,
				61
			],
			[
				17,
				17
			],
			[
				39,
				18
			],
			[
				26,
				22
			],
			[
				-10,
				16
			],
			[
				-51,
				11
			],
			[
				-120,
				10
			],
			[
				-24,
				20
			],
			[
				8,
				24
			],
			[
				32,
				63
			],
			[
				30,
				81
			],
			[
				16,
				63
			],
			[
				2,
				37
			]
		],
		[
			[
				56620,
				17625
			],
			[
				-18,
				4
			],
			[
				-42,
				22
			],
			[
				-36,
				27
			],
			[
				-8,
				18
			],
			[
				-4,
				27
			],
			[
				5,
				101
			],
			[
				-1,
				272
			],
			[
				13,
				51
			],
			[
				18,
				33
			],
			[
				57,
				48
			],
			[
				55,
				69
			],
			[
				62,
				87
			],
			[
				57,
				70
			],
			[
				-20,
				47
			],
			[
				-48,
				45
			],
			[
				-85,
				36
			],
			[
				-82,
				65
			],
			[
				-72,
				82
			],
			[
				-34,
				86
			],
			[
				-31,
				93
			],
			[
				-29,
				73
			],
			[
				-10,
				34
			],
			[
				-29,
				14
			],
			[
				-45,
				37
			],
			[
				-29,
				35
			],
			[
				-41,
				20
			],
			[
				-75,
				22
			],
			[
				-77,
				38
			],
			[
				-97,
				91
			],
			[
				-69,
				101
			],
			[
				-35,
				66
			],
			[
				-37,
				47
			],
			[
				-199,
				78
			],
			[
				-90,
				92
			],
			[
				-36,
				-29
			],
			[
				-53,
				29
			],
			[
				-52,
				44
			],
			[
				-16,
				34
			],
			[
				-22,
				35
			],
			[
				-21,
				41
			],
			[
				-13,
				38
			],
			[
				-54,
				68
			],
			[
				-70,
				73
			],
			[
				-30,
				20
			],
			[
				-15,
				-6
			],
			[
				-15,
				-28
			],
			[
				-10,
				-27
			],
			[
				-26,
				-18
			],
			[
				-33,
				-33
			],
			[
				-33,
				-41
			],
			[
				-42,
				-27
			],
			[
				-51,
				-9
			],
			[
				-34,
				1
			],
			[
				-7,
				16
			],
			[
				-2,
				56
			],
			[
				13,
				128
			],
			[
				-30,
				49
			],
			[
				-39,
				52
			],
			[
				-46,
				71
			],
			[
				-149,
				149
			],
			[
				-203,
				215
			],
			[
				-72,
				66
			],
			[
				-68,
				5
			],
			[
				-61,
				-8
			],
			[
				-57,
				-28
			],
			[
				-43,
				-100
			],
			[
				-18,
				-15
			],
			[
				-109,
				2
			],
			[
				-109,
				17
			],
			[
				-37,
				60
			]
		],
		[
			[
				166494,
				86540
			],
			[
				-61,
				-115
			],
			[
				-121,
				-230
			],
			[
				-102,
				-194
			],
			[
				-55,
				-110
			],
			[
				-39,
				-83
			],
			[
				-41,
				-80
			],
			[
				-6,
				-47
			],
			[
				-47,
				-77
			],
			[
				-86,
				-92
			],
			[
				-18,
				-101
			],
			[
				3,
				-90
			],
			[
				-7,
				-81
			],
			[
				-95,
				-51
			],
			[
				-74,
				-45
			],
			[
				21,
				-154
			],
			[
				38,
				-58
			],
			[
				62,
				-62
			],
			[
				65,
				-50
			],
			[
				56,
				-43
			],
			[
				61,
				21
			],
			[
				53,
				64
			],
			[
				101,
				57
			],
			[
				55,
				1
			],
			[
				40,
				-13
			],
			[
				87,
				-4
			],
			[
				90,
				21
			],
			[
				70,
				4
			],
			[
				91,
				-13
			],
			[
				32,
				-14
			],
			[
				76,
				-25
			],
			[
				83,
				-55
			],
			[
				57,
				-60
			],
			[
				42,
				-12
			],
			[
				21,
				19
			],
			[
				46,
				54
			],
			[
				65,
				53
			],
			[
				79,
				85
			],
			[
				59,
				66
			],
			[
				46,
				10
			],
			[
				90,
				-1
			],
			[
				41,
				16
			],
			[
				68,
				9
			],
			[
				59,
				-25
			],
			[
				168,
				-13
			],
			[
				44,
				-33
			],
			[
				80,
				-100
			],
			[
				44,
				-53
			],
			[
				78,
				-27
			],
			[
				47,
				-18
			],
			[
				42,
				-15
			],
			[
				42,
				-26
			],
			[
				9,
				-31
			],
			[
				17,
				-47
			],
			[
				26,
				-28
			],
			[
				47,
				-27
			],
			[
				36,
				-16
			],
			[
				11,
				-35
			],
			[
				11,
				-17
			],
			[
				33,
				-24
			],
			[
				97,
				-103
			],
			[
				47,
				-28
			],
			[
				72,
				-59
			],
			[
				30,
				-50
			],
			[
				2,
				-52
			],
			[
				18,
				-39
			],
			[
				48,
				-60
			],
			[
				23,
				-40
			],
			[
				-9,
				-55
			],
			[
				7,
				-48
			],
			[
				-18,
				-50
			],
			[
				-77,
				-37
			],
			[
				-27,
				-18
			],
			[
				-56,
				-2
			],
			[
				-94,
				19
			],
			[
				-92,
				-11
			],
			[
				-110,
				21
			],
			[
				-86,
				44
			],
			[
				-46,
				35
			],
			[
				-73,
				21
			],
			[
				-35,
				-11
			],
			[
				-43,
				-45
			],
			[
				-48,
				8
			],
			[
				-44,
				-8
			],
			[
				-114,
				9
			],
			[
				-62,
				12
			],
			[
				-98,
				-32
			],
			[
				-55,
				-10
			],
			[
				-104,
				-39
			],
			[
				-63,
				-67
			],
			[
				-47,
				-16
			],
			[
				-45,
				3
			],
			[
				-33,
				25
			],
			[
				-47,
				29
			],
			[
				-71,
				-1
			],
			[
				-21,
				-13
			],
			[
				-8,
				-27
			],
			[
				-23,
				-84
			],
			[
				0,
				-37
			],
			[
				-15,
				-24
			],
			[
				-42,
				-8
			],
			[
				-73,
				2
			],
			[
				-114,
				6
			],
			[
				-78,
				21
			],
			[
				-46,
				-9
			],
			[
				-64,
				-45
			],
			[
				-45,
				-7
			],
			[
				-36,
				-20
			],
			[
				-30,
				-66
			],
			[
				-46,
				-42
			],
			[
				-57,
				-51
			],
			[
				-60,
				-110
			],
			[
				-33,
				-63
			],
			[
				10,
				-34
			],
			[
				8,
				-41
			],
			[
				-28,
				-47
			],
			[
				-57,
				-43
			],
			[
				-45,
				-8
			],
			[
				-68,
				-42
			],
			[
				-94,
				-75
			],
			[
				-70,
				-63
			],
			[
				-91,
				-16
			],
			[
				-65,
				-16
			],
			[
				-143,
				-20
			],
			[
				-36,
				-5
			],
			[
				-157,
				-9
			],
			[
				-117,
				34
			],
			[
				-61,
				-6
			],
			[
				-54,
				-19
			],
			[
				-28,
				-21
			],
			[
				-9,
				-40
			],
			[
				-10,
				-36
			],
			[
				-44,
				-57
			],
			[
				-89,
				-76
			],
			[
				-74,
				-50
			],
			[
				-56,
				-65
			],
			[
				-32,
				-24
			],
			[
				-65,
				-25
			],
			[
				-34,
				-13
			],
			[
				-81,
				-58
			],
			[
				-64,
				-51
			],
			[
				-43,
				-15
			],
			[
				-51,
				14
			],
			[
				-34,
				4
			],
			[
				-100,
				20
			],
			[
				-67,
				2
			],
			[
				-95,
				13
			],
			[
				-222,
				61
			],
			[
				-71,
				28
			],
			[
				-63,
				77
			],
			[
				-56,
				39
			],
			[
				-77,
				4
			],
			[
				-116,
				0
			],
			[
				-52,
				15
			],
			[
				-87,
				-15
			],
			[
				-95,
				-77
			],
			[
				-45,
				-59
			],
			[
				-39,
				-59
			],
			[
				-48,
				-127
			],
			[
				-21,
				-85
			],
			[
				-16,
				-48
			],
			[
				-51,
				-76
			],
			[
				-5,
				-43
			],
			[
				17,
				-37
			],
			[
				37,
				-42
			],
			[
				22,
				-66
			],
			[
				53,
				-70
			],
			[
				53,
				-54
			],
			[
				98,
				-88
			],
			[
				29,
				-46
			],
			[
				33,
				-53
			],
			[
				7,
				-51
			],
			[
				-6,
				-34
			],
			[
				-36,
				-26
			],
			[
				-69,
				-13
			],
			[
				-33,
				-35
			],
			[
				-51,
				-48
			],
			[
				-61,
				-55
			],
			[
				-28,
				-3
			],
			[
				-34,
				-15
			],
			[
				-171,
				-68
			],
			[
				-64,
				-20
			],
			[
				-52,
				-22
			],
			[
				-60,
				-70
			],
			[
				-48,
				-52
			],
			[
				-59,
				-68
			],
			[
				-26,
				-31
			],
			[
				-52,
				-69
			],
			[
				-69,
				-78
			],
			[
				-38,
				-42
			],
			[
				-21,
				-25
			],
			[
				-19,
				-33
			],
			[
				-72,
				-26
			],
			[
				-59,
				-27
			],
			[
				-90,
				-41
			],
			[
				-129,
				-44
			],
			[
				-103,
				-44
			],
			[
				-67,
				-35
			],
			[
				-98,
				-45
			],
			[
				-67,
				-15
			],
			[
				-134,
				2
			],
			[
				-167,
				-12
			],
			[
				-121,
				-8
			],
			[
				-91,
				11
			],
			[
				-137,
				6
			],
			[
				-105,
				9
			],
			[
				-70,
				-17
			],
			[
				-166,
				-18
			],
			[
				-37,
				-4
			],
			[
				-295,
				-42
			],
			[
				-130,
				-23
			],
			[
				-119,
				-11
			],
			[
				-88,
				-16
			],
			[
				-50,
				-21
			],
			[
				-74,
				-30
			],
			[
				-39,
				-13
			],
			[
				-130,
				-58
			],
			[
				-290,
				-121
			],
			[
				-195,
				-98
			],
			[
				-32,
				-17
			],
			[
				-131,
				-69
			],
			[
				-76,
				-27
			],
			[
				-52,
				-62
			],
			[
				-42,
				-39
			],
			[
				-45,
				-17
			],
			[
				-78,
				40
			],
			[
				-56,
				-2
			],
			[
				-178,
				14
			],
			[
				0,
				180
			],
			[
				-125,
				-25
			],
			[
				-199,
				-41
			],
			[
				-185,
				-37
			],
			[
				-169,
				86
			],
			[
				-130,
				66
			],
			[
				-113,
				58
			],
			[
				-172,
				37
			],
			[
				-150,
				34
			],
			[
				-270,
				54
			],
			[
				-119,
				48
			],
			[
				-60,
				63
			],
			[
				-107,
				143
			],
			[
				-35,
				28
			],
			[
				-52,
				19
			],
			[
				-54,
				13
			],
			[
				-118,
				-1
			],
			[
				-143,
				11
			],
			[
				-206,
				30
			],
			[
				-164,
				24
			],
			[
				-280,
				45
			],
			[
				-66,
				5
			],
			[
				-146,
				-39
			],
			[
				-187,
				-51
			],
			[
				-337,
				40
			],
			[
				-149,
				18
			],
			[
				-302,
				38
			],
			[
				-342,
				43
			],
			[
				-332,
				44
			],
			[
				-241,
				-24
			],
			[
				-134,
				-14
			],
			[
				-155,
				-19
			],
			[
				-21,
				21
			],
			[
				-7,
				85
			],
			[
				-27,
				65
			],
			[
				-85,
				71
			],
			[
				-57,
				68
			],
			[
				-108,
				91
			],
			[
				-35,
				57
			],
			[
				-11,
				89
			],
			[
				-100,
				231
			],
			[
				-62,
				156
			],
			[
				-16,
				32
			],
			[
				-26,
				51
			],
			[
				-36,
				27
			],
			[
				-74,
				16
			],
			[
				-20,
				27
			],
			[
				0,
				54
			],
			[
				12,
				75
			],
			[
				15,
				55
			],
			[
				-11,
				13
			],
			[
				-194,
				-15
			],
			[
				-119,
				36
			],
			[
				-99,
				39
			],
			[
				-141,
				101
			],
			[
				-84,
				38
			],
			[
				-106,
				104
			],
			[
				-156,
				25
			],
			[
				-58,
				40
			],
			[
				-73,
				89
			],
			[
				-64,
				57
			],
			[
				-91,
				36
			],
			[
				-143,
				32
			],
			[
				-245,
				30
			],
			[
				-82,
				13
			],
			[
				-135,
				-20
			],
			[
				-101,
				-2
			],
			[
				-162,
				22
			],
			[
				-92,
				27
			],
			[
				-115,
				1
			],
			[
				-74,
				0
			],
			[
				-99,
				6
			],
			[
				-48,
				18
			],
			[
				-45,
				22
			],
			[
				-83,
				-6
			],
			[
				-58,
				22
			],
			[
				-55,
				41
			],
			[
				-56,
				19
			],
			[
				-63,
				-1
			],
			[
				-25,
				-18
			],
			[
				-24,
				1
			],
			[
				-15,
				55
			],
			[
				-59,
				89
			],
			[
				-8,
				40
			],
			[
				-36,
				46
			],
			[
				-21,
				42
			],
			[
				6,
				57
			],
			[
				25,
				112
			],
			[
				56,
				102
			],
			[
				36,
				26
			],
			[
				23,
				30
			],
			[
				46,
				52
			],
			[
				28,
				42
			],
			[
				-4,
				57
			],
			[
				-31,
				60
			],
			[
				-24,
				77
			],
			[
				5,
				44
			],
			[
				34,
				52
			],
			[
				40,
				117
			],
			[
				-3,
				30
			],
			[
				-16,
				25
			],
			[
				-4,
				53
			],
			[
				-8,
				73
			],
			[
				-48,
				111
			],
			[
				-27,
				58
			],
			[
				-45,
				26
			],
			[
				-54,
				15
			],
			[
				-47,
				80
			],
			[
				-58,
				93
			],
			[
				-37,
				59
			],
			[
				-13,
				36
			],
			[
				-6,
				66
			],
			[
				-27,
				79
			],
			[
				-29,
				43
			],
			[
				-21,
				33
			],
			[
				-11,
				48
			],
			[
				-11,
				18
			],
			[
				-79,
				21
			],
			[
				-57,
				36
			],
			[
				-24,
				48
			],
			[
				-8,
				38
			],
			[
				-17,
				23
			],
			[
				-44,
				7
			],
			[
				-31,
				-35
			],
			[
				-52,
				-17
			],
			[
				-34,
				3
			],
			[
				-34,
				21
			],
			[
				-21,
				22
			],
			[
				-35,
				25
			],
			[
				-50,
				78
			],
			[
				-53,
				21
			],
			[
				-97,
				-4
			],
			[
				-86,
				-36
			],
			[
				-52,
				6
			],
			[
				-44,
				12
			],
			[
				-49,
				39
			],
			[
				-35,
				32
			],
			[
				-51,
				11
			],
			[
				-101,
				56
			],
			[
				-69,
				41
			],
			[
				-6,
				80
			],
			[
				-32,
				56
			],
			[
				-66,
				15
			],
			[
				-68,
				57
			],
			[
				-98,
				30
			],
			[
				-61,
				24
			],
			[
				-54,
				14
			],
			[
				-8,
				22
			],
			[
				3,
				18
			],
			[
				25,
				31
			],
			[
				26,
				28
			],
			[
				6,
				27
			],
			[
				-21,
				23
			],
			[
				-55,
				25
			],
			[
				-72,
				22
			],
			[
				-14,
				36
			],
			[
				-43,
				38
			],
			[
				8,
				30
			],
			[
				33,
				22
			],
			[
				35,
				17
			],
			[
				8,
				28
			],
			[
				-25,
				27
			],
			[
				-12,
				40
			],
			[
				6,
				29
			],
			[
				-7,
				39
			]
		],
		[
			[
				100029,
				85668
			],
			[
				-29,
				41
			],
			[
				-55,
				50
			],
			[
				-88,
				68
			],
			[
				-70,
				-3
			],
			[
				-25,
				18
			],
			[
				-11,
				25
			],
			[
				-29,
				43
			],
			[
				-33,
				31
			],
			[
				-39,
				11
			],
			[
				-57,
				39
			],
			[
				-75,
				84
			],
			[
				-69,
				58
			],
			[
				-67,
				-1
			],
			[
				-42,
				30
			],
			[
				-43,
				40
			],
			[
				-32,
				39
			],
			[
				-49,
				93
			],
			[
				-36,
				54
			],
			[
				-28,
				33
			],
			[
				-32,
				27
			],
			[
				-11,
				22
			],
			[
				38,
				50
			],
			[
				14,
				25
			],
			[
				17,
				19
			],
			[
				10,
				20
			],
			[
				-1,
				15
			],
			[
				-35,
				49
			],
			[
				-47,
				36
			],
			[
				-70,
				36
			],
			[
				-44,
				45
			],
			[
				-17,
				42
			],
			[
				-4,
				23
			],
			[
				-31,
				31
			],
			[
				-24,
				45
			],
			[
				0,
				28
			],
			[
				6,
				7
			],
			[
				23,
				0
			],
			[
				26,
				-18
			],
			[
				36,
				-36
			],
			[
				30,
				-52
			],
			[
				18,
				20
			],
			[
				34,
				55
			],
			[
				61,
				63
			],
			[
				62,
				36
			],
			[
				56,
				3
			],
			[
				46,
				10
			],
			[
				38,
				18
			],
			[
				67,
				-7
			],
			[
				48,
				-13
			],
			[
				15,
				8
			],
			[
				20,
				33
			],
			[
				12,
				28
			],
			[
				107,
				17
			],
			[
				36,
				55
			],
			[
				21,
				-1
			],
			[
				23,
				9
			],
			[
				23,
				20
			],
			[
				22,
				9
			],
			[
				17,
				-10
			],
			[
				23,
				-7
			],
			[
				23,
				13
			],
			[
				35,
				62
			],
			[
				19,
				10
			],
			[
				94,
				10
			],
			[
				127,
				37
			],
			[
				65,
				33
			],
			[
				63,
				18
			],
			[
				68,
				31
			],
			[
				108,
				31
			],
			[
				5,
				13
			],
			[
				-50,
				32
			],
			[
				-17,
				20
			],
			[
				-11,
				20
			],
			[
				18,
				23
			],
			[
				23,
				7
			],
			[
				31,
				-10
			],
			[
				91,
				-13
			],
			[
				24,
				-13
			],
			[
				9,
				-32
			],
			[
				23,
				-30
			],
			[
				19,
				-4
			],
			[
				-7,
				-48
			],
			[
				29,
				-19
			],
			[
				42,
				-15
			],
			[
				28,
				3
			],
			[
				20,
				20
			],
			[
				8,
				13
			]
		],
		[
			[
				108776,
				92893
			],
			[
				-17,
				-2
			],
			[
				-90,
				11
			],
			[
				-99,
				33
			],
			[
				-44,
				25
			],
			[
				-42,
				0
			],
			[
				-52,
				-17
			],
			[
				-186,
				-47
			],
			[
				-45,
				11
			],
			[
				-106,
				46
			],
			[
				-54,
				51
			],
			[
				-119,
				102
			],
			[
				-10,
				24
			],
			[
				-16,
				19
			],
			[
				-127,
				25
			],
			[
				-47,
				37
			],
			[
				-39,
				6
			],
			[
				-58,
				18
			],
			[
				-149,
				80
			],
			[
				-37,
				7
			],
			[
				-9,
				-13
			],
			[
				2,
				-19
			],
			[
				-9,
				-11
			],
			[
				-19,
				1
			],
			[
				-35,
				29
			],
			[
				-41,
				26
			],
			[
				-129,
				-49
			],
			[
				-47,
				-13
			],
			[
				-41,
				-3
			],
			[
				-205,
				-64
			],
			[
				-62,
				-34
			],
			[
				-26,
				4
			]
		],
		[
			[
				108776,
				92893
			],
			[
				76,
				-3
			],
			[
				27,
				-13
			],
			[
				17,
				-65
			],
			[
				87,
				-51
			],
			[
				80,
				-42
			],
			[
				21,
				-19
			],
			[
				6,
				-38
			],
			[
				-5,
				-44
			],
			[
				-10,
				-23
			],
			[
				-34,
				-26
			],
			[
				-29,
				-66
			],
			[
				-4,
				-63
			],
			[
				-47,
				-110
			],
			[
				11,
				-2
			],
			[
				97,
				20
			],
			[
				28,
				-11
			],
			[
				21,
				-24
			],
			[
				7,
				-69
			],
			[
				32,
				-31
			],
			[
				32,
				-48
			],
			[
				10,
				-37
			],
			[
				62,
				-45
			],
			[
				5,
				-29
			],
			[
				38,
				-102
			],
			[
				14,
				-59
			],
			[
				7,
				-45
			],
			[
				-19,
				-58
			],
			[
				-16,
				-39
			]
		],
		[
			[
				104701,
				91691
			],
			[
				174,
				97
			],
			[
				219,
				104
			],
			[
				50,
				10
			],
			[
				201,
				62
			],
			[
				27,
				5
			],
			[
				182,
				-12
			],
			[
				143,
				-15
			],
			[
				120,
				2
			],
			[
				66,
				16
			],
			[
				60,
				-13
			],
			[
				49,
				-47
			],
			[
				49,
				6
			],
			[
				49,
				30
			],
			[
				270,
				-28
			],
			[
				60,
				1
			],
			[
				69,
				-4
			],
			[
				126,
				-28
			],
			[
				73,
				-26
			],
			[
				160,
				15
			],
			[
				68,
				1
			],
			[
				36,
				10
			],
			[
				110,
				71
			],
			[
				48,
				12
			],
			[
				43,
				12
			],
			[
				40,
				-11
			],
			[
				27,
				-59
			],
			[
				81,
				-104
			],
			[
				89,
				-18
			],
			[
				245,
				-40
			],
			[
				50,
				-20
			],
			[
				137,
				-92
			],
			[
				83,
				-44
			],
			[
				52,
				-36
			],
			[
				81,
				-70
			],
			[
				46,
				-51
			],
			[
				77,
				-38
			],
			[
				92,
				-26
			],
			[
				33,
				-4
			]
		],
		[
			[
				104427,
				102384
			],
			[
				-84,
				-3
			],
			[
				-242,
				-10
			],
			[
				107,
				-71
			],
			[
				35,
				-29
			],
			[
				7,
				-42
			],
			[
				-18,
				-78
			],
			[
				-51,
				-67
			],
			[
				-60,
				-54
			],
			[
				-116,
				-54
			],
			[
				176,
				-53
			],
			[
				-119,
				-72
			],
			[
				-56,
				-28
			],
			[
				-64,
				5
			],
			[
				-116,
				25
			],
			[
				-279,
				60
			],
			[
				-134,
				23
			],
			[
				-119,
				6
			],
			[
				-63,
				0
			],
			[
				-253,
				51
			],
			[
				-49,
				-6
			],
			[
				-91,
				-22
			],
			[
				-10,
				-50
			],
			[
				6,
				-124
			],
			[
				13,
				-96
			],
			[
				-33,
				-56
			],
			[
				-33,
				-37
			],
			[
				-102,
				-102
			],
			[
				-227,
				69
			],
			[
				-155,
				46
			],
			[
				-100,
				-61
			],
			[
				-250,
				-111
			],
			[
				-128,
				-220
			],
			[
				-7,
				-8
			],
			[
				-76,
				-55
			],
			[
				-97,
				-26
			],
			[
				-73,
				-13
			],
			[
				-43,
				-65
			],
			[
				100,
				-94
			],
			[
				51,
				-50
			],
			[
				48,
				-80
			],
			[
				-9,
				-50
			],
			[
				-11,
				-32
			],
			[
				-107,
				-65
			],
			[
				-229,
				-171
			],
			[
				-211,
				-179
			],
			[
				-87,
				-51
			],
			[
				39,
				-152
			],
			[
				-70,
				-44
			],
			[
				-143,
				-51
			],
			[
				-73,
				-19
			],
			[
				-79,
				-11
			],
			[
				-242,
				-20
			],
			[
				43,
				-163
			],
			[
				16,
				-72
			],
			[
				0,
				-43
			],
			[
				-25,
				-41
			],
			[
				-30,
				-80
			],
			[
				-45,
				-284
			],
			[
				-35,
				-31
			],
			[
				-47,
				-77
			],
			[
				-154,
				-185
			],
			[
				-123,
				-123
			],
			[
				-177,
				-178
			],
			[
				144,
				-56
			],
			[
				132,
				-41
			],
			[
				27,
				-63
			],
			[
				18,
				-105
			],
			[
				-4,
				-71
			],
			[
				-50,
				-65
			],
			[
				-39,
				-45
			],
			[
				-28,
				-22
			],
			[
				-187,
				22
			],
			[
				-240,
				28
			],
			[
				-62,
				0
			],
			[
				-139,
				-20
			],
			[
				-126,
				-42
			],
			[
				-67,
				-35
			],
			[
				-17,
				-14
			],
			[
				-84,
				-80
			],
			[
				-149,
				-142
			],
			[
				-82,
				-62
			],
			[
				24,
				-85
			],
			[
				-137,
				-166
			],
			[
				89,
				-167
			],
			[
				4,
				-5
			],
			[
				48,
				-68
			],
			[
				-50,
				-43
			],
			[
				-21,
				-24
			],
			[
				7,
				-77
			],
			[
				13,
				-86
			],
			[
				-12,
				-51
			],
			[
				-4,
				-56
			],
			[
				122,
				-252
			],
			[
				-2,
				-60
			],
			[
				-6,
				-38
			],
			[
				-37,
				-157
			],
			[
				-51,
				-211
			],
			[
				88,
				-56
			],
			[
				126,
				-66
			],
			[
				71,
				-26
			],
			[
				104,
				-79
			],
			[
				80,
				-77
			],
			[
				-11,
				-51
			],
			[
				-23,
				-57
			],
			[
				-34,
				-39
			],
			[
				-31,
				-54
			],
			[
				-14,
				-40
			],
			[
				-15,
				-11
			],
			[
				-139,
				-4
			],
			[
				-74,
				-15
			],
			[
				-38,
				-17
			],
			[
				13,
				-91
			],
			[
				84,
				-167
			],
			[
				70,
				-119
			],
			[
				23,
				-79
			],
			[
				-23,
				-79
			],
			[
				-24,
				-41
			],
			[
				-1,
				-54
			],
			[
				-18,
				-109
			],
			[
				-55,
				-55
			],
			[
				-71,
				-60
			],
			[
				-79,
				-45
			],
			[
				-63,
				-13
			],
			[
				-54,
				-5
			],
			[
				-36,
				-23
			],
			[
				-33,
				-67
			],
			[
				-30,
				-70
			],
			[
				-100,
				-86
			],
			[
				3,
				-31
			],
			[
				38,
				-102
			],
			[
				35,
				-117
			],
			[
				-30,
				-109
			],
			[
				-25,
				-114
			],
			[
				-45,
				-77
			],
			[
				-64,
				-27
			],
			[
				-47,
				13
			],
			[
				-54,
				105
			],
			[
				-30,
				43
			],
			[
				-28,
				11
			],
			[
				-40,
				2
			],
			[
				-60,
				-13
			],
			[
				-19,
				-55
			],
			[
				-36,
				-52
			],
			[
				-94,
				-10
			]
		],
		[
			[
				104427,
				102384
			],
			[
				35,
				27
			],
			[
				138,
				2
			],
			[
				114,
				-25
			],
			[
				25,
				11
			],
			[
				15,
				22
			],
			[
				-48,
				87
			],
			[
				8,
				22
			],
			[
				50,
				28
			],
			[
				80,
				22
			],
			[
				126,
				3
			],
			[
				85,
				-3
			],
			[
				18,
				-3
			],
			[
				128,
				-96
			],
			[
				110,
				-93
			],
			[
				58,
				-40
			],
			[
				143,
				-113
			],
			[
				53,
				-65
			],
			[
				18,
				-47
			],
			[
				58,
				0
			],
			[
				201,
				-20
			],
			[
				168,
				-18
			],
			[
				47,
				-26
			],
			[
				116,
				5
			],
			[
				90,
				24
			],
			[
				158,
				30
			],
			[
				42,
				37
			],
			[
				53,
				39
			],
			[
				92,
				-6
			],
			[
				102,
				-31
			],
			[
				114,
				-41
			],
			[
				103,
				-19
			],
			[
				137,
				-29
			],
			[
				64,
				-39
			],
			[
				90,
				-11
			],
			[
				94,
				39
			],
			[
				56,
				103
			],
			[
				49,
				47
			],
			[
				70,
				33
			],
			[
				80,
				15
			],
			[
				61,
				6
			],
			[
				46,
				26
			],
			[
				66,
				59
			],
			[
				12,
				71
			],
			[
				-12,
				128
			],
			[
				12,
				42
			],
			[
				53,
				69
			],
			[
				72,
				183
			],
			[
				33,
				53
			],
			[
				39,
				32
			],
			[
				54,
				19
			],
			[
				98,
				56
			],
			[
				141,
				109
			],
			[
				38,
				10
			],
			[
				100,
				5
			],
			[
				126,
				-4
			],
			[
				112,
				-19
			],
			[
				13,
				1
			],
			[
				50,
				10
			],
			[
				92,
				35
			],
			[
				158,
				67
			],
			[
				101,
				19
			],
			[
				91,
				-3
			],
			[
				102,
				-74
			],
			[
				143,
				-82
			],
			[
				92,
				-41
			],
			[
				251,
				-75
			],
			[
				221,
				-49
			],
			[
				124,
				-164
			],
			[
				-61,
				-65
			],
			[
				-31,
				-23
			],
			[
				-107,
				-65
			],
			[
				-116,
				-91
			],
			[
				-9,
				-48
			],
			[
				39,
				-48
			],
			[
				47,
				-32
			]
		],
		[
			[
				158574,
				54037
			],
			[
				27,
				9
			],
			[
				30,
				34
			],
			[
				33,
				43
			],
			[
				81,
				6
			],
			[
				81,
				-2
			],
			[
				22,
				12
			],
			[
				33,
				46
			],
			[
				54,
				59
			],
			[
				40,
				33
			],
			[
				10,
				26
			],
			[
				-17,
				62
			],
			[
				-9,
				64
			],
			[
				16,
				21
			],
			[
				73,
				-12
			],
			[
				81,
				-30
			],
			[
				19,
				-13
			],
			[
				47,
				78
			],
			[
				12,
				10
			],
			[
				31,
				0
			],
			[
				80,
				14
			],
			[
				78,
				21
			],
			[
				37,
				-4
			],
			[
				36,
				-52
			],
			[
				27,
				-52
			],
			[
				15,
				-4
			],
			[
				40,
				22
			],
			[
				34,
				-28
			],
			[
				70,
				-45
			],
			[
				42,
				-1
			],
			[
				-21,
				104
			],
			[
				24,
				75
			],
			[
				-5,
				20
			],
			[
				-40,
				35
			],
			[
				-134,
				137
			],
			[
				-23,
				40
			],
			[
				3,
				65
			],
			[
				-4,
				94
			],
			[
				-12,
				60
			],
			[
				2,
				35
			],
			[
				8,
				27
			],
			[
				25,
				11
			],
			[
				24,
				4
			],
			[
				19,
				24
			],
			[
				32,
				63
			],
			[
				63,
				-6
			],
			[
				88,
				-35
			],
			[
				65,
				-22
			],
			[
				38,
				4
			],
			[
				9,
				9
			],
			[
				-1,
				34
			],
			[
				4,
				143
			],
			[
				-2,
				30
			],
			[
				55,
				14
			],
			[
				85,
				3
			],
			[
				45,
				8
			],
			[
				41,
				60
			],
			[
				107,
				21
			],
			[
				78,
				81
			],
			[
				70,
				84
			],
			[
				34,
				22
			],
			[
				44,
				15
			],
			[
				33,
				-3
			],
			[
				40,
				-48
			],
			[
				34,
				29
			],
			[
				39,
				57
			],
			[
				21,
				55
			],
			[
				11,
				90
			],
			[
				-8,
				136
			],
			[
				-20,
				108
			],
			[
				-20,
				80
			],
			[
				-4,
				80
			],
			[
				46,
				161
			],
			[
				38,
				175
			],
			[
				-7,
				69
			],
			[
				-42,
				110
			],
			[
				-43,
				133
			],
			[
				-47,
				146
			],
			[
				-18,
				22
			],
			[
				-12,
				40
			],
			[
				-8,
				48
			],
			[
				19,
				150
			],
			[
				3,
				50
			],
			[
				54,
				68
			],
			[
				29,
				78
			],
			[
				27,
				86
			],
			[
				-10,
				45
			]
		],
		[
			[
				46191,
				31015
			],
			[
				11,
				-94
			],
			[
				88,
				-126
			],
			[
				29,
				-141
			],
			[
				20,
				-18
			],
			[
				122,
				-71
			],
			[
				2,
				-16
			],
			[
				-18,
				-27
			],
			[
				-18,
				-34
			],
			[
				13,
				-48
			],
			[
				22,
				-66
			],
			[
				7,
				-61
			],
			[
				14,
				-63
			],
			[
				13,
				-97
			],
			[
				8,
				-87
			],
			[
				31,
				-129
			],
			[
				6,
				-80
			],
			[
				1,
				-48
			],
			[
				24,
				-47
			],
			[
				47,
				-57
			],
			[
				64,
				-56
			],
			[
				51,
				-67
			],
			[
				39,
				-44
			],
			[
				47,
				-37
			],
			[
				36,
				-34
			],
			[
				14,
				-23
			],
			[
				5,
				-19
			],
			[
				-16,
				-17
			],
			[
				-57,
				-88
			],
			[
				-80,
				-132
			],
			[
				2,
				-17
			],
			[
				76,
				-95
			],
			[
				12,
				-38
			],
			[
				-1,
				-53
			],
			[
				-25,
				-64
			],
			[
				-82,
				-21
			],
			[
				-19,
				-17
			],
			[
				-2,
				-21
			],
			[
				19,
				-27
			],
			[
				-3,
				-63
			],
			[
				30,
				-70
			],
			[
				-16,
				-24
			],
			[
				-30,
				-32
			],
			[
				-1,
				-32
			],
			[
				10,
				-35
			],
			[
				32,
				-28
			],
			[
				127,
				-98
			],
			[
				10,
				-14
			],
			[
				-2,
				-10
			],
			[
				-49,
				-65
			],
			[
				-5,
				-41
			],
			[
				1,
				-66
			],
			[
				7,
				-43
			],
			[
				16,
				-18
			],
			[
				63,
				-20
			],
			[
				79,
				-150
			],
			[
				75,
				-141
			],
			[
				-1,
				-121
			],
			[
				8,
				-141
			],
			[
				48,
				-111
			],
			[
				7,
				-89
			],
			[
				16,
				-101
			],
			[
				57,
				-61
			],
			[
				22,
				-121
			],
			[
				6,
				-64
			],
			[
				-3,
				-43
			],
			[
				44,
				-132
			],
			[
				5,
				-113
			],
			[
				-10,
				-81
			],
			[
				0,
				-45
			],
			[
				6,
				-32
			],
			[
				39,
				-29
			],
			[
				16,
				-18
			],
			[
				57,
				-8
			],
			[
				82,
				-2
			],
			[
				141,
				30
			],
			[
				108,
				28
			]
		],
		[
			[
				46191,
				31015
			],
			[
				-48,
				-56
			],
			[
				-64,
				-63
			],
			[
				-78,
				-13
			],
			[
				-30,
				-32
			],
			[
				7,
				-67
			],
			[
				25,
				-95
			],
			[
				0,
				-74
			],
			[
				-24,
				-85
			],
			[
				-56,
				-93
			],
			[
				-86,
				-64
			],
			[
				-80,
				-34
			],
			[
				-64,
				0
			],
			[
				-62,
				-7
			],
			[
				-26,
				-10
			]
		],
		[
			[
				95202,
				86234
			],
			[
				3,
				49
			],
			[
				19,
				72
			],
			[
				19,
				37
			],
			[
				24,
				31
			],
			[
				26,
				21
			],
			[
				6,
				38
			],
			[
				-4,
				37
			],
			[
				-30,
				5
			],
			[
				-75,
				27
			],
			[
				-45,
				29
			],
			[
				-33,
				35
			],
			[
				-43,
				49
			],
			[
				-18,
				49
			],
			[
				-1,
				50
			],
			[
				5,
				22
			]
		],
		[
			[
				92735,
				87590
			],
			[
				7,
				-39
			],
			[
				25,
				-51
			],
			[
				17,
				-27
			],
			[
				-14,
				-36
			],
			[
				11,
				-30
			],
			[
				47,
				-53
			],
			[
				58,
				-50
			],
			[
				52,
				-32
			],
			[
				15,
				3
			],
			[
				38,
				10
			],
			[
				65,
				32
			],
			[
				55,
				11
			],
			[
				31,
				-25
			],
			[
				17,
				-15
			],
			[
				34,
				-56
			],
			[
				10,
				-59
			],
			[
				15,
				-50
			],
			[
				28,
				-20
			],
			[
				104,
				-6
			],
			[
				76,
				-18
			],
			[
				21,
				-17
			],
			[
				26,
				-109
			],
			[
				14,
				-16
			],
			[
				19,
				13
			],
			[
				19,
				18
			],
			[
				26,
				3
			],
			[
				45,
				-7
			],
			[
				59,
				-2
			],
			[
				61,
				-12
			],
			[
				84,
				-62
			],
			[
				-3,
				-20
			],
			[
				-16,
				-36
			],
			[
				-6,
				-28
			],
			[
				15,
				-12
			],
			[
				22,
				-29
			],
			[
				-6,
				-34
			],
			[
				-21,
				-24
			],
			[
				-9,
				-20
			],
			[
				0,
				-13
			],
			[
				8,
				-10
			],
			[
				17,
				-10
			],
			[
				125,
				-12
			],
			[
				114,
				12
			],
			[
				72,
				35
			],
			[
				12,
				37
			],
			[
				20,
				41
			],
			[
				43,
				35
			],
			[
				30,
				11
			],
			[
				27,
				-14
			],
			[
				-46,
				-145
			],
			[
				33,
				-37
			],
			[
				5,
				-56
			],
			[
				12,
				-49
			],
			[
				41,
				1
			],
			[
				49,
				-9
			],
			[
				35,
				-18
			],
			[
				41,
				-29
			],
			[
				59,
				-26
			],
			[
				41,
				-10
			],
			[
				15,
				-22
			],
			[
				33,
				-25
			],
			[
				53,
				-54
			],
			[
				47,
				-36
			],
			[
				22,
				0
			],
			[
				44,
				14
			],
			[
				65,
				9
			],
			[
				51,
				-1
			]
		],
		[
			[
				95055,
				86785
			],
			[
				-4,
				2
			],
			[
				-14,
				26
			],
			[
				-22,
				-1
			],
			[
				-50,
				11
			],
			[
				-71,
				-70
			],
			[
				-32,
				-58
			],
			[
				-19,
				-42
			],
			[
				-28,
				-34
			],
			[
				-6,
				-37
			],
			[
				3,
				-15
			],
			[
				-9,
				-19
			],
			[
				-1,
				-21
			],
			[
				41,
				-41
			],
			[
				10,
				-22
			],
			[
				50,
				-72
			],
			[
				-16,
				-26
			],
			[
				-12,
				-29
			],
			[
				-14,
				-20
			],
			[
				-17,
				-13
			]
		],
		[
			[
				121102,
				79998
			],
			[
				-12,
				11
			],
			[
				-93,
				46
			],
			[
				-35,
				24
			],
			[
				-34,
				2
			],
			[
				-72,
				14
			],
			[
				-61,
				22
			],
			[
				-28,
				29
			],
			[
				-42,
				32
			],
			[
				-77,
				41
			],
			[
				-57,
				38
			],
			[
				-3,
				24
			],
			[
				35,
				101
			],
			[
				25,
				97
			],
			[
				-14,
				19
			],
			[
				-32,
				17
			],
			[
				-60,
				14
			],
			[
				-142,
				-4
			],
			[
				-87,
				97
			],
			[
				-31,
				22
			],
			[
				-57,
				16
			],
			[
				-83,
				30
			],
			[
				-47,
				21
			],
			[
				-13,
				-8
			],
			[
				-52,
				-107
			],
			[
				-51,
				77
			],
			[
				-31,
				21
			],
			[
				-43,
				11
			],
			[
				-46,
				0
			],
			[
				-114,
				-37
			],
			[
				-84,
				-41
			],
			[
				-62,
				-31
			],
			[
				-64,
				-17
			],
			[
				-30,
				-24
			],
			[
				-85,
				4
			],
			[
				-43,
				18
			],
			[
				-14,
				19
			],
			[
				8,
				34
			],
			[
				29,
				37
			],
			[
				2,
				21
			],
			[
				-10,
				16
			],
			[
				-103,
				50
			],
			[
				-43,
				30
			],
			[
				-135,
				43
			],
			[
				-167,
				76
			],
			[
				-58,
				50
			],
			[
				-5,
				35
			],
			[
				-66,
				34
			],
			[
				-84,
				30
			],
			[
				-64,
				-9
			],
			[
				-61,
				-3
			],
			[
				-95,
				57
			],
			[
				-90,
				3
			],
			[
				-102,
				-17
			],
			[
				-22,
				-7
			],
			[
				-25,
				-7
			],
			[
				-303,
				24
			],
			[
				-77,
				47
			],
			[
				-67,
				47
			],
			[
				-177,
				34
			],
			[
				-92,
				36
			],
			[
				-90,
				51
			],
			[
				-100,
				45
			],
			[
				-83,
				-18
			],
			[
				-114,
				25
			],
			[
				-124,
				22
			],
			[
				-43,
				-14
			],
			[
				-39,
				-56
			],
			[
				-29,
				-53
			]
		],
		[
			[
				104649,
				79139
			],
			[
				-4,
				18
			],
			[
				-16,
				26
			],
			[
				-41,
				12
			],
			[
				-84,
				-10
			],
			[
				-20,
				19
			],
			[
				-35,
				110
			],
			[
				-26,
				17
			],
			[
				-31,
				37
			],
			[
				-51,
				120
			],
			[
				-1,
				52
			],
			[
				4,
				46
			],
			[
				-29,
				107
			],
			[
				18,
				27
			],
			[
				26,
				17
			],
			[
				0,
				43
			],
			[
				-7,
				66
			],
			[
				31,
				128
			],
			[
				8,
				9
			]
		],
		[
			[
				104391,
				79983
			],
			[
				10,
				37
			],
			[
				-4,
				78
			],
			[
				-34,
				131
			],
			[
				-24,
				43
			],
			[
				-50,
				42
			],
			[
				-39,
				28
			],
			[
				-69,
				25
			],
			[
				-35,
				72
			],
			[
				-54,
				81
			],
			[
				-25,
				19
			]
		],
		[
			[
				117923,
				79690
			],
			[
				43,
				-17
			],
			[
				81,
				-21
			],
			[
				50,
				-26
			],
			[
				29,
				-7
			],
			[
				66,
				53
			],
			[
				98,
				-2
			],
			[
				86,
				-6
			],
			[
				45,
				-9
			],
			[
				54,
				-18
			],
			[
				66,
				-11
			],
			[
				27,
				25
			],
			[
				39,
				73
			],
			[
				14,
				10
			],
			[
				11,
				6
			],
			[
				49,
				6
			],
			[
				46,
				-6
			],
			[
				22,
				-12
			],
			[
				22,
				-59
			],
			[
				55,
				-21
			],
			[
				97,
				-94
			],
			[
				59,
				-38
			],
			[
				15,
				-16
			],
			[
				-20,
				-19
			],
			[
				8,
				-23
			],
			[
				34,
				-31
			],
			[
				48,
				-11
			],
			[
				51,
				4
			],
			[
				28,
				-11
			],
			[
				20,
				-18
			],
			[
				5,
				-24
			],
			[
				-1,
				-16
			]
		],
		[
			[
				156450,
				63237
			],
			[
				38,
				-37
			],
			[
				-14,
				-95
			],
			[
				19,
				-19
			],
			[
				10,
				-34
			],
			[
				-6,
				-53
			],
			[
				9,
				-45
			],
			[
				15,
				-22
			],
			[
				21,
				-11
			],
			[
				105,
				39
			],
			[
				64,
				3
			],
			[
				27,
				-26
			],
			[
				24,
				-15
			],
			[
				31,
				-13
			],
			[
				23,
				-16
			],
			[
				15,
				5
			],
			[
				36,
				40
			],
			[
				11,
				7
			],
			[
				1,
				19
			],
			[
				-25,
				35
			],
			[
				-26,
				30
			],
			[
				0,
				66
			],
			[
				13,
				115
			],
			[
				2,
				59
			],
			[
				-2,
				142
			],
			[
				-5,
				40
			],
			[
				-23,
				46
			],
			[
				-63,
				89
			],
			[
				-17,
				54
			],
			[
				-10,
				54
			],
			[
				1,
				34
			],
			[
				-16,
				39
			],
			[
				-9,
				36
			],
			[
				29,
				19
			],
			[
				33,
				42
			],
			[
				17,
				64
			],
			[
				16,
				47
			],
			[
				24,
				20
			],
			[
				20,
				8
			],
			[
				14,
				-5
			],
			[
				52,
				-84
			],
			[
				67,
				42
			],
			[
				51,
				0
			],
			[
				44,
				-22
			],
			[
				23,
				-27
			]
		],
		[
			[
				138678,
				77984
			],
			[
				54,
				11
			],
			[
				69,
				22
			],
			[
				32,
				36
			],
			[
				23,
				38
			],
			[
				4,
				23
			],
			[
				-20,
				89
			],
			[
				-28,
				40
			],
			[
				-3,
				30
			],
			[
				14,
				24
			],
			[
				18,
				41
			],
			[
				35,
				83
			],
			[
				34,
				53
			],
			[
				19,
				13
			],
			[
				42,
				13
			],
			[
				101,
				14
			],
			[
				110,
				37
			],
			[
				130,
				112
			],
			[
				43,
				31
			],
			[
				57,
				16
			],
			[
				40,
				-1
			],
			[
				7,
				14
			],
			[
				-26,
				69
			],
			[
				7,
				25
			],
			[
				15,
				19
			],
			[
				20,
				9
			],
			[
				90,
				-36
			],
			[
				69,
				4
			],
			[
				83,
				21
			],
			[
				181,
				122
			],
			[
				23,
				-2
			],
			[
				18,
				-17
			],
			[
				22,
				-73
			],
			[
				25,
				-154
			],
			[
				13,
				-20
			],
			[
				126,
				-2
			],
			[
				86,
				57
			],
			[
				37,
				13
			],
			[
				61,
				-9
			],
			[
				32,
				26
			],
			[
				34,
				18
			],
			[
				39,
				-64
			],
			[
				50,
				31
			],
			[
				54,
				49
			],
			[
				26,
				51
			],
			[
				37,
				55
			],
			[
				29,
				70
			],
			[
				11,
				65
			],
			[
				14,
				31
			],
			[
				31,
				32
			],
			[
				74,
				135
			],
			[
				54,
				35
			],
			[
				51,
				12
			],
			[
				127,
				-23
			],
			[
				65,
				3
			],
			[
				193,
				-18
			],
			[
				89,
				26
			],
			[
				62,
				26
			],
			[
				91,
				-4
			],
			[
				108,
				20
			],
			[
				144,
				170
			],
			[
				1,
				36
			],
			[
				9,
				38
			],
			[
				52,
				38
			],
			[
				65,
				35
			],
			[
				129,
				83
			],
			[
				262,
				131
			],
			[
				94,
				53
			],
			[
				39,
				-2
			],
			[
				97,
				33
			],
			[
				169,
				64
			],
			[
				48,
				80
			],
			[
				45,
				16
			],
			[
				198,
				14
			],
			[
				12,
				9
			],
			[
				7,
				14
			],
			[
				-11,
				58
			],
			[
				-13,
				49
			]
		],
		[
			[
				119170,
				79351
			],
			[
				34,
				7
			],
			[
				99,
				1
			],
			[
				96,
				12
			],
			[
				75,
				23
			],
			[
				108,
				19
			],
			[
				45,
				18
			],
			[
				52,
				8
			],
			[
				159,
				-19
			],
			[
				59,
				15
			],
			[
				179,
				2
			],
			[
				4,
				8
			],
			[
				-24,
				23
			],
			[
				0,
				9
			],
			[
				107,
				15
			],
			[
				16,
				11
			]
		],
		[
			[
				142927,
				80244
			],
			[
				-89,
				93
			],
			[
				-97,
				91
			],
			[
				-76,
				21
			],
			[
				-132,
				15
			],
			[
				-70,
				1
			],
			[
				-40,
				21
			],
			[
				-39,
				53
			],
			[
				-47,
				47
			],
			[
				-60,
				51
			],
			[
				-24,
				77
			],
			[
				-25,
				13
			],
			[
				-43,
				-10
			],
			[
				-72,
				3
			],
			[
				-41,
				7
			],
			[
				-61,
				13
			],
			[
				-96,
				31
			],
			[
				-76,
				30
			],
			[
				-96,
				5
			],
			[
				-56,
				-6
			],
			[
				-172,
				-5
			],
			[
				-143,
				31
			],
			[
				-116,
				6
			],
			[
				-71,
				-2
			],
			[
				-34,
				4
			],
			[
				-59,
				-1
			],
			[
				-86,
				7
			],
			[
				-115,
				48
			],
			[
				-45,
				3
			],
			[
				-28,
				-2
			],
			[
				-192,
				-35
			],
			[
				-89,
				-9
			],
			[
				-188,
				4
			],
			[
				-185,
				4
			],
			[
				-59,
				8
			],
			[
				-33,
				-4
			],
			[
				-70,
				-85
			],
			[
				-30,
				-13
			],
			[
				-174,
				19
			],
			[
				-206,
				55
			],
			[
				-148,
				61
			],
			[
				-126,
				65
			],
			[
				-167,
				101
			],
			[
				-100,
				51
			],
			[
				-15,
				-29
			],
			[
				-26,
				-10
			],
			[
				-39,
				-4
			],
			[
				-88,
				5
			],
			[
				-41,
				-51
			],
			[
				-108,
				-37
			],
			[
				-69,
				-33
			],
			[
				-36,
				-37
			],
			[
				-69,
				-248
			],
			[
				-18,
				-90
			],
			[
				46,
				-152
			],
			[
				-53,
				9
			],
			[
				-61,
				39
			],
			[
				-22,
				30
			],
			[
				-59,
				19
			],
			[
				-217,
				28
			],
			[
				-41,
				35
			],
			[
				-25,
				29
			],
			[
				-56,
				18
			],
			[
				-80,
				15
			],
			[
				-172,
				65
			],
			[
				-74,
				3
			],
			[
				-223,
				51
			],
			[
				-36,
				-1
			],
			[
				-17,
				-2
			],
			[
				-87,
				-33
			],
			[
				-56,
				-10
			],
			[
				-59,
				13
			],
			[
				-107,
				-40
			],
			[
				-58,
				-55
			],
			[
				-47,
				-67
			],
			[
				-46,
				-42
			],
			[
				-13,
				-63
			],
			[
				-33,
				-33
			],
			[
				-38,
				-65
			],
			[
				0,
				-38
			],
			[
				35,
				-37
			]
		],
		[
			[
				54609,
				47053
			],
			[
				-28,
				-12
			],
			[
				-24,
				-17
			],
			[
				-34,
				13
			],
			[
				-48,
				-7
			],
			[
				-49,
				-18
			],
			[
				-46,
				-9
			],
			[
				-85,
				29
			],
			[
				-27,
				4
			],
			[
				-17,
				12
			],
			[
				-36,
				57
			],
			[
				-17,
				7
			],
			[
				-46,
				-27
			],
			[
				-55,
				-18
			],
			[
				-27,
				3
			],
			[
				-32,
				-19
			],
			[
				-30,
				-26
			],
			[
				-57,
				-111
			],
			[
				-29,
				-39
			],
			[
				-31,
				-18
			],
			[
				-63,
				0
			],
			[
				-67,
				-4
			],
			[
				-50,
				-27
			],
			[
				-48,
				-14
			],
			[
				-23,
				-1
			],
			[
				-8,
				-61
			],
			[
				-11,
				-29
			],
			[
				-15,
				-16
			],
			[
				-36,
				-5
			],
			[
				-33,
				2
			],
			[
				-20,
				26
			],
			[
				-37,
				12
			],
			[
				-33,
				10
			],
			[
				-21,
				14
			],
			[
				-17,
				-4
			],
			[
				-15,
				-25
			],
			[
				-11,
				-22
			],
			[
				-10,
				-40
			],
			[
				-50,
				-13
			],
			[
				-21,
				-22
			],
			[
				12,
				-75
			],
			[
				-6,
				-30
			],
			[
				-10,
				-22
			],
			[
				-60,
				-5
			],
			[
				-52,
				2
			],
			[
				-29,
				-28
			],
			[
				-37,
				-32
			],
			[
				-22,
				-6
			],
			[
				-27,
				2
			],
			[
				-35,
				37
			],
			[
				-33,
				46
			],
			[
				-85,
				32
			],
			[
				-85,
				27
			],
			[
				-55,
				73
			],
			[
				-13,
				36
			],
			[
				-26,
				16
			],
			[
				-66,
				86
			],
			[
				-37,
				56
			],
			[
				-39,
				15
			],
			[
				-45,
				23
			],
			[
				2,
				41
			],
			[
				-3,
				39
			],
			[
				-20,
				15
			],
			[
				-27,
				11
			],
			[
				-10,
				22
			],
			[
				3,
				51
			],
			[
				5,
				131
			],
			[
				-7,
				126
			],
			[
				-61,
				43
			],
			[
				-26,
				30
			],
			[
				-46,
				186
			],
			[
				-22,
				84
			],
			[
				-1,
				62
			],
			[
				15,
				185
			],
			[
				18,
				81
			],
			[
				47,
				161
			],
			[
				27,
				54
			],
			[
				1,
				41
			],
			[
				-3,
				52
			],
			[
				-13,
				104
			],
			[
				79,
				65
			],
			[
				34,
				27
			],
			[
				6,
				44
			],
			[
				42,
				55
			],
			[
				19,
				53
			],
			[
				16,
				41
			],
			[
				-5,
				22
			],
			[
				-18,
				13
			],
			[
				-22,
				39
			],
			[
				-46,
				113
			],
			[
				-17,
				23
			],
			[
				-14,
				32
			],
			[
				8,
				50
			],
			[
				18,
				54
			],
			[
				-3,
				23
			],
			[
				-27,
				30
			],
			[
				-57,
				48
			],
			[
				-47,
				4
			],
			[
				-36,
				18
			],
			[
				-54,
				2
			],
			[
				-42,
				5
			],
			[
				-25,
				19
			],
			[
				5,
				30
			],
			[
				11,
				23
			],
			[
				36,
				57
			],
			[
				24,
				61
			],
			[
				3,
				59
			],
			[
				7,
				78
			],
			[
				11,
				68
			],
			[
				6,
				77
			],
			[
				-57,
				50
			],
			[
				-18,
				42
			],
			[
				-23,
				37
			],
			[
				-26,
				0
			],
			[
				-39,
				15
			],
			[
				-60,
				-48
			],
			[
				-48,
				9
			],
			[
				-32,
				-18
			],
			[
				-76,
				3
			],
			[
				-48,
				24
			],
			[
				-59,
				-16
			]
		],
		[
			[
				96526,
				90888
			],
			[
				45,
				-21
			],
			[
				51,
				-96
			],
			[
				34,
				-32
			],
			[
				49,
				-10
			],
			[
				121,
				-2
			],
			[
				30,
				-4
			],
			[
				182,
				-43
			],
			[
				45,
				-30
			],
			[
				56,
				-1
			],
			[
				101,
				28
			],
			[
				76,
				12
			],
			[
				29,
				-17
			],
			[
				42,
				-7
			],
			[
				9,
				0
			]
		],
		[
			[
				97253,
				70381
			],
			[
				77,
				43
			],
			[
				110,
				50
			],
			[
				57,
				37
			],
			[
				24,
				31
			],
			[
				82,
				128
			],
			[
				43,
				71
			],
			[
				58,
				96
			],
			[
				26,
				68
			],
			[
				0,
				62
			],
			[
				-8,
				76
			],
			[
				-46,
				180
			],
			[
				-37,
				176
			],
			[
				29,
				67
			],
			[
				23,
				33
			],
			[
				51,
				82
			],
			[
				20,
				16
			],
			[
				110,
				26
			],
			[
				44,
				55
			],
			[
				33,
				69
			],
			[
				9,
				36
			],
			[
				48,
				38
			],
			[
				57,
				37
			],
			[
				35,
				49
			],
			[
				116,
				76
			],
			[
				105,
				70
			],
			[
				123,
				73
			],
			[
				95,
				56
			],
			[
				20,
				49
			],
			[
				-2,
				43
			],
			[
				-51,
				97
			],
			[
				0,
				114
			],
			[
				3,
				96
			],
			[
				5,
				56
			],
			[
				23,
				157
			],
			[
				1,
				22
			]
		],
		[
			[
				120179,
				79503
			],
			[
				14,
				-37
			],
			[
				40,
				-42
			],
			[
				44,
				-17
			],
			[
				23,
				-22
			],
			[
				1,
				-18
			],
			[
				-77,
				-21
			],
			[
				-5,
				-10
			],
			[
				5,
				-11
			],
			[
				23,
				-5
			],
			[
				108,
				-52
			],
			[
				62,
				-1
			],
			[
				32,
				-16
			],
			[
				16,
				-31
			],
			[
				52,
				-42
			],
			[
				41,
				-41
			],
			[
				2,
				-14
			],
			[
				-7,
				-21
			],
			[
				-115,
				-81
			],
			[
				-15,
				-27
			],
			[
				-2,
				-30
			],
			[
				51,
				-87
			],
			[
				74,
				-95
			],
			[
				108,
				-72
			],
			[
				148,
				-79
			],
			[
				1,
				-49
			],
			[
				-23,
				-57
			],
			[
				-20,
				-40
			],
			[
				-9,
				-26
			],
			[
				-18,
				-11
			],
			[
				-148,
				2
			],
			[
				-22,
				-9
			],
			[
				-9,
				-12
			],
			[
				-1,
				-9
			],
			[
				53,
				-18
			],
			[
				82,
				-62
			],
			[
				48,
				-60
			],
			[
				50,
				-26
			],
			[
				55,
				-48
			],
			[
				45,
				-44
			],
			[
				69,
				-58
			],
			[
				77,
				19
			],
			[
				103,
				-52
			],
			[
				5,
				-34
			],
			[
				-7,
				-32
			],
			[
				-65,
				-34
			],
			[
				-8,
				-14
			],
			[
				0,
				-11
			],
			[
				9,
				-17
			],
			[
				38,
				-28
			],
			[
				45,
				-41
			],
			[
				50,
				-62
			],
			[
				-22,
				-18
			],
			[
				-47,
				-3
			],
			[
				-37,
				8
			],
			[
				-13,
				-13
			],
			[
				1,
				-20
			],
			[
				48,
				-47
			],
			[
				9,
				-34
			],
			[
				-2,
				-60
			],
			[
				2,
				-74
			]
		],
		[
			[
				120029,
				78194
			],
			[
				63,
				13
			],
			[
				107,
				38
			],
			[
				29,
				-19
			],
			[
				31,
				-38
			],
			[
				15,
				-33
			],
			[
				3,
				-61
			],
			[
				13,
				-10
			],
			[
				51,
				21
			],
			[
				24,
				-25
			],
			[
				39,
				-29
			],
			[
				69,
				-30
			],
			[
				100,
				46
			],
			[
				49,
				12
			],
			[
				41,
				-1
			],
			[
				22,
				-14
			],
			[
				8,
				-48
			],
			[
				-8,
				-58
			],
			[
				-12,
				-32
			],
			[
				21,
				-24
			],
			[
				82,
				-56
			],
			[
				34,
				-31
			],
			[
				-17,
				-55
			],
			[
				61,
				-132
			],
			[
				20,
				-52
			],
			[
				24,
				-63
			]
		],
		[
			[
				104182,
				83476
			],
			[
				25,
				20
			],
			[
				147,
				28
			],
			[
				68,
				-28
			],
			[
				31,
				10
			],
			[
				30,
				23
			],
			[
				16,
				18
			],
			[
				3,
				19
			],
			[
				15,
				23
			],
			[
				49,
				11
			],
			[
				131,
				-14
			],
			[
				53,
				33
			],
			[
				20,
				18
			],
			[
				12,
				40
			],
			[
				14,
				32
			],
			[
				47,
				17
			],
			[
				-1,
				30
			],
			[
				-7,
				31
			],
			[
				27,
				71
			],
			[
				16,
				30
			],
			[
				27,
				10
			],
			[
				32,
				23
			],
			[
				56,
				46
			],
			[
				-13,
				41
			],
			[
				11,
				30
			],
			[
				58,
				73
			],
			[
				44,
				70
			],
			[
				-1,
				35
			],
			[
				7,
				31
			],
			[
				39,
				34
			],
			[
				41,
				44
			],
			[
				54,
				137
			],
			[
				20,
				23
			],
			[
				35,
				26
			],
			[
				27,
				26
			],
			[
				3,
				90
			],
			[
				24,
				27
			],
			[
				48,
				29
			],
			[
				47,
				47
			],
			[
				39,
				55
			],
			[
				30,
				26
			],
			[
				39,
				7
			],
			[
				42,
				22
			],
			[
				48,
				8
			],
			[
				46,
				-11
			],
			[
				30,
				6
			],
			[
				44,
				27
			],
			[
				113,
				102
			],
			[
				16,
				20
			]
		],
		[
			[
				136950,
				78635
			],
			[
				21,
				13
			],
			[
				67,
				14
			],
			[
				136,
				13
			],
			[
				46,
				-10
			],
			[
				53,
				-27
			],
			[
				40,
				-27
			],
			[
				39,
				1
			],
			[
				32,
				5
			],
			[
				14,
				-7
			],
			[
				10,
				-24
			],
			[
				17,
				-22
			],
			[
				51,
				29
			],
			[
				47,
				39
			],
			[
				37,
				5
			],
			[
				35,
				15
			],
			[
				10,
				25
			],
			[
				26,
				42
			],
			[
				77,
				81
			],
			[
				40,
				13
			],
			[
				26,
				0
			],
			[
				1,
				-13
			],
			[
				12,
				-12
			],
			[
				67,
				-18
			],
			[
				21,
				21
			],
			[
				11,
				29
			],
			[
				-24,
				47
			],
			[
				0,
				19
			],
			[
				9,
				18
			],
			[
				12,
				11
			],
			[
				107,
				-44
			],
			[
				24,
				1
			],
			[
				48,
				24
			],
			[
				45,
				44
			],
			[
				16,
				35
			],
			[
				219,
				111
			],
			[
				16,
				21
			],
			[
				-3,
				15
			],
			[
				-92,
				26
			],
			[
				-41,
				-15
			],
			[
				-39,
				0
			],
			[
				-23,
				16
			],
			[
				-111,
				7
			],
			[
				-25,
				11
			],
			[
				-74,
				81
			],
			[
				-51,
				31
			],
			[
				-40,
				20
			],
			[
				-45,
				-3
			],
			[
				-53,
				-21
			],
			[
				-17,
				9
			],
			[
				-4,
				34
			],
			[
				0,
				43
			],
			[
				-11,
				45
			],
			[
				-31,
				11
			],
			[
				-41,
				-18
			],
			[
				-60,
				18
			],
			[
				-52,
				7
			],
			[
				-13,
				96
			],
			[
				-21,
				41
			],
			[
				-22,
				43
			],
			[
				-22,
				12
			],
			[
				-37,
				21
			],
			[
				-2,
				51
			],
			[
				-8,
				14
			],
			[
				-13,
				7
			],
			[
				-18,
				-6
			],
			[
				-23,
				-25
			],
			[
				12,
				-56
			],
			[
				-9,
				-56
			],
			[
				-13,
				-28
			],
			[
				-26,
				-21
			],
			[
				-30,
				0
			],
			[
				-51,
				28
			],
			[
				-8,
				-170
			],
			[
				-10,
				-10
			],
			[
				-61,
				24
			],
			[
				-48,
				-11
			],
			[
				-73,
				11
			],
			[
				-55,
				28
			],
			[
				-41,
				8
			],
			[
				-66,
				23
			],
			[
				-50,
				31
			],
			[
				-31,
				114
			],
			[
				-30,
				41
			],
			[
				-28,
				9
			],
			[
				-112,
				-40
			],
			[
				-41,
				31
			],
			[
				-76,
				39
			],
			[
				-58,
				14
			],
			[
				-16,
				21
			],
			[
				3,
				26
			],
			[
				177,
				127
			],
			[
				70,
				87
			],
			[
				44,
				37
			],
			[
				62,
				24
			],
			[
				49,
				15
			],
			[
				25,
				80
			],
			[
				10,
				9
			],
			[
				34,
				6
			],
			[
				79,
				33
			],
			[
				127,
				70
			],
			[
				2,
				19
			],
			[
				-12,
				17
			],
			[
				-54,
				36
			],
			[
				-61,
				28
			],
			[
				-36,
				-15
			],
			[
				-21,
				-14
			]
		],
		[
			[
				103271,
				86282
			],
			[
				68,
				-11
			],
			[
				13,
				-41
			],
			[
				7,
				-43
			],
			[
				117,
				3
			],
			[
				65,
				92
			],
			[
				34,
				11
			],
			[
				54,
				32
			],
			[
				36,
				28
			],
			[
				24,
				-17
			],
			[
				36,
				-59
			],
			[
				38,
				-48
			],
			[
				21,
				-19
			],
			[
				3,
				-14
			],
			[
				21,
				-9
			],
			[
				43,
				-5
			],
			[
				28,
				-15
			],
			[
				9,
				-44
			],
			[
				0,
				-40
			],
			[
				-13,
				-29
			],
			[
				-7,
				-25
			],
			[
				30,
				-10
			],
			[
				43,
				10
			],
			[
				30,
				14
			],
			[
				92,
				-33
			],
			[
				32,
				74
			],
			[
				36,
				37
			],
			[
				47,
				18
			],
			[
				43,
				23
			],
			[
				39,
				16
			],
			[
				27,
				-1
			],
			[
				12,
				7
			],
			[
				33,
				-2
			],
			[
				39,
				-7
			],
			[
				53,
				8
			],
			[
				73,
				-18
			],
			[
				45,
				-34
			],
			[
				45,
				-11
			],
			[
				51,
				2
			],
			[
				34,
				19
			],
			[
				51,
				64
			],
			[
				37,
				-1
			],
			[
				57,
				10
			],
			[
				81,
				0
			],
			[
				187,
				-14
			],
			[
				47,
				-25
			],
			[
				115,
				-31
			],
			[
				50,
				-37
			],
			[
				22,
				-44
			],
			[
				12,
				-30
			],
			[
				118,
				-46
			],
			[
				174,
				-60
			],
			[
				43,
				-7
			]
		],
		[
			[
				86439,
				90884
			],
			[
				-102,
				-53
			],
			[
				-16,
				-20
			],
			[
				-29,
				-81
			],
			[
				-3,
				-23
			],
			[
				-33,
				-43
			],
			[
				-31,
				-47
			],
			[
				-36,
				-18
			],
			[
				-54,
				-15
			],
			[
				-31,
				-14
			],
			[
				-39,
				7
			],
			[
				-49,
				-1
			],
			[
				-24,
				-16
			],
			[
				1,
				-13
			],
			[
				15,
				-14
			],
			[
				43,
				-22
			],
			[
				47,
				-19
			],
			[
				-5,
				-18
			],
			[
				-25,
				-19
			],
			[
				-162,
				-49
			],
			[
				-49,
				-29
			],
			[
				-16,
				-19
			],
			[
				17,
				-33
			],
			[
				129,
				-97
			],
			[
				22,
				-10
			],
			[
				19,
				-57
			],
			[
				114,
				-23
			],
			[
				47,
				-36
			],
			[
				40,
				-8
			],
			[
				87,
				3
			],
			[
				35,
				-13
			],
			[
				20,
				10
			],
			[
				11,
				18
			],
			[
				74,
				48
			],
			[
				24,
				21
			],
			[
				-15,
				29
			],
			[
				-15,
				23
			],
			[
				44,
				44
			],
			[
				54,
				43
			],
			[
				27,
				-1
			],
			[
				47,
				-27
			],
			[
				38,
				-37
			],
			[
				5,
				-29
			],
			[
				7,
				-21
			],
			[
				36,
				-44
			],
			[
				23,
				-16
			],
			[
				63,
				-9
			],
			[
				15,
				-17
			],
			[
				-12,
				-65
			],
			[
				10,
				-22
			],
			[
				65,
				-1
			],
			[
				70,
				5
			],
			[
				24,
				-2
			],
			[
				26,
				13
			],
			[
				38,
				15
			],
			[
				56,
				-5
			]
		],
		[
			[
				103271,
				86282
			],
			[
				-2,
				24
			],
			[
				-14,
				60
			],
			[
				-138,
				119
			],
			[
				-16,
				50
			],
			[
				5,
				19
			],
			[
				-9,
				32
			],
			[
				-30,
				19
			],
			[
				-109,
				22
			],
			[
				-27,
				-13
			],
			[
				-26,
				14
			],
			[
				-39,
				28
			],
			[
				-69,
				23
			],
			[
				-7,
				12
			],
			[
				-25,
				20
			],
			[
				-13,
				3
			],
			[
				-9,
				-12
			],
			[
				-20,
				-18
			],
			[
				-71,
				-22
			],
			[
				-28,
				9
			],
			[
				-25,
				19
			],
			[
				-29,
				42
			],
			[
				-43,
				36
			],
			[
				-35,
				13
			],
			[
				-20,
				19
			],
			[
				-4,
				15
			],
			[
				77,
				30
			],
			[
				17,
				30
			],
			[
				-10,
				56
			],
			[
				-11,
				7
			],
			[
				-31,
				-19
			],
			[
				-65,
				-16
			],
			[
				-59,
				-8
			],
			[
				-31,
				0
			],
			[
				-170,
				102
			],
			[
				-110,
				31
			],
			[
				-65,
				9
			],
			[
				-7,
				-10
			],
			[
				29,
				-57
			],
			[
				51,
				-71
			],
			[
				-3,
				-19
			],
			[
				-60,
				-28
			],
			[
				-35,
				-13
			],
			[
				-41,
				-24
			],
			[
				-34,
				-34
			],
			[
				-30,
				-16
			],
			[
				-26,
				4
			],
			[
				-27,
				17
			],
			[
				-71,
				104
			],
			[
				-89,
				80
			],
			[
				-10,
				18
			],
			[
				-28,
				4
			],
			[
				-39,
				18
			],
			[
				-13,
				24
			],
			[
				20,
				26
			],
			[
				27,
				23
			],
			[
				47,
				15
			],
			[
				15,
				13
			],
			[
				9,
				21
			],
			[
				17,
				26
			],
			[
				-4,
				10
			],
			[
				-34,
				29
			],
			[
				-51,
				29
			],
			[
				-139,
				-21
			],
			[
				-38,
				-16
			],
			[
				-22,
				20
			],
			[
				-16,
				29
			],
			[
				-36,
				5
			],
			[
				-48,
				26
			],
			[
				-57,
				26
			],
			[
				-56,
				8
			],
			[
				-116,
				37
			],
			[
				-45,
				2
			],
			[
				-26,
				12
			],
			[
				-27,
				28
			],
			[
				-23,
				31
			],
			[
				-12,
				63
			],
			[
				-86,
				28
			],
			[
				-85,
				18
			],
			[
				-6,
				-10
			],
			[
				3,
				-62
			],
			[
				-4,
				-34
			],
			[
				-56,
				-21
			],
			[
				-56,
				-2
			]
		],
		[
			[
				136950,
				78635
			],
			[
				2,
				-15
			],
			[
				-9,
				-27
			],
			[
				-135,
				-47
			],
			[
				-61,
				-39
			],
			[
				-13,
				-70
			],
			[
				-16,
				-20
			],
			[
				-27,
				-16
			],
			[
				-27,
				-4
			],
			[
				-41,
				82
			],
			[
				-47,
				17
			],
			[
				-68,
				29
			],
			[
				-131,
				56
			],
			[
				-67,
				24
			],
			[
				-131,
				-36
			],
			[
				-151,
				-51
			],
			[
				-24,
				-30
			],
			[
				-16,
				-33
			],
			[
				1,
				-24
			],
			[
				11,
				-34
			],
			[
				-7,
				-25
			],
			[
				-29,
				-8
			],
			[
				-43,
				31
			],
			[
				-37,
				17
			],
			[
				-19,
				-42
			],
			[
				-22,
				-74
			],
			[
				-10,
				-55
			],
			[
				33,
				-78
			],
			[
				11,
				-117
			],
			[
				61,
				7
			],
			[
				46,
				-1
			],
			[
				88,
				35
			],
			[
				44,
				1
			],
			[
				68,
				-15
			],
			[
				119,
				-3
			],
			[
				94,
				6
			],
			[
				22,
				-3
			],
			[
				23,
				22
			],
			[
				24,
				-7
			],
			[
				23,
				-27
			],
			[
				95,
				32
			],
			[
				71,
				5
			],
			[
				43,
				-10
			],
			[
				26,
				-9
			],
			[
				46,
				-77
			],
			[
				35,
				-48
			],
			[
				43,
				-15
			],
			[
				132,
				14
			],
			[
				39,
				67
			],
			[
				35,
				17
			],
			[
				54,
				5
			],
			[
				46,
				13
			],
			[
				35,
				28
			],
			[
				49,
				24
			],
			[
				43,
				4
			],
			[
				21,
				-17
			],
			[
				10,
				-24
			],
			[
				-8,
				-30
			],
			[
				-2,
				-32
			],
			[
				28,
				-21
			],
			[
				82,
				-5
			],
			[
				38,
				-20
			],
			[
				2,
				-37
			],
			[
				-6,
				-59
			],
			[
				34,
				-23
			],
			[
				18,
				-2
			],
			[
				120,
				62
			],
			[
				33,
				1
			],
			[
				27,
				-34
			],
			[
				41,
				-41
			],
			[
				53,
				-44
			],
			[
				13,
				6
			],
			[
				24,
				48
			],
			[
				45,
				52
			],
			[
				86,
				17
			],
			[
				47,
				17
			],
			[
				50,
				7
			],
			[
				150,
				-21
			],
			[
				50,
				-3
			],
			[
				103,
				4
			],
			[
				81,
				10
			],
			[
				66,
				32
			],
			[
				33,
				25
			],
			[
				53,
				14
			],
			[
				68,
				-2
			],
			[
				37,
				-7
			]
		],
		[
			[
				104026,
				78199
			],
			[
				14,
				1
			],
			[
				24,
				-10
			],
			[
				46,
				-31
			],
			[
				49,
				-6
			],
			[
				27,
				20
			],
			[
				15,
				19
			],
			[
				10,
				31
			],
			[
				4,
				36
			],
			[
				8,
				12
			],
			[
				38,
				-4
			],
			[
				12,
				8
			],
			[
				-1,
				33
			],
			[
				-24,
				40
			],
			[
				-21,
				50
			],
			[
				0,
				23
			],
			[
				17,
				10
			],
			[
				29,
				21
			],
			[
				16,
				27
			],
			[
				31,
				13
			],
			[
				46,
				3
			],
			[
				51,
				11
			],
			[
				33,
				29
			],
			[
				5,
				28
			],
			[
				21,
				78
			],
			[
				13,
				39
			],
			[
				22,
				34
			],
			[
				12,
				47
			],
			[
				23,
				45
			],
			[
				49,
				18
			],
			[
				44,
				22
			],
			[
				34,
				57
			],
			[
				19,
				49
			],
			[
				0,
				29
			],
			[
				-28,
				49
			],
			[
				-21,
				48
			],
			[
				6,
				61
			]
		],
		[
			[
				112555,
				33895
			],
			[
				-34,
				59
			],
			[
				-29,
				-15
			],
			[
				-40,
				-42
			],
			[
				-21,
				-11
			],
			[
				-11,
				1
			],
			[
				-7,
				11
			],
			[
				-9,
				27
			],
			[
				-31,
				77
			],
			[
				-34,
				54
			],
			[
				-36,
				22
			],
			[
				-30,
				25
			],
			[
				13,
				24
			],
			[
				14,
				18
			],
			[
				-6,
				18
			],
			[
				-17,
				26
			],
			[
				-64,
				38
			],
			[
				-1,
				16
			],
			[
				57,
				34
			],
			[
				36,
				39
			],
			[
				24,
				38
			],
			[
				31,
				82
			],
			[
				25,
				82
			],
			[
				19,
				27
			],
			[
				7,
				54
			],
			[
				-5,
				62
			],
			[
				13,
				78
			],
			[
				6,
				74
			],
			[
				-19,
				29
			],
			[
				-16,
				50
			],
			[
				19,
				85
			],
			[
				30,
				58
			],
			[
				143,
				61
			],
			[
				100,
				55
			],
			[
				21,
				24
			],
			[
				34,
				47
			],
			[
				19,
				46
			],
			[
				-14,
				14
			],
			[
				-78,
				1
			],
			[
				-19,
				18
			],
			[
				-57,
				161
			],
			[
				31,
				185
			],
			[
				3,
				73
			],
			[
				-1,
				90
			],
			[
				-10,
				66
			],
			[
				-25,
				27
			],
			[
				-15,
				36
			],
			[
				4,
				96
			],
			[
				23,
				12
			],
			[
				50,
				127
			],
			[
				22,
				76
			],
			[
				-26,
				60
			],
			[
				-30,
				85
			],
			[
				-13,
				55
			],
			[
				-7,
				18
			],
			[
				20,
				34
			],
			[
				34,
				32
			],
			[
				37,
				9
			],
			[
				40,
				16
			],
			[
				126,
				158
			],
			[
				1,
				31
			],
			[
				-22,
				53
			],
			[
				-47,
				81
			],
			[
				-11,
				33
			],
			[
				-5,
				96
			],
			[
				-19,
				29
			],
			[
				-69,
				65
			],
			[
				-53,
				68
			],
			[
				17,
				69
			],
			[
				9,
				76
			],
			[
				-26,
				42
			],
			[
				-39,
				43
			],
			[
				-25,
				63
			],
			[
				-11,
				47
			],
			[
				-30,
				18
			],
			[
				-29,
				1
			],
			[
				-20,
				-29
			],
			[
				-23,
				2
			],
			[
				-27,
				10
			],
			[
				-9,
				41
			],
			[
				-1,
				44
			],
			[
				-19,
				30
			],
			[
				-18,
				41
			],
			[
				-2,
				22
			]
		],
		[
			[
				105403,
				85370
			],
			[
				7,
				135
			],
			[
				98,
				96
			],
			[
				25,
				49
			],
			[
				36,
				106
			],
			[
				28,
				50
			],
			[
				33,
				41
			],
			[
				26,
				39
			],
			[
				10,
				34
			]
		],
		[
			[
				83668,
				51147
			],
			[
				34,
				37
			],
			[
				51,
				118
			],
			[
				70,
				114
			],
			[
				66,
				67
			],
			[
				52,
				70
			],
			[
				55,
				53
			],
			[
				79,
				62
			],
			[
				120,
				163
			],
			[
				29,
				19
			],
			[
				19,
				113
			],
			[
				30,
				144
			],
			[
				35,
				45
			],
			[
				82,
				27
			],
			[
				20,
				25
			],
			[
				29,
				101
			],
			[
				18,
				118
			],
			[
				2,
				26
			]
		],
		[
			[
				105873,
				54456
			],
			[
				46,
				-102
			],
			[
				22,
				-36
			],
			[
				188,
				-243
			],
			[
				37,
				-57
			],
			[
				93,
				-176
			],
			[
				57,
				-119
			],
			[
				65,
				-171
			],
			[
				7,
				-93
			],
			[
				-9,
				-79
			],
			[
				-13,
				-226
			],
			[
				-17,
				-65
			],
			[
				-83,
				-121
			],
			[
				-3,
				-55
			],
			[
				17,
				-45
			],
			[
				25,
				-19
			],
			[
				15,
				-23
			],
			[
				-9,
				-105
			],
			[
				30,
				-41
			],
			[
				62,
				-27
			],
			[
				156,
				-19
			],
			[
				82,
				-15
			],
			[
				95,
				-32
			],
			[
				17,
				-37
			],
			[
				-27,
				-121
			],
			[
				19,
				-76
			],
			[
				53,
				-64
			],
			[
				55,
				-27
			],
			[
				52,
				-16
			],
			[
				181,
				-39
			],
			[
				75,
				-45
			],
			[
				100,
				-142
			],
			[
				125,
				-130
			],
			[
				30,
				-69
			],
			[
				-6,
				-62
			],
			[
				-37,
				-76
			],
			[
				6,
				-31
			],
			[
				57,
				-76
			],
			[
				66,
				-77
			],
			[
				120,
				-86
			],
			[
				208,
				-136
			],
			[
				96,
				-90
			],
			[
				32,
				-69
			],
			[
				54,
				-74
			],
			[
				74,
				-68
			],
			[
				50,
				-53
			],
			[
				-34,
				-148
			],
			[
				10,
				-49
			],
			[
				18,
				-42
			],
			[
				44,
				-59
			],
			[
				17,
				-75
			],
			[
				43,
				-94
			],
			[
				52,
				-42
			],
			[
				85,
				-16
			],
			[
				46,
				-44
			],
			[
				94,
				-74
			],
			[
				91,
				-65
			],
			[
				39,
				-44
			],
			[
				24,
				-40
			],
			[
				21,
				-46
			],
			[
				10,
				-47
			],
			[
				3,
				-100
			],
			[
				15,
				-125
			],
			[
				49,
				-85
			],
			[
				46,
				-63
			]
		],
		[
			[
				108809,
				49665
			],
			[
				23,
				-58
			],
			[
				34,
				-59
			],
			[
				111,
				-100
			],
			[
				36,
				-56
			],
			[
				27,
				-62
			],
			[
				17,
				-48
			],
			[
				35,
				-39
			],
			[
				49,
				-25
			],
			[
				41,
				-29
			],
			[
				25,
				-44
			],
			[
				38,
				-45
			],
			[
				74,
				-61
			],
			[
				35,
				-2
			],
			[
				41,
				-8
			],
			[
				37,
				-16
			],
			[
				39,
				4
			],
			[
				62,
				40
			],
			[
				75,
				68
			],
			[
				56,
				41
			],
			[
				137,
				-14
			],
			[
				77,
				-34
			],
			[
				60,
				-48
			],
			[
				48,
				3
			],
			[
				103,
				88
			],
			[
				55,
				93
			],
			[
				53,
				20
			],
			[
				81,
				-40
			],
			[
				66,
				-87
			],
			[
				59,
				-127
			],
			[
				41,
				-49
			],
			[
				56,
				-75
			],
			[
				113,
				-161
			],
			[
				145,
				-81
			],
			[
				57,
				-40
			],
			[
				19,
				-40
			],
			[
				10,
				-53
			],
			[
				4,
				-57
			],
			[
				18,
				-24
			],
			[
				39,
				8
			],
			[
				34,
				8
			],
			[
				37,
				-16
			],
			[
				26,
				-42
			],
			[
				12,
				-33
			],
			[
				14,
				-35
			]
		],
		[
			[
				118836,
				54522
			],
			[
				82,
				161
			],
			[
				71,
				141
			],
			[
				56,
				111
			]
		],
		[
			[
				118836,
				54522
			],
			[
				-51,
				-1
			],
			[
				-39,
				9
			],
			[
				-27,
				28
			],
			[
				-56,
				29
			],
			[
				-63,
				2
			],
			[
				-60,
				-28
			],
			[
				-101,
				-34
			],
			[
				-92,
				-11
			],
			[
				-73,
				-19
			],
			[
				-62,
				-23
			],
			[
				-55,
				12
			],
			[
				-47,
				21
			],
			[
				-11,
				171
			],
			[
				-11,
				185
			],
			[
				1,
				145
			],
			[
				17,
				80
			],
			[
				15,
				32
			],
			[
				86,
				110
			],
			[
				30,
				45
			],
			[
				99,
				183
			],
			[
				85,
				157
			],
			[
				64,
				117
			]
		],
		[
			[
				110101,
				41782
			],
			[
				1,
				-39
			],
			[
				-24,
				-142
			],
			[
				-27,
				-138
			],
			[
				-2,
				-52
			],
			[
				13,
				-69
			],
			[
				50,
				-159
			],
			[
				36,
				-116
			],
			[
				18,
				-70
			],
			[
				25,
				-81
			],
			[
				33,
				-125
			],
			[
				9,
				-59
			],
			[
				-7,
				-44
			],
			[
				-68,
				-156
			],
			[
				-7,
				-49
			],
			[
				17,
				-122
			],
			[
				22,
				-117
			],
			[
				32,
				-66
			],
			[
				77,
				-184
			],
			[
				57,
				-61
			],
			[
				106,
				-92
			],
			[
				93,
				-92
			],
			[
				36,
				-48
			],
			[
				33,
				-54
			],
			[
				65,
				-137
			],
			[
				40,
				-111
			],
			[
				20,
				-100
			],
			[
				51,
				-138
			],
			[
				48,
				-127
			],
			[
				61,
				-156
			],
			[
				43,
				-110
			],
			[
				20,
				-74
			]
		],
		[
			[
				118485,
				55732
			],
			[
				19,
				23
			],
			[
				27,
				22
			],
			[
				19,
				-6
			],
			[
				123,
				-113
			],
			[
				22,
				3
			],
			[
				41,
				35
			],
			[
				37,
				121
			],
			[
				26,
				44
			],
			[
				12,
				-1
			],
			[
				79,
				34
			],
			[
				71,
				38
			]
		],
		[
			[
				100029,
				85668
			],
			[
				18,
				-6
			],
			[
				53,
				-26
			],
			[
				42,
				-29
			],
			[
				39,
				-74
			],
			[
				90,
				-20
			],
			[
				115,
				-2
			],
			[
				41,
				33
			],
			[
				38,
				8
			],
			[
				42,
				-11
			],
			[
				88,
				-11
			],
			[
				10,
				60
			],
			[
				52,
				62
			],
			[
				23,
				22
			],
			[
				65,
				-2
			],
			[
				16,
				46
			],
			[
				16,
				129
			],
			[
				14,
				14
			],
			[
				47,
				-2
			],
			[
				47,
				-24
			],
			[
				14,
				-19
			],
			[
				25,
				2
			],
			[
				34,
				13
			],
			[
				38,
				8
			],
			[
				59,
				-14
			],
			[
				127,
				-58
			],
			[
				66,
				-22
			],
			[
				41,
				4
			],
			[
				39,
				0
			],
			[
				150,
				-91
			],
			[
				105,
				-13
			],
			[
				95,
				0
			],
			[
				31,
				27
			],
			[
				41,
				24
			],
			[
				42,
				-4
			],
			[
				37,
				-12
			],
			[
				73,
				-39
			],
			[
				33,
				-10
			],
			[
				44,
				-6
			],
			[
				33,
				-9
			],
			[
				29,
				-68
			],
			[
				16,
				-18
			]
		],
		[
			[
				118472,
				76054
			],
			[
				63,
				16
			],
			[
				116,
				100
			],
			[
				68,
				93
			],
			[
				21,
				8
			],
			[
				61,
				-31
			],
			[
				44,
				-8
			],
			[
				101,
				35
			],
			[
				60,
				-18
			],
			[
				50,
				-24
			],
			[
				28,
				-1
			],
			[
				135,
				-58
			],
			[
				34,
				-7
			],
			[
				70,
				-7
			],
			[
				103,
				-3
			],
			[
				67,
				37
			],
			[
				48,
				37
			],
			[
				33,
				-1
			],
			[
				32,
				-9
			],
			[
				27,
				-15
			],
			[
				23,
				-28
			],
			[
				11,
				-39
			],
			[
				-5,
				-124
			],
			[
				11,
				-33
			],
			[
				18,
				-24
			],
			[
				23,
				-4
			],
			[
				29,
				27
			],
			[
				49,
				39
			],
			[
				61,
				43
			],
			[
				45,
				40
			],
			[
				26,
				14
			],
			[
				41,
				-2
			],
			[
				39,
				-6
			],
			[
				23,
				-19
			]
		],
		[
			[
				101501,
				84098
			],
			[
				103,
				90
			],
			[
				51,
				25
			],
			[
				60,
				-5
			],
			[
				19,
				9
			],
			[
				5,
				13
			],
			[
				10,
				29
			],
			[
				5,
				27
			],
			[
				5,
				26
			],
			[
				-6,
				15
			],
			[
				-29,
				4
			],
			[
				-14,
				64
			],
			[
				15,
				24
			],
			[
				15,
				17
			],
			[
				-18,
				78
			],
			[
				5,
				26
			],
			[
				47,
				5
			],
			[
				38,
				16
			],
			[
				32,
				19
			],
			[
				8,
				24
			],
			[
				26,
				49
			],
			[
				-24,
				60
			],
			[
				-134,
				39
			],
			[
				-7,
				15
			],
			[
				31,
				17
			],
			[
				34,
				24
			],
			[
				19,
				19
			],
			[
				26,
				3
			],
			[
				36,
				-10
			],
			[
				65,
				-43
			],
			[
				25,
				-6
			],
			[
				24,
				12
			],
			[
				25,
				3
			],
			[
				72,
				-2
			],
			[
				60,
				10
			],
			[
				-13,
				47
			],
			[
				0,
				33
			],
			[
				-10,
				27
			],
			[
				6,
				30
			],
			[
				24,
				23
			],
			[
				8,
				52
			],
			[
				37,
				35
			]
		],
		[
			[
				95640,
				83325
			],
			[
				22,
				-18
			],
			[
				47,
				-19
			],
			[
				129,
				26
			],
			[
				80,
				27
			],
			[
				56,
				27
			],
			[
				35,
				-5
			],
			[
				126,
				-41
			],
			[
				42,
				21
			],
			[
				91,
				56
			],
			[
				13,
				30
			],
			[
				72,
				90
			],
			[
				1,
				22
			],
			[
				-29,
				56
			],
			[
				9,
				13
			],
			[
				88,
				58
			],
			[
				43,
				51
			],
			[
				47,
				34
			],
			[
				33,
				1
			],
			[
				9,
				-12
			],
			[
				4,
				-24
			],
			[
				-3,
				-98
			],
			[
				13,
				-31
			],
			[
				69,
				-71
			],
			[
				50,
				-40
			],
			[
				114,
				-28
			],
			[
				5,
				-13
			],
			[
				-31,
				-54
			],
			[
				69,
				-64
			],
			[
				12,
				-47
			],
			[
				32,
				-26
			],
			[
				46,
				13
			],
			[
				14,
				25
			],
			[
				-17,
				43
			],
			[
				-13,
				45
			],
			[
				2,
				27
			],
			[
				13,
				30
			],
			[
				31,
				42
			],
			[
				86,
				96
			],
			[
				30,
				56
			],
			[
				6,
				86
			],
			[
				0,
				69
			],
			[
				29,
				17
			],
			[
				61,
				-12
			],
			[
				19,
				1
			],
			[
				8,
				-42
			],
			[
				26,
				-68
			],
			[
				31,
				-35
			],
			[
				33,
				-8
			],
			[
				38,
				-1
			],
			[
				96,
				42
			],
			[
				63,
				18
			],
			[
				35,
				-5
			],
			[
				21,
				-28
			],
			[
				45,
				-74
			],
			[
				25,
				-9
			],
			[
				31,
				9
			],
			[
				11,
				12
			],
			[
				-10,
				29
			],
			[
				-13,
				62
			],
			[
				-18,
				47
			],
			[
				-23,
				23
			],
			[
				-5,
				29
			],
			[
				15,
				52
			],
			[
				17,
				44
			],
			[
				32,
				12
			],
			[
				38,
				6
			],
			[
				49,
				-47
			],
			[
				59,
				-15
			],
			[
				44,
				3
			],
			[
				7,
				27
			],
			[
				-2,
				30
			],
			[
				-27,
				38
			],
			[
				6,
				57
			],
			[
				30,
				108
			]
		],
		[
			[
				97857,
				84100
			],
			[
				1,
				28
			],
			[
				-26,
				54
			],
			[
				-42,
				16
			],
			[
				-109,
				-101
			],
			[
				-30,
				-8
			],
			[
				-89,
				27
			],
			[
				-77,
				44
			],
			[
				-8,
				31
			],
			[
				-13,
				26
			],
			[
				-64,
				25
			],
			[
				-81,
				16
			],
			[
				-26,
				0
			]
		],
		[
			[
				120027,
				76082
			],
			[
				1,
				11
			],
			[
				-6,
				50
			],
			[
				25,
				44
			],
			[
				-2,
				17
			],
			[
				-51,
				55
			],
			[
				-71,
				55
			],
			[
				-20,
				9
			],
			[
				-1,
				59
			],
			[
				3,
				44
			],
			[
				-6,
				40
			],
			[
				-14,
				23
			],
			[
				-1,
				18
			],
			[
				29,
				43
			],
			[
				-18,
				28
			],
			[
				-106,
				70
			],
			[
				-40,
				35
			],
			[
				-73,
				7
			],
			[
				-7,
				23
			],
			[
				11,
				49
			],
			[
				25,
				59
			],
			[
				40,
				58
			],
			[
				13,
				31
			],
			[
				15,
				52
			],
			[
				5,
				37
			],
			[
				45,
				52
			],
			[
				0,
				14
			],
			[
				-12,
				18
			],
			[
				-36,
				11
			],
			[
				-36,
				4
			],
			[
				-14,
				9
			],
			[
				-5,
				28
			],
			[
				5,
				114
			],
			[
				-12,
				68
			],
			[
				-15,
				50
			],
			[
				10,
				111
			],
			[
				-26,
				23
			],
			[
				-39,
				58
			],
			[
				-17,
				50
			],
			[
				9,
				18
			],
			[
				8,
				33
			],
			[
				6,
				43
			],
			[
				-2,
				30
			],
			[
				-36,
				30
			],
			[
				-28,
				31
			],
			[
				-3,
				34
			],
			[
				-11,
				42
			],
			[
				-15,
				33
			],
			[
				-7,
				22
			],
			[
				14,
				13
			],
			[
				51,
				10
			],
			[
				76,
				-7
			],
			[
				61,
				-1
			],
			[
				35,
				22
			],
			[
				43,
				201
			],
			[
				39,
				54
			],
			[
				46,
				30
			],
			[
				89,
				-71
			],
			[
				37,
				-25
			],
			[
				22,
				-1
			]
		],
		[
			[
				106277,
				89934
			],
			[
				-5,
				16
			],
			[
				4,
				39
			],
			[
				-1,
				60
			],
			[
				-18,
				53
			],
			[
				-54,
				47
			],
			[
				-57,
				33
			],
			[
				-72,
				34
			],
			[
				-54,
				15
			],
			[
				-29,
				4
			],
			[
				-7,
				19
			],
			[
				-10,
				17
			],
			[
				-25,
				15
			],
			[
				-54,
				20
			],
			[
				-45,
				4
			],
			[
				-37,
				-32
			]
		],
		[
			[
				110972,
				38694
			],
			[
				16,
				-59
			],
			[
				35,
				-99
			],
			[
				40,
				-73
			],
			[
				49,
				-64
			],
			[
				42,
				-38
			],
			[
				28,
				-12
			],
			[
				177,
				4
			],
			[
				64,
				-38
			],
			[
				55,
				-49
			],
			[
				14,
				-76
			],
			[
				37,
				-48
			],
			[
				39,
				-38
			],
			[
				17,
				-4
			],
			[
				29,
				9
			],
			[
				47,
				1
			],
			[
				44,
				-17
			],
			[
				21,
				-16
			],
			[
				2,
				-64
			],
			[
				14,
				-28
			],
			[
				60,
				-11
			],
			[
				61,
				-5
			],
			[
				59,
				-43
			],
			[
				63,
				-8
			],
			[
				74,
				-18
			],
			[
				35,
				-46
			],
			[
				78,
				-48
			],
			[
				96,
				-43
			],
			[
				69,
				-48
			],
			[
				36,
				-22
			]
		],
		[
			[
				95754,
				89392
			],
			[
				-6,
				-79
			],
			[
				1,
				-154
			],
			[
				-7,
				-28
			],
			[
				-40,
				-65
			],
			[
				-43,
				-117
			],
			[
				-12,
				-77
			],
			[
				-12,
				-15
			],
			[
				-171,
				0
			],
			[
				-25,
				-13
			],
			[
				-3,
				-17
			],
			[
				8,
				-20
			],
			[
				-4,
				-19
			],
			[
				-13,
				-16
			],
			[
				7,
				-26
			],
			[
				30,
				-29
			],
			[
				54,
				-18
			],
			[
				58,
				-2
			],
			[
				29,
				4
			],
			[
				22,
				-21
			],
			[
				22,
				-32
			],
			[
				-2,
				-40
			],
			[
				-8,
				-54
			],
			[
				-28,
				-50
			],
			[
				-79,
				-58
			],
			[
				-35,
				-20
			],
			[
				-33,
				-10
			],
			[
				-16,
				-15
			],
			[
				-7,
				-20
			],
			[
				1,
				-17
			],
			[
				56,
				-46
			],
			[
				-1,
				-11
			],
			[
				-16,
				-24
			],
			[
				-22,
				-22
			],
			[
				-145,
				-47
			],
			[
				-60,
				4
			],
			[
				-34,
				-24
			],
			[
				-10,
				-4
			],
			[
				-38,
				21
			],
			[
				-84,
				25
			],
			[
				-32,
				-9
			],
			[
				-18,
				-13
			],
			[
				-53,
				-17
			],
			[
				-38,
				-25
			],
			[
				0,
				-34
			],
			[
				67,
				-85
			],
			[
				24,
				-17
			],
			[
				1,
				-32
			],
			[
				32,
				-41
			],
			[
				34,
				-50
			],
			[
				3,
				-32
			],
			[
				-3,
				-33
			],
			[
				-18,
				-46
			],
			[
				-58,
				-107
			],
			[
				-1,
				-21
			],
			[
				5,
				-16
			],
			[
				20,
				-4
			],
			[
				15,
				-8
			],
			[
				-4,
				-15
			],
			[
				-109,
				-75
			],
			[
				-14,
				-13
			],
			[
				-46,
				4
			],
			[
				-7,
				-12
			],
			[
				6,
				-21
			],
			[
				18,
				-17
			],
			[
				39,
				-10
			],
			[
				33,
				-19
			],
			[
				27,
				-37
			],
			[
				-35,
				-127
			]
		],
		[
			[
				97293,
				84258
			],
			[
				10,
				16
			],
			[
				10,
				25
			],
			[
				-6,
				21
			],
			[
				-19,
				21
			],
			[
				-11,
				23
			],
			[
				-3,
				22
			],
			[
				-5,
				18
			],
			[
				-4,
				17
			],
			[
				-6,
				13
			]
		],
		[
			[
				85620,
				51685
			],
			[
				37,
				35
			],
			[
				50,
				-9
			],
			[
				78,
				-28
			],
			[
				16,
				28
			],
			[
				59,
				140
			],
			[
				-2,
				52
			],
			[
				-6,
				37
			],
			[
				35,
				96
			],
			[
				27,
				37
			],
			[
				14,
				40
			],
			[
				-4,
				55
			],
			[
				-21,
				21
			],
			[
				-27,
				-4
			],
			[
				-33,
				13
			],
			[
				-49,
				32
			],
			[
				-25,
				28
			],
			[
				8,
				127
			],
			[
				4,
				39
			],
			[
				18,
				23
			],
			[
				27,
				6
			],
			[
				77,
				4
			],
			[
				62,
				-14
			],
			[
				54,
				-9
			],
			[
				29,
				0
			],
			[
				24,
				-37
			],
			[
				31,
				-39
			],
			[
				28,
				0
			],
			[
				9,
				29
			],
			[
				-6,
				125
			],
			[
				-18,
				67
			],
			[
				-42,
				64
			],
			[
				-108,
				54
			],
			[
				-3,
				77
			],
			[
				11,
				83
			],
			[
				24,
				30
			],
			[
				80,
				53
			],
			[
				-14,
				28
			],
			[
				-26,
				30
			],
			[
				-51,
				31
			],
			[
				12,
				99
			],
			[
				2,
				88
			],
			[
				-43,
				-10
			],
			[
				-44,
				-5
			],
			[
				-37,
				27
			],
			[
				-31,
				54
			],
			[
				-6,
				148
			],
			[
				0,
				170
			],
			[
				-6,
				76
			],
			[
				12,
				40
			],
			[
				38,
				37
			],
			[
				42,
				48
			],
			[
				14,
				31
			]
		],
		[
			[
				95945,
				81545
			],
			[
				-2,
				46
			],
			[
				-6,
				35
			],
			[
				27,
				38
			],
			[
				43,
				44
			],
			[
				40,
				57
			],
			[
				17,
				41
			],
			[
				-8,
				27
			],
			[
				-18,
				40
			],
			[
				-25,
				3
			],
			[
				-147,
				-34
			],
			[
				-34,
				9
			],
			[
				-109,
				52
			],
			[
				-118,
				65
			],
			[
				-43,
				46
			],
			[
				-17,
				46
			],
			[
				12,
				30
			],
			[
				-9,
				29
			],
			[
				-23,
				39
			],
			[
				20,
				45
			],
			[
				37,
				55
			],
			[
				18,
				37
			],
			[
				31,
				10
			],
			[
				15,
				23
			],
			[
				-25,
				91
			],
			[
				-13,
				15
			],
			[
				-21,
				11
			],
			[
				-32,
				1
			],
			[
				-57,
				19
			],
			[
				-41,
				32
			],
			[
				-9,
				42
			],
			[
				-21,
				41
			],
			[
				-37,
				38
			],
			[
				-5,
				41
			],
			[
				42,
				22
			],
			[
				57,
				0
			],
			[
				40,
				-7
			],
			[
				90,
				65
			],
			[
				33,
				6
			],
			[
				30,
				15
			],
			[
				24,
				89
			],
			[
				20,
				27
			],
			[
				4,
				16
			],
			[
				-17,
				19
			],
			[
				-73,
				63
			],
			[
				-33,
				66
			],
			[
				-53,
				74
			],
			[
				-48,
				33
			],
			[
				-10,
				26
			],
			[
				-1,
				32
			],
			[
				10,
				28
			],
			[
				88,
				45
			],
			[
				52,
				47
			]
		],
		[
			[
				109818,
				102372
			],
			[
				-43,
				-10
			],
			[
				-133,
				-40
			],
			[
				-82,
				-27
			],
			[
				-98,
				-20
			],
			[
				25,
				-26
			],
			[
				163,
				-6
			],
			[
				26,
				-7
			],
			[
				18,
				-14
			],
			[
				3,
				-22
			],
			[
				-17,
				-35
			],
			[
				-176,
				-192
			],
			[
				-5,
				-41
			],
			[
				57,
				-113
			],
			[
				81,
				-133
			],
			[
				244,
				-60
			],
			[
				182,
				-46
			],
			[
				116,
				-109
			],
			[
				192,
				-145
			],
			[
				102,
				-54
			],
			[
				6,
				-16
			],
			[
				-30,
				-100
			],
			[
				-124,
				-100
			],
			[
				-115,
				-84
			],
			[
				-119,
				-101
			],
			[
				-93,
				-87
			],
			[
				-101,
				-103
			],
			[
				-12,
				-34
			],
			[
				-2,
				-32
			],
			[
				18,
				-35
			],
			[
				129,
				-127
			],
			[
				50,
				-64
			],
			[
				61,
				-70
			],
			[
				51,
				-77
			],
			[
				30,
				-68
			],
			[
				52,
				-66
			],
			[
				32,
				-34
			],
			[
				54,
				-48
			],
			[
				64,
				-71
			],
			[
				22,
				-56
			],
			[
				97,
				-195
			],
			[
				10,
				-50
			],
			[
				-5,
				-37
			],
			[
				-43,
				-9
			],
			[
				-94,
				-6
			],
			[
				-103,
				-24
			],
			[
				-5,
				-8
			],
			[
				67,
				-46
			],
			[
				-59,
				-78
			],
			[
				-9,
				-113
			],
			[
				-63,
				-59
			],
			[
				-6,
				-14
			],
			[
				3,
				-11
			],
			[
				11,
				-9
			],
			[
				117,
				-16
			],
			[
				10,
				-16
			],
			[
				1,
				-33
			],
			[
				-11,
				-31
			],
			[
				-58,
				-23
			],
			[
				-63,
				-33
			],
			[
				-14,
				-31
			],
			[
				2,
				-28
			],
			[
				21,
				-47
			],
			[
				42,
				-54
			],
			[
				53,
				-34
			],
			[
				187,
				-33
			],
			[
				24,
				-26
			],
			[
				10,
				-37
			],
			[
				-4,
				-36
			],
			[
				-87,
				-72
			],
			[
				1,
				-27
			],
			[
				36,
				-67
			],
			[
				42,
				-64
			],
			[
				183,
				-69
			],
			[
				63,
				-37
			],
			[
				17,
				-31
			],
			[
				9,
				-48
			],
			[
				-1,
				-53
			],
			[
				-15,
				-47
			],
			[
				-57,
				-60
			],
			[
				-133,
				-119
			],
			[
				-133,
				-46
			],
			[
				-8,
				-10
			],
			[
				41,
				-38
			],
			[
				235,
				-153
			],
			[
				153,
				-71
			],
			[
				206,
				-96
			],
			[
				134,
				-76
			],
			[
				43,
				-55
			],
			[
				57,
				-61
			],
			[
				65,
				-50
			],
			[
				47,
				-43
			],
			[
				17,
				-28
			],
			[
				-1,
				-30
			],
			[
				-63,
				-90
			],
			[
				-35,
				-69
			],
			[
				-63,
				-103
			],
			[
				-64,
				-71
			],
			[
				-162,
				-130
			],
			[
				-239,
				-162
			],
			[
				-55,
				-49
			],
			[
				-112,
				-85
			],
			[
				-192,
				-171
			],
			[
				-50,
				-38
			],
			[
				-157,
				-136
			],
			[
				-71,
				-44
			],
			[
				-56,
				-40
			],
			[
				-156,
				-129
			],
			[
				-167,
				-98
			],
			[
				-164,
				-91
			],
			[
				-49,
				-46
			],
			[
				-62,
				-35
			],
			[
				-73,
				-34
			],
			[
				-30,
				-19
			],
			[
				-165,
				-124
			],
			[
				-229,
				-173
			],
			[
				-43,
				-66
			]
		],
		[
			[
				111049,
				103000
			],
			[
				35,
				-109
			],
			[
				-1,
				-38
			],
			[
				-17,
				-36
			],
			[
				-23,
				-19
			],
			[
				-47,
				-8
			],
			[
				-112,
				3
			],
			[
				-152,
				43
			],
			[
				-98,
				41
			],
			[
				-31,
				1
			],
			[
				-13,
				-5
			],
			[
				24,
				-40
			],
			[
				-7,
				-32
			],
			[
				-15,
				-33
			],
			[
				-20,
				-31
			],
			[
				-29,
				-26
			],
			[
				-60,
				-33
			],
			[
				-104,
				-27
			],
			[
				-288,
				-51
			],
			[
				-22,
				-23
			],
			[
				-93,
				-143
			],
			[
				-25,
				-21
			],
			[
				-34,
				-18
			],
			[
				-99,
				-23
			]
		],
		[
			[
				126760,
				64175
			],
			[
				5,
				120
			],
			[
				-1,
				60
			],
			[
				5,
				92
			],
			[
				45,
				128
			],
			[
				54,
				163
			],
			[
				39,
				109
			],
			[
				34,
				94
			],
			[
				27,
				75
			],
			[
				15,
				78
			],
			[
				-8,
				55
			],
			[
				-18,
				20
			],
			[
				-15,
				26
			],
			[
				51,
				41
			],
			[
				96,
				27
			],
			[
				54,
				-5
			],
			[
				74,
				20
			],
			[
				59,
				18
			],
			[
				4,
				24
			],
			[
				-16,
				41
			],
			[
				-25,
				60
			],
			[
				-83,
				6
			],
			[
				-25,
				17
			],
			[
				29,
				88
			],
			[
				-1,
				28
			],
			[
				-11,
				33
			],
			[
				-12,
				55
			],
			[
				6,
				72
			],
			[
				17,
				48
			],
			[
				0,
				39
			],
			[
				-8,
				81
			],
			[
				3,
				71
			],
			[
				17,
				36
			],
			[
				31,
				33
			],
			[
				29,
				17
			],
			[
				31,
				-1
			],
			[
				24,
				-14
			],
			[
				10,
				-38
			],
			[
				-6,
				-26
			],
			[
				-18,
				-3
			],
			[
				-6,
				-11
			],
			[
				25,
				-50
			],
			[
				36,
				-49
			],
			[
				27,
				8
			],
			[
				31,
				38
			],
			[
				33,
				32
			],
			[
				41,
				27
			],
			[
				29,
				53
			],
			[
				26,
				35
			],
			[
				22,
				5
			]
		],
		[
			[
				122487,
				79959
			],
			[
				-35,
				-53
			],
			[
				-57,
				-96
			],
			[
				-25,
				-51
			],
			[
				-61,
				-47
			],
			[
				-100,
				-49
			],
			[
				-56,
				-22
			],
			[
				-60,
				-103
			],
			[
				-66,
				-100
			],
			[
				-45,
				-11
			],
			[
				-129,
				16
			],
			[
				-46,
				9
			],
			[
				-131,
				44
			],
			[
				-37,
				27
			],
			[
				-36,
				116
			],
			[
				-40,
				50
			],
			[
				-51,
				31
			],
			[
				-35,
				27
			],
			[
				-14,
				28
			],
			[
				-37,
				41
			],
			[
				-68,
				60
			],
			[
				-49,
				57
			],
			[
				-39,
				16
			],
			[
				-48,
				-21
			],
			[
				-28,
				-5
			],
			[
				-13,
				10
			],
			[
				-9,
				48
			],
			[
				-70,
				17
			]
		],
		[
			[
				55815,
				47370
			],
			[
				-29,
				1
			],
			[
				-23,
				26
			],
			[
				-4,
				32
			],
			[
				-12,
				36
			],
			[
				-29,
				11
			],
			[
				-55,
				-13
			],
			[
				-16,
				9
			],
			[
				-33,
				39
			],
			[
				-27,
				42
			],
			[
				-6,
				40
			],
			[
				-18,
				-3
			],
			[
				-41,
				-37
			],
			[
				-29,
				-8
			],
			[
				-22,
				10
			],
			[
				-25,
				-3
			],
			[
				-64,
				-39
			],
			[
				-37,
				-9
			],
			[
				-27,
				-40
			],
			[
				-177,
				-18
			],
			[
				-46,
				-10
			],
			[
				-105,
				68
			],
			[
				-28,
				23
			],
			[
				-14,
				3
			],
			[
				-11,
				-4
			],
			[
				-12,
				-15
			],
			[
				-17,
				-87
			],
			[
				-16,
				-23
			],
			[
				-28,
				-19
			],
			[
				-27,
				-34
			],
			[
				-5,
				-34
			],
			[
				41,
				-18
			],
			[
				35,
				-65
			],
			[
				38,
				-52
			],
			[
				30,
				-46
			],
			[
				-4,
				-52
			],
			[
				-6,
				-73
			],
			[
				-21,
				-25
			],
			[
				-37,
				-13
			],
			[
				-134,
				36
			],
			[
				-102,
				32
			],
			[
				-44,
				7
			],
			[
				-19,
				8
			]
		],
		[
			[
				121102,
				79998
			],
			[
				-16,
				-30
			],
			[
				-37,
				-53
			],
			[
				-29,
				-28
			],
			[
				-33,
				-4
			],
			[
				-32,
				-12
			],
			[
				-12,
				-29
			],
			[
				-1,
				-37
			],
			[
				6,
				-27
			],
			[
				8,
				-10
			],
			[
				33,
				-8
			],
			[
				33,
				-78
			],
			[
				51,
				-40
			],
			[
				80,
				-45
			],
			[
				71,
				-51
			],
			[
				35,
				-47
			],
			[
				-7,
				-34
			],
			[
				-23,
				-70
			],
			[
				-59,
				-59
			],
			[
				-50,
				-15
			],
			[
				-17,
				5
			],
			[
				-33,
				19
			],
			[
				-65,
				45
			],
			[
				-70,
				36
			],
			[
				-55,
				-11
			],
			[
				-35,
				-14
			],
			[
				-71,
				16
			],
			[
				-83,
				31
			],
			[
				-44,
				31
			],
			[
				-19,
				22
			],
			[
				13,
				40
			],
			[
				-190,
				73
			],
			[
				-91,
				20
			],
			[
				-41,
				-22
			],
			[
				-140,
				-109
			]
		],
		[
			[
				83744,
				55681
			],
			[
				5,
				62
			],
			[
				-43,
				43
			],
			[
				-1,
				21
			],
			[
				4,
				58
			],
			[
				19,
				122
			],
			[
				-2,
				46
			],
			[
				18,
				91
			],
			[
				-28,
				41
			],
			[
				-7,
				30
			],
			[
				-31,
				49
			],
			[
				-37,
				68
			],
			[
				-8,
				55
			],
			[
				-13,
				44
			],
			[
				-34,
				66
			],
			[
				-26,
				10
			],
			[
				-54,
				10
			],
			[
				-9,
				-22
			],
			[
				-20,
				-33
			],
			[
				-18,
				-10
			],
			[
				-30,
				41
			],
			[
				-11,
				34
			],
			[
				0,
				32
			],
			[
				-40,
				54
			],
			[
				-63,
				101
			],
			[
				6,
				83
			],
			[
				39,
				45
			],
			[
				12,
				34
			],
			[
				3,
				38
			],
			[
				-17,
				46
			],
			[
				-21,
				36
			],
			[
				6,
				80
			],
			[
				-6,
				111
			],
			[
				-31,
				56
			],
			[
				-29,
				40
			],
			[
				-40,
				44
			],
			[
				-35,
				68
			],
			[
				14,
				93
			],
			[
				13,
				63
			],
			[
				-60,
				133
			]
		],
		[
			[
				55815,
				47370
			],
			[
				16,
				-11
			],
			[
				26,
				-17
			],
			[
				23,
				-39
			],
			[
				53,
				-31
			],
			[
				91,
				-44
			],
			[
				42,
				-1
			],
			[
				39,
				-13
			],
			[
				24,
				-14
			],
			[
				26,
				25
			],
			[
				93,
				67
			],
			[
				45,
				38
			],
			[
				30,
				29
			],
			[
				23,
				27
			],
			[
				17,
				7
			],
			[
				12,
				-16
			],
			[
				10,
				-22
			],
			[
				33,
				-13
			],
			[
				77,
				-25
			],
			[
				35,
				-8
			],
			[
				50,
				22
			],
			[
				43,
				37
			],
			[
				20,
				13
			],
			[
				32,
				-37
			],
			[
				21,
				-52
			],
			[
				15,
				-22
			],
			[
				32,
				5
			],
			[
				63,
				-8
			],
			[
				47,
				-17
			],
			[
				29,
				2
			],
			[
				40,
				23
			],
			[
				21,
				45
			],
			[
				56,
				42
			],
			[
				54,
				38
			],
			[
				30,
				52
			],
			[
				46,
				85
			],
			[
				15,
				36
			],
			[
				3,
				62
			],
			[
				64,
				178
			],
			[
				24,
				33
			],
			[
				14,
				56
			],
			[
				26,
				66
			],
			[
				0,
				54
			],
			[
				19,
				53
			],
			[
				36,
				46
			],
			[
				27,
				28
			],
			[
				43,
				77
			],
			[
				30,
				72
			],
			[
				76,
				161
			],
			[
				5,
				45
			],
			[
				30,
				27
			],
			[
				10,
				35
			],
			[
				32,
				43
			],
			[
				34,
				33
			],
			[
				14,
				50
			],
			[
				25,
				52
			],
			[
				54,
				39
			],
			[
				20,
				17
			]
		],
		[
			[
				92852,
				50704
			],
			[
				1,
				48
			],
			[
				18,
				139
			],
			[
				11,
				54
			],
			[
				14,
				41
			],
			[
				-14,
				50
			],
			[
				-14,
				67
			],
			[
				-6,
				105
			],
			[
				17,
				32
			],
			[
				5,
				40
			],
			[
				-4,
				62
			],
			[
				0,
				208
			],
			[
				10,
				22
			],
			[
				12,
				18
			],
			[
				1,
				27
			],
			[
				-22,
				54
			],
			[
				-21,
				61
			],
			[
				1,
				88
			],
			[
				-8,
				86
			],
			[
				-14,
				39
			],
			[
				10,
				145
			],
			[
				6,
				184
			],
			[
				-5,
				81
			],
			[
				13,
				58
			],
			[
				7,
				142
			],
			[
				-1,
				139
			],
			[
				27,
				219
			],
			[
				80,
				11
			],
			[
				95,
				18
			],
			[
				42,
				87
			],
			[
				24,
				109
			],
			[
				-7,
				108
			],
			[
				18,
				35
			],
			[
				38,
				59
			],
			[
				68,
				83
			],
			[
				-2,
				92
			],
			[
				19,
				29
			],
			[
				32,
				21
			],
			[
				47,
				11
			],
			[
				52,
				46
			],
			[
				29,
				80
			],
			[
				28,
				128
			],
			[
				-45,
				89
			],
			[
				1,
				20
			],
			[
				17,
				48
			],
			[
				27,
				48
			],
			[
				22,
				16
			],
			[
				51,
				-13
			],
			[
				8,
				4
			],
			[
				8,
				15
			],
			[
				33,
				142
			],
			[
				-3,
				38
			],
			[
				-47,
				95
			],
			[
				-8,
				67
			],
			[
				-7,
				100
			],
			[
				-12,
				89
			],
			[
				-13,
				34
			],
			[
				-25,
				28
			],
			[
				-12,
				18
			],
			[
				-97,
				181
			],
			[
				2,
				85
			],
			[
				40,
				110
			],
			[
				27,
				53
			]
		],
		[
			[
				99550,
				41629
			],
			[
				-16,
				13
			],
			[
				-50,
				55
			],
			[
				-58,
				88
			],
			[
				-21,
				14
			],
			[
				-33,
				-2
			],
			[
				-51,
				-32
			],
			[
				-50,
				-51
			],
			[
				-90,
				-46
			],
			[
				-76,
				-26
			],
			[
				-7,
				-32
			],
			[
				-17,
				-55
			],
			[
				-25,
				-34
			],
			[
				-67,
				-11
			],
			[
				-24,
				-48
			],
			[
				-58,
				-95
			],
			[
				-39,
				-43
			]
		],
		[
			[
				101775,
				83799
			],
			[
				-58,
				20
			],
			[
				-68,
				8
			],
			[
				-13,
				-11
			],
			[
				-28,
				-11
			],
			[
				-14,
				-20
			],
			[
				11,
				-78
			],
			[
				-17,
				-13
			],
			[
				-78,
				8
			],
			[
				-26,
				-9
			],
			[
				-43,
				-55
			],
			[
				-43,
				-23
			],
			[
				-55,
				-16
			],
			[
				-41,
				-20
			],
			[
				-52,
				-17
			],
			[
				-44,
				-10
			],
			[
				-18,
				-24
			],
			[
				-10,
				-26
			],
			[
				3,
				-26
			],
			[
				44,
				-50
			],
			[
				6,
				-53
			],
			[
				-4,
				-65
			],
			[
				-11,
				-35
			],
			[
				-17,
				-24
			],
			[
				-111,
				-30
			],
			[
				-114,
				-53
			],
			[
				-3,
				-12
			],
			[
				52,
				-48
			],
			[
				3,
				-12
			],
			[
				-44,
				-27
			],
			[
				-4,
				-27
			],
			[
				5,
				-32
			],
			[
				23,
				-32
			],
			[
				8,
				-29
			],
			[
				-63,
				-21
			],
			[
				-85,
				7
			],
			[
				-100,
				41
			],
			[
				-36,
				-6
			],
			[
				-34,
				-21
			],
			[
				-35,
				9
			],
			[
				-38,
				25
			],
			[
				-55,
				52
			],
			[
				-26,
				32
			],
			[
				-11,
				34
			],
			[
				-15,
				5
			],
			[
				-22,
				-10
			],
			[
				-19,
				-42
			],
			[
				-50,
				-73
			],
			[
				-37,
				-20
			],
			[
				-56,
				4
			],
			[
				-79,
				-1
			],
			[
				-49,
				-6
			],
			[
				-60,
				26
			],
			[
				-14,
				-5
			],
			[
				0,
				-17
			],
			[
				-23,
				-27
			],
			[
				-37,
				-18
			],
			[
				-170,
				40
			],
			[
				-24,
				33
			]
		],
		[
			[
				103318,
				83330
			],
			[
				-3,
				0
			],
			[
				-44,
				-17
			],
			[
				-71,
				-10
			],
			[
				-36,
				7
			],
			[
				-66,
				-78
			],
			[
				-20,
				-14
			],
			[
				-62,
				-24
			],
			[
				-51,
				-11
			],
			[
				-44,
				9
			],
			[
				-17,
				1
			],
			[
				-194,
				4
			],
			[
				-101,
				16
			],
			[
				-65,
				31
			],
			[
				-44,
				34
			],
			[
				-21,
				37
			],
			[
				-50,
				23
			],
			[
				-79,
				8
			],
			[
				-62,
				37
			],
			[
				-44,
				67
			],
			[
				-60,
				52
			],
			[
				-76,
				39
			],
			[
				-60,
				55
			],
			[
				-44,
				70
			],
			[
				-80,
				64
			],
			[
				-115,
				56
			],
			[
				-34,
				13
			]
		],
		[
			[
				104182,
				83476
			],
			[
				-21,
				14
			],
			[
				-31,
				13
			],
			[
				-147,
				16
			],
			[
				-58,
				-12
			],
			[
				-78,
				5
			],
			[
				-71,
				14
			],
			[
				-54,
				-12
			],
			[
				-47,
				-56
			],
			[
				-23,
				-19
			],
			[
				-19,
				-12
			],
			[
				-40,
				-17
			],
			[
				-34,
				-21
			],
			[
				-45,
				-16
			],
			[
				-40,
				3
			],
			[
				-38,
				24
			],
			[
				-14,
				-6
			],
			[
				-12,
				-22
			],
			[
				-20,
				-19
			],
			[
				-57,
				-23
			],
			[
				-15,
				0
			]
		],
		[
			[
				101775,
				83799
			],
			[
				-7,
				18
			],
			[
				-57,
				70
			],
			[
				-24,
				26
			],
			[
				3,
				35
			],
			[
				-12,
				20
			],
			[
				-20,
				13
			],
			[
				-11,
				51
			],
			[
				-7,
				37
			],
			[
				-16,
				24
			],
			[
				-123,
				5
			]
		],
		[
			[
				124228,
				65744
			],
			[
				-58,
				-17
			],
			[
				-55,
				-18
			],
			[
				-45,
				1
			],
			[
				-37,
				7
			],
			[
				-24,
				17
			],
			[
				-47,
				70
			],
			[
				-33,
				90
			]
		],
		[
			[
				107423,
				30777
			],
			[
				-13,
				-41
			],
			[
				-9,
				-59
			],
			[
				12,
				-44
			],
			[
				26,
				-60
			],
			[
				37,
				-52
			],
			[
				28,
				-31
			],
			[
				34,
				-77
			],
			[
				34,
				-96
			],
			[
				45,
				-74
			],
			[
				131,
				-171
			],
			[
				14,
				-62
			],
			[
				19,
				-60
			],
			[
				82,
				-117
			],
			[
				13,
				-39
			],
			[
				-6,
				-79
			],
			[
				85,
				-238
			],
			[
				56,
				-139
			],
			[
				47,
				-25
			],
			[
				151,
				-148
			],
			[
				131,
				-119
			],
			[
				154,
				-80
			],
			[
				114,
				-53
			],
			[
				55,
				-39
			],
			[
				28,
				-37
			],
			[
				23,
				-71
			],
			[
				12,
				-123
			],
			[
				4,
				-80
			],
			[
				121,
				3
			],
			[
				101,
				-7
			],
			[
				35,
				-16
			],
			[
				13,
				-23
			],
			[
				-3,
				-53
			],
			[
				2,
				-78
			],
			[
				4,
				-63
			],
			[
				-10,
				-68
			],
			[
				-7,
				-79
			],
			[
				-5,
				-99
			],
			[
				15,
				-39
			],
			[
				98,
				-124
			],
			[
				41,
				-80
			],
			[
				43,
				-122
			],
			[
				25,
				-39
			],
			[
				21,
				-16
			],
			[
				88,
				-13
			],
			[
				226,
				-51
			],
			[
				140,
				-47
			],
			[
				110,
				-48
			],
			[
				47,
				-12
			],
			[
				22,
				-13
			],
			[
				8,
				-12
			],
			[
				-14,
				-106
			],
			[
				5,
				-34
			],
			[
				12,
				-31
			],
			[
				19,
				-24
			],
			[
				23,
				-15
			],
			[
				84,
				-11
			],
			[
				50,
				-65
			],
			[
				32,
				-30
			]
		],
		[
			[
				141370,
				74724
			],
			[
				-48,
				-13
			],
			[
				-98,
				-7
			],
			[
				-34,
				1
			],
			[
				-48,
				2
			],
			[
				-98,
				27
			],
			[
				-132,
				36
			],
			[
				-136,
				51
			],
			[
				-73,
				40
			],
			[
				-25,
				14
			],
			[
				-62,
				41
			],
			[
				-44,
				36
			],
			[
				-8,
				94
			],
			[
				-32,
				-7
			],
			[
				-75,
				-34
			],
			[
				-87,
				-21
			],
			[
				-47,
				-1
			],
			[
				-20,
				16
			],
			[
				-28,
				99
			],
			[
				-21,
				28
			],
			[
				-39,
				11
			],
			[
				-43,
				17
			],
			[
				-21,
				26
			],
			[
				-5,
				33
			],
			[
				19,
				37
			],
			[
				23,
				29
			],
			[
				3,
				176
			],
			[
				-14,
				62
			],
			[
				-12,
				53
			],
			[
				-32,
				65
			],
			[
				-28,
				40
			],
			[
				-44,
				38
			],
			[
				-68,
				38
			],
			[
				-61,
				15
			],
			[
				-73,
				-29
			],
			[
				-23,
				11
			],
			[
				-31,
				120
			],
			[
				-19,
				25
			],
			[
				-131,
				49
			],
			[
				-58,
				12
			],
			[
				-68,
				-16
			],
			[
				-39,
				-13
			],
			[
				-31,
				22
			],
			[
				-49,
				28
			],
			[
				-47,
				19
			],
			[
				-59,
				0
			],
			[
				-39,
				-11
			]
		],
		[
			[
				109204,
				80062
			],
			[
				-88,
				15
			],
			[
				-30,
				-5
			],
			[
				-20,
				-20
			],
			[
				-40,
				4
			],
			[
				-51,
				0
			],
			[
				-52,
				-24
			],
			[
				-29,
				-10
			],
			[
				-39,
				22
			],
			[
				-72,
				64
			],
			[
				-44,
				45
			],
			[
				-33,
				12
			],
			[
				-33,
				-14
			],
			[
				-117,
				-15
			],
			[
				-28,
				-26
			],
			[
				-54,
				-29
			],
			[
				-55,
				-14
			],
			[
				-78,
				-10
			],
			[
				-41,
				2
			],
			[
				-23,
				-14
			],
			[
				-20,
				-43
			],
			[
				-13,
				-41
			],
			[
				-11,
				-17
			],
			[
				-98,
				-20
			],
			[
				-21,
				-24
			],
			[
				-6,
				-23
			],
			[
				2,
				-23
			]
		],
		[
			[
				157610,
				55105
			],
			[
				-10,
				21
			],
			[
				-117,
				295
			],
			[
				-20,
				137
			],
			[
				20,
				105
			],
			[
				12,
				36
			],
			[
				-34,
				55
			],
			[
				-47,
				63
			],
			[
				-85,
				83
			],
			[
				-5,
				130
			],
			[
				-19,
				154
			],
			[
				-25,
				52
			],
			[
				-39,
				95
			],
			[
				-21,
				79
			],
			[
				-7,
				207
			],
			[
				11,
				17
			],
			[
				60,
				6
			],
			[
				76,
				15
			],
			[
				12,
				34
			],
			[
				-13,
				27
			],
			[
				49,
				47
			],
			[
				70,
				103
			],
			[
				54,
				108
			],
			[
				39,
				68
			],
			[
				23,
				67
			],
			[
				79,
				96
			],
			[
				109,
				66
			],
			[
				73,
				15
			],
			[
				77,
				23
			],
			[
				74,
				32
			],
			[
				35,
				3
			],
			[
				91,
				-39
			],
			[
				50,
				-10
			],
			[
				51,
				1
			],
			[
				54,
				-4
			],
			[
				47,
				4
			],
			[
				112,
				27
			],
			[
				119,
				-22
			],
			[
				106,
				17
			],
			[
				131,
				32
			],
			[
				65,
				-20
			],
			[
				58,
				-31
			],
			[
				9,
				-64
			],
			[
				13,
				-29
			],
			[
				20,
				-22
			],
			[
				26,
				0
			],
			[
				33,
				44
			],
			[
				28,
				46
			],
			[
				9,
				8
			]
		],
		[
			[
				148537,
				67978
			],
			[
				-6,
				-15
			],
			[
				-79,
				-66
			],
			[
				-14,
				-35
			],
			[
				18,
				-34
			],
			[
				31,
				-29
			],
			[
				14,
				-27
			],
			[
				14,
				-86
			],
			[
				40,
				-24
			],
			[
				79,
				-56
			],
			[
				69,
				-40
			],
			[
				119,
				27
			],
			[
				33,
				-19
			],
			[
				59,
				-19
			],
			[
				45,
				-6
			],
			[
				27,
				-14
			],
			[
				15,
				-14
			],
			[
				-2,
				-17
			],
			[
				2,
				-18
			],
			[
				66,
				-4
			],
			[
				34,
				-11
			],
			[
				116,
				19
			],
			[
				116,
				25
			],
			[
				54,
				77
			],
			[
				23,
				5
			],
			[
				67,
				30
			],
			[
				66,
				-33
			],
			[
				72,
				-44
			],
			[
				39,
				-14
			],
			[
				77,
				-7
			],
			[
				75,
				5
			],
			[
				180,
				21
			],
			[
				99,
				-11
			],
			[
				90,
				64
			],
			[
				19,
				0
			],
			[
				40,
				-49
			],
			[
				99,
				-5
			],
			[
				53,
				24
			],
			[
				58,
				18
			],
			[
				36,
				6
			],
			[
				29,
				1
			],
			[
				36,
				-5
			],
			[
				33,
				16
			],
			[
				15,
				33
			],
			[
				-3,
				50
			],
			[
				-24,
				54
			],
			[
				-21,
				32
			],
			[
				-4,
				17
			],
			[
				6,
				39
			],
			[
				19,
				55
			],
			[
				34,
				63
			],
			[
				-25,
				61
			],
			[
				-35,
				71
			],
			[
				-26,
				6
			],
			[
				-65,
				-16
			],
			[
				-69,
				3
			],
			[
				-55,
				43
			],
			[
				-41,
				52
			],
			[
				-10,
				45
			],
			[
				12,
				54
			],
			[
				18,
				50
			],
			[
				4,
				18
			]
		],
		[
			[
				158342,
				46505
			],
			[
				-1,
				46
			],
			[
				-6,
				56
			],
			[
				-103,
				28
			],
			[
				-48,
				21
			],
			[
				-78,
				-20
			],
			[
				-44,
				-72
			],
			[
				-28,
				-72
			],
			[
				2,
				-32
			],
			[
				4,
				-14
			]
		],
		[
			[
				155791,
				50764
			],
			[
				13,
				38
			],
			[
				15,
				126
			],
			[
				10,
				25
			],
			[
				25,
				13
			],
			[
				29,
				-4
			],
			[
				55,
				-109
			],
			[
				141,
				-68
			],
			[
				42,
				-16
			],
			[
				56,
				27
			],
			[
				25,
				-17
			],
			[
				25,
				-28
			],
			[
				15,
				-78
			],
			[
				37,
				-71
			],
			[
				74,
				10
			],
			[
				27,
				-10
			],
			[
				15,
				-3
			],
			[
				15,
				-63
			],
			[
				6,
				-109
			],
			[
				-7,
				-64
			],
			[
				-53,
				-91
			],
			[
				-7,
				-62
			],
			[
				28,
				-38
			],
			[
				36,
				-41
			],
			[
				21,
				-31
			],
			[
				22,
				5
			],
			[
				28,
				21
			],
			[
				25,
				54
			],
			[
				18,
				46
			],
			[
				95,
				51
			],
			[
				98,
				46
			],
			[
				13,
				-5
			],
			[
				16,
				-20
			],
			[
				32,
				-67
			],
			[
				18,
				-14
			],
			[
				26,
				-7
			],
			[
				46,
				7
			],
			[
				54,
				38
			],
			[
				28,
				71
			],
			[
				12,
				56
			],
			[
				77,
				97
			],
			[
				9,
				73
			],
			[
				21,
				47
			]
		],
		[
			[
				94976,
				87304
			],
			[
				8,
				-15
			],
			[
				73,
				-44
			],
			[
				23,
				-34
			],
			[
				52,
				-34
			],
			[
				-43,
				-42
			],
			[
				6,
				-19
			],
			[
				16,
				-19
			],
			[
				59,
				-12
			],
			[
				30,
				-27
			],
			[
				2,
				-43
			],
			[
				13,
				-69
			],
			[
				-122,
				-69
			],
			[
				-35,
				-77
			],
			[
				-3,
				-15
			]
		],
		[
			[
				44726,
				61712
			],
			[
				14,
				-24
			],
			[
				30,
				-167
			],
			[
				2,
				-53
			],
			[
				-29,
				-80
			],
			[
				4,
				-32
			],
			[
				64,
				-74
			],
			[
				1,
				-27
			],
			[
				-7,
				-27
			],
			[
				-55,
				-70
			],
			[
				-42,
				-49
			],
			[
				13,
				-55
			],
			[
				34,
				-52
			],
			[
				4,
				-44
			],
			[
				-10,
				-58
			],
			[
				-52,
				-72
			],
			[
				-28,
				-26
			],
			[
				-77,
				-3
			],
			[
				-9,
				-11
			],
			[
				39,
				-70
			],
			[
				43,
				-79
			],
			[
				72,
				-62
			],
			[
				16,
				-58
			],
			[
				-17,
				-55
			],
			[
				-3,
				-136
			]
		],
		[
			[
				100190,
				56237
			],
			[
				-85,
				148
			],
			[
				-109,
				191
			],
			[
				-102,
				177
			]
		],
		[
			[
				121168,
				69446
			],
			[
				105,
				135
			],
			[
				49,
				72
			],
			[
				88,
				157
			],
			[
				45,
				112
			],
			[
				44,
				124
			],
			[
				37,
				96
			],
			[
				8,
				18
			],
			[
				22,
				32
			],
			[
				49,
				34
			],
			[
				70,
				31
			],
			[
				118,
				14
			],
			[
				83,
				1
			],
			[
				19,
				-2
			],
			[
				53,
				-15
			],
			[
				145,
				-78
			]
		],
		[
			[
				148032,
				68435
			],
			[
				-7,
				28
			],
			[
				7,
				24
			],
			[
				20,
				13
			],
			[
				87,
				16
			],
			[
				97,
				36
			],
			[
				39,
				19
			],
			[
				30,
				18
			],
			[
				30,
				30
			],
			[
				27,
				-1
			],
			[
				88,
				-43
			],
			[
				30,
				-27
			],
			[
				17,
				-82
			],
			[
				13,
				-32
			],
			[
				-13,
				-84
			],
			[
				-52,
				-202
			],
			[
				10,
				-76
			],
			[
				44,
				-55
			],
			[
				38,
				-39
			]
		],
		[
			[
				32892,
				56779
			],
			[
				-7,
				39
			],
			[
				0,
				42
			],
			[
				37,
				58
			],
			[
				68,
				77
			],
			[
				45,
				39
			],
			[
				22,
				8
			],
			[
				29,
				-4
			],
			[
				29,
				22
			],
			[
				25,
				53
			],
			[
				26,
				34
			],
			[
				65,
				35
			],
			[
				15,
				14
			],
			[
				-5,
				29
			],
			[
				-15,
				58
			],
			[
				3,
				35
			],
			[
				21,
				17
			],
			[
				26,
				3
			],
			[
				53,
				14
			],
			[
				23,
				-3
			],
			[
				13,
				-9
			]
		],
		[
			[
				171245,
				37747
			],
			[
				10,
				-27
			],
			[
				24,
				-34
			],
			[
				17,
				-6
			],
			[
				12,
				8
			],
			[
				96,
				-12
			],
			[
				23,
				12
			],
			[
				37,
				53
			],
			[
				24,
				29
			],
			[
				16,
				62
			],
			[
				4,
				40
			]
		],
		[
			[
				171817,
				38077
			],
			[
				-5,
				-74
			],
			[
				14,
				-18
			],
			[
				24,
				-9
			],
			[
				82,
				50
			],
			[
				16,
				-10
			],
			[
				16,
				-22
			],
			[
				0,
				-66
			],
			[
				-32,
				-55
			],
			[
				-79,
				-5
			],
			[
				-11,
				-15
			],
			[
				-1,
				-34
			],
			[
				6,
				-33
			],
			[
				18,
				-26
			],
			[
				24,
				-46
			],
			[
				22,
				-107
			]
		],
		[
			[
				165497,
				49492
			],
			[
				18,
				-27
			],
			[
				38,
				-96
			],
			[
				25,
				-96
			],
			[
				9,
				-147
			],
			[
				30,
				-62
			],
			[
				-5,
				-13
			],
			[
				-18,
				-10
			],
			[
				-28,
				-5
			],
			[
				-50,
				14
			],
			[
				-41,
				22
			],
			[
				-36,
				158
			],
			[
				-16,
				90
			],
			[
				2,
				107
			],
			[
				-2,
				65
			]
		],
		[
			[
				161936,
				47123
			],
			[
				-58,
				-108
			],
			[
				6,
				-39
			],
			[
				14,
				-35
			],
			[
				42,
				-25
			],
			[
				12,
				-133
			],
			[
				53,
				-76
			],
			[
				53,
				-69
			],
			[
				39,
				-34
			],
			[
				43,
				-49
			],
			[
				30,
				-46
			],
			[
				32,
				-39
			],
			[
				48,
				-37
			],
			[
				129,
				-160
			],
			[
				54,
				-47
			],
			[
				41,
				-47
			],
			[
				28,
				-17
			],
			[
				71,
				13
			],
			[
				209,
				115
			],
			[
				37,
				8
			],
			[
				68,
				20
			],
			[
				120,
				-6
			],
			[
				127,
				-40
			],
			[
				41,
				-1
			],
			[
				39,
				24
			],
			[
				54,
				-7
			],
			[
				51,
				-13
			],
			[
				25,
				11
			],
			[
				74,
				83
			],
			[
				101,
				25
			],
			[
				32,
				83
			],
			[
				25,
				78
			],
			[
				12,
				83
			],
			[
				42,
				33
			],
			[
				59,
				29
			],
			[
				86,
				37
			],
			[
				302,
				6
			],
			[
				29,
				-16
			],
			[
				7,
				-42
			],
			[
				-7,
				-32
			],
			[
				12,
				-19
			],
			[
				40,
				-2
			],
			[
				38,
				-20
			],
			[
				150,
				-66
			],
			[
				64,
				-21
			],
			[
				36,
				5
			],
			[
				70,
				-60
			],
			[
				38,
				21
			],
			[
				51,
				42
			],
			[
				49,
				56
			],
			[
				43,
				45
			],
			[
				63,
				17
			],
			[
				81,
				-2
			],
			[
				97,
				15
			],
			[
				72,
				24
			],
			[
				81,
				-39
			],
			[
				22,
				12
			],
			[
				14,
				39
			],
			[
				42,
				85
			],
			[
				18,
				57
			],
			[
				16,
				109
			],
			[
				12,
				27
			],
			[
				30,
				15
			],
			[
				32,
				20
			],
			[
				8,
				33
			],
			[
				12,
				38
			],
			[
				-10,
				32
			],
			[
				-18,
				27
			],
			[
				-19,
				91
			],
			[
				6,
				42
			],
			[
				12,
				31
			],
			[
				32,
				16
			],
			[
				86,
				67
			],
			[
				76,
				78
			],
			[
				42,
				39
			],
			[
				18,
				25
			],
			[
				1,
				36
			],
			[
				-33,
				38
			],
			[
				-32,
				18
			],
			[
				-2,
				43
			],
			[
				1,
				30
			],
			[
				10,
				29
			],
			[
				-5,
				27
			],
			[
				0,
				41
			],
			[
				20,
				45
			],
			[
				47,
				65
			],
			[
				37,
				43
			],
			[
				41,
				-27
			],
			[
				47,
				12
			],
			[
				46,
				22
			],
			[
				25,
				77
			],
			[
				4,
				37
			],
			[
				-6,
				29
			],
			[
				15,
				111
			],
			[
				4,
				15
			],
			[
				30,
				70
			],
			[
				3,
				46
			],
			[
				-17,
				109
			],
			[
				11,
				82
			],
			[
				4,
				169
			],
			[
				18,
				31
			],
			[
				21,
				88
			],
			[
				33,
				91
			],
			[
				67,
				50
			],
			[
				35,
				66
			],
			[
				15,
				12
			],
			[
				23,
				0
			],
			[
				81,
				-47
			],
			[
				73,
				53
			],
			[
				66,
				6
			],
			[
				54,
				-7
			],
			[
				31,
				-22
			],
			[
				30,
				-16
			],
			[
				65,
				52
			],
			[
				25,
				-9
			],
			[
				23,
				-18
			],
			[
				32,
				1
			],
			[
				38,
				13
			],
			[
				94,
				-13
			],
			[
				166,
				-2
			],
			[
				115,
				-31
			],
			[
				112,
				-88
			],
			[
				56,
				-18
			],
			[
				134,
				-3
			],
			[
				90,
				15
			]
		],
		[
			[
				97857,
				84100
			],
			[
				17,
				-8
			],
			[
				65,
				-2
			],
			[
				71,
				-6
			],
			[
				45,
				-43
			],
			[
				45,
				-15
			],
			[
				64,
				-5
			],
			[
				42,
				6
			],
			[
				21,
				17
			],
			[
				24,
				51
			],
			[
				46,
				63
			],
			[
				71,
				33
			],
			[
				122,
				6
			],
			[
				61,
				12
			],
			[
				64,
				-1
			],
			[
				47,
				-10
			],
			[
				50,
				2
			],
			[
				125,
				44
			],
			[
				129,
				35
			],
			[
				18,
				-6
			],
			[
				3,
				-12
			],
			[
				-23,
				-27
			],
			[
				-23,
				-36
			],
			[
				15,
				-40
			],
			[
				74,
				-82
			],
			[
				40,
				-63
			],
			[
				37,
				-47
			],
			[
				59,
				-25
			],
			[
				77,
				-15
			],
			[
				66,
				-6
			],
			[
				68,
				-18
			],
			[
				235,
				-43
			],
			[
				118,
				-13
			],
			[
				89,
				-2
			],
			[
				136,
				-29
			]
		],
		[
			[
				99955,
				83815
			],
			[
				-13,
				-47
			],
			[
				-28,
				-12
			],
			[
				-47,
				-27
			],
			[
				-55,
				-38
			],
			[
				-51,
				-43
			],
			[
				-14,
				-46
			],
			[
				14,
				-30
			],
			[
				14,
				-11
			],
			[
				18,
				10
			],
			[
				27,
				-6
			],
			[
				35,
				-17
			],
			[
				56,
				-16
			],
			[
				2,
				-16
			],
			[
				-12,
				-20
			],
			[
				-44,
				-36
			],
			[
				-40,
				-41
			],
			[
				-4,
				-25
			],
			[
				5,
				-18
			],
			[
				14,
				-11
			],
			[
				59,
				5
			],
			[
				8,
				-15
			],
			[
				-28,
				-105
			],
			[
				9,
				-18
			],
			[
				51,
				-17
			],
			[
				38,
				-26
			],
			[
				71,
				-66
			],
			[
				28,
				-54
			],
			[
				-19,
				-18
			],
			[
				-45,
				-9
			],
			[
				-36,
				4
			]
		],
		[
			[
				109850,
				43208
			],
			[
				9,
				46
			],
			[
				22,
				51
			],
			[
				25,
				6
			],
			[
				62,
				-21
			],
			[
				64,
				-43
			],
			[
				34,
				-98
			],
			[
				27,
				-14
			],
			[
				47,
				0
			],
			[
				121,
				13
			],
			[
				31,
				-2
			],
			[
				55,
				24
			],
			[
				54,
				41
			],
			[
				16,
				43
			],
			[
				13,
				95
			],
			[
				12,
				173
			],
			[
				27,
				2
			],
			[
				77,
				-62
			],
			[
				16,
				-4
			],
			[
				17,
				2
			],
			[
				26,
				31
			],
			[
				33,
				25
			],
			[
				24,
				-1
			],
			[
				89,
				29
			],
			[
				47,
				-52
			],
			[
				30,
				-16
			],
			[
				16,
				-4
			]
		],
		[
			[
				150917,
				63576
			],
			[
				5,
				-31
			],
			[
				1,
				-273
			],
			[
				6,
				-117
			],
			[
				21,
				-96
			],
			[
				4,
				-37
			],
			[
				-21,
				-30
			],
			[
				-20,
				-5
			],
			[
				-19,
				46
			],
			[
				-44,
				36
			],
			[
				-64,
				38
			],
			[
				-27,
				25
			],
			[
				-33,
				-10
			],
			[
				-46,
				-57
			],
			[
				-18,
				-54
			],
			[
				8,
				-75
			],
			[
				14,
				-74
			],
			[
				32,
				-42
			],
			[
				3,
				-47
			],
			[
				12,
				-60
			],
			[
				16,
				-55
			],
			[
				8,
				-60
			]
		],
		[
			[
				92026,
				80579
			],
			[
				-51,
				78
			],
			[
				-36,
				16
			],
			[
				-55,
				3
			],
			[
				-63,
				24
			],
			[
				-65,
				30
			],
			[
				-159,
				49
			],
			[
				-44,
				6
			],
			[
				-17,
				-8
			],
			[
				-12,
				-29
			],
			[
				-6,
				-83
			],
			[
				-7,
				-9
			],
			[
				-73,
				-2
			],
			[
				-91,
				11
			],
			[
				-42,
				-6
			],
			[
				-37,
				0
			],
			[
				-35,
				22
			],
			[
				-156,
				-25
			],
			[
				-26,
				12
			],
			[
				-38,
				37
			],
			[
				-42,
				30
			],
			[
				-33,
				16
			],
			[
				-28,
				17
			],
			[
				-26,
				3
			],
			[
				-38,
				-17
			],
			[
				-54,
				-7
			],
			[
				-44,
				2
			],
			[
				-24,
				-2
			],
			[
				-99,
				91
			],
			[
				-15,
				25
			],
			[
				-49,
				7
			],
			[
				-61,
				1
			],
			[
				-156,
				59
			],
			[
				-71,
				31
			],
			[
				-11,
				19
			],
			[
				1,
				16
			],
			[
				-12,
				-4
			],
			[
				-22,
				-27
			],
			[
				-11,
				-22
			],
			[
				-15,
				-4
			],
			[
				-23,
				4
			],
			[
				-21,
				12
			],
			[
				-12,
				16
			],
			[
				13,
				28
			],
			[
				24,
				36
			],
			[
				10,
				40
			],
			[
				-2,
				35
			],
			[
				-40,
				23
			],
			[
				-58,
				10
			],
			[
				-42,
				2
			],
			[
				-55,
				21
			],
			[
				-27,
				14
			],
			[
				-25,
				40
			],
			[
				-1,
				28
			]
		],
		[
			[
				92026,
				80579
			],
			[
				20,
				21
			],
			[
				27,
				18
			],
			[
				43,
				-7
			],
			[
				92,
				-25
			],
			[
				19,
				-23
			],
			[
				1,
				-16
			],
			[
				-17,
				-26
			],
			[
				-5,
				-18
			]
		],
		[
			[
				92206,
				80503
			],
			[
				99,
				-38
			],
			[
				44,
				-26
			],
			[
				15,
				-27
			],
			[
				23,
				-29
			],
			[
				30,
				-4
			],
			[
				42,
				27
			],
			[
				66,
				29
			],
			[
				112,
				-26
			],
			[
				125,
				-36
			],
			[
				55,
				-5
			],
			[
				2,
				18
			],
			[
				9,
				26
			],
			[
				21,
				12
			],
			[
				31,
				4
			],
			[
				42,
				14
			],
			[
				49,
				22
			],
			[
				51,
				9
			],
			[
				54,
				-17
			],
			[
				64,
				-13
			],
			[
				38,
				0
			]
		],
		[
			[
				92026,
				80579
			],
			[
				-9,
				-39
			],
			[
				5,
				-15
			],
			[
				5,
				-27
			],
			[
				-1,
				-30
			],
			[
				13,
				-20
			],
			[
				24,
				-2
			],
			[
				31,
				6
			],
			[
				34,
				12
			],
			[
				60,
				33
			],
			[
				18,
				6
			]
		],
		[
			[
				139491,
				76155
			],
			[
				18,
				15
			],
			[
				58,
				36
			],
			[
				46,
				42
			],
			[
				25,
				34
			],
			[
				-13,
				54
			],
			[
				-72,
				66
			],
			[
				-46,
				35
			],
			[
				-14,
				23
			],
			[
				12,
				71
			],
			[
				17,
				70
			],
			[
				-11,
				27
			],
			[
				-14,
				23
			],
			[
				-6,
				77
			],
			[
				-31,
				92
			],
			[
				-34,
				54
			],
			[
				-10,
				73
			],
			[
				-2,
				68
			],
			[
				42,
				107
			],
			[
				-16,
				47
			],
			[
				-43,
				41
			],
			[
				-149,
				74
			],
			[
				-153,
				49
			],
			[
				-58,
				-2
			],
			[
				-37,
				3
			],
			[
				-42,
				-43
			],
			[
				-26,
				-57
			],
			[
				-36,
				-5
			],
			[
				-65,
				24
			],
			[
				-44,
				36
			],
			[
				-30,
				76
			],
			[
				-24,
				98
			],
			[
				-14,
				30
			],
			[
				7,
				27
			],
			[
				15,
				23
			],
			[
				42,
				22
			],
			[
				7,
				23
			],
			[
				-7,
				27
			],
			[
				-33,
				35
			],
			[
				-34,
				50
			],
			[
				-54,
				103
			],
			[
				10,
				56
			],
			[
				9,
				82
			],
			[
				-3,
				43
			]
		],
		[
			[
				139491,
				76155
			],
			[
				-33,
				-5
			],
			[
				-47,
				20
			],
			[
				-18,
				30
			],
			[
				-8,
				4
			],
			[
				-37,
				-20
			],
			[
				-71,
				-25
			],
			[
				-121,
				-65
			],
			[
				3,
				-16
			],
			[
				78,
				-67
			],
			[
				19,
				-21
			],
			[
				9,
				-7
			]
		],
		[
			[
				104649,
				79139
			],
			[
				87,
				5
			],
			[
				31,
				6
			],
			[
				114,
				3
			],
			[
				52,
				33
			],
			[
				36,
				-3
			],
			[
				75,
				-28
			],
			[
				33,
				22
			],
			[
				98,
				45
			],
			[
				97,
				130
			],
			[
				41,
				19
			],
			[
				94,
				8
			],
			[
				30,
				15
			],
			[
				34,
				-3
			],
			[
				106,
				-26
			],
			[
				60,
				-4
			],
			[
				71,
				18
			],
			[
				78,
				31
			],
			[
				20,
				111
			],
			[
				18,
				16
			],
			[
				49,
				4
			],
			[
				37,
				-1
			]
		],
		[
			[
				105034,
				80292
			],
			[
				-111,
				-23
			],
			[
				-37,
				-27
			],
			[
				-22,
				-47
			],
			[
				-7,
				-25
			],
			[
				-20,
				0
			],
			[
				-32,
				24
			],
			[
				-41,
				38
			],
			[
				-54,
				-3
			],
			[
				-182,
				-83
			],
			[
				-18,
				-43
			],
			[
				-4,
				-94
			],
			[
				-12,
				-26
			],
			[
				-20,
				-16
			],
			[
				-75,
				10
			],
			[
				-8,
				6
			]
		],
		[
			[
				105540,
				80347
			],
			[
				-17,
				6
			],
			[
				-26,
				23
			],
			[
				-24,
				7
			],
			[
				-61,
				-27
			],
			[
				-61,
				-17
			],
			[
				-48,
				13
			],
			[
				-47,
				1
			],
			[
				-33,
				-11
			],
			[
				-25,
				-4
			],
			[
				-49,
				-30
			],
			[
				-78,
				-21
			],
			[
				-37,
				5
			]
		],
		[
			[
				105540,
				80347
			],
			[
				50,
				12
			],
			[
				16,
				25
			],
			[
				50,
				67
			],
			[
				6,
				33
			],
			[
				-6,
				19
			],
			[
				-33,
				33
			],
			[
				-23,
				70
			],
			[
				17,
				67
			],
			[
				2,
				34
			],
			[
				-17,
				33
			],
			[
				17,
				42
			],
			[
				36,
				23
			],
			[
				23,
				7
			],
			[
				96,
				5
			],
			[
				61,
				84
			],
			[
				36,
				26
			],
			[
				38,
				48
			],
			[
				18,
				17
			],
			[
				16,
				37
			],
			[
				6,
				38
			],
			[
				-76,
				53
			],
			[
				-26,
				40
			],
			[
				-33,
				44
			],
			[
				-46,
				31
			],
			[
				-92,
				52
			],
			[
				-36,
				53
			],
			[
				-16,
				69
			],
			[
				-24,
				52
			],
			[
				-27,
				34
			],
			[
				-5,
				28
			],
			[
				-11,
				34
			],
			[
				-3,
				66
			],
			[
				22,
				89
			],
			[
				14,
				31
			],
			[
				31,
				9
			],
			[
				83,
				47
			],
			[
				4,
				60
			],
			[
				15,
				38
			],
			[
				26,
				22
			],
			[
				24,
				14
			]
		],
		[
			[
				105910,
				79540
			],
			[
				8,
				17
			],
			[
				14,
				205
			],
			[
				35,
				92
			],
			[
				-1,
				19
			],
			[
				-7,
				14
			],
			[
				-31,
				15
			],
			[
				-23,
				50
			],
			[
				-47,
				130
			],
			[
				-26,
				27
			],
			[
				-73,
				27
			],
			[
				-65,
				38
			],
			[
				-54,
				50
			],
			[
				-100,
				123
			]
		],
		[
			[
				103015,
				80549
			],
			[
				1,
				-30
			],
			[
				25,
				-35
			],
			[
				27,
				-39
			]
		],
		[
			[
				103015,
				80549
			],
			[
				-58,
				22
			],
			[
				-27,
				11
			],
			[
				-117,
				75
			],
			[
				-51,
				42
			],
			[
				-81,
				54
			],
			[
				-50,
				32
			],
			[
				-26,
				47
			],
			[
				-40,
				11
			],
			[
				-47,
				-16
			]
		],
		[
			[
				142092,
				72984
			],
			[
				21,
				-33
			],
			[
				41,
				-45
			],
			[
				35,
				-34
			],
			[
				30,
				-20
			],
			[
				157,
				-46
			],
			[
				13,
				-20
			],
			[
				-23,
				-92
			],
			[
				-4,
				-49
			],
			[
				66,
				-116
			],
			[
				41,
				-86
			],
			[
				-4,
				-35
			],
			[
				-15,
				-37
			],
			[
				-55,
				-60
			],
			[
				-60,
				-52
			],
			[
				-47,
				-5
			],
			[
				-32,
				-3
			],
			[
				-28,
				-18
			],
			[
				-39,
				-72
			],
			[
				-44,
				-19
			],
			[
				-51,
				-6
			],
			[
				-53,
				45
			],
			[
				-43,
				46
			],
			[
				-11,
				26
			],
			[
				-11,
				48
			],
			[
				-23,
				32
			],
			[
				-45,
				-15
			],
			[
				-68,
				-6
			],
			[
				-73,
				-11
			],
			[
				-14,
				-11
			],
			[
				-1,
				-20
			],
			[
				18,
				-44
			],
			[
				15,
				-57
			],
			[
				9,
				-80
			],
			[
				20,
				-53
			],
			[
				6,
				-17
			],
			[
				118,
				-159
			],
			[
				31,
				-33
			],
			[
				6,
				-21
			],
			[
				-10,
				-58
			],
			[
				-21,
				-68
			],
			[
				4,
				-53
			],
			[
				39,
				-60
			],
			[
				32,
				-41
			],
			[
				-31,
				-56
			],
			[
				-18,
				-65
			],
			[
				20,
				-29
			],
			[
				-10,
				-93
			],
			[
				10,
				-17
			],
			[
				22,
				-8
			],
			[
				34,
				7
			],
			[
				35,
				24
			],
			[
				30,
				5
			],
			[
				18,
				-7
			],
			[
				24,
				71
			],
			[
				21,
				10
			],
			[
				41,
				-20
			],
			[
				81,
				-132
			],
			[
				69,
				-113
			],
			[
				20,
				-21
			],
			[
				12,
				-13
			],
			[
				68,
				-58
			],
			[
				46,
				-37
			],
			[
				64,
				13
			],
			[
				85,
				3
			],
			[
				49,
				-36
			],
			[
				29,
				-25
			],
			[
				107,
				-93
			],
			[
				44,
				7
			],
			[
				29,
				-25
			],
			[
				8,
				-63
			],
			[
				-13,
				-64
			],
			[
				3,
				-31
			],
			[
				45,
				-6
			],
			[
				96,
				-42
			],
			[
				85,
				-38
			],
			[
				44,
				-12
			],
			[
				47,
				-28
			],
			[
				42,
				-45
			],
			[
				82,
				-58
			],
			[
				72,
				-44
			],
			[
				16,
				-60
			]
		],
		[
			[
				104248,
				80770
			],
			[
				80,
				25
			],
			[
				12,
				18
			],
			[
				-18,
				37
			],
			[
				10,
				24
			],
			[
				97,
				66
			],
			[
				16,
				31
			],
			[
				5,
				24
			],
			[
				-13,
				25
			],
			[
				-18,
				39
			],
			[
				9,
				17
			],
			[
				50,
				23
			],
			[
				41,
				27
			],
			[
				24,
				2
			],
			[
				15,
				-19
			],
			[
				0,
				-20
			],
			[
				13,
				-34
			],
			[
				30,
				-18
			],
			[
				50,
				-29
			],
			[
				57,
				-20
			],
			[
				46,
				-40
			],
			[
				61,
				-72
			],
			[
				10,
				-35
			],
			[
				55,
				-32
			],
			[
				52,
				-36
			],
			[
				-8,
				-66
			],
			[
				176,
				-57
			],
			[
				39,
				0
			],
			[
				19,
				-10
			],
			[
				0,
				-15
			],
			[
				-14,
				-46
			],
			[
				-72,
				-142
			],
			[
				-6,
				-30
			],
			[
				-52,
				-31
			],
			[
				-7,
				-18
			],
			[
				15,
				-39
			],
			[
				14,
				-28
			]
		],
		[
			[
				104248,
				80770
			],
			[
				-84,
				-24
			],
			[
				-14,
				-36
			],
			[
				-41,
				4
			],
			[
				-48,
				0
			],
			[
				-16,
				-23
			],
			[
				23,
				-38
			],
			[
				15,
				-45
			],
			[
				-12,
				-61
			],
			[
				-4,
				-8
			]
		],
		[
			[
				103505,
				81352
			],
			[
				-2,
				-10
			],
			[
				3,
				-30
			],
			[
				15,
				-29
			],
			[
				51,
				-29
			],
			[
				75,
				-59
			],
			[
				89,
				-108
			],
			[
				40,
				-32
			],
			[
				37,
				-8
			],
			[
				71,
				-44
			],
			[
				50,
				-11
			],
			[
				55,
				-12
			],
			[
				145,
				-94
			],
			[
				65,
				-27
			],
			[
				46,
				-35
			],
			[
				5,
				-33
			],
			[
				-2,
				-21
			]
		],
		[
			[
				33365,
				57340
			],
			[
				16,
				-4
			],
			[
				108,
				-42
			],
			[
				32,
				8
			],
			[
				41,
				-34
			],
			[
				20,
				-26
			],
			[
				17,
				-37
			],
			[
				85,
				-73
			],
			[
				15,
				-32
			],
			[
				63,
				-44
			],
			[
				26,
				-33
			],
			[
				27,
				-14
			],
			[
				54,
				-12
			],
			[
				45,
				-18
			],
			[
				5,
				-12
			],
			[
				5,
				-49
			],
			[
				9,
				-42
			],
			[
				22,
				-2
			],
			[
				26,
				20
			],
			[
				86,
				55
			],
			[
				81,
				37
			],
			[
				45,
				-22
			],
			[
				27,
				-46
			],
			[
				31,
				-21
			],
			[
				64,
				13
			],
			[
				58,
				-4
			],
			[
				46,
				-40
			],
			[
				10,
				-24
			],
			[
				-28,
				-134
			],
			[
				-10,
				-57
			],
			[
				-5,
				-49
			],
			[
				17,
				-13
			],
			[
				16,
				-19
			],
			[
				-4,
				-26
			],
			[
				-50,
				-43
			]
		],
		[
			[
				34674,
				56155
			],
			[
				179,
				10
			],
			[
				32,
				13
			],
			[
				33,
				38
			],
			[
				17,
				53
			],
			[
				2,
				51
			],
			[
				7,
				36
			],
			[
				29,
				36
			],
			[
				53,
				11
			],
			[
				40,
				4
			],
			[
				12,
				23
			],
			[
				-12,
				78
			],
			[
				-22,
				188
			],
			[
				-4,
				52
			],
			[
				7,
				39
			],
			[
				17,
				15
			],
			[
				79,
				9
			],
			[
				151,
				-16
			],
			[
				29,
				12
			],
			[
				61,
				107
			],
			[
				56,
				78
			],
			[
				40,
				35
			],
			[
				31,
				11
			],
			[
				37,
				-70
			],
			[
				127,
				-100
			],
			[
				22,
				7
			],
			[
				12,
				5
			],
			[
				4,
				14
			],
			[
				-2,
				46
			],
			[
				32,
				42
			],
			[
				66,
				38
			],
			[
				66,
				66
			],
			[
				67,
				95
			],
			[
				58,
				56
			],
			[
				49,
				17
			],
			[
				19,
				26
			],
			[
				-12,
				35
			],
			[
				4,
				50
			],
			[
				19,
				65
			],
			[
				29,
				37
			],
			[
				37,
				10
			],
			[
				15,
				21
			],
			[
				-8,
				30
			],
			[
				8,
				34
			],
			[
				33,
				55
			],
			[
				81,
				47
			],
			[
				46,
				-16
			],
			[
				38,
				-63
			],
			[
				54,
				-43
			],
			[
				70,
				-23
			],
			[
				55,
				9
			],
			[
				38,
				39
			],
			[
				35,
				12
			],
			[
				31,
				-15
			],
			[
				16,
				8
			],
			[
				2,
				34
			],
			[
				16,
				7
			],
			[
				30,
				-18
			],
			[
				27,
				-4
			],
			[
				24,
				9
			],
			[
				9,
				16
			],
			[
				5,
				16
			],
			[
				17,
				13
			],
			[
				61,
				-12
			],
			[
				68,
				19
			],
			[
				75,
				51
			],
			[
				50,
				22
			],
			[
				24,
				-6
			],
			[
				30,
				26
			],
			[
				34,
				57
			],
			[
				79,
				26
			],
			[
				166,
				-12
			]
		],
		[
			[
				42461,
				45363
			],
			[
				-116,
				57
			],
			[
				-99,
				83
			],
			[
				-103,
				22
			],
			[
				-67,
				51
			],
			[
				-61,
				80
			],
			[
				-33,
				53
			],
			[
				-27,
				27
			],
			[
				-131,
				78
			],
			[
				-26,
				7
			],
			[
				-50,
				-36
			],
			[
				-16,
				-21
			],
			[
				-3,
				-62
			],
			[
				-6,
				-35
			],
			[
				-44,
				-22
			],
			[
				-70,
				5
			],
			[
				-49,
				22
			],
			[
				-32,
				4
			],
			[
				-7,
				-18
			],
			[
				-18,
				-8
			],
			[
				-40,
				6
			],
			[
				-59,
				17
			],
			[
				-53,
				23
			],
			[
				-72,
				48
			],
			[
				-33,
				-6
			],
			[
				-83,
				10
			],
			[
				-66,
				28
			],
			[
				-18,
				26
			],
			[
				-29,
				174
			],
			[
				-8,
				12
			],
			[
				-29,
				8
			],
			[
				-49,
				24
			],
			[
				-30,
				28
			],
			[
				-16,
				48
			],
			[
				-20,
				46
			],
			[
				-81,
				-10
			],
			[
				-134,
				60
			],
			[
				-93,
				58
			],
			[
				-85,
				64
			],
			[
				-129,
				126
			],
			[
				-49,
				31
			],
			[
				-61,
				39
			],
			[
				-36,
				62
			],
			[
				-59,
				62
			],
			[
				-20,
				17
			]
		],
		[
			[
				53890,
				48229
			],
			[
				0,
				0
			],
			[
				-5,
				2
			],
			[
				-28,
				20
			],
			[
				-6,
				24
			],
			[
				4,
				77
			],
			[
				-46,
				58
			],
			[
				-72,
				73
			],
			[
				-22,
				91
			],
			[
				-27,
				58
			],
			[
				-80,
				120
			],
			[
				-14,
				82
			],
			[
				-1,
				58
			],
			[
				29,
				53
			],
			[
				39,
				94
			],
			[
				16,
				85
			],
			[
				12,
				44
			],
			[
				21,
				58
			],
			[
				18,
				75
			],
			[
				-14,
				46
			],
			[
				-24,
				46
			],
			[
				-8,
				33
			],
			[
				24,
				50
			],
			[
				23,
				35
			],
			[
				26,
				5
			],
			[
				34,
				21
			],
			[
				26,
				30
			],
			[
				41,
				8
			],
			[
				50,
				3
			],
			[
				103,
				0
			],
			[
				52,
				13
			],
			[
				16,
				24
			],
			[
				-2,
				47
			],
			[
				26,
				42
			],
			[
				27,
				18
			],
			[
				11,
				14
			],
			[
				2,
				15
			],
			[
				-7,
				15
			],
			[
				-11,
				9
			],
			[
				-29,
				3
			],
			[
				-25,
				73
			],
			[
				17,
				32
			],
			[
				22,
				59
			],
			[
				7,
				33
			],
			[
				34,
				52
			]
		],
		[
			[
				56160,
				48195
			],
			[
				12,
				22
			],
			[
				35,
				78
			],
			[
				2,
				68
			],
			[
				10,
				48
			],
			[
				-10,
				26
			],
			[
				-18,
				7
			],
			[
				-31,
				63
			],
			[
				-20,
				53
			],
			[
				-54,
				53
			],
			[
				-38,
				55
			],
			[
				-61,
				127
			],
			[
				5,
				70
			],
			[
				-17,
				26
			],
			[
				-19,
				26
			],
			[
				1,
				32
			],
			[
				-13,
				79
			],
			[
				-16,
				75
			],
			[
				-5,
				47
			],
			[
				15,
				81
			],
			[
				-9,
				90
			],
			[
				-20,
				47
			],
			[
				-6,
				72
			],
			[
				4,
				64
			],
			[
				17,
				37
			],
			[
				-3,
				45
			],
			[
				78,
				143
			],
			[
				59,
				83
			],
			[
				54,
				59
			]
		],
		[
			[
				53361,
				17458
			],
			[
				-20,
				78
			],
			[
				-23,
				84
			],
			[
				0,
				80
			],
			[
				11,
				114
			],
			[
				24,
				132
			],
			[
				19,
				98
			],
			[
				8,
				76
			],
			[
				17,
				18
			],
			[
				75,
				12
			],
			[
				54,
				67
			],
			[
				16,
				40
			],
			[
				2,
				54
			],
			[
				-7,
				68
			],
			[
				-26,
				155
			],
			[
				-12,
				139
			]
		],
		[
			[
				53881,
				20556
			],
			[
				-23,
				-32
			],
			[
				-4,
				-56
			],
			[
				-40,
				-74
			],
			[
				-76,
				-91
			],
			[
				-27,
				-80
			],
			[
				35,
				-99
			],
			[
				5,
				-121
			],
			[
				-15,
				-49
			],
			[
				-34,
				-16
			],
			[
				-8,
				-31
			],
			[
				19,
				-46
			],
			[
				1,
				-61
			],
			[
				-16,
				-75
			],
			[
				-36,
				-86
			],
			[
				-55,
				-96
			],
			[
				-13,
				-65
			],
			[
				28,
				-32
			],
			[
				14,
				-35
			],
			[
				0,
				-37
			],
			[
				-12,
				-53
			],
			[
				-23,
				-69
			],
			[
				-34,
				-52
			],
			[
				-47,
				-33
			],
			[
				-13,
				-43
			],
			[
				18,
				-51
			],
			[
				3,
				-54
			],
			[
				-14,
				-56
			],
			[
				8,
				-54
			],
			[
				29,
				-53
			],
			[
				-2,
				-60
			],
			[
				-50,
				-123
			]
		],
		[
			[
				55815,
				24359
			],
			[
				51,
				0
			],
			[
				23,
				-26
			],
			[
				37,
				-14
			],
			[
				39,
				30
			],
			[
				34,
				14
			],
			[
				53,
				1
			],
			[
				28,
				34
			],
			[
				33,
				5
			],
			[
				23,
				-18
			],
			[
				22,
				-22
			],
			[
				47,
				-5
			],
			[
				37,
				-58
			],
			[
				41,
				-17
			],
			[
				18,
				-66
			],
			[
				26,
				-174
			],
			[
				50,
				-102
			],
			[
				49,
				-117
			],
			[
				1,
				-52
			],
			[
				-27,
				-53
			],
			[
				-5,
				-75
			],
			[
				-17,
				-184
			],
			[
				-5,
				-68
			],
			[
				16,
				-46
			],
			[
				7,
				-64
			],
			[
				-27,
				-79
			],
			[
				-51,
				-118
			],
			[
				-50,
				-32
			],
			[
				-13,
				-1
			],
			[
				-68,
				-68
			],
			[
				-47,
				-26
			],
			[
				-28,
				18
			],
			[
				-31,
				-30
			],
			[
				-36,
				-76
			],
			[
				-43,
				-34
			],
			[
				-78,
				-19
			],
			[
				-24,
				-9
			],
			[
				-45,
				2
			],
			[
				-39,
				-19
			],
			[
				-33,
				-40
			],
			[
				-35,
				-15
			],
			[
				-37,
				10
			],
			[
				-34,
				-15
			],
			[
				-30,
				-40
			],
			[
				-17,
				-44
			],
			[
				-5,
				-46
			],
			[
				-29,
				-32
			],
			[
				-55,
				-17
			],
			[
				-19,
				-24
			],
			[
				4,
				-32
			],
			[
				-25,
				-26
			],
			[
				-91,
				-26
			],
			[
				-67,
				-47
			],
			[
				-41,
				-68
			],
			[
				-43,
				-42
			],
			[
				-68,
				-26
			],
			[
				-93,
				-69
			],
			[
				-13,
				-42
			],
			[
				35,
				-39
			],
			[
				13,
				-35
			],
			[
				-10,
				-30
			],
			[
				-29,
				-5
			],
			[
				-48,
				23
			],
			[
				-34,
				4
			],
			[
				-20,
				-13
			],
			[
				-10,
				-24
			],
			[
				1,
				-36
			],
			[
				-17,
				-25
			],
			[
				-35,
				-13
			],
			[
				-23,
				-29
			],
			[
				-9,
				-47
			],
			[
				-45,
				-58
			],
			[
				-79,
				-71
			],
			[
				-62,
				-95
			],
			[
				-46,
				-119
			],
			[
				-54,
				-79
			],
			[
				-61,
				-37
			],
			[
				-42,
				-54
			],
			[
				-23,
				-69
			],
			[
				-65,
				-108
			],
			[
				-108,
				-146
			],
			[
				-97,
				-100
			],
			[
				-87,
				-54
			],
			[
				-49,
				-62
			],
			[
				-11,
				-68
			],
			[
				-57,
				-78
			],
			[
				-102,
				-88
			],
			[
				-30,
				-39
			]
		],
		[
			[
				104427,
				102384
			],
			[
				177,
				-47
			],
			[
				8,
				-10
			],
			[
				1,
				-24
			],
			[
				6,
				-26
			],
			[
				171,
				-64
			],
			[
				49,
				-34
			],
			[
				106,
				-52
			],
			[
				27,
				-28
			],
			[
				98,
				-33
			],
			[
				69,
				-35
			],
			[
				82,
				-28
			],
			[
				95,
				-44
			],
			[
				128,
				-36
			],
			[
				108,
				-11
			],
			[
				271,
				-60
			],
			[
				47,
				-20
			],
			[
				78,
				-42
			],
			[
				79,
				-48
			],
			[
				55,
				-100
			],
			[
				88,
				-5
			],
			[
				24,
				-35
			],
			[
				76,
				-59
			],
			[
				107,
				-51
			],
			[
				-4,
				-18
			],
			[
				-85,
				-48
			],
			[
				-9,
				-65
			],
			[
				8,
				-82
			],
			[
				27,
				-68
			],
			[
				-3,
				-20
			],
			[
				-21,
				-23
			],
			[
				-25,
				-36
			],
			[
				-9,
				-32
			],
			[
				2,
				-16
			],
			[
				8,
				-8
			],
			[
				45,
				-1
			],
			[
				80,
				-8
			],
			[
				47,
				-14
			],
			[
				27,
				-77
			],
			[
				-10,
				-15
			],
			[
				-67,
				-36
			],
			[
				-20,
				-28
			],
			[
				-2,
				-41
			],
			[
				12,
				-45
			],
			[
				24,
				-50
			],
			[
				52,
				-54
			],
			[
				72,
				-57
			],
			[
				46,
				-46
			],
			[
				22,
				-33
			],
			[
				9,
				-23
			],
			[
				-33,
				-28
			],
			[
				-28,
				-57
			],
			[
				-6,
				-65
			],
			[
				-13,
				-43
			],
			[
				-63,
				-58
			],
			[
				-43,
				-21
			],
			[
				-13,
				-31
			],
			[
				-5,
				-51
			],
			[
				13,
				-63
			],
			[
				4,
				-43
			],
			[
				14,
				-30
			],
			[
				19,
				-21
			],
			[
				101,
				-35
			],
			[
				56,
				-72
			],
			[
				36,
				-59
			],
			[
				68,
				-152
			],
			[
				-16,
				-38
			],
			[
				18,
				-33
			],
			[
				21,
				-55
			],
			[
				-1,
				-37
			],
			[
				-47,
				-84
			]
		],
		[
			[
				93834,
				87828
			],
			[
				-10,
				-31
			],
			[
				-25,
				-34
			],
			[
				-85,
				-50
			],
			[
				-90,
				-32
			],
			[
				-46,
				4
			],
			[
				-31,
				17
			],
			[
				-17,
				18
			],
			[
				-48,
				17
			],
			[
				-65,
				9
			],
			[
				-41,
				-19
			],
			[
				-29,
				-18
			],
			[
				-26,
				3
			],
			[
				-19,
				15
			],
			[
				-15,
				23
			],
			[
				-19,
				71
			]
		],
		[
			[
				94976,
				87304
			],
			[
				-127,
				3
			],
			[
				-33,
				4
			],
			[
				-34,
				13
			],
			[
				-16,
				26
			],
			[
				-19,
				31
			],
			[
				5,
				19
			],
			[
				58,
				54
			],
			[
				8,
				15
			],
			[
				-6,
				8
			],
			[
				6,
				23
			],
			[
				45,
				81
			],
			[
				5,
				32
			],
			[
				-20,
				23
			],
			[
				-28,
				13
			],
			[
				-93,
				24
			],
			[
				-44,
				34
			],
			[
				-20,
				29
			],
			[
				-21,
				9
			],
			[
				-31,
				-10
			],
			[
				-76,
				-11
			],
			[
				-63,
				16
			],
			[
				-74,
				55
			],
			[
				-17,
				50
			],
			[
				-9,
				38
			],
			[
				-18,
				14
			],
			[
				-25,
				-20
			],
			[
				-31,
				-31
			],
			[
				-62,
				-4
			],
			[
				-18,
				8
			],
			[
				-3,
				17
			],
			[
				-4,
				16
			],
			[
				-17,
				20
			],
			[
				-18,
				12
			],
			[
				-79,
				-58
			],
			[
				-29,
				1
			],
			[
				-37,
				22
			],
			[
				-18,
				21
			],
			[
				-40,
				-12
			],
			[
				-37,
				-27
			],
			[
				13,
				-50
			],
			[
				-20,
				-9
			],
			[
				-45,
				5
			],
			[
				-50,
				20
			]
		],
		[
			[
				95202,
				86234
			],
			[
				25,
				4
			],
			[
				49,
				-12
			],
			[
				49,
				-40
			],
			[
				21,
				-40
			],
			[
				5,
				-22
			],
			[
				21,
				-24
			],
			[
				83,
				-107
			],
			[
				26,
				-6
			],
			[
				29,
				17
			],
			[
				19,
				23
			],
			[
				27,
				4
			],
			[
				43,
				-10
			],
			[
				28,
				-12
			],
			[
				13,
				-47
			],
			[
				10,
				-9
			],
			[
				19,
				10
			],
			[
				33,
				3
			],
			[
				53,
				-12
			],
			[
				74,
				13
			],
			[
				58,
				20
			],
			[
				30,
				-1
			],
			[
				49,
				-54
			],
			[
				55,
				-21
			],
			[
				121,
				-16
			],
			[
				131,
				-26
			],
			[
				51,
				-20
			],
			[
				35,
				-10
			],
			[
				4,
				-72
			],
			[
				-11,
				-11
			],
			[
				-130,
				-144
			],
			[
				-55,
				-52
			],
			[
				-27,
				-73
			],
			[
				-20,
				-113
			],
			[
				-38,
				-107
			],
			[
				-58,
				-102
			],
			[
				-21,
				-76
			],
			[
				16,
				-51
			],
			[
				-10,
				-80
			],
			[
				-35,
				-109
			],
			[
				-6,
				-82
			],
			[
				23,
				-56
			],
			[
				33,
				-11
			]
		],
		[
			[
				97257,
				84643
			],
			[
				-113,
				62
			],
			[
				-108,
				59
			],
			[
				-35,
				0
			],
			[
				-160,
				-12
			],
			[
				-4,
				5
			],
			[
				-28,
				34
			],
			[
				-24,
				11
			],
			[
				-15,
				-6
			],
			[
				-10,
				-9
			],
			[
				-17,
				1
			],
			[
				-72,
				55
			],
			[
				-29,
				8
			],
			[
				-40,
				-8
			],
			[
				-48,
				-29
			],
			[
				-21,
				-36
			],
			[
				6,
				-20
			],
			[
				25,
				-9
			],
			[
				65,
				6
			],
			[
				10,
				-6
			],
			[
				2,
				-12
			],
			[
				-7,
				-11
			],
			[
				-53,
				-10
			],
			[
				-16,
				-13
			],
			[
				-15,
				-4
			],
			[
				-10,
				-2
			],
			[
				-56,
				14
			],
			[
				-84,
				0
			],
			[
				-67,
				-25
			],
			[
				-108,
				-10
			],
			[
				-148,
				5
			],
			[
				-53,
				19
			]
		],
		[
			[
				97259,
				84434
			],
			[
				53,
				100
			],
			[
				11,
				62
			],
			[
				-47,
				37
			],
			[
				-19,
				10
			]
		],
		[
			[
				97293,
				84258
			],
			[
				-50,
				5
			],
			[
				-10,
				-1
			],
			[
				-5,
				29
			],
			[
				3,
				62
			],
			[
				28,
				81
			]
		],
		[
			[
				95640,
				83325
			],
			[
				-11,
				27
			],
			[
				-33,
				48
			],
			[
				-36,
				29
			],
			[
				-26,
				31
			],
			[
				-34,
				34
			],
			[
				-21,
				29
			],
			[
				29,
				90
			],
			[
				-21,
				32
			],
			[
				-11,
				46
			],
			[
				5,
				31
			],
			[
				-11,
				7
			],
			[
				-116,
				18
			],
			[
				-97,
				-6
			],
			[
				-69,
				-30
			],
			[
				-56,
				-50
			],
			[
				-7,
				-11
			],
			[
				3,
				-9
			],
			[
				28,
				-47
			],
			[
				-47,
				-48
			],
			[
				-73,
				-38
			],
			[
				-52,
				-4
			],
			[
				-23,
				7
			],
			[
				0,
				52
			],
			[
				42,
				20
			],
			[
				39,
				34
			],
			[
				13,
				48
			],
			[
				5,
				34
			],
			[
				-41,
				40
			],
			[
				5,
				25
			],
			[
				25,
				48
			],
			[
				15,
				42
			],
			[
				20,
				36
			],
			[
				80,
				60
			],
			[
				81,
				59
			],
			[
				12,
				64
			],
			[
				6,
				77
			],
			[
				12,
				18
			],
			[
				109,
				47
			],
			[
				27,
				18
			],
			[
				13,
				26
			],
			[
				86,
				87
			],
			[
				85,
				85
			],
			[
				17,
				29
			],
			[
				14,
				17
			],
			[
				0,
				14
			],
			[
				-10,
				11
			],
			[
				-41,
				7
			],
			[
				-13,
				27
			],
			[
				44,
				49
			],
			[
				55,
				30
			],
			[
				53,
				0
			],
			[
				21,
				-14
			],
			[
				-1,
				-16
			],
			[
				23,
				-17
			],
			[
				41,
				-6
			],
			[
				50,
				6
			],
			[
				49,
				18
			],
			[
				31,
				44
			],
			[
				18,
				32
			],
			[
				78,
				38
			]
		],
		[
			[
				86318,
				76112
			],
			[
				-39,
				205
			],
			[
				-19,
				79
			],
			[
				-5,
				51
			],
			[
				39,
				118
			],
			[
				42,
				48
			],
			[
				56,
				99
			],
			[
				69,
				82
			],
			[
				73,
				20
			],
			[
				32,
				12
			],
			[
				27,
				63
			],
			[
				15,
				55
			],
			[
				-11,
				5
			],
			[
				-85,
				-11
			],
			[
				-153,
				228
			],
			[
				4,
				36
			],
			[
				20,
				54
			],
			[
				12,
				68
			],
			[
				4,
				54
			],
			[
				39,
				46
			],
			[
				61,
				47
			],
			[
				52,
				66
			],
			[
				25,
				64
			],
			[
				6,
				59
			],
			[
				-29,
				42
			],
			[
				-84,
				23
			],
			[
				-86,
				167
			],
			[
				-19,
				105
			],
			[
				-18,
				11
			],
			[
				-53,
				48
			],
			[
				-51,
				89
			],
			[
				-8,
				14
			],
			[
				53,
				16
			],
			[
				217,
				1
			],
			[
				46,
				19
			],
			[
				7,
				7
			],
			[
				39,
				70
			],
			[
				42,
				114
			],
			[
				10,
				70
			],
			[
				-14,
				29
			],
			[
				-72,
				71
			],
			[
				-3,
				21
			],
			[
				12,
				33
			],
			[
				43,
				36
			],
			[
				58,
				40
			],
			[
				31,
				35
			],
			[
				-7,
				28
			],
			[
				-17,
				28
			],
			[
				-3,
				27
			],
			[
				11,
				33
			],
			[
				3,
				112
			],
			[
				8,
				29
			],
			[
				-12,
				101
			],
			[
				-14,
				84
			],
			[
				-45,
				107
			],
			[
				8,
				24
			],
			[
				21,
				20
			],
			[
				69,
				38
			],
			[
				56,
				88
			],
			[
				80,
				73
			],
			[
				105,
				60
			],
			[
				74,
				65
			],
			[
				29,
				50
			],
			[
				20,
				14
			],
			[
				-6,
				23
			],
			[
				-14,
				34
			],
			[
				-41,
				34
			],
			[
				-55,
				19
			],
			[
				-60,
				-1
			],
			[
				-37,
				7
			],
			[
				-11,
				26
			],
			[
				5,
				70
			],
			[
				-4,
				70
			],
			[
				-11,
				32
			],
			[
				-28,
				24
			],
			[
				-55,
				-6
			],
			[
				-48,
				19
			],
			[
				-36,
				5
			],
			[
				-21,
				-16
			],
			[
				-106,
				5
			],
			[
				-45,
				11
			],
			[
				-31,
				14
			],
			[
				-20,
				-8
			],
			[
				-11,
				-13
			],
			[
				-2,
				-22
			],
			[
				-7,
				-28
			],
			[
				-38,
				-25
			],
			[
				-87,
				-26
			],
			[
				-71,
				2
			],
			[
				-64,
				18
			],
			[
				-21,
				14
			],
			[
				-31,
				12
			],
			[
				-132,
				-15
			],
			[
				-16,
				11
			],
			[
				-45,
				-27
			],
			[
				-67,
				-31
			],
			[
				-37,
				-1
			],
			[
				-14,
				6
			],
			[
				-5,
				14
			],
			[
				-28,
				49
			],
			[
				8,
				25
			],
			[
				53,
				76
			],
			[
				-6,
				18
			],
			[
				-22,
				24
			],
			[
				-20,
				35
			],
			[
				-5,
				18
			],
			[
				-35,
				3
			],
			[
				-36,
				-18
			],
			[
				-139,
				-38
			],
			[
				-34,
				-14
			],
			[
				-60,
				-36
			],
			[
				-61,
				-56
			]
		],
		[
			[
				100029,
				85668
			],
			[
				-8,
				-16
			],
			[
				-3,
				-50
			],
			[
				1,
				-54
			],
			[
				-9,
				-28
			],
			[
				-40,
				-37
			],
			[
				-20,
				-8
			],
			[
				-11,
				-8
			],
			[
				-122,
				48
			],
			[
				-10,
				-8
			],
			[
				-7,
				-6
			],
			[
				-33,
				-140
			],
			[
				-22,
				-27
			],
			[
				-34,
				-25
			],
			[
				-69,
				-24
			],
			[
				-49,
				-10
			],
			[
				-37,
				-12
			],
			[
				-120,
				-59
			],
			[
				-53,
				-36
			],
			[
				-35,
				-44
			],
			[
				0,
				-26
			],
			[
				58,
				-75
			],
			[
				67,
				-78
			],
			[
				0,
				-68
			],
			[
				-30,
				-51
			],
			[
				-6,
				-20
			],
			[
				19,
				-7
			],
			[
				37,
				-3
			],
			[
				31,
				-9
			],
			[
				14,
				-36
			],
			[
				-4,
				-62
			],
			[
				-11,
				-59
			],
			[
				-11,
				-25
			],
			[
				-30,
				-2
			],
			[
				-58,
				26
			],
			[
				-44,
				29
			],
			[
				-18,
				18
			],
			[
				-1,
				22
			],
			[
				10,
				14
			],
			[
				-16,
				26
			],
			[
				-55,
				25
			],
			[
				-59,
				-11
			],
			[
				-44,
				-16
			],
			[
				-28,
				1
			],
			[
				-31,
				23
			],
			[
				-47,
				19
			],
			[
				-61,
				12
			],
			[
				-38,
				12
			],
			[
				-8,
				-7
			],
			[
				4,
				-52
			],
			[
				-11,
				-22
			],
			[
				-303,
				-30
			],
			[
				-93,
				-28
			],
			[
				-67,
				-36
			],
			[
				-50,
				-15
			],
			[
				-12,
				-22
			],
			[
				-49,
				-30
			],
			[
				-56,
				-9
			],
			[
				-13,
				10
			],
			[
				-36,
				-14
			],
			[
				-60,
				-13
			],
			[
				-40,
				4
			],
			[
				-18,
				24
			],
			[
				-38,
				36
			],
			[
				-15,
				25
			],
			[
				1,
				16
			],
			[
				-84,
				3
			],
			[
				-54,
				19
			],
			[
				-114,
				-4
			],
			[
				-28,
				8
			],
			[
				-6,
				-9
			],
			[
				-17,
				-102
			],
			[
				-22,
				-42
			],
			[
				-37,
				-44
			],
			[
				-46,
				-24
			],
			[
				-37,
				-4
			],
			[
				1,
				32
			],
			[
				10,
				38
			],
			[
				-27,
				9
			],
			[
				-40,
				4
			],
			[
				-20,
				11
			],
			[
				5,
				29
			],
			[
				-9,
				17
			],
			[
				-17,
				21
			],
			[
				-40,
				26
			],
			[
				-86,
				38
			],
			[
				-58,
				20
			],
			[
				-22,
				-21
			],
			[
				-41,
				-20
			],
			[
				-66,
				6
			],
			[
				-16,
				-8
			]
		],
		[
			[
				101501,
				84098
			],
			[
				-36,
				-15
			],
			[
				-39,
				-36
			],
			[
				2,
				-79
			],
			[
				-5,
				-7
			],
			[
				-9,
				-16
			],
			[
				-124,
				28
			],
			[
				-4,
				-1
			],
			[
				-82,
				-10
			],
			[
				-57,
				-36
			],
			[
				-68,
				-20
			],
			[
				-144,
				11
			],
			[
				-140,
				-14
			],
			[
				-33,
				-11
			],
			[
				-36,
				-6
			],
			[
				-34,
				-21
			],
			[
				-19,
				-30
			],
			[
				-35,
				-37
			],
			[
				-50,
				-29
			],
			[
				-53,
				-23
			],
			[
				-13,
				-19
			],
			[
				-18,
				-11
			],
			[
				-30,
				14
			],
			[
				-24,
				-1
			],
			[
				-30,
				10
			],
			[
				-98,
				11
			],
			[
				-109,
				17
			],
			[
				-51,
				17
			],
			[
				-59,
				13
			],
			[
				-63,
				11
			],
			[
				-57,
				2
			],
			[
				-28,
				5
			]
		],
		[
			[
				103015,
				80549
			],
			[
				12,
				4
			],
			[
				16,
				12
			],
			[
				36,
				34
			],
			[
				7,
				18
			],
			[
				-2,
				27
			],
			[
				-50,
				85
			],
			[
				-7,
				55
			],
			[
				-7,
				102
			],
			[
				11,
				25
			],
			[
				18,
				11
			],
			[
				87,
				13
			],
			[
				-1,
				80
			],
			[
				5,
				24
			],
			[
				18,
				33
			],
			[
				11,
				31
			],
			[
				48,
				43
			],
			[
				66,
				52
			],
			[
				29,
				1
			],
			[
				25,
				-7
			],
			[
				29,
				-44
			],
			[
				31,
				5
			],
			[
				6,
				54
			],
			[
				-41,
				70
			],
			[
				-21,
				45
			],
			[
				7,
				25
			],
			[
				15,
				13
			],
			[
				35,
				-9
			],
			[
				33,
				-12
			],
			[
				21,
				9
			],
			[
				34,
				6
			],
			[
				19,
				-2
			]
		],
		[
			[
				103505,
				81352
			],
			[
				39,
				42
			],
			[
				30,
				6
			],
			[
				38,
				2
			],
			[
				26,
				-22
			],
			[
				33,
				-4
			],
			[
				18,
				27
			],
			[
				10,
				39
			],
			[
				-4,
				50
			],
			[
				-80,
				117
			],
			[
				-69,
				81
			],
			[
				-8,
				18
			],
			[
				15,
				15
			],
			[
				24,
				8
			],
			[
				25,
				-6
			],
			[
				68,
				-6
			],
			[
				64,
				7
			],
			[
				23,
				20
			],
			[
				0,
				27
			],
			[
				-24,
				25
			],
			[
				-76,
				66
			],
			[
				-59,
				59
			],
			[
				-69,
				45
			],
			[
				-52,
				18
			],
			[
				-15,
				23
			],
			[
				-6,
				25
			],
			[
				6,
				45
			],
			[
				3,
				57
			],
			[
				12,
				36
			],
			[
				47,
				68
			],
			[
				44,
				72
			],
			[
				28,
				69
			],
			[
				14,
				64
			],
			[
				-5,
				18
			],
			[
				-24,
				14
			],
			[
				-49,
				14
			],
			[
				-68,
				-12
			],
			[
				-57,
				-23
			],
			[
				-23,
				-2
			]
		],
		[
			[
				103384,
				82454
			],
			[
				-43,
				-4
			],
			[
				-67,
				15
			],
			[
				-31,
				26
			],
			[
				-6,
				27
			],
			[
				0,
				25
			],
			[
				-22,
				40
			],
			[
				-54,
				43
			],
			[
				-112,
				6
			],
			[
				-42,
				14
			],
			[
				-43,
				15
			],
			[
				-47,
				11
			],
			[
				-43,
				-1
			],
			[
				-52,
				-11
			],
			[
				-91,
				19
			],
			[
				-31,
				-25
			],
			[
				-48,
				-29
			],
			[
				-40,
				1
			],
			[
				-79,
				66
			],
			[
				-24,
				4
			],
			[
				-69,
				-33
			],
			[
				-28,
				-2
			],
			[
				-22,
				11
			],
			[
				-93,
				25
			],
			[
				-43,
				5
			],
			[
				-31,
				-12
			],
			[
				-55,
				13
			],
			[
				-133,
				87
			],
			[
				-83,
				-66
			],
			[
				-168,
				16
			],
			[
				-50,
				-45
			],
			[
				-57,
				-85
			],
			[
				-46,
				-41
			],
			[
				-41,
				15
			],
			[
				-47,
				37
			],
			[
				-84,
				97
			],
			[
				-42,
				17
			],
			[
				-48,
				5
			],
			[
				-42,
				-11
			],
			[
				-23,
				-20
			],
			[
				-17,
				-141
			],
			[
				-15,
				-125
			],
			[
				-1,
				-75
			],
			[
				93,
				-69
			],
			[
				109,
				-119
			],
			[
				35,
				-13
			],
			[
				17,
				-39
			],
			[
				26,
				-101
			],
			[
				28,
				-113
			],
			[
				56,
				-74
			],
			[
				50,
				-54
			],
			[
				61,
				-47
			],
			[
				77,
				-74
			],
			[
				62,
				-81
			],
			[
				17,
				-29
			],
			[
				122,
				-107
			],
			[
				118,
				-110
			],
			[
				105,
				-38
			],
			[
				17,
				-20
			],
			[
				1,
				-84
			],
			[
				11,
				-32
			],
			[
				71,
				-88
			],
			[
				144,
				-128
			],
			[
				16,
				-30
			],
			[
				5,
				-22
			],
			[
				-9,
				-17
			],
			[
				-38,
				-18
			]
		],
		[
			[
				103384,
				82454
			],
			[
				-8,
				28
			],
			[
				10,
				13
			],
			[
				18,
				-1
			],
			[
				14,
				-6
			],
			[
				16,
				13
			],
			[
				10,
				39
			],
			[
				-24,
				135
			],
			[
				43,
				12
			],
			[
				1,
				19
			],
			[
				4,
				17
			],
			[
				44,
				-23
			],
			[
				63,
				0
			],
			[
				55,
				4
			],
			[
				8,
				14
			],
			[
				0,
				19
			],
			[
				-12,
				15
			],
			[
				-19,
				12
			],
			[
				-14,
				19
			],
			[
				-37,
				8
			],
			[
				-116,
				48
			],
			[
				-58,
				52
			],
			[
				2,
				55
			],
			[
				17,
				30
			],
			[
				20,
				10
			],
			[
				-6,
				10
			],
			[
				-66,
				26
			],
			[
				-23,
				35
			],
			[
				19,
				45
			],
			[
				-34,
				92
			],
			[
				-36,
				57
			],
			[
				36,
				24
			],
			[
				4,
				35
			],
			[
				3,
				20
			]
		],
		[
			[
				102057,
				85530
			],
			[
				21,
				64
			],
			[
				50,
				86
			],
			[
				47,
				49
			],
			[
				34,
				17
			],
			[
				70,
				-15
			],
			[
				120,
				-13
			],
			[
				92,
				12
			],
			[
				86,
				38
			],
			[
				47,
				33
			],
			[
				40,
				36
			],
			[
				13,
				22
			],
			[
				18,
				11
			],
			[
				71,
				20
			],
			[
				23,
				24
			],
			[
				9,
				45
			],
			[
				6,
				50
			],
			[
				15,
				37
			],
			[
				18,
				27
			],
			[
				132,
				65
			],
			[
				12,
				22
			],
			[
				21,
				23
			],
			[
				39,
				25
			],
			[
				38,
				36
			],
			[
				40,
				22
			],
			[
				51,
				-3
			],
			[
				48,
				5
			],
			[
				37,
				12
			],
			[
				16,
				2
			]
		],
		[
			[
				102182,
				85041
			],
			[
				-39,
				27
			],
			[
				-12,
				36
			],
			[
				-62,
				95
			],
			[
				-69,
				156
			],
			[
				-2,
				45
			],
			[
				27,
				51
			],
			[
				26,
				39
			],
			[
				3,
				31
			],
			[
				3,
				9
			]
		],
		[
			[
				102182,
				85041
			],
			[
				18,
				5
			],
			[
				66,
				-7
			],
			[
				16,
				-9
			],
			[
				10,
				-2
			],
			[
				106,
				-85
			],
			[
				100,
				-64
			],
			[
				81,
				-33
			],
			[
				121,
				-3
			],
			[
				127,
				-2
			],
			[
				214,
				11
			],
			[
				160,
				8
			],
			[
				11,
				16
			],
			[
				24,
				38
			],
			[
				-19,
				33
			],
			[
				1,
				39
			],
			[
				27,
				50
			],
			[
				79,
				42
			],
			[
				227,
				18
			],
			[
				130,
				31
			],
			[
				20,
				42
			],
			[
				43,
				42
			],
			[
				39,
				9
			],
			[
				55,
				-20
			],
			[
				65,
				-36
			],
			[
				57,
				-20
			],
			[
				33,
				13
			],
			[
				116,
				62
			],
			[
				132,
				60
			],
			[
				91,
				165
			],
			[
				10,
				26
			],
			[
				99,
				19
			],
			[
				144,
				-3
			],
			[
				74,
				-22
			],
			[
				56,
				-11
			],
			[
				83,
				4
			],
			[
				121,
				35
			],
			[
				44,
				-1
			],
			[
				35,
				-25
			],
			[
				37,
				-22
			],
			[
				26,
				-26
			],
			[
				19,
				-37
			],
			[
				11,
				-14
			],
			[
				16,
				-19
			],
			[
				31,
				-27
			],
			[
				29,
				-7
			],
			[
				223,
				46
			],
			[
				13,
				10
			]
		],
		[
			[
				100672,
				87393
			],
			[
				3,
				11
			],
			[
				67,
				113
			],
			[
				30,
				71
			],
			[
				34,
				130
			],
			[
				-41,
				103
			],
			[
				-12,
				48
			],
			[
				-19,
				23
			],
			[
				-117,
				50
			],
			[
				-9,
				17
			],
			[
				18,
				68
			],
			[
				-9,
				28
			],
			[
				-28,
				30
			],
			[
				-37,
				60
			],
			[
				-14,
				51
			],
			[
				47,
				60
			],
			[
				12,
				44
			],
			[
				20,
				60
			],
			[
				15,
				33
			],
			[
				3,
				9
			],
			[
				-31,
				23
			],
			[
				-8,
				33
			],
			[
				9,
				47
			],
			[
				-17,
				36
			],
			[
				-41,
				22
			],
			[
				-27,
				30
			],
			[
				-13,
				38
			],
			[
				10,
				59
			],
			[
				32,
				80
			],
			[
				-68,
				97
			],
			[
				-168,
				113
			],
			[
				-81,
				79
			],
			[
				7,
				45
			],
			[
				35,
				40
			],
			[
				64,
				37
			],
			[
				49,
				65
			],
			[
				27,
				77
			],
			[
				1,
				15
			],
			[
				2,
				55
			],
			[
				-75,
				225
			],
			[
				-12,
				56
			],
			[
				-9,
				68
			],
			[
				-44,
				175
			],
			[
				8,
				26
			]
		],
		[
			[
				105884,
				84992
			],
			[
				-13,
				11
			],
			[
				-6,
				30
			],
			[
				7,
				27
			],
			[
				-14,
				25
			],
			[
				-35,
				29
			],
			[
				-8,
				12
			],
			[
				-44,
				-2
			],
			[
				-12,
				-3
			],
			[
				-4,
				1
			],
			[
				-61,
				24
			],
			[
				-40,
				59
			],
			[
				-62,
				31
			],
			[
				-48,
				11
			],
			[
				-22,
				25
			],
			[
				-14,
				34
			],
			[
				-14,
				25
			],
			[
				-2,
				2
			],
			[
				-10,
				39
			],
			[
				-15,
				4
			],
			[
				-3,
				1
			],
			[
				-61,
				-7
			]
		],
		[
			[
				109573,
				81524
			],
			[
				-105,
				-1
			],
			[
				-31,
				4
			],
			[
				-99,
				23
			],
			[
				-111,
				40
			],
			[
				-66,
				80
			],
			[
				-41,
				57
			],
			[
				-95,
				-26
			],
			[
				-17,
				7
			],
			[
				-26,
				27
			],
			[
				-71,
				18
			],
			[
				-88,
				1
			],
			[
				-197,
				103
			],
			[
				-22,
				18
			],
			[
				-154,
				-17
			],
			[
				-232,
				-52
			],
			[
				-176,
				-63
			],
			[
				-183,
				-113
			],
			[
				-74,
				-85
			],
			[
				-86,
				-46
			],
			[
				-122,
				-34
			],
			[
				-218,
				13
			],
			[
				-227,
				43
			],
			[
				-244,
				46
			],
			[
				-132,
				-25
			],
			[
				-178,
				19
			],
			[
				-269,
				55
			],
			[
				-200,
				17
			],
			[
				-197,
				-33
			],
			[
				-34,
				25
			],
			[
				-7,
				29
			],
			[
				8,
				40
			],
			[
				28,
				32
			],
			[
				47,
				25
			],
			[
				26,
				25
			],
			[
				2,
				25
			],
			[
				-53,
				41
			],
			[
				-110,
				56
			],
			[
				-46,
				35
			]
		],
		[
			[
				104182,
				83476
			],
			[
				38,
				-48
			],
			[
				37,
				-62
			],
			[
				51,
				-29
			],
			[
				62,
				-34
			],
			[
				31,
				-24
			],
			[
				46,
				-75
			],
			[
				37,
				-36
			],
			[
				12,
				2
			],
			[
				12,
				9
			],
			[
				9,
				8
			],
			[
				9,
				-7
			],
			[
				1,
				-23
			],
			[
				2,
				-49
			],
			[
				-9,
				-54
			],
			[
				13,
				-50
			],
			[
				1,
				-16
			],
			[
				-9,
				-14
			],
			[
				1,
				-13
			],
			[
				13,
				-14
			],
			[
				49,
				-33
			],
			[
				46,
				-51
			],
			[
				53,
				-36
			],
			[
				49,
				-23
			],
			[
				31,
				-2
			],
			[
				51,
				-41
			],
			[
				100,
				-30
			],
			[
				32,
				-11
			],
			[
				22,
				-17
			],
			[
				16,
				-19
			],
			[
				1,
				-22
			],
			[
				-15,
				-10
			],
			[
				-22,
				-28
			],
			[
				-9,
				-35
			],
			[
				-16,
				-9
			],
			[
				-16,
				-1
			],
			[
				-11,
				-10
			],
			[
				2,
				-15
			],
			[
				14,
				-14
			],
			[
				21,
				-13
			],
			[
				40,
				-13
			],
			[
				39,
				-19
			],
			[
				0,
				-15
			],
			[
				-8,
				-17
			],
			[
				-51,
				-6
			],
			[
				-37,
				-3
			],
			[
				-17,
				-6
			],
			[
				1,
				-29
			]
		],
		[
			[
				105910,
				79540
			],
			[
				70,
				-9
			],
			[
				85,
				-2
			],
			[
				54,
				51
			],
			[
				85,
				4
			],
			[
				40,
				8
			],
			[
				66,
				-11
			],
			[
				64,
				1
			],
			[
				82,
				22
			],
			[
				77,
				35
			],
			[
				60,
				-3
			],
			[
				24,
				6
			],
			[
				14,
				8
			],
			[
				15,
				48
			],
			[
				113,
				3
			],
			[
				38,
				-5
			],
			[
				63,
				-1
			],
			[
				65,
				26
			],
			[
				20,
				-2
			],
			[
				33,
				-71
			],
			[
				17,
				-20
			],
			[
				36,
				-19
			],
			[
				79,
				-52
			],
			[
				14,
				13
			],
			[
				33,
				18
			],
			[
				95,
				-24
			],
			[
				90,
				-41
			],
			[
				76,
				-59
			],
			[
				85,
				17
			],
			[
				94,
				29
			],
			[
				61,
				9
			],
			[
				66,
				4
			],
			[
				39,
				12
			],
			[
				90,
				-15
			],
			[
				92,
				32
			],
			[
				45,
				29
			],
			[
				12,
				41
			],
			[
				-7,
				71
			],
			[
				-21,
				72
			],
			[
				-22,
				26
			],
			[
				-7,
				27
			],
			[
				12,
				26
			],
			[
				15,
				17
			],
			[
				60,
				15
			],
			[
				78,
				-22
			]
		],
		[
			[
				108110,
				79854
			],
			[
				57,
				-17
			],
			[
				34,
				-27
			],
			[
				21,
				-25
			],
			[
				32,
				-21
			],
			[
				24,
				-5
			],
			[
				18,
				-74
			],
			[
				10,
				-91
			],
			[
				-15,
				-39
			],
			[
				-42,
				-9
			],
			[
				-133,
				-86
			],
			[
				-3,
				-79
			],
			[
				1,
				-38
			],
			[
				3,
				-27
			],
			[
				14,
				-23
			],
			[
				0,
				-32
			],
			[
				-15,
				-36
			],
			[
				-58,
				-58
			],
			[
				-40,
				-47
			],
			[
				-45,
				-64
			],
			[
				-26,
				-7
			],
			[
				-20,
				-11
			]
		],
		[
			[
				104067,
				80539
			],
			[
				-12,
				2
			],
			[
				-69,
				-36
			],
			[
				-51,
				-16
			],
			[
				-46,
				-9
			],
			[
				-22,
				17
			],
			[
				-11,
				24
			],
			[
				2,
				67
			],
			[
				-8,
				23
			],
			[
				-16,
				11
			],
			[
				-32,
				-16
			],
			[
				-37,
				-52
			],
			[
				-34,
				-61
			],
			[
				-51,
				-63
			],
			[
				-42,
				-60
			],
			[
				-46,
				-77
			],
			[
				-31,
				-63
			],
			[
				32,
				-36
			],
			[
				20,
				-49
			],
			[
				-6,
				-38
			],
			[
				6,
				-21
			],
			[
				-10,
				-65
			],
			[
				-2,
				-41
			]
		],
		[
			[
				108302,
				85250
			],
			[
				61,
				3
			],
			[
				48,
				-6
			],
			[
				73,
				-37
			],
			[
				52,
				-46
			],
			[
				20,
				-37
			],
			[
				44,
				-52
			],
			[
				47,
				-73
			],
			[
				50,
				-97
			],
			[
				12,
				-49
			],
			[
				19,
				-53
			],
			[
				38,
				-64
			],
			[
				73,
				-72
			],
			[
				10,
				-13
			],
			[
				33,
				-51
			],
			[
				63,
				-111
			],
			[
				53,
				-45
			],
			[
				46,
				-48
			],
			[
				23,
				-49
			],
			[
				33,
				-45
			],
			[
				78,
				-58
			],
			[
				63,
				-54
			],
			[
				50,
				-153
			],
			[
				36,
				-71
			],
			[
				22,
				-54
			],
			[
				-11,
				-110
			],
			[
				14,
				-47
			],
			[
				-29,
				-85
			],
			[
				-52,
				-172
			],
			[
				-12,
				-137
			],
			[
				9,
				-74
			],
			[
				1,
				-48
			],
			[
				13,
				-30
			],
			[
				13,
				-62
			],
			[
				3,
				-55
			],
			[
				-19,
				-15
			],
			[
				-26,
				-13
			],
			[
				-10,
				-11
			],
			[
				24,
				-25
			],
			[
				32,
				-46
			],
			[
				33,
				-52
			]
		],
		[
			[
				105884,
				84992
			],
			[
				24,
				14
			],
			[
				91,
				35
			],
			[
				23,
				35
			],
			[
				32,
				32
			],
			[
				41,
				-3
			],
			[
				133,
				-78
			],
			[
				142,
				5
			],
			[
				26,
				-3
			],
			[
				8,
				-1
			],
			[
				18,
				-7
			],
			[
				189,
				-38
			],
			[
				30,
				4
			],
			[
				8,
				3
			],
			[
				76,
				-32
			],
			[
				67,
				4
			],
			[
				64,
				23
			],
			[
				67,
				7
			],
			[
				61,
				-13
			],
			[
				47,
				-45
			],
			[
				120,
				-96
			],
			[
				36,
				-35
			],
			[
				56,
				5
			],
			[
				61,
				18
			],
			[
				62,
				64
			],
			[
				190,
				72
			],
			[
				145,
				18
			],
			[
				142,
				29
			],
			[
				164,
				21
			],
			[
				48,
				59
			],
			[
				26,
				40
			],
			[
				19,
				75
			],
			[
				88,
				21
			],
			[
				84,
				16
			],
			[
				30,
				9
			]
		],
		[
			[
				105666,
				85920
			],
			[
				26,
				4
			],
			[
				79,
				-31
			],
			[
				70,
				-16
			],
			[
				19,
				15
			],
			[
				8,
				20
			],
			[
				-3,
				15
			],
			[
				-56,
				46
			],
			[
				-35,
				29
			],
			[
				-3,
				17
			],
			[
				13,
				40
			],
			[
				7,
				45
			],
			[
				-8,
				48
			],
			[
				-38,
				107
			],
			[
				-8,
				46
			],
			[
				37,
				55
			],
			[
				119,
				132
			],
			[
				40,
				50
			],
			[
				54,
				60
			],
			[
				148,
				143
			],
			[
				93,
				83
			],
			[
				63,
				47
			],
			[
				92,
				80
			],
			[
				41,
				41
			],
			[
				168,
				27
			],
			[
				21,
				39
			],
			[
				31,
				42
			],
			[
				24,
				18
			],
			[
				3,
				72
			],
			[
				-31,
				87
			],
			[
				-25,
				31
			],
			[
				-19,
				21
			],
			[
				12,
				19
			],
			[
				19,
				6
			],
			[
				23,
				3
			],
			[
				28,
				21
			],
			[
				-6,
				23
			],
			[
				-71,
				56
			],
			[
				-31,
				43
			],
			[
				-48,
				110
			],
			[
				-98,
				114
			],
			[
				-31,
				37
			],
			[
				-4,
				35
			],
			[
				14,
				35
			],
			[
				-13,
				45
			],
			[
				-35,
				57
			]
		],
		[
			[
				106355,
				87937
			],
			[
				-43,
				83
			],
			[
				4,
				75
			],
			[
				23,
				43
			],
			[
				29,
				39
			],
			[
				-12,
				58
			],
			[
				29,
				77
			],
			[
				0,
				56
			],
			[
				-12,
				24
			],
			[
				-23,
				27
			],
			[
				-62,
				31
			],
			[
				-28,
				24
			],
			[
				-85,
				32
			],
			[
				-84,
				40
			],
			[
				-14,
				25
			],
			[
				4,
				17
			],
			[
				15,
				25
			],
			[
				64,
				75
			],
			[
				69,
				72
			],
			[
				45,
				29
			],
			[
				236,
				93
			],
			[
				36,
				33
			],
			[
				9,
				55
			],
			[
				1,
				40
			],
			[
				-5,
				71
			],
			[
				-14,
				101
			],
			[
				-18,
				70
			],
			[
				-45,
				131
			],
			[
				-123,
				270
			],
			[
				-74,
				281
			]
		],
		[
			[
				104607,
				91045
			],
			[
				113,
				-20
			],
			[
				144,
				1
			],
			[
				59,
				10
			],
			[
				37,
				-34
			],
			[
				70,
				-33
			],
			[
				83,
				-28
			],
			[
				123,
				-50
			],
			[
				128,
				-30
			],
			[
				43,
				-4
			],
			[
				135,
				4
			],
			[
				142,
				-4
			],
			[
				39,
				-73
			],
			[
				71,
				-34
			],
			[
				57,
				-48
			],
			[
				4,
				-27
			],
			[
				-79,
				-170
			],
			[
				-16,
				-57
			],
			[
				-3,
				-58
			],
			[
				29,
				-72
			],
			[
				27,
				-40
			]
		],
		[
			[
				111626,
				88418
			],
			[
				-3,
				20
			],
			[
				-44,
				78
			],
			[
				-26,
				35
			],
			[
				-32,
				18
			],
			[
				-15,
				23
			],
			[
				-1,
				94
			],
			[
				6,
				87
			],
			[
				20,
				12
			],
			[
				-58,
				71
			],
			[
				-5,
				55
			],
			[
				29,
				27
			],
			[
				1,
				22
			],
			[
				-20,
				33
			],
			[
				-59,
				52
			],
			[
				-58,
				59
			],
			[
				-38,
				47
			],
			[
				-23,
				22
			],
			[
				28,
				36
			],
			[
				40,
				65
			],
			[
				16,
				37
			],
			[
				19,
				10
			],
			[
				93,
				5
			],
			[
				69,
				-1
			],
			[
				51,
				-14
			],
			[
				19,
				-31
			],
			[
				47,
				-33
			],
			[
				133,
				-14
			],
			[
				56,
				1
			],
			[
				70,
				31
			],
			[
				113,
				68
			],
			[
				28,
				49
			],
			[
				70,
				35
			],
			[
				43,
				13
			],
			[
				39,
				6
			],
			[
				4,
				29
			],
			[
				-3,
				40
			],
			[
				-13,
				24
			],
			[
				-140,
				81
			],
			[
				-17,
				27
			],
			[
				-11,
				31
			],
			[
				16,
				30
			],
			[
				0,
				32
			],
			[
				-162,
				73
			],
			[
				-134,
				13
			],
			[
				-111,
				-4
			],
			[
				-43,
				15
			],
			[
				19,
				37
			],
			[
				27,
				66
			],
			[
				8,
				54
			],
			[
				-8,
				25
			],
			[
				-22,
				21
			],
			[
				-105,
				45
			],
			[
				-146,
				70
			],
			[
				-67,
				79
			],
			[
				-35,
				83
			],
			[
				-39,
				50
			],
			[
				-71,
				32
			],
			[
				5,
				21
			],
			[
				47,
				78
			],
			[
				-2,
				11
			],
			[
				-20,
				20
			],
			[
				-88,
				39
			],
			[
				-120,
				72
			],
			[
				-5,
				18
			],
			[
				8,
				46
			],
			[
				17,
				44
			],
			[
				24,
				22
			],
			[
				71,
				90
			],
			[
				0,
				31
			],
			[
				-12,
				41
			],
			[
				-52,
				71
			],
			[
				-41,
				45
			],
			[
				-3,
				24
			],
			[
				7,
				19
			],
			[
				26,
				25
			],
			[
				25,
				30
			],
			[
				6,
				106
			],
			[
				-1,
				37
			],
			[
				-16,
				21
			],
			[
				-17,
				9
			],
			[
				-36,
				-5
			],
			[
				-51,
				17
			],
			[
				-38,
				28
			],
			[
				-24,
				9
			],
			[
				-25,
				28
			],
			[
				-72,
				56
			],
			[
				-13,
				15
			],
			[
				-143,
				48
			],
			[
				-124,
				-7
			],
			[
				-68,
				7
			],
			[
				-36,
				-10
			],
			[
				-37,
				-31
			],
			[
				-52,
				-20
			],
			[
				-38,
				-1
			],
			[
				-35,
				-15
			],
			[
				-96,
				-55
			],
			[
				-45,
				33
			],
			[
				-38,
				49
			],
			[
				13,
				42
			],
			[
				16,
				38
			],
			[
				-2,
				26
			],
			[
				-13,
				22
			],
			[
				-60,
				24
			],
			[
				-126,
				44
			],
			[
				-36,
				0
			],
			[
				-54,
				-16
			],
			[
				-99,
				-49
			],
			[
				-35,
				10
			],
			[
				-32,
				39
			],
			[
				-35,
				49
			],
			[
				-47,
				25
			],
			[
				-102,
				-3
			],
			[
				-9,
				-1
			],
			[
				-49,
				-29
			],
			[
				-21,
				3
			],
			[
				-88,
				72
			]
		],
		[
			[
				111626,
				88418
			],
			[
				12,
				-2
			],
			[
				60,
				-23
			],
			[
				64,
				-20
			],
			[
				44,
				-1
			],
			[
				52,
				4
			],
			[
				61,
				27
			],
			[
				43,
				25
			],
			[
				51,
				131
			],
			[
				19,
				19
			],
			[
				28,
				10
			],
			[
				47,
				1
			],
			[
				89,
				-24
			],
			[
				104,
				-22
			],
			[
				60,
				3
			],
			[
				161,
				69
			],
			[
				89,
				11
			],
			[
				107,
				-16
			],
			[
				104,
				-1
			],
			[
				79,
				10
			],
			[
				54,
				-24
			],
			[
				67,
				-53
			],
			[
				60,
				-79
			],
			[
				63,
				-145
			],
			[
				184,
				-165
			],
			[
				3,
				-32
			],
			[
				-15,
				-20
			],
			[
				-90,
				-20
			],
			[
				-77,
				-11
			],
			[
				-3,
				-28
			],
			[
				20,
				-31
			],
			[
				35,
				-45
			],
			[
				5,
				-57
			],
			[
				-1,
				-53
			],
			[
				15,
				-47
			],
			[
				29,
				-19
			],
			[
				3,
				-23
			],
			[
				-33,
				-29
			],
			[
				-10,
				-18
			],
			[
				13,
				-9
			],
			[
				166,
				-6
			],
			[
				82,
				-28
			],
			[
				61,
				-25
			],
			[
				31,
				-3
			],
			[
				70,
				17
			],
			[
				79,
				10
			],
			[
				48,
				1
			],
			[
				18,
				-18
			],
			[
				15,
				-50
			],
			[
				27,
				-49
			],
			[
				26,
				-14
			],
			[
				46,
				2
			],
			[
				28,
				-2
			],
			[
				14,
				-19
			],
			[
				-16,
				-28
			],
			[
				4,
				-31
			],
			[
				20,
				-37
			],
			[
				24,
				-87
			],
			[
				22,
				-26
			],
			[
				15,
				-33
			],
			[
				0,
				-37
			],
			[
				-19,
				-33
			],
			[
				-13,
				-26
			],
			[
				13,
				-59
			],
			[
				50,
				-66
			],
			[
				37,
				-16
			],
			[
				29,
				-59
			],
			[
				53,
				-19
			],
			[
				80,
				50
			],
			[
				60,
				26
			],
			[
				76,
				-15
			],
			[
				70,
				-9
			],
			[
				48,
				-34
			],
			[
				35,
				-46
			],
			[
				40,
				-26
			],
			[
				41,
				14
			],
			[
				84,
				-14
			],
			[
				39,
				-37
			],
			[
				39,
				-21
			],
			[
				49,
				30
			],
			[
				41,
				38
			],
			[
				148,
				39
			],
			[
				92,
				10
			],
			[
				26,
				8
			],
			[
				54,
				28
			],
			[
				57,
				18
			],
			[
				52,
				-5
			],
			[
				50,
				-58
			],
			[
				53,
				-40
			],
			[
				14,
				-64
			],
			[
				64,
				-87
			],
			[
				159,
				-119
			],
			[
				63,
				-37
			],
			[
				42,
				7
			],
			[
				22,
				9
			],
			[
				11,
				13
			],
			[
				9,
				58
			],
			[
				20,
				21
			],
			[
				33,
				1
			],
			[
				124,
				-73
			],
			[
				65,
				-7
			],
			[
				62,
				-2
			],
			[
				83,
				-56
			],
			[
				92,
				-50
			],
			[
				71,
				-5
			],
			[
				56,
				20
			],
			[
				39,
				11
			],
			[
				23,
				-19
			],
			[
				23,
				-42
			],
			[
				36,
				-33
			],
			[
				43,
				-9
			],
			[
				61,
				-2
			],
			[
				105,
				-64
			],
			[
				100,
				-65
			],
			[
				62,
				-4
			],
			[
				53,
				20
			],
			[
				47,
				4
			],
			[
				32,
				-16
			],
			[
				9,
				-28
			],
			[
				-24,
				-38
			],
			[
				0,
				-54
			],
			[
				44,
				-51
			],
			[
				2,
				-51
			],
			[
				-13,
				-46
			],
			[
				-25,
				-42
			],
			[
				-61,
				-59
			],
			[
				-56,
				-54
			],
			[
				-84,
				-22
			],
			[
				-47,
				-24
			],
			[
				13,
				-40
			],
			[
				30,
				-37
			],
			[
				72,
				-30
			],
			[
				81,
				-22
			],
			[
				9,
				-24
			],
			[
				-12,
				-13
			],
			[
				-52,
				-11
			],
			[
				-72,
				12
			],
			[
				-24,
				-21
			],
			[
				-33,
				-36
			],
			[
				-22,
				-63
			],
			[
				-17,
				-59
			],
			[
				78,
				-16
			],
			[
				46,
				-24
			],
			[
				14,
				-48
			],
			[
				16,
				-54
			],
			[
				5,
				-48
			],
			[
				-26,
				-24
			],
			[
				-2,
				-24
			],
			[
				12,
				-11
			],
			[
				34,
				-6
			],
			[
				26,
				-11
			],
			[
				2,
				-25
			],
			[
				-50,
				-57
			],
			[
				-45,
				-110
			],
			[
				-25,
				-59
			],
			[
				2,
				-63
			],
			[
				-28,
				-35
			],
			[
				-50,
				-3
			],
			[
				-173,
				-6
			],
			[
				-150,
				3
			],
			[
				-65,
				9
			],
			[
				-102,
				5
			],
			[
				-50,
				-15
			],
			[
				-67,
				-101
			],
			[
				-51,
				-40
			],
			[
				-83,
				-36
			],
			[
				-92,
				-10
			],
			[
				-53,
				-42
			],
			[
				-18,
				-66
			],
			[
				-2,
				-58
			],
			[
				-8,
				-29
			],
			[
				-20,
				-25
			],
			[
				-7,
				-18
			],
			[
				4,
				-20
			],
			[
				21,
				-8
			],
			[
				26,
				-9
			],
			[
				0,
				-14
			],
			[
				-10,
				-19
			],
			[
				-29,
				-20
			],
			[
				-12,
				-30
			],
			[
				2,
				-33
			],
			[
				6,
				-37
			]
		],
		[
			[
				119170,
				79351
			],
			[
				10,
				-35
			],
			[
				40,
				-49
			],
			[
				48,
				-30
			],
			[
				26,
				-33
			],
			[
				42,
				-111
			],
			[
				17,
				-61
			],
			[
				-6,
				-60
			],
			[
				-29,
				-60
			],
			[
				-64,
				-76
			],
			[
				16,
				-32
			],
			[
				14,
				-41
			],
			[
				-5,
				-31
			],
			[
				45,
				-96
			],
			[
				21,
				-60
			],
			[
				-17,
				-14
			],
			[
				-11,
				-20
			],
			[
				81,
				-46
			],
			[
				97,
				-39
			],
			[
				41,
				-7
			],
			[
				111,
				18
			],
			[
				72,
				4
			],
			[
				71,
				-37
			],
			[
				104,
				-89
			],
			[
				112,
				-117
			],
			[
				23,
				-35
			]
		],
		[
			[
				120029,
				78194
			],
			[
				9,
				-16
			],
			[
				22,
				-28
			]
		],
		[
			[
				120060,
				78150
			],
			[
				14,
				-18
			],
			[
				104,
				-169
			],
			[
				47,
				-50
			],
			[
				26,
				-42
			],
			[
				19,
				-48
			],
			[
				31,
				-32
			],
			[
				43,
				-17
			],
			[
				51,
				-46
			],
			[
				35,
				-35
			],
			[
				58,
				-74
			],
			[
				62,
				-28
			],
			[
				224,
				-53
			],
			[
				124,
				-25
			]
		],
		[
			[
				120898,
				77513
			],
			[
				36,
				-7
			],
			[
				96,
				36
			],
			[
				111,
				-5
			]
		],
		[
			[
				121141,
				77537
			],
			[
				42,
				-2
			],
			[
				147,
				151
			],
			[
				45,
				50
			],
			[
				88,
				26
			],
			[
				50,
				60
			],
			[
				79,
				73
			],
			[
				97,
				68
			],
			[
				89,
				62
			],
			[
				68,
				37
			],
			[
				124,
				86
			],
			[
				77,
				31
			],
			[
				67,
				-1
			],
			[
				100,
				-102
			],
			[
				85,
				-93
			],
			[
				26,
				-40
			],
			[
				-42,
				-37
			],
			[
				-78,
				-35
			],
			[
				-15,
				-26
			],
			[
				-6,
				-33
			],
			[
				3,
				-31
			],
			[
				11,
				-26
			],
			[
				96,
				-60
			],
			[
				11,
				-33
			],
			[
				0,
				-33
			],
			[
				-11,
				-21
			],
			[
				-21,
				-12
			],
			[
				-67,
				-17
			],
			[
				-57,
				-19
			],
			[
				-20,
				-19
			],
			[
				-17,
				-23
			],
			[
				2,
				-25
			],
			[
				18,
				-29
			],
			[
				117,
				-78
			],
			[
				13,
				-29
			],
			[
				23,
				-38
			],
			[
				29,
				-24
			],
			[
				49,
				-7
			],
			[
				23,
				-16
			],
			[
				114,
				-144
			],
			[
				27,
				-10
			],
			[
				133,
				32
			],
			[
				18,
				-2
			]
		],
		[
			[
				147844,
				85994
			],
			[
				75,
				2
			],
			[
				34,
				18
			],
			[
				27,
				28
			],
			[
				56,
				30
			],
			[
				12,
				34
			],
			[
				1,
				69
			],
			[
				37,
				58
			],
			[
				93,
				17
			],
			[
				36,
				9
			],
			[
				38,
				-9
			],
			[
				60,
				8
			],
			[
				57,
				3
			],
			[
				32,
				-18
			],
			[
				42,
				-15
			],
			[
				54,
				2
			],
			[
				19,
				27
			],
			[
				2,
				38
			],
			[
				24,
				10
			],
			[
				29,
				-26
			],
			[
				16,
				-20
			],
			[
				25,
				-9
			],
			[
				65,
				24
			],
			[
				46,
				25
			],
			[
				14,
				53
			],
			[
				27,
				25
			],
			[
				36,
				-13
			],
			[
				62,
				1
			],
			[
				51,
				40
			],
			[
				67,
				32
			],
			[
				49,
				15
			],
			[
				10,
				27
			],
			[
				-23,
				60
			],
			[
				6,
				66
			],
			[
				65,
				37
			],
			[
				87,
				5
			],
			[
				64,
				25
			],
			[
				18,
				70
			],
			[
				31,
				20
			],
			[
				32,
				8
			],
			[
				78,
				11
			],
			[
				57,
				29
			],
			[
				34,
				13
			],
			[
				98,
				38
			],
			[
				90,
				7
			],
			[
				38,
				31
			],
			[
				30,
				38
			],
			[
				50,
				15
			],
			[
				51,
				33
			],
			[
				67,
				43
			],
			[
				27,
				6
			],
			[
				111,
				24
			],
			[
				43,
				9
			],
			[
				26,
				6
			],
			[
				48,
				-2
			],
			[
				20,
				45
			],
			[
				49,
				33
			],
			[
				48,
				11
			],
			[
				24,
				32
			],
			[
				47,
				42
			],
			[
				63,
				23
			],
			[
				99,
				3
			],
			[
				95,
				-4
			],
			[
				57,
				7
			],
			[
				47,
				61
			],
			[
				9,
				31
			],
			[
				11,
				31
			],
			[
				38,
				12
			],
			[
				46,
				-51
			],
			[
				39,
				-31
			],
			[
				60,
				-33
			],
			[
				30,
				-30
			],
			[
				36,
				-5
			],
			[
				37,
				23
			],
			[
				26,
				56
			],
			[
				50,
				9
			],
			[
				55,
				-9
			],
			[
				14,
				-28
			],
			[
				5,
				-26
			],
			[
				25,
				-48
			],
			[
				60,
				-42
			],
			[
				77,
				2
			],
			[
				31,
				8
			],
			[
				76,
				-6
			],
			[
				73,
				-9
			],
			[
				81,
				-10
			],
			[
				23,
				-2
			],
			[
				87,
				-5
			],
			[
				125,
				-7
			],
			[
				56,
				3
			],
			[
				113,
				-13
			],
			[
				23,
				-37
			],
			[
				21,
				-88
			],
			[
				18,
				-84
			],
			[
				5,
				-67
			],
			[
				29,
				-35
			],
			[
				38,
				-11
			],
			[
				25,
				-27
			],
			[
				44,
				-37
			],
			[
				32,
				-53
			],
			[
				39,
				3
			],
			[
				28,
				13
			],
			[
				60,
				4
			],
			[
				77,
				-4
			],
			[
				53,
				-29
			],
			[
				21,
				-39
			],
			[
				43,
				-21
			],
			[
				35,
				7
			],
			[
				106,
				0
			],
			[
				36,
				-2
			],
			[
				36,
				-22
			],
			[
				53,
				-3
			],
			[
				28,
				27
			],
			[
				91,
				18
			],
			[
				53,
				38
			],
			[
				40,
				1
			],
			[
				31,
				-19
			],
			[
				24,
				-25
			],
			[
				34,
				11
			],
			[
				19,
				21
			],
			[
				30,
				0
			],
			[
				30,
				-13
			],
			[
				76,
				-24
			],
			[
				56,
				-44
			],
			[
				42,
				-4
			],
			[
				55,
				13
			],
			[
				26,
				6
			],
			[
				24,
				-22
			],
			[
				36,
				-11
			],
			[
				27,
				16
			],
			[
				46,
				11
			],
			[
				177,
				-24
			],
			[
				41,
				-43
			],
			[
				31,
				-21
			],
			[
				26,
				-35
			],
			[
				46,
				-26
			],
			[
				98,
				9
			],
			[
				37,
				26
			],
			[
				80,
				58
			],
			[
				31,
				56
			],
			[
				40,
				18
			],
			[
				45,
				9
			],
			[
				42,
				0
			],
			[
				44,
				2
			],
			[
				53,
				41
			],
			[
				44,
				15
			],
			[
				64,
				52
			],
			[
				12,
				24
			],
			[
				31,
				61
			],
			[
				20,
				39
			],
			[
				32,
				61
			],
			[
				17,
				100
			],
			[
				10,
				53
			],
			[
				-8,
				38
			],
			[
				-38,
				20
			],
			[
				-49,
				9
			],
			[
				-43,
				29
			],
			[
				-31,
				34
			],
			[
				-19,
				47
			],
			[
				-25,
				55
			],
			[
				1,
				40
			],
			[
				-7,
				31
			],
			[
				-22,
				27
			],
			[
				-41,
				46
			],
			[
				-20,
				35
			],
			[
				7,
				54
			],
			[
				49,
				94
			],
			[
				4,
				43
			],
			[
				6,
				27
			],
			[
				-2,
				25
			],
			[
				15,
				56
			],
			[
				27,
				24
			],
			[
				32,
				60
			],
			[
				42,
				27
			],
			[
				53,
				2
			],
			[
				22,
				17
			],
			[
				12,
				60
			],
			[
				25,
				46
			],
			[
				17,
				33
			],
			[
				32,
				35
			],
			[
				186,
				69
			],
			[
				77,
				86
			],
			[
				28,
				43
			],
			[
				30,
				93
			],
			[
				28,
				39
			],
			[
				42,
				-13
			],
			[
				50,
				-54
			],
			[
				36,
				-1
			],
			[
				55,
				-30
			],
			[
				149,
				-62
			],
			[
				81,
				-19
			],
			[
				52,
				-6
			],
			[
				69,
				-18
			],
			[
				44,
				-36
			],
			[
				87,
				-59
			],
			[
				73,
				-15
			],
			[
				126,
				-6
			],
			[
				154,
				-4
			],
			[
				44,
				-10
			],
			[
				113,
				-43
			],
			[
				124,
				-47
			],
			[
				118,
				-42
			],
			[
				89,
				-33
			],
			[
				52,
				-32
			],
			[
				50,
				-18
			],
			[
				54,
				16
			],
			[
				68,
				-4
			],
			[
				162,
				-38
			],
			[
				102,
				-32
			],
			[
				86,
				-24
			],
			[
				28,
				-33
			],
			[
				3,
				-43
			],
			[
				-11,
				-37
			],
			[
				6,
				-90
			],
			[
				27,
				-47
			],
			[
				11,
				-62
			],
			[
				10,
				-61
			],
			[
				-7,
				-59
			],
			[
				13,
				-31
			],
			[
				26,
				-19
			],
			[
				26,
				-41
			],
			[
				-8,
				-44
			],
			[
				-12,
				-26
			],
			[
				2,
				-40
			],
			[
				31,
				-34
			],
			[
				46,
				-7
			],
			[
				40,
				-8
			],
			[
				50,
				-54
			],
			[
				88,
				-61
			],
			[
				53,
				-17
			],
			[
				61,
				-27
			],
			[
				116,
				-27
			],
			[
				79,
				-8
			],
			[
				47,
				-22
			],
			[
				45,
				-53
			],
			[
				76,
				-11
			],
			[
				48,
				-18
			],
			[
				89,
				-22
			],
			[
				58,
				13
			],
			[
				51,
				18
			],
			[
				35,
				-3
			],
			[
				66,
				-12
			],
			[
				78,
				-3
			],
			[
				65,
				13
			],
			[
				52,
				37
			],
			[
				61,
				50
			],
			[
				72,
				25
			],
			[
				84,
				10
			],
			[
				58,
				20
			],
			[
				188,
				34
			],
			[
				76,
				6
			],
			[
				59,
				32
			],
			[
				52,
				26
			],
			[
				76,
				11
			],
			[
				102,
				-27
			],
			[
				98,
				-22
			],
			[
				118,
				-8
			],
			[
				78,
				-31
			],
			[
				55,
				-29
			],
			[
				88,
				-23
			],
			[
				97,
				11
			],
			[
				133,
				9
			],
			[
				89,
				-13
			],
			[
				92,
				-53
			],
			[
				56,
				-43
			],
			[
				64,
				-91
			],
			[
				67,
				-44
			],
			[
				58,
				-36
			],
			[
				73,
				-2
			],
			[
				184,
				-3
			],
			[
				101,
				-19
			],
			[
				83,
				-10
			],
			[
				21,
				-19
			],
			[
				-9,
				-62
			],
			[
				3,
				-90
			],
			[
				-1,
				-41
			],
			[
				18,
				-31
			],
			[
				29,
				-5
			],
			[
				15,
				-44
			],
			[
				42,
				-26
			],
			[
				74,
				-31
			],
			[
				125,
				-106
			],
			[
				75,
				-45
			],
			[
				59,
				-15
			],
			[
				77,
				10
			],
			[
				121,
				0
			],
			[
				204,
				0
			],
			[
				141,
				-32
			],
			[
				48,
				-22
			],
			[
				143,
				-25
			],
			[
				158,
				-28
			],
			[
				133,
				-29
			],
			[
				78,
				37
			],
			[
				69,
				4
			],
			[
				66,
				-27
			],
			[
				65,
				-41
			],
			[
				51,
				4
			],
			[
				77,
				19
			],
			[
				243,
				114
			],
			[
				85,
				43
			],
			[
				60,
				-11
			],
			[
				53,
				15
			],
			[
				41,
				13
			],
			[
				104,
				17
			],
			[
				63,
				5
			],
			[
				66,
				10
			],
			[
				93,
				7
			],
			[
				191,
				75
			],
			[
				78,
				14
			],
			[
				130,
				-20
			],
			[
				71,
				13
			],
			[
				70,
				38
			],
			[
				91,
				39
			],
			[
				23,
				62
			],
			[
				47,
				87
			],
			[
				100,
				63
			],
			[
				82,
				56
			],
			[
				83,
				54
			],
			[
				102,
				45
			],
			[
				96,
				32
			],
			[
				123,
				86
			],
			[
				97,
				43
			],
			[
				49,
				14
			],
			[
				58,
				-15
			],
			[
				108,
				-12
			],
			[
				78,
				4
			],
			[
				44,
				-10
			],
			[
				88,
				-42
			],
			[
				80,
				-37
			],
			[
				62,
				-65
			],
			[
				114,
				-91
			],
			[
				58,
				-31
			],
			[
				41,
				-12
			],
			[
				103,
				-9
			],
			[
				84,
				-4
			],
			[
				50,
				20
			],
			[
				84,
				39
			],
			[
				135,
				48
			],
			[
				53,
				-1
			],
			[
				87,
				-26
			],
			[
				129,
				-48
			],
			[
				52,
				-35
			],
			[
				34,
				-44
			]
		],
		[
			[
				166494,
				86540
			],
			[
				133,
				-71
			],
			[
				85,
				-37
			],
			[
				145,
				-56
			],
			[
				150,
				-13
			],
			[
				143,
				-61
			],
			[
				73,
				-18
			],
			[
				40,
				0
			],
			[
				202,
				148
			],
			[
				171,
				125
			],
			[
				197,
				97
			],
			[
				144,
				14
			],
			[
				109,
				28
			],
			[
				73,
				44
			],
			[
				42,
				73
			],
			[
				13,
				102
			],
			[
				-29,
				62
			],
			[
				-70,
				21
			],
			[
				-19,
				22
			],
			[
				35,
				22
			],
			[
				25,
				42
			],
			[
				16,
				64
			],
			[
				41,
				60
			],
			[
				66,
				57
			],
			[
				36,
				63
			],
			[
				7,
				69
			],
			[
				39,
				69
			],
			[
				72,
				69
			],
			[
				40,
				64
			],
			[
				7,
				59
			],
			[
				36,
				72
			],
			[
				99,
				128
			],
			[
				65,
				147
			],
			[
				110,
				101
			],
			[
				177,
				103
			],
			[
				110,
				103
			],
			[
				44,
				102
			],
			[
				-3,
				90
			],
			[
				-51,
				78
			],
			[
				-10,
				79
			],
			[
				32,
				80
			],
			[
				-28,
				61
			],
			[
				-88,
				40
			],
			[
				-104,
				9
			],
			[
				-121,
				-20
			],
			[
				-68,
				25
			],
			[
				-15,
				71
			],
			[
				33,
				57
			],
			[
				80,
				43
			],
			[
				131,
				106
			],
			[
				183,
				168
			],
			[
				181,
				93
			],
			[
				272,
				27
			],
			[
				219,
				54
			],
			[
				222,
				56
			],
			[
				161,
				28
			],
			[
				28,
				-19
			],
			[
				87,
				-4
			],
			[
				148,
				9
			],
			[
				138,
				25
			],
			[
				127,
				38
			],
			[
				100,
				9
			],
			[
				74,
				-20
			],
			[
				42,
				-1
			],
			[
				30,
				-3
			],
			[
				16,
				0
			],
			[
				31,
				17
			],
			[
				86,
				-30
			],
			[
				164,
				-86
			],
			[
				103,
				-39
			],
			[
				42,
				9
			],
			[
				47,
				-24
			],
			[
				50,
				-58
			],
			[
				62,
				-34
			],
			[
				113,
				-15
			],
			[
				111,
				-64
			],
			[
				45,
				-3
			],
			[
				16,
				35
			],
			[
				42,
				21
			],
			[
				67,
				5
			],
			[
				97,
				-31
			],
			[
				127,
				-68
			],
			[
				80,
				-30
			],
			[
				32,
				8
			],
			[
				35,
				-12
			],
			[
				27,
				-32
			],
			[
				3,
				-39
			],
			[
				-10,
				-21
			],
			[
				31,
				-33
			],
			[
				35,
				0
			],
			[
				58,
				-16
			],
			[
				45,
				-58
			],
			[
				40,
				-27
			],
			[
				29,
				-24
			],
			[
				5,
				-19
			],
			[
				2,
				-20
			],
			[
				-8,
				-15
			],
			[
				-16,
				-25
			],
			[
				-4,
				-27
			],
			[
				19,
				-31
			],
			[
				72,
				-22
			],
			[
				24,
				-23
			],
			[
				6,
				-29
			],
			[
				22,
				-32
			],
			[
				49,
				-37
			],
			[
				18,
				-31
			],
			[
				-11,
				-25
			],
			[
				14,
				-21
			],
			[
				24,
				-16
			],
			[
				5,
				-60
			],
			[
				2,
				-34
			],
			[
				40,
				-38
			],
			[
				8,
				-79
			],
			[
				27,
				-87
			],
			[
				93,
				-119
			],
			[
				30,
				-65
			],
			[
				-8,
				-76
			],
			[
				14,
				-36
			],
			[
				42,
				-18
			],
			[
				20,
				-32
			],
			[
				-3,
				-48
			],
			[
				17,
				-29
			],
			[
				13,
				-32
			],
			[
				-9,
				-49
			],
			[
				13,
				-44
			],
			[
				22,
				-26
			],
			[
				15,
				-47
			],
			[
				9,
				-60
			],
			[
				62,
				-94
			],
			[
				115,
				-129
			],
			[
				70,
				-100
			],
			[
				26,
				-72
			],
			[
				0,
				-58
			],
			[
				-25,
				-46
			],
			[
				-2,
				-34
			],
			[
				23,
				-21
			],
			[
				6,
				-28
			],
			[
				-9,
				-36
			],
			[
				38,
				-43
			],
			[
				126,
				-74
			],
			[
				-50,
				-113
			],
			[
				-14,
				-80
			],
			[
				7,
				-83
			],
			[
				31,
				-59
			],
			[
				56,
				-35
			],
			[
				34,
				-36
			],
			[
				14,
				-37
			],
			[
				67,
				-41
			],
			[
				119,
				-44
			],
			[
				154,
				-7
			],
			[
				187,
				28
			],
			[
				115,
				5
			],
			[
				42,
				-19
			],
			[
				14,
				-29
			],
			[
				-14,
				-39
			],
			[
				32,
				-25
			],
			[
				77,
				-12
			],
			[
				53,
				-25
			],
			[
				29,
				-37
			],
			[
				35,
				-10
			],
			[
				42,
				16
			],
			[
				41,
				-2
			],
			[
				40,
				-21
			],
			[
				26,
				7
			],
			[
				22,
				23
			],
			[
				36,
				0
			],
			[
				38,
				-1
			],
			[
				23,
				-54
			],
			[
				37,
				-30
			],
			[
				51,
				-7
			],
			[
				79,
				-66
			],
			[
				158,
				-187
			],
			[
				103,
				-66
			],
			[
				102,
				-21
			],
			[
				128,
				-4
			],
			[
				42,
				-73
			],
			[
				-34,
				-76
			],
			[
				-8,
				-64
			],
			[
				29,
				-23
			],
			[
				40,
				-76
			],
			[
				56,
				-43
			],
			[
				11,
				-35
			],
			[
				26,
				-39
			],
			[
				-11,
				-71
			],
			[
				-48,
				-105
			],
			[
				13,
				-89
			],
			[
				75,
				-75
			],
			[
				43,
				-71
			],
			[
				12,
				-68
			],
			[
				18,
				-42
			],
			[
				27,
				-15
			],
			[
				77,
				5
			],
			[
				127,
				25
			],
			[
				94,
				-4
			],
			[
				60,
				-34
			],
			[
				147,
				-1
			],
			[
				236,
				31
			],
			[
				149,
				10
			],
			[
				62,
				-12
			],
			[
				55,
				44
			],
			[
				49,
				100
			],
			[
				45,
				47
			],
			[
				42,
				-6
			],
			[
				68,
				32
			],
			[
				92,
				71
			],
			[
				80,
				34
			],
			[
				102,
				-4
			],
			[
				108,
				-3
			],
			[
				68,
				29
			],
			[
				63,
				62
			],
			[
				110,
				54
			],
			[
				235,
				71
			],
			[
				57,
				12
			],
			[
				27,
				-4
			],
			[
				78,
				-11
			],
			[
				69,
				-28
			],
			[
				66,
				-56
			],
			[
				10,
				-36
			],
			[
				-7,
				-47
			],
			[
				-15,
				-27
			],
			[
				-27,
				-31
			],
			[
				-25,
				-50
			],
			[
				16,
				-39
			],
			[
				38,
				-83
			],
			[
				32,
				-60
			],
			[
				34,
				-71
			],
			[
				-15,
				-26
			],
			[
				-21,
				-49
			],
			[
				-65,
				-83
			],
			[
				-35,
				-32
			],
			[
				-37,
				-31
			],
			[
				-66,
				-8
			],
			[
				-27,
				-7
			],
			[
				-32,
				-13
			],
			[
				-20,
				-30
			],
			[
				-22,
				-20
			],
			[
				-37,
				-42
			],
			[
				-3,
				-36
			],
			[
				17,
				-53
			],
			[
				8,
				-54
			],
			[
				-42,
				-49
			],
			[
				-33,
				-75
			],
			[
				-10,
				-23
			],
			[
				-16,
				-56
			],
			[
				-5,
				-20
			],
			[
				-10,
				-120
			],
			[
				-42,
				-81
			],
			[
				-59,
				-95
			],
			[
				13,
				-57
			],
			[
				10,
				-52
			],
			[
				-14,
				-26
			],
			[
				-4,
				-22
			],
			[
				-8,
				-50
			],
			[
				-19,
				-20
			],
			[
				-53,
				-31
			],
			[
				-32,
				-38
			],
			[
				7,
				-58
			],
			[
				-17,
				-50
			],
			[
				-24,
				-45
			],
			[
				-26,
				-28
			],
			[
				-37,
				-19
			],
			[
				-24,
				-16
			],
			[
				-19,
				-56
			],
			[
				-5,
				-44
			],
			[
				-18,
				-43
			],
			[
				11,
				-44
			],
			[
				-19,
				-39
			],
			[
				-52,
				-26
			],
			[
				-30,
				-16
			],
			[
				-27,
				-7
			],
			[
				-53,
				-41
			],
			[
				-47,
				-143
			],
			[
				-10,
				-84
			],
			[
				11,
				-74
			],
			[
				-66,
				-46
			],
			[
				-49,
				-37
			],
			[
				-31,
				14
			],
			[
				-32,
				12
			],
			[
				-75,
				16
			],
			[
				-37,
				11
			],
			[
				-75,
				24
			],
			[
				-120,
				31
			],
			[
				-118,
				35
			],
			[
				-73,
				19
			],
			[
				-58,
				15
			],
			[
				-45,
				24
			],
			[
				-37,
				44
			],
			[
				-36,
				-18
			],
			[
				-35,
				-51
			],
			[
				-56,
				-31
			],
			[
				-26,
				-57
			],
			[
				-23,
				-43
			],
			[
				-59,
				-59
			],
			[
				-26,
				-24
			],
			[
				-116,
				-39
			],
			[
				-26,
				-13
			],
			[
				-94,
				-9
			],
			[
				-32,
				-17
			],
			[
				-33,
				-37
			],
			[
				-9,
				-36
			],
			[
				24,
				-39
			],
			[
				36,
				-77
			],
			[
				17,
				-53
			],
			[
				25,
				-104
			],
			[
				84,
				-328
			],
			[
				-27,
				-57
			],
			[
				-25,
				-246
			],
			[
				6,
				-44
			],
			[
				-3,
				-69
			],
			[
				2,
				-51
			],
			[
				17,
				-12
			],
			[
				23,
				-18
			],
			[
				11,
				-30
			],
			[
				-3,
				-45
			],
			[
				-11,
				-33
			],
			[
				-18,
				-66
			],
			[
				-24,
				-95
			],
			[
				-25,
				-37
			],
			[
				-18,
				-29
			],
			[
				-14,
				-20
			],
			[
				-2,
				-68
			],
			[
				-10,
				-44
			],
			[
				-40,
				-16
			],
			[
				-41,
				-26
			],
			[
				-48,
				10
			],
			[
				-42,
				-6
			],
			[
				-52,
				-17
			],
			[
				-94,
				-20
			],
			[
				-55,
				-27
			],
			[
				-26,
				-19
			],
			[
				-18,
				-24
			],
			[
				-3,
				-22
			],
			[
				13,
				-12
			],
			[
				52,
				-9
			],
			[
				36,
				-42
			],
			[
				5,
				-47
			],
			[
				-37,
				-26
			]
		],
		[
			[
				175438,
				80529
			],
			[
				-18,
				29
			],
			[
				-31,
				9
			],
			[
				-58,
				41
			],
			[
				-42,
				44
			],
			[
				-32,
				50
			],
			[
				2,
				105
			],
			[
				-6,
				16
			],
			[
				-57,
				22
			],
			[
				-18,
				31
			],
			[
				-27,
				15
			],
			[
				-39,
				-10
			],
			[
				-29,
				11
			],
			[
				-23,
				17
			],
			[
				-28,
				2
			],
			[
				-24,
				-28
			],
			[
				-13,
				-58
			],
			[
				-40,
				-97
			],
			[
				-4,
				-59
			],
			[
				-17,
				-83
			],
			[
				-17,
				-107
			],
			[
				-14,
				-22
			],
			[
				-46,
				-3
			],
			[
				-15,
				-7
			],
			[
				-24,
				-36
			],
			[
				-28,
				-6
			],
			[
				-25,
				21
			],
			[
				-40,
				21
			],
			[
				-37,
				3
			],
			[
				-34,
				-21
			],
			[
				-39,
				-46
			],
			[
				-23,
				-38
			],
			[
				-8,
				-34
			],
			[
				-6,
				-43
			],
			[
				-40,
				-41
			],
			[
				-36,
				-22
			],
			[
				-76,
				-61
			],
			[
				-24,
				-25
			],
			[
				-54,
				0
			],
			[
				-58,
				2
			],
			[
				-79,
				-16
			],
			[
				-129,
				-9
			],
			[
				-77,
				13
			],
			[
				-96,
				-12
			],
			[
				-74,
				-20
			],
			[
				-11,
				-29
			],
			[
				3,
				-44
			],
			[
				15,
				-29
			],
			[
				18,
				-19
			],
			[
				31,
				-59
			],
			[
				32,
				-57
			],
			[
				49,
				-37
			],
			[
				21,
				-39
			],
			[
				1,
				-37
			],
			[
				-24,
				-46
			],
			[
				-35,
				-61
			],
			[
				-33,
				-37
			],
			[
				-24,
				1
			],
			[
				-38,
				22
			],
			[
				-26,
				27
			],
			[
				-61,
				10
			],
			[
				-149,
				-17
			],
			[
				-75,
				12
			],
			[
				-35,
				22
			],
			[
				-63,
				2
			],
			[
				-97,
				30
			],
			[
				-58,
				9
			],
			[
				-28,
				19
			],
			[
				-6,
				44
			],
			[
				-27,
				30
			],
			[
				-16,
				36
			],
			[
				-35,
				45
			],
			[
				-34,
				23
			],
			[
				-33,
				9
			],
			[
				-36,
				-27
			],
			[
				-39,
				-25
			],
			[
				-28,
				6
			],
			[
				-14,
				-7
			],
			[
				-16,
				-20
			],
			[
				-62,
				-42
			],
			[
				-15,
				-39
			],
			[
				-25,
				-81
			],
			[
				-17,
				-84
			],
			[
				-15,
				-30
			],
			[
				-25,
				-5
			],
			[
				-25,
				-25
			],
			[
				-54,
				-79
			],
			[
				-49,
				-72
			],
			[
				-70,
				-50
			],
			[
				-33,
				-45
			],
			[
				-17,
				-40
			],
			[
				-51,
				-58
			],
			[
				-73,
				-10
			],
			[
				-59,
				-17
			],
			[
				-36,
				-4
			],
			[
				-26,
				-23
			],
			[
				-19,
				-35
			],
			[
				-9,
				-14
			],
			[
				-33,
				0
			],
			[
				-33,
				-30
			],
			[
				-81,
				-69
			],
			[
				-67,
				-12
			],
			[
				-83,
				-46
			],
			[
				-73,
				-34
			],
			[
				-30,
				-20
			],
			[
				-8,
				-21
			],
			[
				-11,
				-27
			],
			[
				-35,
				-6
			],
			[
				-34,
				1
			],
			[
				-76,
				-62
			],
			[
				-39,
				-53
			],
			[
				-149,
				-114
			],
			[
				-61,
				-64
			],
			[
				-16,
				-82
			]
		],
		[
			[
				175438,
				80529
			],
			[
				18,
				-50
			],
			[
				41,
				-49
			],
			[
				22,
				-35
			],
			[
				4,
				-37
			],
			[
				19,
				-21
			]
		],
		[
			[
				136950,
				78635
			],
			[
				-38,
				-3
			],
			[
				-159,
				-28
			],
			[
				-32,
				11
			],
			[
				-24,
				44
			],
			[
				-21,
				47
			],
			[
				-41,
				17
			],
			[
				-47,
				13
			],
			[
				-17,
				19
			],
			[
				-1,
				23
			],
			[
				5,
				22
			],
			[
				3,
				12
			],
			[
				108,
				90
			],
			[
				96,
				82
			],
			[
				9,
				6
			],
			[
				9,
				15
			],
			[
				16,
				28
			],
			[
				0,
				15
			],
			[
				-72,
				32
			],
			[
				-3,
				15
			],
			[
				15,
				15
			],
			[
				0,
				21
			],
			[
				-51,
				59
			],
			[
				-89,
				92
			],
			[
				-25,
				10
			],
			[
				-19,
				-6
			],
			[
				-35,
				-90
			],
			[
				-17,
				-22
			],
			[
				-101,
				-59
			],
			[
				-84,
				-41
			],
			[
				-150,
				-71
			],
			[
				-39,
				-23
			],
			[
				-28,
				4
			],
			[
				-27,
				14
			],
			[
				-84,
				73
			],
			[
				-55,
				25
			],
			[
				-36,
				-25
			],
			[
				-31,
				-36
			],
			[
				3,
				-73
			],
			[
				-35,
				-39
			],
			[
				-35,
				-18
			],
			[
				64,
				-197
			],
			[
				-7,
				-25
			],
			[
				-48,
				-7
			],
			[
				36,
				-74
			],
			[
				-31,
				-9
			],
			[
				-76,
				17
			],
			[
				-102,
				12
			],
			[
				-193,
				-33
			],
			[
				-15,
				-13
			],
			[
				-5,
				-16
			],
			[
				11,
				-15
			],
			[
				94,
				-2
			],
			[
				92,
				8
			],
			[
				25,
				-14
			],
			[
				4,
				-25
			],
			[
				-11,
				-15
			],
			[
				-30,
				-2
			],
			[
				-67,
				-15
			],
			[
				-8,
				-16
			],
			[
				-2,
				-15
			],
			[
				23,
				-43
			],
			[
				25,
				-28
			],
			[
				3,
				-16
			],
			[
				-10,
				-14
			],
			[
				-13,
				-5
			],
			[
				-23,
				20
			],
			[
				-13,
				-4
			],
			[
				-6,
				-18
			],
			[
				-6,
				-22
			],
			[
				-15,
				-16
			],
			[
				-31,
				9
			],
			[
				-31,
				-7
			],
			[
				-19,
				-78
			],
			[
				-15,
				-90
			],
			[
				-52,
				-59
			],
			[
				-28,
				-22
			],
			[
				-41,
				-6
			],
			[
				-62,
				7
			],
			[
				-38,
				9
			],
			[
				-108,
				13
			],
			[
				-109,
				24
			],
			[
				-123,
				23
			],
			[
				-114,
				-53
			],
			[
				-33,
				-32
			],
			[
				-20,
				-30
			],
			[
				-22,
				-13
			],
			[
				-49,
				-185
			],
			[
				5,
				-21
			],
			[
				27,
				-16
			],
			[
				140,
				-38
			],
			[
				21,
				-16
			],
			[
				12,
				-18
			],
			[
				6,
				-83
			],
			[
				11,
				-12
			],
			[
				48,
				-10
			],
			[
				70,
				1
			],
			[
				54,
				8
			],
			[
				55,
				-8
			],
			[
				38,
				-18
			],
			[
				19,
				-28
			],
			[
				10,
				-31
			],
			[
				-65,
				-182
			],
			[
				5,
				-66
			],
			[
				20,
				-96
			],
			[
				37,
				-74
			],
			[
				69,
				-73
			],
			[
				53,
				-47
			],
			[
				11,
				-22
			],
			[
				3,
				-34
			],
			[
				-9,
				-44
			],
			[
				-30,
				-69
			],
			[
				-37,
				-60
			],
			[
				-41,
				-26
			],
			[
				-56,
				-77
			],
			[
				-49,
				-94
			],
			[
				-95,
				-124
			],
			[
				-32,
				-69
			],
			[
				-11,
				-200
			],
			[
				-25,
				-60
			]
		],
		[
			[
				114294,
				75071
			],
			[
				48,
				-6
			],
			[
				104,
				-64
			],
			[
				17,
				2
			],
			[
				31,
				85
			],
			[
				30,
				29
			],
			[
				64,
				25
			],
			[
				18,
				139
			],
			[
				30,
				26
			],
			[
				36,
				15
			],
			[
				55,
				2
			],
			[
				48,
				8
			],
			[
				3,
				25
			],
			[
				-67,
				160
			],
			[
				5,
				40
			],
			[
				33,
				161
			],
			[
				20,
				63
			],
			[
				20,
				20
			],
			[
				76,
				-8
			],
			[
				107,
				-28
			],
			[
				28,
				-46
			],
			[
				52,
				-41
			],
			[
				78,
				2
			],
			[
				91,
				-7
			],
			[
				70,
				-3
			],
			[
				57,
				29
			],
			[
				127,
				54
			],
			[
				63,
				18
			],
			[
				57,
				24
			],
			[
				184,
				88
			],
			[
				74,
				-7
			],
			[
				51,
				-11
			],
			[
				38,
				-14
			],
			[
				87,
				-61
			],
			[
				72,
				-61
			],
			[
				50,
				-18
			],
			[
				90,
				1
			],
			[
				131,
				-11
			],
			[
				160,
				1
			],
			[
				94,
				17
			],
			[
				119,
				30
			],
			[
				213,
				72
			],
			[
				281,
				151
			],
			[
				165,
				73
			],
			[
				71,
				8
			],
			[
				92,
				1
			],
			[
				93,
				-19
			],
			[
				105,
				-14
			],
			[
				48,
				2
			],
			[
				114,
				15
			],
			[
				147,
				30
			],
			[
				93,
				25
			],
			[
				112,
				41
			],
			[
				69,
				68
			],
			[
				23,
				7
			],
			[
				29,
				-12
			],
			[
				13,
				-5
			],
			[
				29,
				-38
			],
			[
				30,
				-100
			]
		],
		[
			[
				114008,
				71411
			],
			[
				-18,
				-126
			],
			[
				1,
				-1
			],
			[
				-15,
				-78
			],
			[
				6,
				-13
			],
			[
				19,
				-68
			],
			[
				-36,
				-123
			],
			[
				-41,
				-101
			],
			[
				-14,
				-48
			],
			[
				-40,
				-106
			],
			[
				-40,
				-123
			],
			[
				-22,
				-85
			],
			[
				5,
				-31
			],
			[
				-10,
				-155
			],
			[
				6,
				-45
			],
			[
				-48,
				-135
			],
			[
				-9,
				-67
			],
			[
				-19,
				-90
			],
			[
				-33,
				-191
			]
		],
		[
			[
				114073,
				72167
			],
			[
				14,
				-130
			],
			[
				-24,
				-111
			],
			[
				-2,
				-98
			],
			[
				17,
				-181
			],
			[
				-38,
				-76
			],
			[
				-22,
				-91
			],
			[
				-10,
				-69
			]
		],
		[
			[
				114112,
				72403
			],
			[
				-11,
				-11
			],
			[
				-14,
				-23
			],
			[
				-2,
				-17
			],
			[
				-12,
				-185
			]
		],
		[
			[
				148032,
				68435
			],
			[
				-56,
				11
			],
			[
				-58,
				6
			],
			[
				-47,
				-4
			],
			[
				-115,
				-53
			],
			[
				-39,
				-5
			],
			[
				-43,
				5
			],
			[
				-59,
				2
			],
			[
				-112,
				-2
			],
			[
				-97,
				14
			],
			[
				-78,
				74
			],
			[
				-56,
				33
			],
			[
				-59,
				25
			],
			[
				-59,
				19
			],
			[
				-20,
				40
			],
			[
				-19,
				20
			],
			[
				-49,
				7
			],
			[
				-39,
				-15
			],
			[
				-24,
				-100
			],
			[
				-21,
				-20
			],
			[
				-49,
				-9
			],
			[
				-52,
				26
			],
			[
				-71,
				51
			],
			[
				-29,
				58
			],
			[
				-24,
				18
			],
			[
				-37,
				-25
			],
			[
				-2,
				-73
			],
			[
				-8,
				-50
			],
			[
				-45,
				-20
			],
			[
				-26,
				15
			],
			[
				-21,
				51
			],
			[
				-52,
				120
			],
			[
				-53,
				70
			],
			[
				-52,
				47
			],
			[
				-173,
				-1
			],
			[
				-128,
				13
			],
			[
				-58,
				20
			],
			[
				-22,
				46
			],
			[
				21,
				92
			],
			[
				25,
				73
			],
			[
				0,
				17
			],
			[
				-22,
				8
			],
			[
				-37,
				6
			],
			[
				-138,
				-46
			],
			[
				-37,
				5
			],
			[
				-25,
				16
			],
			[
				-29,
				13
			],
			[
				-24,
				22
			],
			[
				-17,
				31
			],
			[
				-120,
				77
			],
			[
				-35,
				42
			],
			[
				-64,
				53
			],
			[
				-54,
				36
			],
			[
				-34,
				103
			],
			[
				-31,
				99
			],
			[
				-17,
				52
			],
			[
				-51,
				28
			],
			[
				-56,
				21
			],
			[
				-94,
				-43
			],
			[
				-77,
				-32
			],
			[
				-56,
				-4
			],
			[
				-82,
				101
			],
			[
				-66,
				110
			],
			[
				-77,
				95
			],
			[
				-52,
				48
			],
			[
				-91,
				5
			],
			[
				-104,
				53
			],
			[
				-137,
				122
			],
			[
				-100,
				91
			],
			[
				-172,
				101
			],
			[
				-40,
				42
			],
			[
				-15,
				37
			],
			[
				-24,
				71
			],
			[
				-36,
				67
			],
			[
				-121,
				29
			],
			[
				-138,
				21
			],
			[
				-145,
				-41
			],
			[
				-105,
				-202
			],
			[
				-50,
				-44
			],
			[
				-43,
				-2
			],
			[
				-36,
				51
			],
			[
				-29,
				54
			]
		],
		[
			[
				143445,
				70327
			],
			[
				-29,
				13
			],
			[
				-37,
				-7
			],
			[
				-39,
				-26
			],
			[
				-18,
				-17
			],
			[
				-88,
				-103
			],
			[
				-46,
				-32
			],
			[
				-41,
				-46
			],
			[
				-95,
				-140
			],
			[
				-55,
				-130
			],
			[
				-40,
				-123
			],
			[
				1,
				-87
			],
			[
				-15,
				-102
			],
			[
				-41,
				-58
			],
			[
				-25,
				-19
			],
			[
				-30,
				-88
			],
			[
				-21,
				-102
			],
			[
				12,
				-33
			],
			[
				51,
				-45
			],
			[
				50,
				-43
			],
			[
				63,
				-47
			],
			[
				61,
				-45
			],
			[
				39,
				-6
			],
			[
				11,
				25
			],
			[
				14,
				25
			],
			[
				45,
				-13
			],
			[
				54,
				-44
			],
			[
				35,
				-35
			],
			[
				16,
				-12
			],
			[
				94,
				-58
			],
			[
				78,
				-49
			],
			[
				98,
				-62
			],
			[
				25,
				-37
			],
			[
				21,
				-40
			],
			[
				46,
				-53
			],
			[
				113,
				-95
			],
			[
				97,
				-67
			],
			[
				79,
				-55
			],
			[
				61,
				-38
			],
			[
				29,
				6
			],
			[
				31,
				20
			],
			[
				27,
				12
			],
			[
				32,
				-11
			],
			[
				49,
				-29
			],
			[
				113,
				-90
			],
			[
				106,
				-69
			],
			[
				115,
				12
			],
			[
				31,
				-11
			],
			[
				22,
				-63
			],
			[
				14,
				-65
			],
			[
				129,
				-42
			],
			[
				85,
				-19
			],
			[
				97,
				-35
			],
			[
				49,
				-26
			],
			[
				51,
				33
			],
			[
				10,
				28
			],
			[
				40,
				17
			],
			[
				68,
				-7
			],
			[
				126,
				-50
			],
			[
				53,
				-15
			],
			[
				44,
				47
			],
			[
				83,
				22
			],
			[
				43,
				25
			],
			[
				89,
				-53
			],
			[
				162,
				-65
			],
			[
				84,
				-41
			],
			[
				20,
				-40
			],
			[
				9,
				-39
			],
			[
				-1,
				-92
			],
			[
				21,
				-42
			],
			[
				162,
				-94
			],
			[
				54,
				-40
			],
			[
				43,
				-13
			],
			[
				25,
				-1
			],
			[
				17,
				-12
			],
			[
				14,
				-54
			],
			[
				12,
				-12
			],
			[
				31,
				-13
			],
			[
				34,
				-8
			],
			[
				106,
				46
			],
			[
				72,
				35
			],
			[
				52,
				-9
			],
			[
				33,
				-39
			],
			[
				5,
				-56
			],
			[
				19,
				-61
			],
			[
				37,
				-29
			],
			[
				40,
				-3
			],
			[
				98,
				40
			],
			[
				79,
				-31
			],
			[
				72,
				-11
			],
			[
				80,
				-20
			],
			[
				32,
				-14
			],
			[
				83,
				-50
			],
			[
				102,
				-50
			],
			[
				40,
				5
			],
			[
				164,
				94
			],
			[
				14,
				-12
			],
			[
				33,
				-89
			],
			[
				50,
				-32
			],
			[
				78,
				-28
			],
			[
				81,
				52
			],
			[
				65,
				-15
			],
			[
				77,
				-5
			],
			[
				75,
				25
			],
			[
				65,
				6
			],
			[
				94,
				-45
			],
			[
				21,
				11
			],
			[
				18,
				28
			],
			[
				36,
				129
			],
			[
				33,
				114
			],
			[
				-3,
				69
			],
			[
				-30,
				99
			],
			[
				-76,
				130
			],
			[
				-6,
				40
			],
			[
				26,
				227
			],
			[
				28,
				130
			],
			[
				24,
				62
			],
			[
				27,
				88
			],
			[
				5,
				41
			],
			[
				-3,
				37
			],
			[
				-26,
				22
			]
		],
		[
			[
				153985,
				68722
			],
			[
				-8,
				-52
			],
			[
				-5,
				-57
			],
			[
				23,
				-45
			],
			[
				3,
				-40
			],
			[
				-5,
				-37
			],
			[
				-19,
				-25
			],
			[
				-52,
				-15
			],
			[
				-44,
				-43
			],
			[
				-70,
				-64
			],
			[
				-56,
				-51
			],
			[
				-41,
				-45
			],
			[
				-14,
				-47
			],
			[
				4,
				-59
			],
			[
				12,
				-62
			],
			[
				130,
				-228
			],
			[
				-1,
				-39
			],
			[
				-41,
				-11
			],
			[
				-55,
				25
			],
			[
				-47,
				37
			],
			[
				-54,
				98
			],
			[
				-42,
				29
			],
			[
				-43,
				6
			],
			[
				-253,
				-50
			],
			[
				-54,
				-14
			],
			[
				-83,
				-36
			],
			[
				-59,
				-74
			],
			[
				-42,
				-67
			],
			[
				-44,
				-27
			],
			[
				-64,
				-52
			],
			[
				-177,
				-161
			],
			[
				-103,
				-69
			],
			[
				-67,
				-25
			],
			[
				-47,
				-37
			],
			[
				-25,
				-59
			],
			[
				-19,
				-42
			],
			[
				-6,
				-105
			],
			[
				11,
				-129
			],
			[
				26,
				-82
			],
			[
				13,
				-17
			],
			[
				3,
				-24
			],
			[
				-26,
				-45
			],
			[
				-34,
				-38
			],
			[
				-16,
				-23
			],
			[
				-15,
				-117
			],
			[
				-30,
				-58
			],
			[
				-55,
				-85
			],
			[
				-48,
				-65
			],
			[
				-77,
				-49
			],
			[
				-29,
				-41
			],
			[
				-27,
				-74
			],
			[
				-17,
				-63
			],
			[
				-1,
				-23
			],
			[
				9,
				-20
			],
			[
				32,
				-22
			],
			[
				38,
				-22
			],
			[
				19,
				-33
			],
			[
				2,
				-41
			],
			[
				-29,
				-97
			],
			[
				-51,
				-135
			],
			[
				-59,
				-107
			],
			[
				-60,
				-102
			],
			[
				-14,
				-33
			],
			[
				-55,
				-125
			],
			[
				-47,
				-172
			],
			[
				-32,
				-116
			],
			[
				-28,
				-79
			],
			[
				-34,
				-4
			],
			[
				-41,
				25
			],
			[
				-101,
				34
			],
			[
				-64,
				27
			],
			[
				-47,
				25
			],
			[
				-32,
				-1
			],
			[
				-45,
				-16
			],
			[
				-45,
				-11
			],
			[
				-27,
				12
			],
			[
				-63,
				72
			],
			[
				-18,
				-9
			],
			[
				-13,
				-35
			],
			[
				42,
				-204
			],
			[
				28,
				-76
			],
			[
				-5,
				-127
			],
			[
				-10,
				-156
			],
			[
				-17,
				-170
			],
			[
				-11,
				-39
			],
			[
				-26,
				-45
			],
			[
				-36,
				-12
			],
			[
				-32,
				17
			],
			[
				-25,
				-4
			],
			[
				-9,
				-28
			],
			[
				8,
				-74
			],
			[
				-31,
				-84
			],
			[
				-23,
				-73
			],
			[
				6,
				-70
			],
			[
				11,
				-71
			],
			[
				36,
				-154
			],
			[
				1,
				-56
			],
			[
				-8,
				-51
			],
			[
				-19,
				-21
			],
			[
				-33,
				4
			],
			[
				-18,
				-21
			],
			[
				-13,
				-32
			],
			[
				-37,
				-117
			],
			[
				-36,
				-12
			],
			[
				-35,
				17
			],
			[
				-54,
				79
			],
			[
				-33,
				22
			],
			[
				-20,
				-1
			],
			[
				-9,
				-21
			],
			[
				-15,
				-46
			],
			[
				-14,
				-32
			],
			[
				-36,
				-27
			]
		],
		[
			[
				155794,
				62206
			],
			[
				-77,
				52
			],
			[
				-32,
				29
			],
			[
				-41,
				8
			],
			[
				-42,
				-33
			],
			[
				-34,
				-36
			],
			[
				-34,
				-13
			],
			[
				-53,
				-4
			],
			[
				-69,
				18
			],
			[
				-47,
				17
			],
			[
				-7,
				-9
			],
			[
				25,
				-75
			],
			[
				10,
				-60
			],
			[
				-11,
				-32
			],
			[
				-22,
				-26
			],
			[
				-34,
				-20
			],
			[
				-39,
				-12
			],
			[
				-35,
				1
			],
			[
				-56,
				29
			],
			[
				-43,
				1
			],
			[
				-37,
				-14
			],
			[
				-22,
				-22
			],
			[
				-12,
				-26
			],
			[
				-22,
				-149
			],
			[
				-19,
				-46
			],
			[
				-26,
				-27
			],
			[
				-27,
				-2
			],
			[
				-36,
				7
			],
			[
				-38,
				-6
			],
			[
				-173,
				-58
			],
			[
				-25,
				-5
			],
			[
				-54,
				-5
			],
			[
				-50,
				-1
			],
			[
				-35,
				3
			],
			[
				-83,
				59
			],
			[
				-40,
				6
			],
			[
				-22,
				-17
			],
			[
				-15,
				-79
			],
			[
				-49,
				-50
			],
			[
				-64,
				-110
			],
			[
				-15,
				-160
			],
			[
				7,
				-111
			],
			[
				-58,
				-111
			],
			[
				-6,
				-53
			],
			[
				31,
				-257
			],
			[
				-5,
				-27
			],
			[
				-12,
				-13
			],
			[
				-36,
				-9
			],
			[
				-61,
				-27
			],
			[
				-40,
				-25
			],
			[
				-20,
				-3
			],
			[
				-56,
				19
			],
			[
				-15,
				1
			],
			[
				4,
				-20
			],
			[
				45,
				-111
			],
			[
				48,
				-53
			],
			[
				48,
				6
			],
			[
				22,
				-10
			],
			[
				-7,
				-27
			],
			[
				19,
				-69
			],
			[
				44,
				-113
			],
			[
				13,
				-84
			],
			[
				-27,
				-84
			],
			[
				6,
				-30
			],
			[
				14,
				-18
			],
			[
				42,
				-77
			],
			[
				88,
				-122
			],
			[
				86,
				-132
			],
			[
				72,
				-110
			],
			[
				53,
				-77
			],
			[
				118,
				-141
			],
			[
				21,
				-67
			],
			[
				4,
				-134
			],
			[
				29,
				-78
			],
			[
				27,
				-55
			],
			[
				19,
				-46
			],
			[
				43,
				-152
			],
			[
				19,
				-21
			],
			[
				94,
				92
			],
			[
				22,
				-19
			],
			[
				12,
				-35
			],
			[
				0,
				-44
			],
			[
				-15,
				-50
			],
			[
				-30,
				-47
			],
			[
				-146,
				-107
			],
			[
				-12,
				-93
			],
			[
				-10,
				-140
			],
			[
				-2,
				-172
			],
			[
				6,
				-129
			],
			[
				-5,
				-29
			],
			[
				-13,
				-14
			],
			[
				-55,
				5
			],
			[
				-79,
				-65
			],
			[
				-28,
				-6
			],
			[
				-35,
				-25
			],
			[
				-26,
				-30
			],
			[
				-9,
				-47
			],
			[
				16,
				-141
			],
			[
				28,
				-133
			],
			[
				56,
				-98
			],
			[
				44,
				-77
			],
			[
				61,
				-107
			],
			[
				49,
				-94
			],
			[
				97,
				-102
			],
			[
				137,
				-153
			],
			[
				53,
				-85
			],
			[
				46,
				-102
			],
			[
				33,
				-88
			],
			[
				12,
				-116
			],
			[
				10,
				-65
			],
			[
				3,
				-218
			],
			[
				-25,
				-49
			],
			[
				-19,
				-58
			],
			[
				10,
				-60
			],
			[
				32,
				-57
			],
			[
				0,
				-65
			],
			[
				30,
				-118
			],
			[
				50,
				-71
			],
			[
				49,
				-49
			],
			[
				21,
				-38
			],
			[
				-7,
				-61
			],
			[
				14,
				-65
			],
			[
				11,
				-71
			],
			[
				19,
				-98
			],
			[
				39,
				-83
			],
			[
				60,
				-254
			],
			[
				-2,
				-26
			],
			[
				-25,
				-52
			],
			[
				-38,
				-46
			],
			[
				-24,
				-15
			],
			[
				-23,
				-48
			],
			[
				-54,
				-136
			],
			[
				-109,
				-235
			],
			[
				-106,
				-152
			],
			[
				-90,
				-109
			],
			[
				-64,
				-66
			],
			[
				-19,
				-39
			],
			[
				0,
				-31
			],
			[
				11,
				-55
			],
			[
				-4,
				-104
			],
			[
				-14,
				-66
			],
			[
				-19,
				-70
			],
			[
				-10,
				-62
			]
		],
		[
			[
				155794,
				62206
			],
			[
				-5,
				-49
			],
			[
				16,
				-10
			],
			[
				22,
				23
			],
			[
				28,
				55
			],
			[
				31,
				31
			],
			[
				34,
				7
			],
			[
				36,
				-38
			],
			[
				37,
				-82
			],
			[
				39,
				-46
			],
			[
				18,
				-6
			],
			[
				13,
				-37
			],
			[
				2,
				-36
			],
			[
				-18,
				-76
			],
			[
				-31,
				-89
			],
			[
				-45,
				-109
			],
			[
				15,
				-92
			],
			[
				60,
				-75
			],
			[
				73,
				-45
			],
			[
				76,
				13
			],
			[
				41,
				22
			],
			[
				33,
				36
			],
			[
				31,
				16
			],
			[
				39,
				5
			],
			[
				122,
				-26
			],
			[
				37,
				-26
			],
			[
				5,
				-51
			],
			[
				-15,
				-131
			],
			[
				19,
				-95
			],
			[
				34,
				-102
			],
			[
				5,
				-92
			],
			[
				-43,
				-152
			],
			[
				-35,
				-144
			],
			[
				-39,
				-70
			],
			[
				-29,
				-45
			],
			[
				-9,
				-30
			],
			[
				2,
				-29
			],
			[
				28,
				-43
			],
			[
				28,
				-56
			],
			[
				8,
				-53
			],
			[
				-3,
				-66
			],
			[
				-20,
				-90
			],
			[
				-74,
				-195
			],
			[
				-59,
				-176
			],
			[
				31,
				-35
			],
			[
				58,
				-26
			],
			[
				39,
				-25
			],
			[
				40,
				16
			],
			[
				85,
				104
			],
			[
				74,
				77
			],
			[
				91,
				78
			],
			[
				6,
				6
			],
			[
				80,
				57
			],
			[
				36,
				52
			],
			[
				20,
				67
			],
			[
				29,
				26
			],
			[
				36,
				-15
			],
			[
				47,
				29
			],
			[
				56,
				72
			],
			[
				43,
				34
			],
			[
				30,
				-5
			],
			[
				54,
				-46
			],
			[
				78,
				-85
			],
			[
				69,
				-50
			],
			[
				61,
				-16
			],
			[
				29,
				-32
			],
			[
				-1,
				-47
			],
			[
				13,
				-30
			],
			[
				29,
				-13
			],
			[
				12,
				5
			],
			[
				-3,
				23
			],
			[
				27,
				34
			],
			[
				58,
				43
			],
			[
				59,
				26
			],
			[
				60,
				8
			],
			[
				39,
				35
			],
			[
				26,
				93
			],
			[
				-1,
				-4
			],
			[
				38,
				70
			],
			[
				33,
				31
			],
			[
				41,
				16
			],
			[
				10,
				22
			],
			[
				-19,
				28
			],
			[
				1,
				28
			],
			[
				24,
				29
			],
			[
				51,
				12
			],
			[
				78,
				-4
			],
			[
				92,
				-29
			],
			[
				105,
				-55
			],
			[
				69,
				-17
			],
			[
				32,
				19
			],
			[
				64,
				-84
			],
			[
				96,
				-188
			],
			[
				81,
				-143
			],
			[
				69,
				-96
			],
			[
				71,
				-74
			],
			[
				76,
				-51
			],
			[
				54,
				-71
			],
			[
				49,
				-133
			],
			[
				-37,
				-184
			],
			[
				-10,
				-159
			],
			[
				5,
				-195
			],
			[
				44,
				-150
			],
			[
				85,
				-104
			],
			[
				49,
				-84
			],
			[
				14,
				-64
			],
			[
				65,
				-55
			],
			[
				118,
				-46
			],
			[
				49,
				-41
			],
			[
				-20,
				-38
			],
			[
				-2,
				-43
			],
			[
				17,
				-49
			],
			[
				41,
				-41
			],
			[
				64,
				-32
			],
			[
				39,
				-34
			],
			[
				12,
				-36
			],
			[
				-1,
				-58
			],
			[
				-15,
				-81
			],
			[
				-27,
				-62
			],
			[
				-39,
				-43
			],
			[
				-5,
				-34
			],
			[
				-10,
				-52
			],
			[
				0,
				-106
			],
			[
				28,
				-71
			],
			[
				8,
				-90
			],
			[
				-15,
				-74
			],
			[
				-15,
				-150
			],
			[
				-2,
				-58
			],
			[
				-14,
				-50
			],
			[
				-34,
				-48
			],
			[
				-52,
				-46
			],
			[
				-64,
				-40
			],
			[
				-39,
				-18
			]
		],
		[
			[
				156450,
				63237
			],
			[
				-37,
				-81
			],
			[
				-99,
				-85
			],
			[
				-70,
				-42
			],
			[
				-41,
				-2
			],
			[
				-34,
				-50
			],
			[
				-29,
				-100
			],
			[
				-29,
				-59
			],
			[
				-30,
				-17
			],
			[
				-20,
				-38
			],
			[
				-9,
				-58
			],
			[
				17,
				-31
			],
			[
				45,
				-4
			],
			[
				3,
				-16
			],
			[
				-37,
				-29
			],
			[
				-47,
				-10
			],
			[
				-55,
				9
			],
			[
				-53,
				-23
			],
			[
				-49,
				-54
			],
			[
				-43,
				-116
			],
			[
				-35,
				-179
			],
			[
				-4,
				-46
			]
		],
		[
			[
				153985,
				68722
			],
			[
				21,
				30
			],
			[
				49,
				82
			],
			[
				30,
				59
			],
			[
				16,
				25
			],
			[
				23,
				45
			],
			[
				39,
				6
			],
			[
				39,
				-15
			],
			[
				23,
				-25
			],
			[
				23,
				-51
			],
			[
				25,
				-42
			],
			[
				31,
				0
			],
			[
				31,
				6
			],
			[
				15,
				-6
			],
			[
				30,
				-35
			],
			[
				57,
				-84
			],
			[
				25,
				-22
			],
			[
				24,
				-36
			],
			[
				13,
				-71
			],
			[
				8,
				-73
			],
			[
				71,
				-251
			],
			[
				21,
				-52
			],
			[
				16,
				-41
			],
			[
				34,
				-10
			],
			[
				27,
				41
			],
			[
				10,
				43
			],
			[
				29,
				14
			],
			[
				33,
				-7
			],
			[
				62,
				-41
			],
			[
				33,
				-21
			],
			[
				17,
				-125
			],
			[
				3,
				-145
			],
			[
				-5,
				-45
			],
			[
				27,
				-120
			],
			[
				9,
				-139
			],
			[
				5,
				-75
			],
			[
				1,
				-72
			],
			[
				-5,
				-95
			],
			[
				-14,
				-127
			],
			[
				-25,
				-108
			],
			[
				9,
				-90
			],
			[
				-14,
				-41
			],
			[
				-59,
				-21
			],
			[
				-5,
				-34
			],
			[
				17,
				-57
			],
			[
				41,
				-71
			],
			[
				1,
				-45
			],
			[
				-20,
				-30
			],
			[
				-43,
				-3
			],
			[
				-60,
				-28
			],
			[
				-41,
				-92
			],
			[
				-44,
				-75
			],
			[
				-24,
				-15
			],
			[
				-80,
				21
			],
			[
				-19,
				-19
			],
			[
				-28,
				-128
			],
			[
				-23,
				-55
			],
			[
				-35,
				-47
			],
			[
				-31,
				-27
			],
			[
				-29,
				-19
			],
			[
				-63,
				13
			],
			[
				-34,
				-78
			],
			[
				-34,
				-102
			],
			[
				-3,
				-52
			],
			[
				18,
				-83
			],
			[
				-9,
				-23
			],
			[
				-35,
				-18
			],
			[
				-56,
				-38
			],
			[
				-35,
				-118
			],
			[
				2,
				-115
			],
			[
				20,
				-40
			],
			[
				39,
				-17
			],
			[
				28,
				-35
			],
			[
				3,
				-56
			],
			[
				24,
				-69
			],
			[
				-12,
				-81
			],
			[
				-79,
				-117
			],
			[
				-2,
				-64
			],
			[
				42,
				-20
			],
			[
				36,
				9
			],
			[
				45,
				28
			],
			[
				53,
				45
			],
			[
				116,
				65
			],
			[
				127,
				38
			],
			[
				100,
				7
			],
			[
				85,
				-3
			],
			[
				42,
				-14
			],
			[
				12,
				-24
			],
			[
				117,
				38
			],
			[
				25,
				2
			],
			[
				21,
				2
			],
			[
				-1,
				-25
			],
			[
				-85,
				-104
			],
			[
				-16,
				-49
			],
			[
				2,
				-52
			],
			[
				35,
				-48
			],
			[
				34,
				-38
			],
			[
				29,
				-93
			],
			[
				-22,
				-86
			],
			[
				14,
				-31
			],
			[
				25,
				-35
			],
			[
				16,
				-50
			],
			[
				1,
				-60
			],
			[
				-14,
				-96
			],
			[
				124,
				-50
			],
			[
				107,
				-22
			],
			[
				78,
				-6
			],
			[
				49,
				-22
			],
			[
				31,
				-19
			],
			[
				21,
				-34
			],
			[
				6,
				-38
			],
			[
				-26,
				-26
			],
			[
				-53,
				-84
			],
			[
				-30,
				-113
			],
			[
				3,
				-84
			],
			[
				-3,
				-73
			],
			[
				-62,
				-105
			],
			[
				-24,
				-73
			],
			[
				-21,
				-74
			],
			[
				0,
				-32
			],
			[
				13,
				-23
			],
			[
				26,
				-13
			],
			[
				45,
				-8
			],
			[
				55,
				8
			],
			[
				132,
				-17
			],
			[
				151,
				-33
			],
			[
				59,
				-18
			],
			[
				20,
				-33
			],
			[
				-5,
				-71
			],
			[
				-10,
				-67
			],
			[
				10,
				-51
			],
			[
				24,
				-47
			],
			[
				41,
				-16
			],
			[
				35,
				-18
			],
			[
				7,
				-36
			],
			[
				-11,
				-48
			],
			[
				18,
				-39
			],
			[
				20,
				-25
			],
			[
				43,
				-15
			],
			[
				88,
				32
			],
			[
				61,
				-14
			],
			[
				56,
				-22
			],
			[
				47,
				11
			],
			[
				47,
				28
			],
			[
				102,
				124
			],
			[
				119,
				67
			],
			[
				39,
				16
			],
			[
				27,
				-8
			],
			[
				6,
				-9
			],
			[
				-2,
				-25
			],
			[
				13,
				-102
			],
			[
				-6,
				-12
			]
		],
		[
			[
				157089,
				63907
			],
			[
				36,
				-79
			],
			[
				76,
				-87
			],
			[
				92,
				-125
			],
			[
				29,
				-57
			],
			[
				61,
				-44
			],
			[
				18,
				-43
			],
			[
				14,
				-66
			],
			[
				6,
				-50
			],
			[
				13,
				-29
			],
			[
				22,
				-12
			],
			[
				28,
				14
			],
			[
				21,
				26
			],
			[
				17,
				72
			],
			[
				12,
				8
			],
			[
				19,
				-60
			],
			[
				20,
				-10
			],
			[
				27,
				-8
			],
			[
				20,
				-26
			],
			[
				6,
				-45
			],
			[
				-6,
				-47
			],
			[
				-26,
				-52
			],
			[
				-14,
				-55
			],
			[
				-10,
				-84
			],
			[
				-13,
				-59
			],
			[
				21,
				-53
			],
			[
				142,
				-256
			],
			[
				69,
				-42
			],
			[
				163,
				-50
			],
			[
				59,
				-35
			],
			[
				52,
				-33
			],
			[
				51,
				16
			],
			[
				50,
				76
			],
			[
				59,
				43
			],
			[
				110,
				66
			],
			[
				31,
				3
			],
			[
				61,
				-26
			],
			[
				100,
				-76
			],
			[
				72,
				-72
			],
			[
				45,
				-38
			],
			[
				34,
				-34
			],
			[
				-5,
				-38
			],
			[
				-28,
				-38
			],
			[
				-35,
				-21
			],
			[
				-46,
				-36
			],
			[
				-25,
				-36
			],
			[
				15,
				-14
			],
			[
				68,
				-9
			],
			[
				79,
				-32
			],
			[
				24,
				-38
			],
			[
				4,
				-33
			],
			[
				9,
				-53
			],
			[
				14,
				-16
			],
			[
				74,
				10
			],
			[
				23,
				-12
			],
			[
				26,
				-28
			],
			[
				26,
				-71
			],
			[
				-1,
				-53
			],
			[
				-53,
				-59
			],
			[
				-19,
				-35
			],
			[
				-9,
				-56
			],
			[
				-38,
				-68
			],
			[
				-100,
				-112
			],
			[
				-27,
				-6
			],
			[
				-185,
				61
			],
			[
				-86,
				-3
			],
			[
				-41,
				-2
			],
			[
				-20,
				-3
			],
			[
				-12,
				-24
			],
			[
				24,
				-68
			],
			[
				8,
				-67
			],
			[
				-23,
				-51
			],
			[
				-62,
				-45
			],
			[
				-23,
				-22
			],
			[
				-3,
				-28
			],
			[
				17,
				-31
			],
			[
				57,
				-31
			],
			[
				66,
				-29
			],
			[
				218,
				-174
			],
			[
				47,
				-41
			],
			[
				61,
				-61
			],
			[
				67,
				-47
			],
			[
				179,
				-62
			],
			[
				78,
				-41
			],
			[
				21,
				-23
			],
			[
				-1,
				-28
			],
			[
				-21,
				-36
			],
			[
				-17,
				-63
			],
			[
				-1,
				-38
			],
			[
				19,
				-37
			],
			[
				32,
				-55
			],
			[
				71,
				-86
			],
			[
				39,
				-37
			],
			[
				42,
				-9
			],
			[
				38,
				-20
			],
			[
				39,
				-64
			],
			[
				45,
				-77
			],
			[
				6,
				-54
			],
			[
				19,
				-69
			],
			[
				42,
				-80
			],
			[
				57,
				-77
			],
			[
				79,
				-95
			],
			[
				46,
				-68
			],
			[
				21,
				-26
			],
			[
				170,
				-164
			],
			[
				42,
				-60
			],
			[
				59,
				-116
			],
			[
				26,
				-17
			],
			[
				24,
				-23
			],
			[
				15,
				-64
			],
			[
				5,
				-46
			],
			[
				8,
				-140
			],
			[
				31,
				-42
			],
			[
				28,
				-51
			],
			[
				12,
				-38
			],
			[
				26,
				-27
			],
			[
				28,
				-6
			],
			[
				34,
				31
			],
			[
				26,
				30
			],
			[
				12,
				-9
			],
			[
				27,
				-98
			],
			[
				24,
				-36
			],
			[
				47,
				-34
			],
			[
				43,
				-26
			],
			[
				96,
				-119
			],
			[
				51,
				-43
			],
			[
				34,
				-13
			],
			[
				30,
				-21
			],
			[
				9,
				-37
			],
			[
				-11,
				-38
			],
			[
				-21,
				-25
			],
			[
				-111,
				-68
			],
			[
				-15,
				-30
			],
			[
				16,
				-45
			],
			[
				28,
				-57
			],
			[
				30,
				-49
			],
			[
				38,
				-48
			],
			[
				78,
				-78
			],
			[
				68,
				-62
			],
			[
				37,
				-67
			],
			[
				20,
				-45
			],
			[
				-12,
				-54
			],
			[
				-29,
				-59
			],
			[
				-22,
				-51
			],
			[
				-38,
				-29
			],
			[
				-10,
				-34
			],
			[
				15,
				-53
			],
			[
				13,
				-36
			],
			[
				-7,
				-45
			],
			[
				4,
				-93
			]
		],
		[
			[
				108809,
				49665
			],
			[
				-186,
				73
			],
			[
				-28,
				1
			],
			[
				-33,
				-12
			],
			[
				-98,
				-90
			],
			[
				-31,
				-11
			],
			[
				-35,
				8
			],
			[
				-87,
				11
			],
			[
				-297,
				71
			],
			[
				-228,
				68
			],
			[
				-69,
				25
			],
			[
				-122,
				23
			],
			[
				-80,
				-46
			],
			[
				-76,
				-160
			],
			[
				-22,
				-31
			],
			[
				-119,
				-47
			],
			[
				-56,
				13
			],
			[
				-137,
				-44
			],
			[
				-213,
				66
			],
			[
				-75,
				-13
			],
			[
				-60,
				-33
			],
			[
				-152,
				-73
			],
			[
				-93,
				-41
			],
			[
				-108,
				-37
			],
			[
				-102,
				-58
			],
			[
				-69,
				-31
			],
			[
				-67,
				0
			],
			[
				-61,
				33
			],
			[
				-66,
				28
			],
			[
				-80,
				5
			],
			[
				-83,
				-16
			],
			[
				-70,
				-64
			],
			[
				-28,
				-45
			],
			[
				-62,
				-121
			],
			[
				-72,
				-196
			],
			[
				-28,
				-39
			],
			[
				-8,
				-4
			],
			[
				-18,
				-17
			],
			[
				-332,
				98
			],
			[
				-143,
				23
			],
			[
				-96,
				-30
			],
			[
				-121,
				55
			],
			[
				-53,
				9
			],
			[
				-25,
				-17
			],
			[
				-67,
				25
			],
			[
				-110,
				67
			],
			[
				-105,
				28
			],
			[
				-94,
				-10
			],
			[
				-58,
				22
			],
			[
				-46,
				66
			],
			[
				-60,
				119
			],
			[
				-108,
				118
			],
			[
				-145,
				95
			],
			[
				-90,
				71
			],
			[
				-36,
				48
			],
			[
				-78,
				27
			],
			[
				-120,
				5
			],
			[
				-115,
				-47
			],
			[
				-164,
				-148
			],
			[
				-153,
				-303
			],
			[
				-86,
				-117
			],
			[
				-68,
				-30
			],
			[
				-17,
				-73
			],
			[
				34,
				-116
			],
			[
				9,
				-134
			],
			[
				-24,
				-227
			],
			[
				9,
				-165
			]
		],
		[
			[
				110844,
				43472
			],
			[
				-13,
				-22
			],
			[
				-59,
				-154
			],
			[
				-11,
				-23
			],
			[
				6,
				-14
			],
			[
				25,
				-30
			],
			[
				-14,
				-48
			],
			[
				-6,
				-13
			],
			[
				-11,
				-46
			],
			[
				6,
				-41
			],
			[
				14,
				-16
			],
			[
				38,
				-20
			],
			[
				58,
				-14
			],
			[
				68,
				-35
			],
			[
				46,
				-6
			],
			[
				11,
				-25
			],
			[
				-3,
				-45
			],
			[
				12,
				-39
			],
			[
				0,
				-69
			],
			[
				-14,
				-61
			],
			[
				-70,
				-29
			],
			[
				-36,
				-31
			],
			[
				-10,
				-16
			],
			[
				9,
				-18
			],
			[
				5,
				-25
			],
			[
				-66,
				-61
			],
			[
				-68,
				-79
			],
			[
				-16,
				-54
			],
			[
				-13,
				-63
			],
			[
				-20,
				-41
			],
			[
				-52,
				-58
			],
			[
				-52,
				-118
			],
			[
				-26,
				-76
			],
			[
				-129,
				-183
			],
			[
				-115,
				-91
			],
			[
				-34,
				-31
			],
			[
				-203,
				5
			]
		],
		[
			[
				109850,
				43208
			],
			[
				0,
				-31
			],
			[
				1,
				-35
			],
			[
				31,
				-42
			],
			[
				57,
				-86
			],
			[
				46,
				-81
			],
			[
				2,
				-70
			],
			[
				-9,
				-118
			],
			[
				-2,
				-67
			],
			[
				5,
				-93
			],
			[
				0,
				-173
			],
			[
				-4,
				-122
			],
			[
				8,
				-64
			],
			[
				70,
				-152
			],
			[
				30,
				-169
			],
			[
				16,
				-123
			]
		],
		[
			[
				110213,
				44307
			],
			[
				-25,
				-18
			],
			[
				-45,
				-48
			],
			[
				-43,
				-33
			],
			[
				-32,
				-8
			],
			[
				-54,
				-86
			],
			[
				-46,
				-81
			],
			[
				-35,
				-79
			],
			[
				-9,
				-37
			],
			[
				7,
				-102
			],
			[
				5,
				-122
			],
			[
				-11,
				-52
			],
			[
				-16,
				-31
			],
			[
				-75,
				-66
			],
			[
				-50,
				-48
			],
			[
				-23,
				-24
			],
			[
				-12,
				-39
			],
			[
				21,
				-89
			],
			[
				2,
				-66
			],
			[
				18,
				-39
			],
			[
				60,
				-31
			]
		],
		[
			[
				113891,
				49981
			],
			[
				-11,
				15
			],
			[
				-57,
				58
			],
			[
				-53,
				76
			],
			[
				-32,
				84
			],
			[
				-31,
				68
			],
			[
				-16,
				154
			],
			[
				-40,
				95
			],
			[
				-38,
				116
			],
			[
				-58,
				221
			],
			[
				-25,
				76
			],
			[
				-46,
				51
			],
			[
				-49,
				47
			],
			[
				-51,
				98
			],
			[
				-132,
				86
			],
			[
				-51,
				68
			],
			[
				-88,
				116
			],
			[
				-22,
				59
			],
			[
				-7,
				58
			],
			[
				-27,
				55
			],
			[
				-49,
				62
			],
			[
				-153,
				133
			],
			[
				-42,
				16
			],
			[
				-54,
				15
			],
			[
				-81,
				13
			],
			[
				-107,
				30
			],
			[
				-94,
				52
			],
			[
				-43,
				37
			],
			[
				-10,
				26
			],
			[
				9,
				43
			],
			[
				34,
				73
			],
			[
				65,
				174
			],
			[
				44,
				120
			],
			[
				31,
				33
			],
			[
				82,
				9
			],
			[
				88,
				-4
			],
			[
				65,
				-9
			],
			[
				90,
				-1
			],
			[
				109,
				10
			],
			[
				43,
				40
			],
			[
				34,
				44
			],
			[
				14,
				31
			],
			[
				5,
				77
			],
			[
				0,
				63
			],
			[
				-7,
				238
			],
			[
				-4,
				146
			],
			[
				-5,
				167
			],
			[
				1,
				77
			],
			[
				27,
				178
			],
			[
				25,
				102
			],
			[
				17,
				54
			],
			[
				68,
				170
			],
			[
				13,
				54
			],
			[
				2,
				50
			],
			[
				-25,
				229
			],
			[
				44,
				107
			],
			[
				57,
				107
			],
			[
				49,
				45
			],
			[
				42,
				31
			],
			[
				19,
				-13
			],
			[
				47,
				-49
			],
			[
				62,
				-49
			],
			[
				29,
				11
			],
			[
				43,
				42
			],
			[
				32,
				45
			],
			[
				-4,
				80
			],
			[
				28,
				165
			],
			[
				-5,
				95
			],
			[
				30,
				118
			],
			[
				34,
				166
			],
			[
				15,
				105
			],
			[
				19,
				56
			],
			[
				90,
				116
			],
			[
				78,
				164
			],
			[
				50,
				119
			],
			[
				94,
				195
			],
			[
				48,
				72
			],
			[
				39,
				30
			],
			[
				58,
				20
			],
			[
				108,
				18
			],
			[
				78,
				16
			],
			[
				11,
				26
			],
			[
				7,
				39
			],
			[
				1,
				88
			],
			[
				15,
				150
			],
			[
				33,
				147
			],
			[
				40,
				111
			],
			[
				22,
				50
			],
			[
				25,
				49
			],
			[
				29,
				82
			],
			[
				36,
				178
			],
			[
				-2,
				121
			],
			[
				52,
				221
			]
		],
		[
			[
				105873,
				54456
			],
			[
				-27,
				7
			],
			[
				-57,
				22
			],
			[
				-68,
				19
			],
			[
				-84,
				16
			],
			[
				-80,
				-37
			],
			[
				-87,
				-48
			],
			[
				-27,
				-35
			],
			[
				-24,
				-21
			],
			[
				-39,
				4
			],
			[
				-34,
				-7
			],
			[
				-19,
				-33
			],
			[
				-32,
				-38
			],
			[
				-125,
				-77
			],
			[
				-26,
				-28
			],
			[
				-16,
				-28
			],
			[
				0,
				-30
			],
			[
				13,
				-63
			],
			[
				0,
				-79
			],
			[
				-28,
				-63
			],
			[
				-33,
				-43
			],
			[
				-36,
				-16
			],
			[
				-31,
				-9
			],
			[
				-20,
				-26
			],
			[
				-66,
				-144
			],
			[
				-28,
				-26
			],
			[
				-57,
				4
			],
			[
				-164,
				-216
			],
			[
				-17,
				-63
			],
			[
				-60,
				-90
			],
			[
				-76,
				-100
			],
			[
				-68,
				-48
			],
			[
				-5,
				-19
			],
			[
				-19,
				-19
			],
			[
				-41,
				-22
			],
			[
				-145,
				-122
			],
			[
				-175,
				5
			],
			[
				-77,
				-48
			],
			[
				-74,
				-21
			],
			[
				-110,
				-23
			],
			[
				-33,
				2
			],
			[
				-140,
				-10
			],
			[
				-165,
				3
			],
			[
				-63,
				-17
			],
			[
				-59,
				-46
			],
			[
				-44,
				-41
			],
			[
				-6,
				-13
			],
			[
				6,
				-17
			],
			[
				-1,
				-14
			],
			[
				115,
				-99
			],
			[
				29,
				-49
			],
			[
				-29,
				-48
			],
			[
				-14,
				-7
			],
			[
				-2,
				-2
			],
			[
				-19,
				-38
			],
			[
				-67,
				-112
			],
			[
				-103,
				-133
			],
			[
				-52,
				-38
			],
			[
				-21,
				-25
			],
			[
				-27,
				-88
			],
			[
				-18,
				-13
			],
			[
				-71,
				-11
			],
			[
				-139,
				-10
			],
			[
				-193,
				-28
			],
			[
				-116,
				-10
			],
			[
				-72,
				8
			],
			[
				-102,
				-61
			],
			[
				-36,
				-15
			],
			[
				-22,
				-6
			],
			[
				-100,
				-59
			],
			[
				-84,
				-91
			],
			[
				-29,
				-18
			],
			[
				-118,
				-38
			],
			[
				-46,
				-63
			],
			[
				-22,
				-6
			],
			[
				-75,
				83
			],
			[
				-51,
				76
			],
			[
				-25,
				76
			],
			[
				-4,
				25
			],
			[
				-14,
				-5
			],
			[
				-41,
				-34
			],
			[
				-36,
				-38
			],
			[
				-16,
				-73
			],
			[
				-122,
				-50
			],
			[
				-103,
				-42
			],
			[
				-47,
				-53
			],
			[
				-73,
				-27
			],
			[
				-93,
				11
			],
			[
				-72,
				22
			],
			[
				-71,
				7
			]
		],
		[
			[
				99692,
				47234
			],
			[
				-15,
				51
			],
			[
				-32,
				27
			],
			[
				-58,
				3
			],
			[
				-170,
				-11
			],
			[
				-130,
				8
			],
			[
				-42,
				7
			],
			[
				-46,
				14
			],
			[
				-109,
				12
			],
			[
				-134,
				-10
			],
			[
				-31,
				3
			],
			[
				-107,
				-2
			],
			[
				-246,
				14
			],
			[
				-136,
				-2
			],
			[
				3,
				-32
			],
			[
				-9,
				-23
			],
			[
				-7,
				-54
			]
		],
		[
			[
				98295,
				42222
			],
			[
				38,
				127
			],
			[
				29,
				59
			],
			[
				35,
				41
			],
			[
				139,
				99
			],
			[
				21,
				-4
			],
			[
				97,
				-129
			],
			[
				30,
				-11
			],
			[
				35,
				4
			],
			[
				40,
				-5
			],
			[
				20,
				25
			],
			[
				3,
				33
			],
			[
				-29,
				38
			],
			[
				-4,
				40
			],
			[
				20,
				43
			],
			[
				12,
				49
			],
			[
				30,
				57
			],
			[
				3,
				26
			],
			[
				-32,
				30
			],
			[
				-65,
				44
			],
			[
				-44,
				43
			],
			[
				-17,
				41
			],
			[
				12,
				53
			],
			[
				36,
				43
			],
			[
				-2,
				23
			],
			[
				-32,
				39
			],
			[
				-23,
				41
			],
			[
				-24,
				25
			],
			[
				-65,
				16
			],
			[
				12,
				55
			],
			[
				25,
				81
			],
			[
				5,
				63
			],
			[
				-18,
				163
			],
			[
				2,
				30
			],
			[
				18,
				15
			],
			[
				39,
				-18
			],
			[
				39,
				-25
			],
			[
				107,
				36
			],
			[
				37,
				5
			],
			[
				31,
				-31
			],
			[
				43,
				-24
			],
			[
				247,
				68
			],
			[
				5,
				69
			],
			[
				14,
				63
			],
			[
				2,
				47
			],
			[
				-11,
				31
			],
			[
				-12,
				23
			],
			[
				-7,
				47
			],
			[
				0,
				50
			],
			[
				23,
				24
			],
			[
				79,
				61
			],
			[
				25,
				-3
			],
			[
				55,
				-32
			],
			[
				51,
				-52
			],
			[
				46,
				-108
			],
			[
				32,
				-93
			],
			[
				51,
				-114
			],
			[
				107,
				-46
			],
			[
				129,
				-29
			],
			[
				69,
				8
			],
			[
				99,
				96
			],
			[
				57,
				75
			],
			[
				18,
				41
			],
			[
				32,
				-21
			],
			[
				37,
				-99
			],
			[
				24,
				-38
			],
			[
				6,
				-37
			],
			[
				-16,
				-46
			],
			[
				16,
				-29
			],
			[
				69,
				-21
			],
			[
				60,
				20
			],
			[
				28,
				40
			],
			[
				45,
				53
			],
			[
				0,
				44
			],
			[
				-24,
				29
			],
			[
				0,
				39
			],
			[
				25,
				32
			],
			[
				25,
				85
			],
			[
				7,
				62
			],
			[
				24,
				39
			],
			[
				46,
				28
			],
			[
				16,
				25
			],
			[
				25,
				147
			],
			[
				-13,
				53
			],
			[
				0,
				44
			],
			[
				29,
				57
			],
			[
				5,
				92
			],
			[
				-12,
				151
			],
			[
				-8,
				104
			],
			[
				-9,
				109
			],
			[
				22,
				142
			],
			[
				23,
				149
			],
			[
				-4,
				37
			],
			[
				-32,
				45
			],
			[
				-39,
				42
			],
			[
				-102,
				34
			],
			[
				-37,
				54
			],
			[
				-30,
				57
			],
			[
				-21,
				18
			],
			[
				-111,
				23
			],
			[
				-25,
				33
			],
			[
				10,
				92
			],
			[
				10,
				137
			],
			[
				-4,
				96
			],
			[
				20,
				76
			],
			[
				22,
				58
			],
			[
				49,
				61
			],
			[
				26,
				72
			],
			[
				14,
				18
			],
			[
				93,
				12
			],
			[
				34,
				30
			],
			[
				26,
				30
			],
			[
				11,
				41
			],
			[
				32,
				67
			],
			[
				29,
				46
			],
			[
				3,
				31
			],
			[
				-6,
				44
			],
			[
				-29,
				85
			],
			[
				-33,
				70
			],
			[
				-20,
				26
			],
			[
				-41,
				166
			],
			[
				-38,
				39
			],
			[
				-74,
				21
			],
			[
				-139,
				19
			],
			[
				-84,
				-30
			],
			[
				-128,
				-56
			],
			[
				-98,
				-38
			],
			[
				-63,
				-22
			],
			[
				-38,
				6
			],
			[
				-16,
				25
			],
			[
				24,
				22
			],
			[
				13,
				50
			],
			[
				-16,
				73
			],
			[
				-25,
				66
			],
			[
				-14,
				93
			],
			[
				6,
				116
			],
			[
				24,
				109
			],
			[
				51,
				141
			],
			[
				3,
				58
			]
		],
		[
			[
				101105,
				51656
			],
			[
				34,
				66
			],
			[
				13,
				50
			],
			[
				3,
				61
			],
			[
				-5,
				41
			],
			[
				-42,
				20
			],
			[
				-27,
				32
			],
			[
				-61,
				192
			],
			[
				-62,
				196
			],
			[
				-88,
				194
			],
			[
				-96,
				124
			],
			[
				-69,
				75
			],
			[
				-22,
				10
			],
			[
				-36,
				24
			],
			[
				-25,
				22
			],
			[
				-127,
				131
			],
			[
				-131,
				147
			],
			[
				-34,
				67
			],
			[
				-66,
				101
			],
			[
				-74,
				103
			],
			[
				-38,
				47
			],
			[
				-18,
				85
			],
			[
				51,
				76
			],
			[
				54,
				97
			],
			[
				67,
				64
			],
			[
				87,
				5
			],
			[
				142,
				-27
			],
			[
				154,
				-9
			],
			[
				152,
				20
			],
			[
				40,
				14
			],
			[
				39,
				-1
			],
			[
				82,
				-23
			],
			[
				142,
				5
			],
			[
				74,
				39
			],
			[
				-79,
				67
			],
			[
				-86,
				106
			],
			[
				-80,
				116
			],
			[
				-48,
				105
			],
			[
				-45,
				135
			],
			[
				-41,
				167
			],
			[
				-25,
				216
			],
			[
				4,
				123
			],
			[
				13,
				88
			],
			[
				43,
				142
			],
			[
				-29,
				84
			],
			[
				7,
				67
			],
			[
				-5,
				100
			],
			[
				-13,
				51
			],
			[
				-56,
				166
			],
			[
				-11,
				18
			],
			[
				-49,
				114
			],
			[
				-22,
				192
			],
			[
				-55,
				127
			],
			[
				-89,
				61
			],
			[
				-51,
				75
			],
			[
				-19,
				131
			],
			[
				-35,
				35
			],
			[
				-140,
				46
			],
			[
				-117,
				1
			]
		],
		[
			[
				100190,
				56237
			],
			[
				62,
				-384
			],
			[
				7,
				-73
			],
			[
				5,
				-33
			],
			[
				4,
				-31
			],
			[
				8,
				-52
			],
			[
				49,
				-23
			],
			[
				92,
				-10
			],
			[
				67,
				-38
			],
			[
				40,
				-63
			],
			[
				4,
				-10
			],
			[
				21,
				-48
			],
			[
				5,
				-35
			],
			[
				-6,
				-101
			],
			[
				-13,
				-129
			],
			[
				-23,
				-83
			],
			[
				13,
				-114
			],
			[
				-4,
				-48
			],
			[
				-11,
				-33
			],
			[
				-41,
				-38
			],
			[
				-56,
				-38
			],
			[
				-133,
				-109
			],
			[
				-39,
				-16
			],
			[
				-56,
				-3
			],
			[
				-48,
				-28
			],
			[
				-58,
				-59
			],
			[
				-124,
				-220
			],
			[
				-106,
				-221
			],
			[
				-37,
				-183
			],
			[
				-41,
				-175
			],
			[
				-94,
				-111
			],
			[
				-13,
				-63
			],
			[
				-4,
				-36
			],
			[
				-3,
				-84
			],
			[
				-11,
				-140
			],
			[
				-15,
				-67
			],
			[
				-15,
				-20
			],
			[
				-101,
				-42
			],
			[
				-58,
				-51
			],
			[
				-35,
				-101
			],
			[
				-12,
				-110
			],
			[
				-21,
				-125
			],
			[
				-11,
				-109
			],
			[
				-16,
				-57
			],
			[
				-33,
				-59
			],
			[
				-51,
				-65
			],
			[
				-45,
				-36
			],
			[
				-116,
				-23
			],
			[
				-59,
				-145
			],
			[
				-51,
				-114
			],
			[
				-1,
				-45
			],
			[
				-49,
				-235
			],
			[
				-84,
				-177
			],
			[
				-6,
				-62
			],
			[
				0,
				-52
			],
			[
				-106,
				-156
			],
			[
				-28,
				-45
			],
			[
				-27,
				-61
			],
			[
				27,
				-58
			],
			[
				30,
				-52
			],
			[
				4,
				-18
			],
			[
				-48,
				-50
			],
			[
				-84,
				-86
			],
			[
				-50,
				-52
			],
			[
				-11,
				-28
			],
			[
				-7,
				-130
			],
			[
				-15,
				-35
			],
			[
				-33,
				-47
			],
			[
				-49,
				-52
			],
			[
				-50,
				-41
			],
			[
				-56,
				-28
			],
			[
				-54,
				-11
			],
			[
				-31,
				17
			],
			[
				-17,
				39
			],
			[
				-31,
				159
			],
			[
				-15,
				34
			],
			[
				-35,
				31
			],
			[
				-70,
				86
			],
			[
				-70,
				88
			],
			[
				-85,
				62
			],
			[
				-18,
				-4
			],
			[
				-14,
				-17
			],
			[
				-24,
				-88
			],
			[
				-24,
				-33
			],
			[
				-45,
				-11
			],
			[
				-77,
				-1
			],
			[
				-57,
				13
			],
			[
				-13,
				17
			],
			[
				-11,
				38
			],
			[
				-16,
				31
			],
			[
				-68,
				-62
			],
			[
				-106,
				-97
			],
			[
				-34,
				-16
			],
			[
				-27,
				-20
			],
			[
				-35,
				-91
			],
			[
				-42,
				-97
			],
			[
				-56,
				-51
			],
			[
				-54,
				-43
			],
			[
				-31,
				-37
			],
			[
				-45,
				-44
			],
			[
				-86,
				-110
			],
			[
				-116,
				-146
			],
			[
				-41,
				-76
			],
			[
				-40,
				-112
			],
			[
				-23,
				-125
			],
			[
				-26,
				-137
			],
			[
				-37,
				-220
			],
			[
				-56,
				-124
			],
			[
				-48,
				-99
			],
			[
				-36,
				-77
			],
			[
				-19,
				-64
			]
		],
		[
			[
				93426,
				55097
			],
			[
				38,
				29
			],
			[
				7,
				25
			],
			[
				-11,
				31
			],
			[
				-19,
				23
			],
			[
				-4,
				49
			],
			[
				5,
				33
			],
			[
				13,
				36
			],
			[
				-5,
				75
			],
			[
				1,
				116
			],
			[
				7,
				168
			],
			[
				1,
				102
			],
			[
				80,
				76
			],
			[
				115,
				126
			],
			[
				59,
				132
			],
			[
				31,
				100
			],
			[
				39,
				331
			],
			[
				28,
				21
			],
			[
				33,
				15
			],
			[
				116,
				121
			],
			[
				89,
				45
			],
			[
				68,
				26
			],
			[
				103,
				22
			],
			[
				63,
				-9
			],
			[
				116,
				-5
			],
			[
				91,
				11
			],
			[
				77,
				66
			],
			[
				35,
				19
			],
			[
				50,
				11
			],
			[
				223,
				-89
			],
			[
				224,
				-84
			],
			[
				41,
				8
			],
			[
				34,
				-12
			],
			[
				56,
				-45
			],
			[
				82,
				-98
			],
			[
				49,
				-63
			],
			[
				24,
				-37
			],
			[
				115,
				-211
			],
			[
				42,
				-53
			],
			[
				43,
				-29
			],
			[
				44,
				-11
			],
			[
				34,
				4
			],
			[
				32,
				24
			],
			[
				43,
				47
			],
			[
				66,
				22
			],
			[
				53,
				-5
			],
			[
				279,
				191
			],
			[
				27,
				2
			],
			[
				81,
				-15
			],
			[
				90,
				-26
			],
			[
				233,
				-191
			],
			[
				190,
				-125
			],
			[
				134,
				-42
			],
			[
				157,
				-29
			],
			[
				268,
				-9
			],
			[
				203,
				268
			],
			[
				75,
				58
			],
			[
				90,
				53
			],
			[
				29,
				9
			],
			[
				159,
				40
			],
			[
				312,
				34
			],
			[
				293,
				-14
			],
			[
				57,
				-11
			],
			[
				124,
				-36
			],
			[
				192,
				-87
			],
			[
				83,
				-83
			],
			[
				130,
				-14
			],
			[
				93,
				16
			],
			[
				30,
				83
			],
			[
				94,
				109
			],
			[
				68,
				45
			],
			[
				72,
				56
			],
			[
				114,
				71
			],
			[
				94,
				32
			],
			[
				84,
				80
			],
			[
				67,
				26
			],
			[
				115,
				2
			]
		],
		[
			[
				92647,
				55262
			],
			[
				-17,
				-47
			],
			[
				-49,
				-122
			],
			[
				-36,
				-51
			],
			[
				-162,
				-174
			],
			[
				-80,
				20
			],
			[
				-166,
				-35
			],
			[
				-25,
				40
			],
			[
				-39,
				5
			],
			[
				-48,
				-7
			],
			[
				-17,
				-15
			],
			[
				-6,
				-17
			],
			[
				-17,
				-24
			],
			[
				-31,
				-69
			],
			[
				-23,
				-17
			],
			[
				-30,
				-11
			],
			[
				-36,
				1
			],
			[
				-21,
				-9
			],
			[
				-1,
				-34
			],
			[
				-6,
				-30
			],
			[
				-25,
				-14
			],
			[
				-10,
				-34
			],
			[
				2,
				-32
			],
			[
				-14,
				-15
			],
			[
				-32,
				8
			],
			[
				-18,
				9
			]
		],
		[
			[
				91870,
				50473
			],
			[
				-1,
				46
			],
			[
				-29,
				8
			],
			[
				-36,
				16
			],
			[
				-22,
				23
			],
			[
				-31,
				55
			],
			[
				-11,
				42
			],
			[
				-47,
				7
			],
			[
				-58,
				48
			],
			[
				-56,
				54
			],
			[
				-19,
				55
			],
			[
				5,
				25
			],
			[
				-8,
				26
			],
			[
				-19,
				10
			],
			[
				-50,
				123
			],
			[
				-31,
				50
			],
			[
				-14,
				40
			],
			[
				5,
				31
			],
			[
				-7,
				42
			],
			[
				10,
				33
			],
			[
				27,
				20
			],
			[
				8,
				25
			],
			[
				2,
				52
			],
			[
				16,
				107
			],
			[
				9,
				105
			],
			[
				-28,
				29
			],
			[
				-35,
				8
			],
			[
				-17,
				30
			],
			[
				-7,
				49
			],
			[
				0,
				43
			],
			[
				68,
				149
			],
			[
				-14,
				345
			],
			[
				10,
				52
			],
			[
				31,
				37
			],
			[
				27,
				42
			],
			[
				-1,
				41
			],
			[
				-46,
				103
			],
			[
				-85,
				79
			],
			[
				-44,
				64
			],
			[
				-24,
				57
			],
			[
				-4,
				31
			],
			[
				52,
				45
			],
			[
				23,
				31
			],
			[
				3,
				36
			],
			[
				-21,
				65
			],
			[
				3,
				116
			],
			[
				20,
				88
			],
			[
				21,
				113
			],
			[
				-2,
				33
			],
			[
				-51,
				67
			],
			[
				-27,
				10
			],
			[
				-22,
				-5
			],
			[
				-53,
				-45
			],
			[
				-19,
				-4
			],
			[
				-12,
				13
			],
			[
				-5,
				18
			],
			[
				18,
				26
			],
			[
				-6,
				33
			],
			[
				15,
				29
			],
			[
				34,
				13
			],
			[
				10,
				15
			],
			[
				-46,
				13
			],
			[
				-5,
				20
			],
			[
				3,
				19
			],
			[
				13,
				4
			],
			[
				15,
				-1
			],
			[
				8,
				13
			],
			[
				6,
				96
			],
			[
				6,
				34
			],
			[
				6,
				66
			],
			[
				7,
				257
			],
			[
				10,
				26
			],
			[
				1,
				20
			],
			[
				-31,
				12
			],
			[
				-75,
				69
			],
			[
				-44,
				53
			],
			[
				-38,
				54
			],
			[
				-32,
				36
			],
			[
				-63,
				55
			],
			[
				-19,
				35
			],
			[
				-2,
				35
			],
			[
				19,
				70
			],
			[
				30,
				75
			],
			[
				15,
				107
			],
			[
				-9,
				28
			],
			[
				-41,
				50
			]
		],
		[
			[
				89361,
				53270
			],
			[
				7,
				-41
			],
			[
				-13,
				-66
			],
			[
				3,
				-41
			],
			[
				17,
				-16
			],
			[
				-9,
				-52
			],
			[
				-37,
				-90
			],
			[
				-1,
				-53
			],
			[
				37,
				-17
			],
			[
				27,
				-56
			],
			[
				15,
				-97
			],
			[
				16,
				-32
			],
			[
				2,
				-20
			],
			[
				26,
				-234
			],
			[
				33,
				-234
			],
			[
				-21,
				-31
			],
			[
				-29,
				-9
			],
			[
				-18,
				-11
			],
			[
				-6,
				-22
			],
			[
				13,
				-32
			],
			[
				-8,
				-29
			],
			[
				-36,
				-20
			],
			[
				-78,
				-75
			],
			[
				-6,
				-29
			],
			[
				-20,
				-64
			],
			[
				-18,
				-38
			],
			[
				-25,
				-72
			],
			[
				-41,
				-190
			],
			[
				-15,
				-158
			],
			[
				-2,
				-48
			],
			[
				-16,
				-34
			],
			[
				-17,
				-49
			],
			[
				-85,
				-135
			],
			[
				-43,
				-110
			],
			[
				5,
				-48
			],
			[
				2,
				-48
			],
			[
				-13,
				-35
			],
			[
				3,
				-93
			],
			[
				10,
				-78
			],
			[
				15,
				-77
			],
			[
				62,
				-216
			],
			[
				32,
				-132
			],
			[
				20,
				-106
			],
			[
				17,
				-71
			],
			[
				16,
				-29
			],
			[
				7,
				-27
			],
			[
				91,
				-20
			],
			[
				18,
				-16
			],
			[
				25,
				-138
			],
			[
				-4,
				-62
			],
			[
				-18,
				-24
			],
			[
				0,
				-53
			],
			[
				-4,
				-65
			],
			[
				-13,
				-26
			],
			[
				-51,
				-4
			],
			[
				-35,
				-24
			],
			[
				-45,
				9
			],
			[
				-44,
				-2
			],
			[
				-18,
				-32
			]
		],
		[
			[
				87534,
				54049
			],
			[
				11,
				48
			],
			[
				18,
				67
			],
			[
				2,
				65
			],
			[
				12,
				105
			],
			[
				-7,
				132
			],
			[
				-14,
				92
			],
			[
				43,
				38
			],
			[
				49,
				34
			],
			[
				31,
				62
			],
			[
				32,
				141
			],
			[
				13,
				121
			],
			[
				-9,
				44
			],
			[
				-17,
				36
			],
			[
				-13,
				52
			],
			[
				-7,
				64
			],
			[
				9,
				55
			],
			[
				37,
				52
			],
			[
				47,
				43
			],
			[
				33,
				21
			],
			[
				89,
				21
			],
			[
				110,
				32
			],
			[
				64,
				36
			],
			[
				47,
				36
			],
			[
				26,
				29
			],
			[
				26,
				59
			],
			[
				43,
				46
			],
			[
				33,
				46
			],
			[
				4,
				128
			],
			[
				0,
				73
			],
			[
				-24,
				40
			],
			[
				-14,
				35
			],
			[
				164,
				100
			],
			[
				1,
				71
			],
			[
				-23,
				79
			],
			[
				-32,
				63
			],
			[
				-12,
				55
			],
			[
				46,
				65
			],
			[
				40,
				48
			],
			[
				29,
				42
			],
			[
				65,
				62
			],
			[
				67,
				17
			],
			[
				60,
				-24
			],
			[
				180,
				-148
			],
			[
				31,
				-9
			],
			[
				37,
				11
			],
			[
				48,
				39
			],
			[
				61,
				31
			],
			[
				23,
				98
			],
			[
				-3,
				146
			],
			[
				14,
				67
			],
			[
				33,
				12
			],
			[
				103,
				-28
			],
			[
				27,
				-2
			],
			[
				30,
				10
			],
			[
				21,
				25
			],
			[
				0,
				47
			],
			[
				-5,
				42
			],
			[
				33,
				135
			],
			[
				62,
				101
			],
			[
				124,
				127
			],
			[
				39,
				26
			],
			[
				45,
				13
			],
			[
				222,
				-87
			],
			[
				36,
				21
			],
			[
				54,
				216
			],
			[
				61,
				21
			],
			[
				72,
				4
			],
			[
				47,
				18
			],
			[
				24,
				15
			],
			[
				106,
				82
			],
			[
				187,
				112
			],
			[
				100,
				48
			],
			[
				20,
				18
			],
			[
				72,
				79
			],
			[
				95,
				91
			],
			[
				61,
				18
			],
			[
				84,
				7
			],
			[
				53,
				-15
			],
			[
				14,
				-26
			],
			[
				17,
				-13
			],
			[
				110,
				38
			],
			[
				157,
				-61
			],
			[
				136,
				-61
			]
		],
		[
			[
				89361,
				53270
			],
			[
				-13,
				-20
			],
			[
				-32,
				-26
			],
			[
				-33,
				0
			],
			[
				-37,
				62
			],
			[
				-17,
				28
			],
			[
				-31,
				63
			],
			[
				-26,
				63
			],
			[
				-35,
				28
			],
			[
				-34,
				26
			],
			[
				-42,
				80
			],
			[
				-41,
				38
			],
			[
				-42,
				-11
			],
			[
				-63,
				15
			],
			[
				-126,
				20
			],
			[
				-135,
				-6
			],
			[
				-56,
				-19
			],
			[
				-56,
				-29
			],
			[
				-140,
				-64
			],
			[
				-56,
				-32
			],
			[
				-42,
				-80
			],
			[
				-48,
				2
			],
			[
				-48,
				25
			],
			[
				-29,
				37
			],
			[
				-65,
				-8
			],
			[
				-62,
				35
			],
			[
				-59,
				70
			],
			[
				-45,
				23
			],
			[
				-56,
				50
			],
			[
				-15,
				96
			],
			[
				-36,
				68
			],
			[
				-33,
				93
			],
			[
				-49,
				42
			],
			[
				-56,
				23
			],
			[
				-77,
				-5
			],
			[
				-51,
				37
			],
			[
				-41,
				55
			]
		],
		[
			[
				85620,
				51685
			],
			[
				12,
				-10
			],
			[
				20,
				-25
			],
			[
				18,
				-86
			],
			[
				73,
				-279
			],
			[
				-4,
				-77
			],
			[
				-14,
				-50
			],
			[
				-1,
				-49
			],
			[
				-5,
				-49
			],
			[
				-44,
				-79
			],
			[
				-131,
				-163
			],
			[
				11,
				-14
			],
			[
				31,
				-19
			],
			[
				32,
				-9
			],
			[
				26,
				5
			],
			[
				32,
				-41
			],
			[
				36,
				-51
			],
			[
				37,
				-27
			],
			[
				54,
				-23
			],
			[
				47,
				-3
			],
			[
				40,
				9
			],
			[
				56,
				-10
			],
			[
				60,
				-42
			],
			[
				22,
				-70
			],
			[
				14,
				-61
			],
			[
				21,
				-31
			],
			[
				3,
				-52
			],
			[
				43,
				-46
			],
			[
				60,
				-10
			],
			[
				79,
				-54
			],
			[
				21,
				3
			],
			[
				8,
				7
			],
			[
				10,
				-11
			],
			[
				20,
				-156
			],
			[
				15,
				-83
			],
			[
				-8,
				-34
			],
			[
				-11,
				-26
			],
			[
				0,
				-127
			],
			[
				-36,
				-72
			],
			[
				-6,
				-80
			],
			[
				-10,
				-26
			],
			[
				-38,
				-23
			],
			[
				0,
				-61
			],
			[
				-11,
				-74
			],
			[
				-4,
				-79
			],
			[
				11,
				-205
			],
			[
				2,
				-153
			],
			[
				17,
				-29
			]
		],
		[
			[
				85620,
				51685
			],
			[
				-23,
				22
			],
			[
				-27,
				32
			],
			[
				-10,
				43
			],
			[
				-18,
				9
			],
			[
				-34,
				1
			],
			[
				-31,
				-25
			],
			[
				-14,
				-44
			],
			[
				-2,
				-51
			],
			[
				-5,
				-39
			],
			[
				-19,
				-24
			],
			[
				-38,
				-62
			],
			[
				-17,
				-57
			],
			[
				-22,
				-49
			],
			[
				-32,
				2
			],
			[
				-15,
				7
			],
			[
				-10,
				-13
			],
			[
				-49,
				-27
			],
			[
				-42,
				-8
			],
			[
				-11,
				29
			],
			[
				-24,
				23
			],
			[
				-28,
				45
			],
			[
				-31,
				36
			],
			[
				-59,
				26
			],
			[
				-24,
				-11
			],
			[
				-28,
				3
			],
			[
				-18,
				14
			],
			[
				2,
				22
			],
			[
				31,
				56
			],
			[
				18,
				51
			],
			[
				10,
				55
			],
			[
				0,
				53
			],
			[
				-17,
				75
			],
			[
				-27,
				60
			],
			[
				-6,
				34
			],
			[
				3,
				49
			],
			[
				-6,
				46
			],
			[
				-9,
				24
			],
			[
				-4,
				45
			],
			[
				-9,
				41
			],
			[
				-15,
				16
			],
			[
				-9,
				69
			],
			[
				2,
				71
			],
			[
				-23,
				27
			],
			[
				-36,
				19
			],
			[
				-21,
				28
			],
			[
				-14,
				31
			],
			[
				-13,
				9
			],
			[
				-11,
				-2
			],
			[
				-10,
				-19
			],
			[
				-12,
				-4
			],
			[
				-21,
				66
			],
			[
				-9,
				3
			],
			[
				-15,
				-15
			],
			[
				-167,
				-74
			],
			[
				-8,
				29
			],
			[
				-14,
				34
			],
			[
				-32,
				11
			],
			[
				-55,
				-25
			],
			[
				-33,
				-3
			]
		],
		[
			[
				87534,
				54049
			],
			[
				-21,
				12
			],
			[
				-89,
				-6
			],
			[
				-97,
				-36
			],
			[
				-33,
				-29
			],
			[
				-8,
				-39
			],
			[
				-21,
				-26
			],
			[
				-31,
				-30
			],
			[
				-30,
				-36
			],
			[
				-53,
				5
			],
			[
				-52,
				25
			],
			[
				-26,
				25
			],
			[
				-2,
				14
			],
			[
				17,
				36
			],
			[
				14,
				39
			],
			[
				1,
				25
			],
			[
				-17,
				63
			],
			[
				-14,
				67
			],
			[
				6,
				33
			],
			[
				-13,
				99
			],
			[
				-7,
				5
			],
			[
				-68,
				-26
			],
			[
				-25,
				-6
			],
			[
				-14,
				-11
			],
			[
				-4,
				-19
			],
			[
				16,
				-63
			],
			[
				-10,
				-11
			],
			[
				-38,
				2
			],
			[
				-53,
				21
			],
			[
				-58,
				57
			],
			[
				-14,
				-18
			],
			[
				-7,
				-46
			],
			[
				-4,
				-55
			],
			[
				15,
				-99
			],
			[
				-15,
				-35
			],
			[
				-39,
				6
			],
			[
				-52,
				0
			],
			[
				-45,
				-9
			],
			[
				-30,
				-3
			],
			[
				-19,
				-35
			],
			[
				-8,
				-39
			],
			[
				18,
				-44
			],
			[
				-3,
				-19
			],
			[
				-14,
				-17
			],
			[
				-18,
				-10
			],
			[
				-14,
				1
			],
			[
				-42,
				49
			],
			[
				-50,
				18
			],
			[
				-117,
				28
			],
			[
				-14,
				66
			],
			[
				-20,
				1
			],
			[
				-27,
				36
			],
			[
				-26,
				46
			],
			[
				-23,
				-3
			],
			[
				-19,
				-13
			],
			[
				-64,
				5
			],
			[
				-57,
				-70
			],
			[
				-42,
				-87
			],
			[
				-45,
				-42
			],
			[
				-49,
				-18
			],
			[
				-20,
				-1
			]
		],
		[
			[
				81384,
				54473
			],
			[
				28,
				43
			],
			[
				35,
				66
			],
			[
				107,
				275
			],
			[
				38,
				63
			],
			[
				24,
				22
			],
			[
				51,
				3
			],
			[
				98,
				36
			],
			[
				81,
				61
			],
			[
				40,
				25
			],
			[
				93,
				-7
			],
			[
				109,
				11
			],
			[
				142,
				59
			],
			[
				3,
				81
			],
			[
				-1,
				103
			],
			[
				-5,
				41
			],
			[
				-51,
				37
			],
			[
				-29,
				32
			],
			[
				-25,
				41
			],
			[
				-31,
				29
			],
			[
				1,
				31
			],
			[
				38,
				26
			],
			[
				25,
				13
			],
			[
				58,
				0
			],
			[
				19,
				15
			],
			[
				14,
				26
			],
			[
				17,
				67
			],
			[
				6,
				70
			],
			[
				-39,
				94
			],
			[
				3,
				67
			]
		],
		[
			[
				83744,
				55681
			],
			[
				-18,
				-22
			],
			[
				-19,
				-48
			],
			[
				-18,
				-60
			],
			[
				-17,
				-40
			],
			[
				6,
				-26
			],
			[
				50,
				-52
			],
			[
				71,
				-73
			],
			[
				29,
				-9
			],
			[
				33,
				17
			],
			[
				51,
				58
			],
			[
				41,
				62
			],
			[
				40,
				30
			],
			[
				46,
				-1
			],
			[
				37,
				-44
			],
			[
				45,
				-97
			],
			[
				41,
				-89
			],
			[
				5,
				-9
			],
			[
				17,
				-14
			],
			[
				20,
				0
			],
			[
				22,
				22
			],
			[
				16,
				13
			],
			[
				19,
				40
			],
			[
				80,
				123
			],
			[
				60,
				33
			],
			[
				21,
				9
			],
			[
				43,
				19
			],
			[
				69,
				-29
			],
			[
				101,
				-51
			],
			[
				123,
				-61
			],
			[
				43,
				-10
			],
			[
				25,
				10
			],
			[
				37,
				83
			],
			[
				45,
				33
			],
			[
				66,
				38
			],
			[
				53,
				20
			],
			[
				30,
				2
			],
			[
				11,
				23
			],
			[
				6,
				33
			],
			[
				-6,
				35
			],
			[
				-34,
				63
			],
			[
				-1,
				19
			],
			[
				19,
				12
			],
			[
				42,
				9
			],
			[
				55,
				-6
			],
			[
				61,
				-28
			],
			[
				50,
				-39
			],
			[
				29,
				-46
			],
			[
				31,
				-100
			],
			[
				24,
				-96
			],
			[
				62,
				-154
			],
			[
				-2,
				-95
			],
			[
				-1,
				-110
			],
			[
				28,
				-21
			],
			[
				30,
				-9
			],
			[
				14,
				-16
			],
			[
				30,
				-85
			],
			[
				28,
				-24
			],
			[
				34,
				-6
			],
			[
				63,
				-54
			],
			[
				41,
				-22
			],
			[
				6,
				-16
			],
			[
				-2,
				-22
			],
			[
				-15,
				-29
			],
			[
				-25,
				-20
			],
			[
				-37,
				-37
			],
			[
				-30,
				-48
			],
			[
				-63,
				-117
			],
			[
				-1,
				-22
			],
			[
				13,
				-15
			],
			[
				26,
				-3
			],
			[
				27,
				8
			],
			[
				58,
				43
			],
			[
				45,
				-16
			],
			[
				43,
				-32
			],
			[
				16,
				-34
			],
			[
				4,
				-44
			],
			[
				-10,
				-57
			],
			[
				-1,
				-64
			],
			[
				14,
				-109
			],
			[
				23,
				-108
			],
			[
				23,
				-40
			],
			[
				145,
				-96
			],
			[
				14,
				-35
			],
			[
				7,
				-41
			],
			[
				-11,
				-55
			]
		],
		[
			[
				160573,
				57578
			],
			[
				-35,
				-33
			],
			[
				-33,
				-84
			],
			[
				-22,
				-6
			],
			[
				-57,
				30
			],
			[
				-19,
				-17
			],
			[
				-36,
				-61
			],
			[
				-63,
				-67
			],
			[
				-30,
				0
			],
			[
				-21,
				8
			],
			[
				-25,
				-29
			],
			[
				-35,
				-52
			],
			[
				-16,
				1
			],
			[
				-60,
				-12
			],
			[
				-24,
				17
			],
			[
				-29,
				43
			],
			[
				-47,
				45
			],
			[
				-43,
				31
			],
			[
				-23,
				21
			],
			[
				-21,
				37
			],
			[
				-19,
				24
			],
			[
				-35,
				-53
			],
			[
				-59,
				-49
			],
			[
				-57,
				9
			],
			[
				-27,
				8
			],
			[
				-23,
				-72
			],
			[
				-16,
				-13
			],
			[
				-101,
				-13
			],
			[
				-19,
				-11
			],
			[
				16,
				-67
			],
			[
				60,
				-112
			],
			[
				18,
				-64
			],
			[
				-38,
				-105
			],
			[
				-105,
				2
			],
			[
				-47,
				43
			],
			[
				-43,
				60
			],
			[
				-16,
				30
			],
			[
				-134,
				58
			],
			[
				-90,
				-40
			],
			[
				-28,
				2
			],
			[
				-42,
				43
			],
			[
				-25,
				32
			],
			[
				-25,
				49
			],
			[
				-14,
				49
			],
			[
				-2,
				22
			]
		],
		[
			[
				164799,
				49242
			],
			[
				23,
				-26
			],
			[
				47,
				-32
			],
			[
				36,
				-40
			],
			[
				24,
				-52
			],
			[
				17,
				-50
			],
			[
				1,
				-41
			],
			[
				22,
				-34
			],
			[
				60,
				-6
			],
			[
				20,
				-43
			],
			[
				42,
				-74
			],
			[
				38,
				-54
			],
			[
				24,
				-20
			],
			[
				30,
				11
			],
			[
				46,
				49
			],
			[
				33,
				59
			],
			[
				22,
				81
			],
			[
				-18,
				11
			],
			[
				31,
				61
			],
			[
				6,
				32
			],
			[
				-14,
				30
			],
			[
				-18,
				28
			],
			[
				-7,
				74
			],
			[
				-13,
				94
			],
			[
				-8,
				42
			],
			[
				24,
				30
			],
			[
				52,
				39
			],
			[
				51,
				45
			],
			[
				53,
				36
			]
		],
		[
			[
				34098,
				58423
			],
			[
				-28,
				-29
			],
			[
				-60,
				-65
			],
			[
				-109,
				-111
			],
			[
				-98,
				-99
			],
			[
				-94,
				-91
			],
			[
				-85,
				-81
			],
			[
				-10,
				-8
			],
			[
				-107,
				-58
			],
			[
				-18,
				-27
			],
			[
				-23,
				-115
			],
			[
				-10,
				-28
			],
			[
				19,
				-64
			],
			[
				19,
				-98
			],
			[
				-6,
				-52
			],
			[
				-74,
				-63
			],
			[
				-34,
				-57
			],
			[
				-15,
				-37
			]
		],
		[
			[
				41111,
				52591
			],
			[
				-12,
				-11
			],
			[
				-36,
				-65
			],
			[
				-20,
				-55
			],
			[
				46,
				-59
			],
			[
				14,
				-62
			],
			[
				26,
				-68
			],
			[
				41,
				-68
			],
			[
				45,
				-126
			],
			[
				11,
				-51
			],
			[
				-13,
				-33
			],
			[
				-43,
				-20
			],
			[
				-41,
				-59
			],
			[
				-11,
				-72
			],
			[
				8,
				-36
			],
			[
				-121,
				-115
			],
			[
				-31,
				-19
			],
			[
				-21,
				18
			],
			[
				-26,
				57
			],
			[
				-31,
				47
			],
			[
				-16,
				16
			],
			[
				-10,
				1
			],
			[
				-10,
				-11
			],
			[
				-4,
				-25
			],
			[
				16,
				-108
			],
			[
				-14,
				-44
			],
			[
				-41,
				-34
			],
			[
				-47,
				-176
			]
		],
		[
			[
				51857,
				49741
			],
			[
				-137,
				194
			],
			[
				-138,
				196
			],
			[
				-135,
				192
			],
			[
				-9,
				26
			],
			[
				57,
				91
			],
			[
				50,
				66
			],
			[
				42,
				37
			],
			[
				20,
				33
			],
			[
				-15,
				141
			],
			[
				1,
				51
			],
			[
				-20,
				55
			],
			[
				-14,
				61
			],
			[
				17,
				52
			],
			[
				20,
				36
			],
			[
				27,
				14
			],
			[
				63,
				12
			],
			[
				44,
				6
			],
			[
				16,
				20
			],
			[
				26,
				24
			],
			[
				34,
				2
			],
			[
				67,
				-17
			],
			[
				30,
				31
			],
			[
				55,
				42
			],
			[
				123,
				73
			],
			[
				28,
				47
			],
			[
				19,
				74
			],
			[
				-2,
				34
			],
			[
				-12,
				14
			],
			[
				-31,
				12
			],
			[
				-47,
				1
			],
			[
				-38,
				-19
			],
			[
				-38,
				11
			],
			[
				-33,
				45
			],
			[
				-2,
				38
			],
			[
				20,
				53
			],
			[
				-11,
				35
			],
			[
				-62,
				111
			],
			[
				0,
				31
			],
			[
				45,
				50
			],
			[
				25,
				43
			],
			[
				35,
				102
			],
			[
				28,
				34
			],
			[
				86,
				11
			],
			[
				21,
				22
			],
			[
				44,
				54
			],
			[
				65,
				62
			],
			[
				95,
				49
			],
			[
				26,
				89
			],
			[
				17,
				25
			],
			[
				75,
				47
			],
			[
				13,
				25
			],
			[
				-2,
				22
			],
			[
				-120,
				201
			]
		],
		[
			[
				51857,
				49741
			],
			[
				19,
				-8
			],
			[
				26,
				-23
			],
			[
				24,
				-68
			],
			[
				20,
				-72
			],
			[
				0,
				-37
			],
			[
				-15,
				-47
			],
			[
				-33,
				-54
			],
			[
				-41,
				-44
			],
			[
				-59,
				-37
			],
			[
				-47,
				-35
			],
			[
				-39,
				-92
			],
			[
				-23,
				-33
			],
			[
				-22,
				-13
			],
			[
				-43,
				-12
			],
			[
				-69,
				3
			],
			[
				-46,
				7
			],
			[
				-56,
				-69
			],
			[
				-72,
				-25
			],
			[
				-49,
				-95
			],
			[
				-172,
				-75
			],
			[
				-168,
				-58
			],
			[
				-47,
				-23
			],
			[
				-166,
				48
			],
			[
				-40,
				-15
			],
			[
				-46,
				-45
			],
			[
				-43,
				-34
			],
			[
				-36,
				-2
			],
			[
				-30,
				-18
			],
			[
				-18,
				-64
			],
			[
				-16,
				-221
			],
			[
				-59,
				-65
			],
			[
				-73,
				0
			],
			[
				-49,
				76
			],
			[
				-59,
				58
			],
			[
				-102,
				137
			],
			[
				-29,
				18
			],
			[
				-26,
				-1
			],
			[
				-95,
				-41
			],
			[
				-45,
				18
			],
			[
				-37,
				21
			],
			[
				-60,
				-7
			],
			[
				-109,
				-1
			],
			[
				-69,
				-2
			],
			[
				-33,
				38
			],
			[
				-32,
				76
			],
			[
				-21,
				28
			],
			[
				-24,
				22
			],
			[
				-41,
				11
			],
			[
				-175,
				-1
			],
			[
				-32,
				0
			],
			[
				-24,
				15
			],
			[
				-34,
				65
			],
			[
				-37,
				31
			],
			[
				-43,
				2
			],
			[
				-18,
				-37
			],
			[
				74,
				-117
			],
			[
				22,
				-64
			],
			[
				65,
				-93
			],
			[
				189,
				-195
			],
			[
				35,
				-62
			],
			[
				-4,
				-80
			],
			[
				-1,
				-121
			],
			[
				7,
				-115
			],
			[
				48,
				-165
			],
			[
				69,
				-167
			],
			[
				18,
				-107
			],
			[
				-13,
				-79
			],
			[
				-13,
				-42
			],
			[
				2,
				-19
			],
			[
				14,
				-17
			],
			[
				65,
				-24
			],
			[
				137,
				-16
			],
			[
				82,
				0
			],
			[
				127,
				-18
			],
			[
				9,
				-59
			],
			[
				-12,
				-97
			],
			[
				-25,
				-55
			],
			[
				-21,
				-16
			],
			[
				-68,
				-13
			],
			[
				-73,
				-60
			],
			[
				-104,
				-59
			],
			[
				-60,
				-8
			],
			[
				-25,
				-11
			],
			[
				-21,
				-18
			],
			[
				-18,
				-22
			],
			[
				-20,
				-111
			],
			[
				-31,
				-124
			],
			[
				-58,
				-74
			],
			[
				-65,
				-62
			],
			[
				-65,
				-7
			],
			[
				-52,
				5
			],
			[
				-26,
				-18
			],
			[
				-38,
				-50
			],
			[
				-53,
				-63
			],
			[
				-42,
				-33
			],
			[
				-55,
				3
			],
			[
				-60,
				-31
			],
			[
				-75,
				-50
			],
			[
				-50,
				-42
			],
			[
				-43,
				-71
			],
			[
				-61,
				-74
			],
			[
				-62,
				-52
			],
			[
				-30,
				-65
			],
			[
				-43,
				-82
			],
			[
				-53,
				-2
			],
			[
				-5,
				49
			],
			[
				26,
				79
			],
			[
				-28,
				68
			],
			[
				-51,
				36
			],
			[
				-23,
				11
			],
			[
				-24,
				-4
			],
			[
				-60,
				-34
			],
			[
				-74,
				-61
			],
			[
				-46,
				-44
			],
			[
				-41,
				-20
			],
			[
				-85,
				-18
			],
			[
				-71,
				-10
			],
			[
				-29,
				13
			],
			[
				-54,
				45
			],
			[
				-122,
				140
			],
			[
				-166,
				191
			]
		],
		[
			[
				125020,
				79906
			],
			[
				131,
				136
			],
			[
				113,
				96
			],
			[
				91,
				57
			],
			[
				28,
				14
			],
			[
				126,
				48
			],
			[
				162,
				44
			],
			[
				119,
				31
			],
			[
				156,
				28
			],
			[
				51,
				5
			],
			[
				74,
				-1
			],
			[
				61,
				-26
			],
			[
				37,
				-19
			],
			[
				130,
				-83
			],
			[
				132,
				-84
			],
			[
				114,
				-93
			],
			[
				32,
				-38
			],
			[
				18,
				-46
			],
			[
				14,
				-44
			],
			[
				96,
				-141
			],
			[
				39,
				-65
			],
			[
				57,
				-84
			],
			[
				45,
				-41
			],
			[
				44,
				-51
			],
			[
				30,
				-42
			],
			[
				34,
				-20
			],
			[
				38,
				-7
			],
			[
				86,
				13
			],
			[
				104,
				26
			],
			[
				61,
				11
			],
			[
				28,
				-1
			]
		],
		[
			[
				127271,
				79529
			],
			[
				171,
				-10
			],
			[
				154,
				-8
			],
			[
				189,
				-11
			],
			[
				57,
				-9
			],
			[
				68,
				-9
			],
			[
				33,
				-2
			],
			[
				30,
				36
			],
			[
				20,
				20
			],
			[
				15,
				16
			],
			[
				-3,
				18
			],
			[
				-24,
				15
			],
			[
				-38,
				50
			],
			[
				-21,
				180
			],
			[
				-14,
				154
			],
			[
				45,
				48
			],
			[
				52,
				35
			],
			[
				74,
				105
			],
			[
				40,
				33
			],
			[
				59,
				27
			],
			[
				197,
				7
			],
			[
				83,
				20
			],
			[
				27,
				34
			],
			[
				43,
				86
			],
			[
				15,
				70
			],
			[
				24,
				32
			],
			[
				29,
				24
			],
			[
				31,
				-1
			],
			[
				58,
				-21
			],
			[
				44,
				-11
			],
			[
				32,
				-16
			],
			[
				28,
				-24
			],
			[
				28,
				-43
			],
			[
				4,
				-29
			],
			[
				13,
				-16
			],
			[
				22,
				-1
			],
			[
				17,
				0
			],
			[
				11,
				7
			],
			[
				8,
				14
			],
			[
				-6,
				19
			],
			[
				-38,
				55
			],
			[
				-84,
				99
			],
			[
				-54,
				41
			],
			[
				-28,
				22
			],
			[
				-6,
				21
			],
			[
				35,
				31
			],
			[
				35,
				18
			],
			[
				60,
				-13
			],
			[
				80,
				-8
			],
			[
				36,
				16
			],
			[
				36,
				80
			],
			[
				91,
				-85
			],
			[
				95,
				-94
			],
			[
				35,
				-18
			],
			[
				68,
				-10
			],
			[
				56,
				-3
			],
			[
				24,
				-11
			],
			[
				26,
				-24
			],
			[
				50,
				-104
			],
			[
				50,
				-27
			],
			[
				62,
				-19
			],
			[
				202,
				1
			],
			[
				61,
				-5
			],
			[
				51,
				-49
			],
			[
				31,
				-20
			],
			[
				14,
				-17
			],
			[
				-3,
				-22
			],
			[
				-13,
				-27
			],
			[
				-1,
				-52
			],
			[
				-4,
				-41
			],
			[
				-16,
				-19
			],
			[
				-5,
				-18
			],
			[
				14,
				-16
			],
			[
				93,
				-39
			],
			[
				32,
				-41
			],
			[
				23,
				-19
			],
			[
				6,
				-26
			],
			[
				-16,
				-17
			],
			[
				-44,
				9
			],
			[
				-21,
				-28
			],
			[
				0,
				-48
			],
			[
				31,
				-46
			],
			[
				9,
				-42
			],
			[
				-21,
				-40
			],
			[
				-24,
				-57
			],
			[
				0,
				-41
			],
			[
				14,
				-23
			],
			[
				71,
				-41
			],
			[
				165,
				-105
			],
			[
				38,
				-5
			],
			[
				156,
				25
			],
			[
				72,
				2
			],
			[
				43,
				-16
			],
			[
				121,
				-15
			],
			[
				38,
				-17
			],
			[
				41,
				-1
			],
			[
				56,
				5
			],
			[
				37,
				47
			],
			[
				20,
				11
			],
			[
				17,
				7
			],
			[
				34,
				2
			],
			[
				96,
				-30
			],
			[
				100,
				-63
			],
			[
				66,
				-58
			],
			[
				33,
				-52
			],
			[
				42,
				-113
			],
			[
				50,
				-173
			],
			[
				60,
				-117
			],
			[
				71,
				-61
			],
			[
				50,
				-112
			],
			[
				43,
				-244
			],
			[
				26,
				-50
			],
			[
				28,
				-26
			],
			[
				81,
				-70
			],
			[
				165,
				-117
			],
			[
				98,
				-69
			],
			[
				151,
				-110
			],
			[
				138,
				-101
			],
			[
				139,
				-156
			],
			[
				28,
				-23
			],
			[
				122,
				-84
			],
			[
				136,
				-87
			],
			[
				95,
				20
			],
			[
				143,
				-133
			],
			[
				58,
				-49
			],
			[
				25,
				-17
			],
			[
				104,
				-53
			],
			[
				165,
				-109
			],
			[
				209,
				-157
			],
			[
				138,
				-91
			],
			[
				37,
				-11
			],
			[
				37,
				1
			],
			[
				40,
				19
			],
			[
				43,
				16
			],
			[
				74,
				-21
			],
			[
				80,
				-36
			],
			[
				51,
				-28
			],
			[
				58,
				-40
			],
			[
				46,
				-38
			],
			[
				36,
				-17
			],
			[
				119,
				-33
			],
			[
				20,
				-20
			],
			[
				13,
				-22
			],
			[
				2,
				-23
			],
			[
				-67,
				-121
			],
			[
				-9,
				-154
			],
			[
				0,
				-115
			],
			[
				7,
				-91
			]
		],
		[
			[
				122913,
				83664
			],
			[
				-31,
				10
			],
			[
				-146,
				77
			],
			[
				-119,
				54
			],
			[
				-106,
				48
			],
			[
				-16,
				9
			],
			[
				-29,
				24
			],
			[
				-20,
				36
			],
			[
				-5,
				40
			],
			[
				11,
				30
			],
			[
				25,
				19
			],
			[
				31,
				7
			],
			[
				27,
				-6
			],
			[
				30,
				-18
			],
			[
				53,
				-22
			],
			[
				70,
				-4
			],
			[
				43,
				17
			],
			[
				5,
				40
			],
			[
				-82,
				149
			],
			[
				-76,
				120
			],
			[
				-73,
				133
			],
			[
				-31,
				49
			],
			[
				-90,
				111
			],
			[
				-89,
				111
			],
			[
				-70,
				97
			],
			[
				-37,
				31
			],
			[
				-114,
				12
			],
			[
				-216,
				24
			],
			[
				-76,
				12
			],
			[
				-61,
				-29
			],
			[
				-62,
				-23
			],
			[
				-58,
				43
			],
			[
				-46,
				69
			],
			[
				-24,
				59
			],
			[
				12,
				59
			],
			[
				4,
				88
			],
			[
				-35,
				87
			],
			[
				-39,
				43
			],
			[
				-97,
				33
			],
			[
				-125,
				73
			],
			[
				-33,
				133
			],
			[
				60,
				191
			],
			[
				98,
				135
			],
			[
				70,
				57
			],
			[
				34,
				49
			],
			[
				11,
				43
			],
			[
				-9,
				41
			],
			[
				-42,
				44
			],
			[
				-64,
				42
			],
			[
				-33,
				52
			],
			[
				13,
				112
			],
			[
				43,
				160
			],
			[
				66,
				129
			],
			[
				89,
				71
			],
			[
				77,
				51
			],
			[
				30,
				47
			],
			[
				2,
				68
			],
			[
				-2,
				63
			],
			[
				20,
				47
			],
			[
				33,
				36
			],
			[
				34,
				33
			],
			[
				48,
				37
			],
			[
				62,
				9
			],
			[
				69,
				-29
			],
			[
				93,
				-79
			],
			[
				136,
				-156
			],
			[
				78,
				-102
			],
			[
				28,
				-31
			],
			[
				71,
				-61
			],
			[
				64,
				-24
			],
			[
				107,
				38
			],
			[
				103,
				44
			],
			[
				33,
				28
			],
			[
				21,
				42
			],
			[
				-16,
				71
			],
			[
				-21,
				47
			],
			[
				-23,
				59
			],
			[
				-32,
				104
			],
			[
				-22,
				162
			],
			[
				-26,
				51
			],
			[
				19,
				6
			],
			[
				51,
				-10
			],
			[
				48,
				-5
			],
			[
				68,
				36
			],
			[
				94,
				67
			],
			[
				171,
				103
			],
			[
				36,
				69
			],
			[
				29,
				76
			],
			[
				48,
				47
			],
			[
				108,
				15
			],
			[
				101,
				24
			],
			[
				71,
				54
			],
			[
				112,
				48
			],
			[
				91,
				28
			],
			[
				41,
				27
			],
			[
				28,
				40
			],
			[
				105,
				112
			],
			[
				83,
				69
			],
			[
				72,
				70
			],
			[
				25,
				45
			],
			[
				57,
				-8
			],
			[
				88,
				-31
			],
			[
				94,
				-28
			],
			[
				68,
				-44
			],
			[
				14,
				-45
			],
			[
				7,
				-35
			],
			[
				28,
				-18
			],
			[
				33,
				-4
			],
			[
				50,
				9
			],
			[
				88,
				2
			],
			[
				107,
				58
			],
			[
				150,
				97
			],
			[
				137,
				31
			],
			[
				72,
				-23
			],
			[
				59,
				-72
			],
			[
				48,
				-68
			],
			[
				48,
				-25
			],
			[
				30,
				-1
			],
			[
				11,
				-1
			],
			[
				61,
				16
			],
			[
				59,
				-3
			],
			[
				53,
				-23
			],
			[
				88,
				-3
			],
			[
				122,
				18
			],
			[
				13,
				7
			],
			[
				59,
				-10
			],
			[
				71,
				-31
			],
			[
				56,
				-37
			],
			[
				99,
				-122
			],
			[
				57,
				-31
			],
			[
				116,
				-43
			],
			[
				55,
				-38
			],
			[
				64,
				-62
			],
			[
				33,
				-37
			],
			[
				69,
				-67
			],
			[
				80,
				-110
			],
			[
				14,
				-88
			],
			[
				18,
				-75
			],
			[
				30,
				-35
			],
			[
				24,
				-4
			],
			[
				27,
				12
			],
			[
				25,
				34
			],
			[
				9,
				56
			],
			[
				-8,
				100
			],
			[
				-20,
				82
			],
			[
				-26,
				26
			],
			[
				-13,
				28
			],
			[
				17,
				37
			],
			[
				45,
				17
			],
			[
				55,
				-11
			],
			[
				91,
				-47
			],
			[
				95,
				-59
			],
			[
				117,
				-103
			],
			[
				107,
				-65
			],
			[
				117,
				-53
			],
			[
				93,
				-15
			],
			[
				72,
				15
			],
			[
				85,
				43
			],
			[
				78,
				49
			],
			[
				35,
				52
			],
			[
				26,
				57
			],
			[
				117,
				75
			],
			[
				107,
				69
			],
			[
				49,
				-13
			],
			[
				34,
				-19
			],
			[
				110,
				42
			],
			[
				38,
				11
			],
			[
				105,
				16
			],
			[
				108,
				-24
			],
			[
				87,
				-73
			],
			[
				83,
				-48
			],
			[
				75,
				6
			],
			[
				62,
				24
			],
			[
				41,
				46
			],
			[
				31,
				54
			],
			[
				41,
				35
			],
			[
				7,
				2
			],
			[
				133,
				-19
			],
			[
				84,
				3
			],
			[
				9,
				8
			],
			[
				110,
				-15
			],
			[
				121,
				-76
			],
			[
				76,
				-85
			],
			[
				97,
				-108
			],
			[
				45,
				-35
			],
			[
				65,
				-15
			],
			[
				51,
				-7
			],
			[
				69,
				-17
			],
			[
				182,
				-22
			],
			[
				28,
				-14
			],
			[
				18,
				-17
			],
			[
				-16,
				-60
			],
			[
				16,
				-15
			],
			[
				147,
				43
			],
			[
				40,
				31
			],
			[
				48,
				89
			],
			[
				44,
				90
			],
			[
				32,
				33
			],
			[
				35,
				9
			],
			[
				34,
				-13
			],
			[
				49,
				-53
			],
			[
				65,
				-54
			],
			[
				88,
				-21
			],
			[
				55,
				-8
			],
			[
				83,
				-5
			],
			[
				197,
				27
			],
			[
				184,
				65
			],
			[
				105,
				71
			],
			[
				49,
				107
			],
			[
				30,
				121
			],
			[
				47,
				76
			],
			[
				-19,
				78
			],
			[
				-93,
				75
			],
			[
				-31,
				22
			],
			[
				-225,
				42
			],
			[
				-14,
				30
			],
			[
				-13,
				7
			],
			[
				-222,
				65
			],
			[
				-107,
				29
			],
			[
				-30,
				43
			],
			[
				-20,
				57
			],
			[
				-69,
				51
			],
			[
				-137,
				46
			],
			[
				-24,
				35
			],
			[
				22,
				36
			],
			[
				109,
				40
			],
			[
				124,
				83
			],
			[
				48,
				17
			],
			[
				110,
				4
			],
			[
				102,
				68
			],
			[
				71,
				39
			],
			[
				37,
				46
			],
			[
				-10,
				48
			],
			[
				-102,
				144
			],
			[
				-31,
				88
			],
			[
				18,
				57
			],
			[
				59,
				61
			],
			[
				33,
				34
			],
			[
				40,
				60
			],
			[
				27,
				32
			],
			[
				103,
				14
			],
			[
				125,
				6
			],
			[
				86,
				-15
			],
			[
				120,
				-7
			],
			[
				109,
				-11
			],
			[
				56,
				-10
			],
			[
				40,
				18
			],
			[
				30,
				33
			],
			[
				-1,
				42
			],
			[
				-43,
				42
			],
			[
				-161,
				54
			],
			[
				-69,
				45
			],
			[
				-54,
				-5
			],
			[
				-90,
				14
			],
			[
				-81,
				30
			],
			[
				-72,
				10
			],
			[
				-24,
				41
			],
			[
				15,
				57
			],
			[
				28,
				33
			],
			[
				53,
				16
			],
			[
				58,
				-8
			],
			[
				63,
				24
			],
			[
				18,
				14
			],
			[
				6,
				18
			],
			[
				-10,
				25
			],
			[
				-30,
				22
			],
			[
				-41,
				5
			],
			[
				-48,
				-18
			],
			[
				-57,
				-12
			],
			[
				-96,
				27
			],
			[
				-77,
				32
			],
			[
				4,
				29
			],
			[
				57,
				44
			],
			[
				25,
				35
			],
			[
				0,
				50
			],
			[
				0,
				57
			],
			[
				20,
				67
			],
			[
				56,
				46
			],
			[
				67,
				24
			],
			[
				171,
				-44
			],
			[
				213,
				-40
			],
			[
				37,
				6
			],
			[
				11,
				21
			],
			[
				24,
				19
			],
			[
				297,
				9
			],
			[
				57,
				25
			],
			[
				29,
				21
			],
			[
				285,
				30
			],
			[
				34,
				28
			],
			[
				42,
				26
			],
			[
				65,
				-1
			],
			[
				79,
				11
			],
			[
				108,
				32
			],
			[
				77,
				17
			],
			[
				13,
				2
			],
			[
				82,
				-7
			],
			[
				101,
				25
			],
			[
				22,
				10
			],
			[
				16,
				20
			],
			[
				88,
				36
			],
			[
				169,
				31
			],
			[
				42,
				-19
			],
			[
				80,
				-8
			],
			[
				103,
				14
			],
			[
				76,
				23
			],
			[
				45,
				-23
			],
			[
				60,
				-24
			],
			[
				44,
				20
			],
			[
				23,
				64
			],
			[
				29,
				61
			],
			[
				51,
				30
			],
			[
				40,
				10
			],
			[
				36,
				24
			],
			[
				28,
				25
			],
			[
				149,
				-4
			],
			[
				133,
				61
			],
			[
				26,
				-27
			],
			[
				174,
				6
			],
			[
				215,
				40
			],
			[
				128,
				18
			],
			[
				222,
				42
			],
			[
				103,
				33
			],
			[
				147,
				21
			],
			[
				135,
				15
			],
			[
				88,
				59
			],
			[
				71,
				8
			],
			[
				87,
				5
			],
			[
				53,
				14
			],
			[
				34,
				22
			],
			[
				23,
				41
			],
			[
				-13,
				51
			],
			[
				-12,
				38
			],
			[
				62,
				21
			],
			[
				88,
				7
			],
			[
				56,
				8
			],
			[
				122,
				86
			],
			[
				84,
				41
			],
			[
				86,
				26
			],
			[
				175,
				-14
			],
			[
				159,
				-13
			],
			[
				159,
				-41
			],
			[
				84,
				-51
			],
			[
				72,
				-38
			],
			[
				69,
				-19
			],
			[
				61,
				-12
			],
			[
				72,
				18
			],
			[
				50,
				23
			],
			[
				30,
				34
			],
			[
				44,
				24
			],
			[
				163,
				19
			],
			[
				34,
				-36
			],
			[
				77,
				-110
			],
			[
				53,
				-146
			],
			[
				87,
				-195
			],
			[
				38,
				-95
			],
			[
				-17,
				-50
			],
			[
				0,
				-69
			],
			[
				-4,
				-75
			],
			[
				-65,
				-85
			],
			[
				26,
				-40
			],
			[
				158,
				-45
			],
			[
				220,
				17
			],
			[
				136,
				35
			],
			[
				75,
				-13
			],
			[
				40,
				22
			],
			[
				25,
				63
			],
			[
				53,
				14
			],
			[
				53,
				-44
			],
			[
				39,
				-75
			],
			[
				38,
				-48
			],
			[
				-3,
				-57
			],
			[
				14,
				-74
			],
			[
				27,
				-18
			],
			[
				54,
				28
			],
			[
				36,
				16
			],
			[
				8,
				23
			],
			[
				-15,
				27
			],
			[
				-7,
				28
			],
			[
				12,
				26
			],
			[
				25,
				11
			],
			[
				77,
				-9
			],
			[
				112,
				-14
			],
			[
				133,
				-104
			],
			[
				71,
				-19
			],
			[
				30,
				-2
			],
			[
				67,
				6
			],
			[
				81,
				30
			],
			[
				55,
				38
			],
			[
				18,
				18
			],
			[
				31,
				-3
			],
			[
				30,
				-17
			],
			[
				2,
				-38
			],
			[
				-24,
				-55
			],
			[
				-80,
				-51
			],
			[
				-101,
				-47
			],
			[
				-60,
				-86
			],
			[
				-13,
				-89
			],
			[
				27,
				-46
			],
			[
				22,
				-31
			],
			[
				7,
				-42
			],
			[
				22,
				-6
			],
			[
				41,
				18
			],
			[
				112,
				88
			],
			[
				57,
				22
			],
			[
				82,
				14
			],
			[
				136,
				-7
			],
			[
				91,
				-29
			],
			[
				44,
				-40
			],
			[
				48,
				-33
			],
			[
				33,
				14
			],
			[
				17,
				38
			],
			[
				1,
				44
			],
			[
				14,
				36
			],
			[
				148,
				88
			],
			[
				98,
				59
			],
			[
				35,
				7
			],
			[
				66,
				-12
			],
			[
				40,
				6
			],
			[
				109,
				55
			],
			[
				101,
				63
			],
			[
				10,
				43
			],
			[
				4,
				38
			],
			[
				25,
				18
			],
			[
				142,
				13
			],
			[
				23,
				7
			],
			[
				122,
				44
			],
			[
				168,
				75
			],
			[
				81,
				44
			],
			[
				149,
				20
			],
			[
				27,
				12
			],
			[
				49,
				30
			],
			[
				93,
				41
			],
			[
				51,
				5
			],
			[
				-31,
				-100
			],
			[
				-56,
				-115
			],
			[
				-31,
				-30
			],
			[
				-151,
				5
			],
			[
				0,
				-32
			],
			[
				24,
				-48
			],
			[
				17,
				-27
			],
			[
				18,
				-24
			],
			[
				41,
				-42
			],
			[
				158,
				-99
			],
			[
				201,
				-125
			],
			[
				218,
				-142
			],
			[
				152,
				-98
			],
			[
				61,
				-51
			],
			[
				40,
				-40
			],
			[
				112,
				-144
			],
			[
				106,
				-136
			],
			[
				179,
				-240
			],
			[
				159,
				-232
			],
			[
				175,
				-256
			],
			[
				101,
				-147
			],
			[
				207,
				-310
			],
			[
				55,
				-95
			],
			[
				105,
				-179
			],
			[
				93,
				-169
			],
			[
				81,
				-149
			],
			[
				52,
				-14
			],
			[
				4,
				41
			],
			[
				9,
				27
			],
			[
				26,
				15
			],
			[
				61,
				44
			],
			[
				32,
				11
			],
			[
				48,
				-5
			],
			[
				51,
				22
			],
			[
				18,
				43
			],
			[
				-12,
				78
			],
			[
				-7,
				36
			],
			[
				17,
				39
			],
			[
				28,
				15
			],
			[
				38,
				12
			],
			[
				35,
				7
			],
			[
				30,
				43
			],
			[
				54,
				14
			],
			[
				51,
				-9
			],
			[
				41,
				-1
			],
			[
				37,
				-32
			],
			[
				20,
				-44
			],
			[
				40,
				-3
			],
			[
				65,
				4
			],
			[
				8,
				-36
			],
			[
				-18,
				-62
			],
			[
				-23,
				-47
			],
			[
				-3,
				-38
			],
			[
				34,
				-19
			],
			[
				126,
				17
			],
			[
				44,
				-8
			],
			[
				14,
				-39
			],
			[
				18,
				-32
			],
			[
				9,
				-39
			],
			[
				-13,
				-43
			],
			[
				22,
				-26
			],
			[
				109,
				0
			],
			[
				76,
				20
			],
			[
				118,
				2
			],
			[
				106,
				-46
			],
			[
				73,
				7
			],
			[
				74,
				19
			],
			[
				109,
				-12
			],
			[
				76,
				36
			],
			[
				52,
				45
			],
			[
				17,
				36
			],
			[
				27,
				20
			],
			[
				102,
				0
			],
			[
				65,
				3
			],
			[
				48,
				52
			],
			[
				43,
				24
			],
			[
				73,
				4
			],
			[
				54,
				0
			],
			[
				145,
				-48
			],
			[
				88,
				-40
			],
			[
				92,
				-57
			],
			[
				55,
				-36
			],
			[
				37,
				-81
			],
			[
				63,
				-59
			],
			[
				49,
				-70
			],
			[
				12,
				-68
			],
			[
				41,
				-123
			],
			[
				43,
				-41
			],
			[
				50,
				0
			],
			[
				63,
				-17
			],
			[
				70,
				-13
			],
			[
				150,
				-92
			],
			[
				55,
				-2
			],
			[
				42,
				-22
			],
			[
				7,
				-43
			],
			[
				-16,
				-48
			],
			[
				16,
				-47
			],
			[
				49,
				-60
			],
			[
				39,
				-59
			],
			[
				48,
				-70
			],
			[
				14,
				-41
			],
			[
				38,
				-13
			],
			[
				52,
				20
			],
			[
				82,
				-15
			],
			[
				247,
				-41
			],
			[
				34,
				-5
			],
			[
				26,
				-42
			],
			[
				36,
				4
			],
			[
				41,
				1
			],
			[
				57,
				-5
			],
			[
				39,
				39
			],
			[
				33,
				34
			],
			[
				81,
				42
			],
			[
				67,
				57
			],
			[
				57,
				51
			],
			[
				42,
				6
			],
			[
				35,
				-23
			],
			[
				1,
				-44
			],
			[
				-42,
				-32
			],
			[
				-33,
				-39
			],
			[
				8,
				-39
			],
			[
				56,
				-3
			],
			[
				64,
				-58
			],
			[
				91,
				-137
			],
			[
				31,
				-29
			],
			[
				45,
				-27
			],
			[
				50,
				-12
			],
			[
				55,
				-19
			],
			[
				41,
				-57
			],
			[
				17,
				-51
			]
		],
		[
			[
				113199,
				71282
			],
			[
				9,
				-25
			],
			[
				22,
				-69
			]
		],
		[
			[
				113230,
				71188
			],
			[
				53,
				-176
			],
			[
				47,
				-138
			],
			[
				58,
				-191
			],
			[
				18,
				-73
			],
			[
				7,
				-51
			],
			[
				84,
				-210
			],
			[
				49,
				-172
			],
			[
				36,
				-140
			],
			[
				51,
				-205
			],
			[
				22,
				-72
			]
		],
		[
			[
				113056,
				48932
			],
			[
				129,
				164
			],
			[
				132,
				166
			]
		],
		[
			[
				118165,
				48732
			],
			[
				-94,
				1
			],
			[
				-166,
				-13
			],
			[
				-70,
				-14
			],
			[
				-35,
				-3
			],
			[
				-63,
				0
			],
			[
				-52,
				16
			],
			[
				-35,
				24
			],
			[
				-43,
				54
			],
			[
				-95,
				110
			],
			[
				-70,
				68
			],
			[
				-153,
				-79
			],
			[
				-137,
				-78
			],
			[
				-195,
				-111
			],
			[
				-111,
				-80
			],
			[
				-34,
				-80
			],
			[
				-86,
				-145
			],
			[
				-76,
				-90
			],
			[
				-29,
				-11
			],
			[
				-174,
				19
			],
			[
				-62,
				18
			],
			[
				-104,
				17
			],
			[
				-139,
				31
			],
			[
				-94,
				34
			],
			[
				-101,
				4
			],
			[
				-146,
				12
			],
			[
				-90,
				24
			],
			[
				-91,
				81
			],
			[
				-118,
				97
			],
			[
				-121,
				100
			],
			[
				-124,
				103
			],
			[
				-148,
				119
			],
			[
				-161,
				129
			],
			[
				-37,
				13
			],
			[
				-16,
				3
			],
			[
				-174,
				6
			],
			[
				-182,
				6
			],
			[
				-123,
				4
			],
			[
				-39,
				15
			],
			[
				-27,
				29
			],
			[
				-38,
				96
			]
		],
		[
			[
				106210,
				30903
			],
			[
				-202,
				-48
			],
			[
				-287,
				-68
			],
			[
				-194,
				-46
			],
			[
				-235,
				-56
			],
			[
				-156,
				-35
			],
			[
				-195,
				-44
			],
			[
				-31,
				1
			],
			[
				-52,
				31
			],
			[
				-113,
				6
			],
			[
				-133,
				-42
			],
			[
				-105,
				-11
			],
			[
				-78,
				19
			],
			[
				-76,
				36
			],
			[
				-74,
				54
			],
			[
				-128,
				19
			],
			[
				-183,
				-14
			],
			[
				-176,
				10
			],
			[
				-169,
				36
			],
			[
				-121,
				14
			],
			[
				-73,
				-8
			],
			[
				-79,
				12
			],
			[
				-83,
				31
			],
			[
				-70,
				52
			],
			[
				-84,
				110
			],
			[
				-65,
				105
			],
			[
				-17,
				15
			],
			[
				-21,
				16
			],
			[
				-21,
				4
			],
			[
				-185,
				3
			],
			[
				-177,
				3
			],
			[
				-101,
				0
			],
			[
				-247,
				0
			],
			[
				-248,
				1
			],
			[
				-247,
				0
			],
			[
				-247,
				1
			],
			[
				-247,
				0
			],
			[
				-248,
				1
			],
			[
				-247,
				0
			],
			[
				-247,
				1
			],
			[
				-131,
				0
			],
			[
				-122,
				-8
			],
			[
				-135,
				-10
			],
			[
				-19,
				4
			],
			[
				-32,
				13
			],
			[
				-22,
				23
			],
			[
				-73,
				60
			],
			[
				-63,
				45
			],
			[
				-85,
				76
			],
			[
				-56,
				84
			],
			[
				-46,
				26
			],
			[
				-83,
				15
			],
			[
				-62,
				15
			],
			[
				-51,
				3
			],
			[
				-89,
				-39
			],
			[
				-67,
				-39
			],
			[
				-48,
				-38
			],
			[
				-83,
				-43
			],
			[
				-70,
				-43
			],
			[
				-122,
				6
			],
			[
				-27,
				-6
			],
			[
				-68,
				3
			],
			[
				-64,
				37
			],
			[
				-64,
				-3
			],
			[
				-72,
				-48
			],
			[
				-103,
				-19
			]
		],
		[
			[
				107423,
				30777
			],
			[
				125,
				-42
			],
			[
				68,
				-4
			],
			[
				53,
				21
			],
			[
				66,
				-28
			],
			[
				79,
				-77
			],
			[
				85,
				-15
			],
			[
				93,
				48
			],
			[
				126,
				-15
			],
			[
				157,
				-77
			],
			[
				131,
				-15
			],
			[
				156,
				68
			],
			[
				139,
				190
			],
			[
				130,
				179
			],
			[
				129,
				206
			],
			[
				77,
				166
			],
			[
				114,
				135
			],
			[
				149,
				105
			],
			[
				153,
				88
			],
			[
				233,
				108
			],
			[
				0,
				0
			],
			[
				46,
				89
			],
			[
				16,
				97
			],
			[
				0,
				135
			],
			[
				12,
				88
			],
			[
				24,
				39
			],
			[
				39,
				32
			],
			[
				50,
				40
			],
			[
				153,
				103
			],
			[
				129,
				65
			],
			[
				157,
				43
			],
			[
				171,
				1
			],
			[
				166,
				0
			],
			[
				94,
				1
			]
		],
		[
			[
				106210,
				30903
			],
			[
				138,
				34
			],
			[
				132,
				33
			],
			[
				154,
				32
			],
			[
				123,
				26
			],
			[
				31,
				7
			],
			[
				295,
				-30
			],
			[
				129,
				-21
			],
			[
				45,
				-21
			],
			[
				59,
				-54
			],
			[
				107,
				-132
			]
		],
		[
			[
				111319,
				26977
			],
			[
				91,
				85
			],
			[
				92,
				120
			],
			[
				107,
				140
			],
			[
				96,
				125
			],
			[
				84,
				110
			],
			[
				116,
				151
			],
			[
				114,
				149
			],
			[
				26,
				19
			],
			[
				12,
				12
			],
			[
				-50,
				132
			],
			[
				80,
				154
			],
			[
				4,
				100
			],
			[
				-4,
				96
			],
			[
				10,
				44
			],
			[
				24,
				38
			],
			[
				92,
				80
			],
			[
				70,
				128
			],
			[
				58,
				119
			],
			[
				79,
				191
			],
			[
				8,
				45
			],
			[
				1,
				47
			],
			[
				-22,
				64
			],
			[
				-53,
				105
			],
			[
				-38,
				91
			],
			[
				-35,
				140
			],
			[
				35,
				121
			],
			[
				12,
				74
			],
			[
				0,
				39
			],
			[
				-15,
				38
			],
			[
				-39,
				28
			],
			[
				-32,
				19
			],
			[
				-11,
				50
			],
			[
				0,
				60
			],
			[
				14,
				33
			],
			[
				86,
				53
			],
			[
				19,
				29
			],
			[
				11,
				33
			],
			[
				0,
				46
			],
			[
				27,
				116
			],
			[
				32,
				109
			],
			[
				3,
				39
			],
			[
				-12,
				34
			],
			[
				-9,
				62
			],
			[
				-6,
				94
			],
			[
				0,
				262
			],
			[
				17,
				270
			],
			[
				-8,
				153
			],
			[
				-55,
				177
			],
			[
				-5,
				127
			],
			[
				40,
				88
			],
			[
				6,
				53
			],
			[
				-29,
				7
			],
			[
				-60,
				5
			],
			[
				-44,
				17
			],
			[
				-68,
				72
			],
			[
				-119,
				61
			],
			[
				-135,
				55
			],
			[
				-196,
				17
			],
			[
				-163,
				177
			],
			[
				-128,
				28
			],
			[
				-41,
				23
			],
			[
				-123,
				106
			],
			[
				-192,
				10
			],
			[
				-199,
				10
			],
			[
				-125,
				3
			],
			[
				-18,
				14
			],
			[
				-7,
				147
			],
			[
				-1,
				130
			]
		],
		[
			[
				99035,
				40500
			],
			[
				32,
				-17
			],
			[
				58,
				-17
			],
			[
				80,
				19
			],
			[
				142,
				40
			],
			[
				77,
				49
			],
			[
				68,
				32
			],
			[
				55,
				9
			],
			[
				75,
				7
			],
			[
				76,
				-21
			],
			[
				29,
				15
			],
			[
				16,
				1
			],
			[
				179,
				0
			],
			[
				75,
				6
			],
			[
				138,
				-2
			],
			[
				87,
				-7
			],
			[
				50,
				-9
			],
			[
				134,
				-13
			],
			[
				168,
				3
			],
			[
				59,
				7
			],
			[
				220,
				5
			],
			[
				217,
				4
			],
			[
				195,
				4
			],
			[
				215,
				0
			],
			[
				165,
				-1
			],
			[
				75,
				-29
			],
			[
				68,
				-54
			],
			[
				31,
				-49
			],
			[
				15,
				-21
			],
			[
				20,
				-52
			],
			[
				38,
				-41
			],
			[
				13,
				-64
			],
			[
				-11,
				-86
			],
			[
				5,
				-104
			],
			[
				22,
				-121
			],
			[
				45,
				-127
			],
			[
				69,
				-133
			],
			[
				30,
				-106
			],
			[
				-9,
				-78
			],
			[
				21,
				-83
			],
			[
				51,
				-87
			],
			[
				38,
				-46
			],
			[
				21,
				-35
			],
			[
				58,
				-134
			],
			[
				108,
				-213
			],
			[
				80,
				-160
			],
			[
				29,
				-19
			],
			[
				41,
				7
			],
			[
				87,
				16
			],
			[
				87,
				3
			],
			[
				62,
				-33
			],
			[
				25,
				6
			],
			[
				93,
				63
			],
			[
				93,
				20
			],
			[
				96,
				26
			],
			[
				51,
				27
			],
			[
				58,
				0
			],
			[
				159,
				-52
			],
			[
				29,
				-2
			],
			[
				129,
				0
			],
			[
				128,
				28
			],
			[
				18,
				215
			],
			[
				2,
				42
			],
			[
				30,
				81
			],
			[
				39,
				70
			],
			[
				5,
				67
			],
			[
				-2,
				92
			],
			[
				28,
				111
			],
			[
				86,
				89
			],
			[
				139,
				42
			],
			[
				79,
				8
			],
			[
				124,
				25
			],
			[
				189,
				25
			],
			[
				70,
				-4
			],
			[
				5,
				-12
			],
			[
				-40,
				-154
			],
			[
				0,
				-50
			],
			[
				14,
				-51
			],
			[
				32,
				-28
			],
			[
				196,
				-3
			],
			[
				181,
				-3
			],
			[
				207,
				-9
			],
			[
				155,
				-7
			],
			[
				20,
				-8
			],
			[
				15,
				-12
			],
			[
				23,
				-76
			],
			[
				-5,
				-149
			],
			[
				-34,
				-217
			],
			[
				13,
				-203
			],
			[
				61,
				-190
			],
			[
				7,
				-290
			],
			[
				-22,
				-173
			],
			[
				-27,
				-219
			],
			[
				-11,
				-247
			],
			[
				28,
				-104
			],
			[
				60,
				-108
			],
			[
				90,
				-113
			],
			[
				70,
				-147
			],
			[
				50,
				-180
			],
			[
				18,
				-114
			],
			[
				-13,
				-46
			],
			[
				1,
				-81
			],
			[
				15,
				-116
			],
			[
				-17,
				-76
			],
			[
				-50,
				-38
			],
			[
				-16,
				-51
			],
			[
				25,
				-100
			],
			[
				6,
				-90
			],
			[
				20,
				-34
			],
			[
				14,
				-25
			],
			[
				23,
				-4
			],
			[
				51,
				32
			],
			[
				60,
				60
			],
			[
				48,
				26
			],
			[
				68,
				-3
			],
			[
				96,
				-17
			],
			[
				169,
				-7
			],
			[
				52,
				11
			],
			[
				157,
				81
			],
			[
				42,
				6
			],
			[
				62,
				-8
			],
			[
				88,
				-23
			],
			[
				89,
				-6
			],
			[
				43,
				26
			],
			[
				4,
				32
			],
			[
				14,
				43
			],
			[
				24,
				16
			]
		],
		[
			[
				80402,
				56656
			],
			[
				164,
				8
			],
			[
				198,
				-3
			],
			[
				216,
				-4
			],
			[
				102,
				-2
			],
			[
				54,
				117
			],
			[
				101,
				51
			],
			[
				105,
				19
			],
			[
				54,
				-5
			],
			[
				57,
				-17
			],
			[
				110,
				-96
			],
			[
				68,
				-22
			],
			[
				58,
				-22
			],
			[
				41,
				-46
			],
			[
				66,
				-47
			],
			[
				51,
				-12
			],
			[
				31,
				7
			],
			[
				51,
				18
			],
			[
				34,
				14
			],
			[
				109,
				6
			],
			[
				81,
				-53
			],
			[
				17,
				-59
			],
			[
				-14,
				-59
			],
			[
				-108,
				-33
			],
			[
				-150,
				-50
			],
			[
				-124,
				28
			],
			[
				-150,
				68
			],
			[
				-89,
				49
			],
			[
				-36,
				20
			],
			[
				-55,
				31
			],
			[
				-48,
				33
			],
			[
				-47,
				22
			],
			[
				-35,
				14
			],
			[
				-26,
				-18
			],
			[
				-13,
				-41
			],
			[
				-21,
				-46
			],
			[
				-27,
				-27
			],
			[
				-127,
				-17
			],
			[
				-113,
				-17
			],
			[
				-61,
				-14
			],
			[
				-41,
				-11
			],
			[
				-12,
				-139
			],
			[
				-129,
				2
			],
			[
				-126,
				1
			],
			[
				-131,
				-2
			],
			[
				-141,
				-3
			],
			[
				-36,
				-28
			],
			[
				-38,
				-46
			]
		],
		[
			[
				91244,
				57748
			],
			[
				-9,
				-38
			],
			[
				-1,
				-68
			],
			[
				-11,
				-107
			],
			[
				-14,
				-128
			],
			[
				56,
				-83
			],
			[
				67,
				-90
			],
			[
				18,
				-35
			],
			[
				-17,
				-88
			],
			[
				12,
				-51
			],
			[
				36,
				-86
			],
			[
				60,
				-110
			],
			[
				62,
				-112
			],
			[
				43,
				-15
			],
			[
				40,
				-9
			],
			[
				25,
				-20
			],
			[
				36,
				-19
			],
			[
				36,
				-13
			],
			[
				32,
				-25
			],
			[
				20,
				-24
			],
			[
				26,
				-69
			],
			[
				70,
				-46
			],
			[
				48,
				-45
			],
			[
				-19,
				-23
			],
			[
				-61,
				9
			],
			[
				-57,
				20
			],
			[
				-8,
				-33
			],
			[
				-2,
				-128
			],
			[
				9,
				-105
			],
			[
				13,
				-15
			],
			[
				58,
				-19
			],
			[
				137,
				-138
			],
			[
				124,
				-130
			],
			[
				41,
				-34
			],
			[
				69,
				-13
			],
			[
				77,
				-5
			],
			[
				33,
				12
			],
			[
				74,
				66
			],
			[
				40,
				7
			],
			[
				36,
				-2
			],
			[
				20,
				-10
			],
			[
				36,
				-54
			],
			[
				33,
				-81
			],
			[
				10,
				-59
			],
			[
				-3,
				-32
			],
			[
				-12,
				-12
			],
			[
				-61,
				-16
			],
			[
				-26,
				-12
			],
			[
				-7,
				-17
			],
			[
				10,
				-41
			],
			[
				12,
				-25
			],
			[
				66,
				-117
			],
			[
				96,
				-157
			],
			[
				30,
				-41
			]
		],
		[
			[
				103128,
				48320
			],
			[
				-37,
				26
			],
			[
				-35,
				77
			],
			[
				-16,
				16
			],
			[
				-101,
				-35
			],
			[
				-53,
				-31
			],
			[
				-27,
				-31
			],
			[
				-22,
				-5
			],
			[
				-32,
				43
			],
			[
				-25,
				7
			],
			[
				-40,
				-7
			],
			[
				-40,
				0
			],
			[
				-27,
				6
			],
			[
				-17,
				-4
			],
			[
				-48,
				25
			],
			[
				-173,
				64
			],
			[
				-30,
				21
			],
			[
				-35,
				-2
			],
			[
				-90,
				-56
			],
			[
				-48,
				-15
			],
			[
				-143,
				-35
			],
			[
				-154,
				-17
			],
			[
				-59,
				0
			],
			[
				-40,
				-25
			],
			[
				-26,
				-35
			],
			[
				-18,
				-77
			],
			[
				-30,
				-133
			],
			[
				-13,
				-36
			],
			[
				2,
				-52
			],
			[
				-9,
				-89
			],
			[
				-4,
				-80
			],
			[
				6,
				-54
			],
			[
				-44,
				-107
			],
			[
				-52,
				-131
			],
			[
				-44,
				-112
			],
			[
				-44,
				-113
			]
		],
		[
			[
				101559,
				47317
			],
			[
				-4,
				-48
			],
			[
				-39,
				-30
			],
			[
				-23,
				-50
			],
			[
				-7,
				-71
			],
			[
				12,
				-85
			],
			[
				30,
				-101
			],
			[
				1,
				-59
			],
			[
				-11,
				-8
			],
			[
				-19,
				-19
			],
			[
				-20,
				-12
			],
			[
				-54,
				69
			],
			[
				-60,
				46
			],
			[
				-91,
				81
			],
			[
				-91,
				30
			],
			[
				-118,
				5
			],
			[
				-51,
				-10
			],
			[
				-37,
				30
			],
			[
				-51,
				36
			],
			[
				-28,
				9
			],
			[
				-39,
				-27
			],
			[
				-27,
				-2
			],
			[
				-33,
				11
			],
			[
				-67,
				-1
			],
			[
				-6,
				47
			],
			[
				-12,
				9
			],
			[
				-72,
				-4
			],
			[
				-23,
				39
			],
			[
				-9,
				-5
			],
			[
				-29,
				12
			],
			[
				-58,
				56
			],
			[
				-61,
				-37
			],
			[
				-128,
				5
			],
			[
				-163,
				-1
			],
			[
				-169,
				-2
			],
			[
				-155,
				2
			],
			[
				-155,
				2
			]
		],
		[
			[
				101105,
				51656
			],
			[
				-65,
				-137
			],
			[
				-86,
				-78
			],
			[
				-26,
				-47
			],
			[
				-13,
				-59
			],
			[
				-19,
				-59
			],
			[
				-45,
				-126
			],
			[
				-34,
				-104
			],
			[
				-33,
				-32
			],
			[
				-78,
				-156
			],
			[
				-53,
				-157
			],
			[
				-10,
				-41
			],
			[
				-17,
				-30
			],
			[
				-25,
				-24
			],
			[
				-91,
				-49
			],
			[
				-30,
				-24
			],
			[
				-24,
				-29
			],
			[
				-22,
				-33
			],
			[
				-7,
				-40
			],
			[
				22,
				-56
			],
			[
				25,
				-44
			],
			[
				25,
				-3
			],
			[
				23,
				2
			],
			[
				14,
				-26
			],
			[
				11,
				-16
			],
			[
				0,
				-305
			],
			[
				-21,
				-46
			],
			[
				0,
				-20
			],
			[
				-10,
				-53
			],
			[
				-3,
				-59
			],
			[
				6,
				-23
			],
			[
				19,
				-19
			],
			[
				25,
				-41
			],
			[
				13,
				-93
			],
			[
				31,
				-330
			],
			[
				14,
				-52
			],
			[
				26,
				-37
			],
			[
				79,
				-71
			],
			[
				84,
				-93
			],
			[
				26,
				-61
			],
			[
				15,
				-100
			],
			[
				32,
				-78
			],
			[
				0,
				-27
			],
			[
				-13,
				-10
			],
			[
				-32,
				-1
			],
			[
				-21,
				-6
			],
			[
				18,
				-57
			],
			[
				43,
				-99
			],
			[
				72,
				-103
			],
			[
				78,
				-111
			],
			[
				63,
				-91
			],
			[
				79,
				-105
			],
			[
				62,
				-82
			],
			[
				64,
				-85
			],
			[
				48,
				-20
			],
			[
				36,
				-6
			],
			[
				15,
				-16
			],
			[
				19,
				-39
			],
			[
				32,
				-43
			],
			[
				36,
				-56
			],
			[
				12,
				-57
			],
			[
				-15,
				-55
			],
			[
				15,
				-78
			],
			[
				1,
				-7
			],
			[
				12,
				-31
			],
			[
				-4,
				-27
			],
			[
				7,
				-104
			],
			[
				19,
				-90
			],
			[
				31,
				-78
			]
		],
		[
			[
				101560,
				47323
			],
			[
				-1,
				-6
			]
		],
		[
			[
				113056,
				48932
			],
			[
				-152,
				-194
			],
			[
				-112,
				-143
			],
			[
				-18,
				-21
			],
			[
				-33,
				-26
			],
			[
				-107,
				-1
			],
			[
				-109,
				17
			],
			[
				-102,
				87
			],
			[
				-103,
				-67
			],
			[
				-65,
				-22
			],
			[
				-39,
				-7
			],
			[
				-92,
				-11
			],
			[
				-128,
				-36
			],
			[
				-59,
				-46
			],
			[
				-31,
				-36
			],
			[
				-26,
				-65
			],
			[
				-13,
				-7
			],
			[
				-24,
				8
			],
			[
				-33,
				26
			],
			[
				-69,
				38
			],
			[
				-34,
				84
			],
			[
				-32,
				51
			],
			[
				-27,
				26
			],
			[
				-109,
				-83
			],
			[
				-53,
				-20
			],
			[
				-43,
				2
			],
			[
				-79,
				47
			],
			[
				-88,
				40
			],
			[
				-45,
				0
			],
			[
				-67,
				-50
			],
			[
				-77,
				-75
			],
			[
				-39,
				-74
			],
			[
				-20,
				-44
			]
		],
		[
			[
				99550,
				41629
			],
			[
				-10,
				-13
			],
			[
				-71,
				-37
			],
			[
				-76,
				-34
			],
			[
				-100,
				-139
			],
			[
				-51,
				-60
			],
			[
				-15,
				-15
			],
			[
				-46,
				-34
			],
			[
				-33,
				-28
			],
			[
				1,
				-16
			],
			[
				22,
				-18
			],
			[
				23,
				-30
			],
			[
				-2,
				-227
			],
			[
				-10,
				-224
			],
			[
				-12,
				-19
			],
			[
				-64,
				-7
			],
			[
				-84,
				-16
			],
			[
				-27,
				-10
			]
		],
		[
			[
				111745,
				24045
			],
			[
				-13,
				59
			],
			[
				-5,
				92
			],
			[
				42,
				117
			],
			[
				-3,
				225
			],
			[
				4,
				79
			],
			[
				0,
				156
			],
			[
				-1,
				190
			],
			[
				-1,
				170
			],
			[
				2,
				146
			],
			[
				-13,
				70
			],
			[
				-10,
				38
			],
			[
				-28,
				77
			],
			[
				-32,
				162
			],
			[
				-38,
				122
			],
			[
				-48,
				80
			],
			[
				-16,
				43
			],
			[
				-16,
				57
			],
			[
				-46,
				100
			],
			[
				-38,
				58
			],
			[
				-10,
				47
			],
			[
				1,
				120
			],
			[
				-42,
				217
			],
			[
				-30,
				158
			],
			[
				-46,
				171
			],
			[
				-31,
				115
			],
			[
				-5,
				19
			],
			[
				-3,
				44
			]
		],
		[
			[
				111745,
				24045
			],
			[
				-17,
				-10
			],
			[
				-32,
				-10
			],
			[
				-149,
				94
			],
			[
				-146,
				100
			],
			[
				-21,
				3
			],
			[
				-31,
				-11
			],
			[
				-82,
				-72
			],
			[
				-77,
				-113
			],
			[
				-36,
				-97
			],
			[
				-57,
				-100
			],
			[
				-91,
				-160
			],
			[
				-10,
				-35
			],
			[
				-1,
				-130
			],
			[
				5,
				-125
			],
			[
				8,
				-17
			],
			[
				49,
				-6
			],
			[
				36,
				-102
			],
			[
				81,
				-162
			],
			[
				136,
				-104
			],
			[
				126,
				-47
			],
			[
				176,
				-12
			],
			[
				140,
				4
			],
			[
				-8,
				109
			],
			[
				14,
				175
			],
			[
				17,
				118
			],
			[
				20,
				6
			],
			[
				37,
				-12
			],
			[
				20,
				-12
			]
		],
		[
			[
				111852,
				23317
			],
			[
				-5,
				264
			],
			[
				-18,
				58
			],
			[
				-19,
				84
			],
			[
				-4,
				55
			],
			[
				12,
				54
			],
			[
				5,
				87
			],
			[
				-5,
				76
			],
			[
				-60,
				38
			],
			[
				-13,
				12
			]
		],
		[
			[
				112555,
				33895
			],
			[
				-138,
				-59
			],
			[
				-73,
				-31
			],
			[
				-208,
				-89
			],
			[
				-181,
				-77
			],
			[
				-47,
				-14
			],
			[
				-94,
				-38
			],
			[
				-47,
				-23
			],
			[
				-163,
				-67
			],
			[
				-69,
				-34
			],
			[
				-55,
				-33
			],
			[
				-135,
				-50
			],
			[
				-128,
				-47
			],
			[
				-139,
				-48
			],
			[
				-156,
				-55
			],
			[
				-88,
				-39
			],
			[
				-59,
				-34
			],
			[
				-139,
				-68
			],
			[
				-6,
				-17
			],
			[
				2,
				-46
			],
			[
				18,
				-96
			],
			[
				34,
				-87
			],
			[
				29,
				-50
			],
			[
				19,
				-129
			],
			[
				11,
				-113
			]
		],
		[
			[
				113691,
				35903
			],
			[
				-86,
				2
			],
			[
				-108,
				-11
			],
			[
				-26,
				-26
			],
			[
				-8,
				-57
			],
			[
				-34,
				-119
			],
			[
				-19,
				-44
			],
			[
				-40,
				-80
			],
			[
				-56,
				-112
			],
			[
				-12,
				-37
			],
			[
				2,
				-38
			],
			[
				33,
				-152
			],
			[
				35,
				-161
			],
			[
				11,
				-63
			],
			[
				25,
				-213
			],
			[
				14,
				-151
			],
			[
				2,
				-89
			],
			[
				11,
				-119
			],
			[
				31,
				-64
			],
			[
				33,
				-40
			],
			[
				122,
				-24
			],
			[
				36,
				-30
			],
			[
				69,
				-75
			],
			[
				151,
				-209
			],
			[
				83,
				-134
			],
			[
				73,
				-117
			],
			[
				130,
				-218
			],
			[
				102,
				-170
			],
			[
				12,
				-159
			],
			[
				17,
				-23
			],
			[
				-34,
				-118
			],
			[
				-22,
				-190
			],
			[
				16,
				-126
			],
			[
				-7,
				-216
			],
			[
				-19,
				-230
			],
			[
				-23,
				-82
			],
			[
				-30,
				-31
			],
			[
				-71,
				-24
			],
			[
				-155,
				-29
			],
			[
				-24,
				-27
			],
			[
				-20,
				-44
			],
			[
				-31,
				-106
			],
			[
				-37,
				-107
			],
			[
				-12,
				-46
			],
			[
				7,
				-10
			],
			[
				34,
				-55
			],
			[
				33,
				-139
			],
			[
				6,
				-238
			],
			[
				-12,
				-18
			],
			[
				-46,
				-10
			],
			[
				-49,
				3
			],
			[
				-21,
				13
			],
			[
				-18,
				27
			],
			[
				-13,
				51
			],
			[
				32,
				35
			],
			[
				12,
				62
			],
			[
				-21,
				54
			],
			[
				-42,
				12
			],
			[
				-53,
				48
			],
			[
				-113,
				160
			],
			[
				-94,
				112
			],
			[
				-55,
				92
			],
			[
				-56,
				37
			],
			[
				-16,
				23
			],
			[
				-13,
				39
			],
			[
				-1,
				56
			],
			[
				5,
				42
			],
			[
				-17,
				47
			],
			[
				-57,
				72
			],
			[
				-26,
				40
			],
			[
				-1,
				48
			],
			[
				24,
				46
			],
			[
				48,
				56
			],
			[
				37,
				115
			],
			[
				13,
				74
			],
			[
				69,
				148
			],
			[
				9,
				129
			],
			[
				1,
				103
			],
			[
				-4,
				77
			],
			[
				-17,
				158
			],
			[
				-12,
				109
			],
			[
				-85,
				143
			],
			[
				-27,
				14
			],
			[
				-80,
				-13
			],
			[
				-69,
				-21
			],
			[
				-34,
				-29
			],
			[
				-51,
				-2
			],
			[
				-135,
				-25
			],
			[
				-42,
				-11
			],
			[
				-25,
				-25
			],
			[
				-14,
				-6
			],
			[
				-85,
				111
			],
			[
				-74,
				119
			],
			[
				-95,
				203
			],
			[
				-27,
				25
			]
		],
		[
			[
				110213,
				44307
			],
			[
				2,
				25
			],
			[
				-10,
				194
			],
			[
				-1,
				119
			],
			[
				18,
				75
			],
			[
				10,
				85
			],
			[
				1,
				76
			],
			[
				26,
				129
			],
			[
				-9,
				77
			],
			[
				33,
				271
			],
			[
				8,
				44
			],
			[
				13,
				130
			],
			[
				21,
				41
			],
			[
				18,
				15
			],
			[
				24,
				81
			],
			[
				46,
				128
			],
			[
				31,
				66
			],
			[
				-7,
				144
			],
			[
				5,
				98
			],
			[
				8,
				22
			],
			[
				67,
				36
			],
			[
				88,
				91
			],
			[
				37,
				107
			],
			[
				52,
				68
			],
			[
				101,
				44
			],
			[
				1,
				0
			],
			[
				300,
				366
			],
			[
				139,
				197
			],
			[
				61,
				101
			],
			[
				2,
				37
			],
			[
				12,
				47
			],
			[
				-25,
				37
			],
			[
				-29,
				34
			],
			[
				-9,
				31
			],
			[
				-25,
				16
			],
			[
				-36,
				-1
			],
			[
				-24,
				23
			],
			[
				-27,
				44
			],
			[
				-27,
				28
			],
			[
				-85,
				-2
			],
			[
				-66,
				45
			],
			[
				1,
				62
			],
			[
				26,
				122
			],
			[
				50,
				139
			],
			[
				2,
				39
			],
			[
				-7,
				32
			],
			[
				-12,
				28
			],
			[
				-22,
				28
			],
			[
				-21,
				34
			],
			[
				16,
				100
			],
			[
				31,
				98
			],
			[
				26,
				49
			],
			[
				25,
				55
			],
			[
				-7,
				46
			],
			[
				-37,
				22
			]
		],
		[
			[
				114702,
				57208
			],
			[
				-21,
				238
			],
			[
				-14,
				158
			],
			[
				-14,
				168
			],
			[
				-14,
				158
			],
			[
				61,
				98
			],
			[
				29,
				92
			],
			[
				73,
				300
			],
			[
				29,
				60
			],
			[
				58,
				161
			],
			[
				8,
				46
			],
			[
				57,
				203
			],
			[
				-6,
				135
			],
			[
				-11,
				136
			],
			[
				31,
				81
			],
			[
				28,
				64
			],
			[
				-2,
				55
			],
			[
				12,
				127
			],
			[
				9,
				31
			],
			[
				34,
				2
			],
			[
				70,
				-16
			],
			[
				51,
				13
			],
			[
				59,
				0
			],
			[
				46,
				4
			],
			[
				27,
				38
			],
			[
				37,
				148
			],
			[
				24,
				30
			],
			[
				19,
				9
			],
			[
				52,
				27
			],
			[
				44,
				43
			],
			[
				37,
				31
			],
			[
				13,
				7
			],
			[
				39,
				4
			],
			[
				38,
				18
			],
			[
				18,
				21
			],
			[
				49,
				16
			],
			[
				47,
				-9
			],
			[
				32,
				18
			],
			[
				22,
				12
			],
			[
				24,
				1
			],
			[
				22,
				17
			],
			[
				9,
				26
			],
			[
				15,
				17
			],
			[
				37,
				38
			],
			[
				17,
				28
			],
			[
				8,
				28
			],
			[
				7,
				23
			],
			[
				16,
				37
			],
			[
				65,
				95
			],
			[
				56,
				55
			]
		],
		[
			[
				118485,
				55732
			],
			[
				-58,
				86
			],
			[
				-42,
				75
			],
			[
				-58,
				90
			],
			[
				-57,
				41
			],
			[
				-61,
				51
			],
			[
				-60,
				118
			],
			[
				-61,
				131
			],
			[
				-90,
				106
			],
			[
				-170,
				154
			],
			[
				-155,
				195
			],
			[
				-119,
				204
			],
			[
				-76,
				106
			],
			[
				-33,
				27
			],
			[
				-158,
				66
			],
			[
				-111,
				93
			],
			[
				-85,
				77
			],
			[
				-52,
				21
			],
			[
				-51,
				2
			],
			[
				-108,
				-15
			],
			[
				-90,
				48
			],
			[
				-37,
				0
			],
			[
				-61,
				14
			],
			[
				-47,
				17
			],
			[
				-55,
				-20
			],
			[
				-114,
				-34
			],
			[
				-46,
				7
			],
			[
				-26,
				48
			],
			[
				-15,
				37
			],
			[
				-39,
				38
			],
			[
				-33,
				0
			],
			[
				-18,
				-34
			],
			[
				-119,
				-87
			],
			[
				-199,
				-47
			],
			[
				-47,
				3
			],
			[
				-35,
				35
			],
			[
				-100,
				147
			],
			[
				-29,
				24
			],
			[
				-23,
				3
			],
			[
				-46,
				17
			],
			[
				-44,
				29
			],
			[
				-38,
				60
			],
			[
				-38,
				35
			],
			[
				-42,
				-119
			],
			[
				-72,
				-207
			],
			[
				-39,
				-111
			],
			[
				-50,
				-143
			],
			[
				-15,
				-5
			],
			[
				-26,
				11
			],
			[
				-99,
				178
			],
			[
				-62,
				67
			],
			[
				-47,
				-7
			],
			[
				-34,
				-32
			],
			[
				-21,
				-60
			],
			[
				-24,
				-37
			],
			[
				-25,
				-14
			],
			[
				-54,
				7
			],
			[
				-83,
				28
			],
			[
				-86,
				-6
			],
			[
				-88,
				-40
			],
			[
				-12,
				-2
			]
		],
		[
			[
				108776,
				92893
			],
			[
				1,
				19
			],
			[
				11,
				51
			],
			[
				19,
				45
			],
			[
				59,
				48
			],
			[
				15,
				32
			],
			[
				18,
				29
			],
			[
				136,
				34
			],
			[
				15,
				13
			],
			[
				1,
				12
			],
			[
				-6,
				11
			],
			[
				-30,
				17
			],
			[
				-32,
				24
			],
			[
				-19,
				66
			],
			[
				-47,
				102
			],
			[
				-44,
				69
			],
			[
				-10,
				40
			],
			[
				12,
				46
			],
			[
				16,
				46
			],
			[
				1,
				44
			],
			[
				-68,
				246
			],
			[
				5,
				45
			],
			[
				19,
				44
			],
			[
				32,
				37
			],
			[
				70,
				49
			],
			[
				88,
				88
			],
			[
				59,
				116
			],
			[
				31,
				70
			],
			[
				26,
				16
			],
			[
				51,
				4
			],
			[
				19,
				21
			],
			[
				10,
				13
			],
			[
				43,
				12
			],
			[
				15,
				14
			],
			[
				-12,
				24
			],
			[
				-43,
				41
			],
			[
				-35,
				25
			]
		],
		[
			[
				139113,
				72509
			],
			[
				32,
				-34
			],
			[
				83,
				2
			],
			[
				68,
				-15
			],
			[
				28,
				15
			],
			[
				20,
				-11
			],
			[
				-13,
				-124
			],
			[
				10,
				-73
			],
			[
				18,
				-21
			],
			[
				66,
				-30
			],
			[
				128,
				4
			],
			[
				76,
				-35
			],
			[
				84,
				-39
			],
			[
				44,
				-44
			],
			[
				20,
				-33
			],
			[
				-6,
				-53
			],
			[
				-45,
				-61
			],
			[
				-75,
				-30
			],
			[
				-43,
				-12
			],
			[
				-215,
				-116
			],
			[
				-67,
				-49
			],
			[
				-52,
				-59
			],
			[
				-19,
				-44
			],
			[
				-10,
				-43
			],
			[
				46,
				-156
			],
			[
				8,
				-48
			],
			[
				-38,
				-168
			],
			[
				-11,
				-63
			],
			[
				14,
				-43
			],
			[
				46,
				-17
			],
			[
				10,
				-36
			],
			[
				4,
				-28
			],
			[
				-79,
				-62
			],
			[
				-84,
				-55
			],
			[
				-26,
				0
			],
			[
				-80,
				-102
			],
			[
				-134,
				-206
			],
			[
				-71,
				-69
			],
			[
				-5,
				-35
			],
			[
				-5,
				-34
			],
			[
				27,
				-58
			],
			[
				6,
				-49
			],
			[
				-31,
				-50
			],
			[
				-50,
				-57
			],
			[
				-97,
				-49
			],
			[
				-124,
				-51
			],
			[
				-55,
				-31
			],
			[
				-42,
				-133
			],
			[
				-38,
				-134
			],
			[
				-17,
				-49
			],
			[
				-67,
				-154
			],
			[
				-116,
				-227
			],
			[
				-29,
				-49
			],
			[
				-179,
				-110
			],
			[
				-184,
				-119
			],
			[
				-32,
				-45
			],
			[
				-38,
				-108
			],
			[
				-35,
				-119
			],
			[
				-33,
				-62
			],
			[
				-116,
				-140
			],
			[
				-38,
				-107
			],
			[
				-12,
				-70
			],
			[
				-100,
				-39
			],
			[
				-112,
				-37
			],
			[
				-163,
				-12
			],
			[
				-68,
				-20
			],
			[
				-201,
				-96
			],
			[
				-49,
				-4
			],
			[
				-39,
				16
			],
			[
				-30,
				33
			],
			[
				-27,
				54
			],
			[
				-13,
				85
			],
			[
				-39,
				38
			],
			[
				-52,
				32
			],
			[
				-55,
				2
			],
			[
				-55,
				-36
			],
			[
				-48,
				-39
			],
			[
				-33,
				-33
			],
			[
				-31,
				-37
			],
			[
				-62,
				-128
			],
			[
				-99,
				-182
			],
			[
				-111,
				-133
			],
			[
				-41,
				-39
			],
			[
				-25,
				-30
			],
			[
				-35,
				-45
			],
			[
				-20,
				-42
			],
			[
				-28,
				-139
			],
			[
				-15,
				-124
			],
			[
				7,
				-27
			],
			[
				17,
				-24
			],
			[
				60,
				-36
			],
			[
				87,
				-59
			],
			[
				114,
				-34
			],
			[
				95,
				-6
			],
			[
				36,
				-25
			],
			[
				22,
				-35
			],
			[
				5,
				-28
			],
			[
				-4,
				-103
			],
			[
				-11,
				-109
			],
			[
				-36,
				-118
			],
			[
				1,
				-67
			],
			[
				14,
				-66
			],
			[
				106,
				-168
			],
			[
				39,
				-17
			],
			[
				80,
				-4
			],
			[
				37,
				3
			],
			[
				41,
				17
			],
			[
				29,
				-11
			],
			[
				22,
				-21
			],
			[
				6,
				-34
			],
			[
				-4,
				-167
			],
			[
				33,
				-76
			],
			[
				63,
				-103
			],
			[
				50,
				-118
			],
			[
				47,
				-141
			],
			[
				46,
				-111
			],
			[
				17,
				-57
			],
			[
				-29,
				-28
			],
			[
				-17,
				-29
			],
			[
				-4,
				-39
			],
			[
				6,
				-41
			],
			[
				-4,
				-29
			],
			[
				21,
				-35
			],
			[
				25,
				-12
			],
			[
				0,
				-25
			],
			[
				-40,
				-32
			],
			[
				-35,
				1
			],
			[
				-27,
				-15
			],
			[
				-53,
				-68
			],
			[
				-24,
				-13
			],
			[
				-33,
				-6
			],
			[
				-37,
				6
			],
			[
				-52,
				28
			],
			[
				-15,
				42
			],
			[
				6,
				46
			],
			[
				-12,
				26
			],
			[
				-37,
				-5
			],
			[
				-129,
				-46
			],
			[
				-123,
				-56
			],
			[
				-22,
				-39
			],
			[
				-28,
				-41
			],
			[
				-57,
				-16
			],
			[
				-83,
				-5
			],
			[
				-57,
				6
			],
			[
				-53,
				43
			],
			[
				-49,
				40
			],
			[
				-74,
				2
			],
			[
				-135,
				-6
			],
			[
				-75,
				0
			],
			[
				-44,
				15
			],
			[
				-43,
				-11
			],
			[
				-54,
				16
			],
			[
				-24,
				-22
			],
			[
				-23,
				-2
			],
			[
				-18,
				37
			],
			[
				-12,
				4
			],
			[
				-15,
				-5
			],
			[
				-12,
				-13
			],
			[
				-8,
				-22
			],
			[
				-2,
				-248
			],
			[
				-89,
				2
			],
			[
				-63,
				0
			],
			[
				-70,
				-13
			],
			[
				-64,
				-19
			],
			[
				-31,
				-23
			],
			[
				-44,
				-35
			]
		],
		[
			[
				36605,
				54506
			],
			[
				-35,
				-4
			],
			[
				-56,
				14
			],
			[
				-94,
				44
			],
			[
				-43,
				6
			],
			[
				-62,
				-38
			],
			[
				-73,
				-50
			],
			[
				-174,
				78
			],
			[
				-122,
				54
			],
			[
				-110,
				50
			],
			[
				-30,
				19
			],
			[
				-24,
				-4
			],
			[
				-21,
				-26
			],
			[
				-23,
				-46
			],
			[
				-8,
				-13
			],
			[
				-13,
				-13
			],
			[
				-14,
				-3
			]
		],
		[
			[
				37554,
				52107
			],
			[
				-3,
				49
			],
			[
				-19,
				57
			],
			[
				-23,
				47
			],
			[
				-48,
				49
			],
			[
				-3,
				18
			],
			[
				19,
				25
			],
			[
				88,
				71
			],
			[
				11,
				29
			],
			[
				2,
				62
			],
			[
				-9,
				59
			],
			[
				-39,
				86
			],
			[
				22,
				54
			],
			[
				45,
				43
			],
			[
				47,
				34
			],
			[
				8,
				14
			],
			[
				-9,
				29
			],
			[
				-27,
				32
			],
			[
				-63,
				54
			],
			[
				-39,
				4
			],
			[
				-1,
				156
			],
			[
				2,
				165
			],
			[
				9,
				16
			],
			[
				24,
				10
			],
			[
				18,
				25
			],
			[
				11,
				49
			],
			[
				27,
				17
			],
			[
				51,
				-37
			],
			[
				51,
				-34
			],
			[
				21,
				11
			],
			[
				16,
				17
			],
			[
				11,
				16
			],
			[
				4,
				15
			]
		],
		[
			[
				47894,
				46460
			],
			[
				-13,
				55
			],
			[
				7,
				56
			],
			[
				-30,
				83
			],
			[
				-17,
				87
			],
			[
				-15,
				30
			],
			[
				-5,
				66
			],
			[
				-36,
				118
			],
			[
				-29,
				96
			],
			[
				-27,
				49
			],
			[
				11,
				42
			],
			[
				-11,
				42
			],
			[
				-22,
				34
			],
			[
				-32,
				110
			],
			[
				11,
				47
			],
			[
				-9,
				47
			],
			[
				-27,
				33
			],
			[
				-38,
				35
			],
			[
				-51,
				72
			],
			[
				-62,
				69
			],
			[
				-31,
				28
			],
			[
				-21,
				11
			],
			[
				-19,
				65
			],
			[
				-14,
				20
			],
			[
				-31,
				5
			],
			[
				-65,
				28
			],
			[
				-59,
				-33
			],
			[
				-2,
				51
			],
			[
				17,
				31
			],
			[
				207,
				243
			],
			[
				104,
				111
			],
			[
				11,
				17
			],
			[
				10,
				26
			],
			[
				7,
				34
			],
			[
				-24,
				40
			],
			[
				-98,
				187
			],
			[
				-33,
				35
			],
			[
				-34,
				29
			],
			[
				-38,
				79
			],
			[
				-45,
				183
			],
			[
				-33,
				92
			],
			[
				-10,
				71
			],
			[
				2,
				80
			],
			[
				-12,
				61
			],
			[
				-27,
				43
			],
			[
				0,
				131
			],
			[
				27,
				219
			],
			[
				6,
				166
			],
			[
				-13,
				114
			],
			[
				23,
				86
			],
			[
				61,
				60
			],
			[
				34,
				91
			],
			[
				7,
				125
			],
			[
				36,
				102
			],
			[
				66,
				80
			],
			[
				22,
				78
			],
			[
				-21,
				78
			],
			[
				-7,
				50
			],
			[
				-55,
				51
			],
			[
				-103,
				35
			],
			[
				-85,
				4
			],
			[
				-52,
				-39
			],
			[
				-132,
				-37
			],
			[
				-212,
				-34
			],
			[
				-171,
				1
			],
			[
				-130,
				34
			],
			[
				-99,
				-12
			],
			[
				-67,
				-57
			],
			[
				-48,
				-12
			],
			[
				-27,
				31
			],
			[
				-30,
				8
			],
			[
				-45,
				-19
			],
			[
				-8,
				9
			],
			[
				-101,
				153
			],
			[
				-93,
				143
			],
			[
				-107,
				170
			],
			[
				-123,
				196
			],
			[
				-22,
				13
			],
			[
				-38,
				-2
			],
			[
				-51,
				-3
			],
			[
				-78,
				20
			],
			[
				-54,
				29
			],
			[
				-42,
				27
			],
			[
				-77,
				35
			],
			[
				-53,
				6
			],
			[
				-47,
				-10
			],
			[
				-131,
				-69
			],
			[
				-75,
				-6
			],
			[
				-57,
				-1
			],
			[
				-155,
				34
			],
			[
				-106,
				5
			],
			[
				-123,
				-22
			],
			[
				-53,
				-13
			],
			[
				-73,
				35
			],
			[
				-50,
				53
			],
			[
				-47,
				126
			],
			[
				-33,
				99
			],
			[
				-57,
				20
			],
			[
				-64,
				17
			],
			[
				-31,
				33
			],
			[
				-19,
				57
			],
			[
				-4,
				74
			],
			[
				6,
				119
			],
			[
				6,
				43
			],
			[
				9,
				129
			],
			[
				35,
				67
			],
			[
				22,
				33
			],
			[
				-4,
				54
			],
			[
				-17,
				110
			],
			[
				-17,
				79
			],
			[
				-71,
				88
			],
			[
				-90,
				114
			],
			[
				-39,
				182
			],
			[
				-45,
				215
			],
			[
				-36,
				22
			],
			[
				-34,
				-11
			],
			[
				-36,
				11
			],
			[
				-32,
				86
			],
			[
				-32,
				16
			],
			[
				-50,
				-30
			],
			[
				-37,
				-24
			],
			[
				-93,
				-21
			],
			[
				-19,
				21
			],
			[
				7,
				27
			],
			[
				39,
				79
			],
			[
				46,
				100
			],
			[
				54,
				92
			],
			[
				50,
				93
			],
			[
				37,
				100
			],
			[
				25,
				198
			],
			[
				18,
				137
			],
			[
				45,
				244
			],
			[
				85,
				195
			],
			[
				31,
				89
			],
			[
				76,
				117
			],
			[
				35,
				63
			],
			[
				47,
				50
			],
			[
				128,
				68
			],
			[
				152,
				334
			],
			[
				35,
				53
			],
			[
				154,
				50
			],
			[
				119,
				39
			],
			[
				88,
				41
			],
			[
				29,
				21
			],
			[
				23,
				10
			]
		],
		[
			[
				46881,
				2274
			],
			[
				-11,
				55
			],
			[
				-83,
				14
			],
			[
				-81,
				14
			],
			[
				-136,
				39
			],
			[
				-182,
				60
			],
			[
				-182,
				0
			],
			[
				-145,
				50
			],
			[
				-160,
				55
			],
			[
				-338,
				5
			],
			[
				-297,
				4
			],
			[
				-305,
				3
			],
			[
				-195,
				2
			],
			[
				-130,
				2
			],
			[
				-34,
				21
			],
			[
				11,
				69
			],
			[
				-48,
				51
			],
			[
				-70,
				61
			],
			[
				-86,
				44
			],
			[
				-42,
				58
			],
			[
				-47,
				66
			],
			[
				26,
				58
			],
			[
				41,
				141
			],
			[
				1,
				63
			],
			[
				-37,
				43
			],
			[
				-11,
				62
			],
			[
				11,
				29
			],
			[
				34,
				22
			],
			[
				20,
				102
			],
			[
				-16,
				99
			],
			[
				-26,
				89
			],
			[
				-33,
				39
			],
			[
				-44,
				19
			],
			[
				-32,
				3
			],
			[
				-72,
				-33
			],
			[
				-118,
				9
			],
			[
				-40,
				-13
			],
			[
				-58,
				-36
			],
			[
				-82,
				-53
			],
			[
				-46,
				19
			],
			[
				-14,
				56
			],
			[
				-30,
				49
			],
			[
				-20,
				43
			],
			[
				-14,
				71
			],
			[
				-24,
				91
			],
			[
				-49,
				108
			],
			[
				-74,
				87
			],
			[
				-4,
				78
			],
			[
				-14,
				99
			],
			[
				38,
				96
			],
			[
				-22,
				79
			],
			[
				-46,
				95
			],
			[
				14,
				99
			],
			[
				46,
				54
			],
			[
				14,
				69
			],
			[
				211,
				11
			],
			[
				-9,
				93
			],
			[
				35,
				75
			],
			[
				39,
				68
			],
			[
				34,
				31
			],
			[
				75,
				27
			],
			[
				88,
				40
			],
			[
				50,
				45
			],
			[
				24,
				40
			],
			[
				15,
				52
			],
			[
				4,
				55
			],
			[
				-15,
				118
			],
			[
				17,
				37
			],
			[
				54,
				48
			],
			[
				93,
				42
			],
			[
				40,
				113
			],
			[
				-23,
				98
			],
			[
				-51,
				78
			],
			[
				-66,
				35
			],
			[
				-5,
				80
			],
			[
				29,
				76
			],
			[
				39,
				81
			],
			[
				45,
				94
			],
			[
				-2,
				65
			],
			[
				40,
				38
			],
			[
				116,
				86
			],
			[
				40,
				83
			],
			[
				41,
				23
			],
			[
				48,
				10
			],
			[
				2,
				47
			],
			[
				-34,
				47
			],
			[
				-6,
				59
			],
			[
				4,
				66
			],
			[
				11,
				87
			],
			[
				54,
				32
			],
			[
				80,
				71
			],
			[
				21,
				45
			],
			[
				3,
				60
			],
			[
				-23,
				124
			],
			[
				-20,
				89
			],
			[
				-10,
				33
			],
			[
				-37,
				61
			],
			[
				-27,
				38
			],
			[
				43,
				47
			],
			[
				81,
				51
			],
			[
				34,
				72
			],
			[
				-31,
				62
			],
			[
				-46,
				33
			],
			[
				-14,
				94
			],
			[
				17,
				120
			],
			[
				34,
				37
			],
			[
				120,
				18
			],
			[
				11,
				62
			],
			[
				92,
				87
			],
			[
				-3,
				84
			],
			[
				-58,
				51
			],
			[
				-57,
				83
			],
			[
				-42,
				73
			],
			[
				-140,
				40
			],
			[
				-148,
				22
			],
			[
				-20,
				69
			],
			[
				6,
				40
			],
			[
				69,
				-16
			],
			[
				112,
				14
			],
			[
				85,
				3
			],
			[
				59,
				7
			],
			[
				68,
				10
			],
			[
				63,
				-29
			],
			[
				63,
				18
			],
			[
				25,
				109
			],
			[
				40,
				58
			],
			[
				6,
				55
			],
			[
				-40,
				44
			],
			[
				-73,
				13
			],
			[
				-320,
				35
			],
			[
				-9,
				43
			],
			[
				2,
				73
			],
			[
				13,
				75
			],
			[
				-1,
				37
			],
			[
				30,
				32
			],
			[
				33,
				68
			],
			[
				23,
				45
			],
			[
				-23,
				59
			],
			[
				-51,
				87
			],
			[
				37,
				40
			],
			[
				3,
				48
			],
			[
				-12,
				46
			],
			[
				-53,
				52
			],
			[
				-46,
				72
			],
			[
				0,
				77
			],
			[
				54,
				20
			],
			[
				37,
				23
			],
			[
				8,
				47
			],
			[
				-20,
				59
			],
			[
				-75,
				17
			],
			[
				-101,
				36
			],
			[
				-31,
				30
			],
			[
				-28,
				62
			],
			[
				21,
				176
			],
			[
				-11,
				106
			],
			[
				-9,
				59
			],
			[
				25,
				45
			],
			[
				34,
				41
			],
			[
				-16,
				94
			],
			[
				-30,
				50
			],
			[
				10,
				38
			],
			[
				29,
				38
			],
			[
				24,
				48
			],
			[
				21,
				11
			],
			[
				32,
				-27
			],
			[
				54,
				16
			],
			[
				65,
				38
			],
			[
				7,
				45
			],
			[
				-13,
				65
			],
			[
				-48,
				162
			],
			[
				-44,
				100
			],
			[
				9,
				36
			],
			[
				17,
				38
			],
			[
				-13,
				138
			],
			[
				4,
				83
			],
			[
				3,
				246
			],
			[
				5,
				84
			],
			[
				-44,
				85
			],
			[
				6,
				81
			],
			[
				31,
				58
			],
			[
				29,
				80
			],
			[
				22,
				70
			],
			[
				23,
				32
			],
			[
				39,
				15
			],
			[
				9,
				39
			],
			[
				-18,
				29
			],
			[
				-50,
				46
			],
			[
				-11,
				55
			],
			[
				10,
				43
			],
			[
				25,
				25
			],
			[
				38,
				0
			],
			[
				29,
				61
			],
			[
				8,
				76
			],
			[
				6,
				34
			],
			[
				-22,
				45
			],
			[
				-16,
				104
			],
			[
				-15,
				59
			],
			[
				18,
				25
			],
			[
				25,
				9
			],
			[
				43,
				-14
			],
			[
				31,
				7
			],
			[
				5,
				32
			],
			[
				4,
				33
			],
			[
				11,
				23
			],
			[
				28,
				77
			],
			[
				29,
				95
			],
			[
				7,
				67
			],
			[
				-11,
				182
			],
			[
				16,
				41
			],
			[
				31,
				39
			],
			[
				44,
				35
			],
			[
				57,
				30
			],
			[
				71,
				43
			],
			[
				88,
				16
			],
			[
				35,
				47
			],
			[
				25,
				63
			],
			[
				7,
				52
			],
			[
				-34,
				36
			],
			[
				-44,
				43
			],
			[
				-21,
				108
			],
			[
				-11,
				100
			],
			[
				-7,
				125
			],
			[
				-44,
				109
			],
			[
				-46,
				121
			],
			[
				-12,
				109
			],
			[
				15,
				59
			],
			[
				18,
				94
			],
			[
				-19,
				43
			],
			[
				-23,
				77
			],
			[
				24,
				60
			],
			[
				29,
				93
			],
			[
				-4,
				47
			],
			[
				-23,
				113
			],
			[
				-21,
				63
			],
			[
				21,
				68
			],
			[
				34,
				63
			],
			[
				26,
				34
			],
			[
				-4,
				54
			],
			[
				11,
				45
			],
			[
				51,
				30
			],
			[
				47,
				56
			],
			[
				33,
				6
			],
			[
				41,
				0
			],
			[
				26,
				16
			],
			[
				11,
				43
			],
			[
				7,
				47
			],
			[
				65,
				59
			],
			[
				37,
				54
			],
			[
				69,
				11
			],
			[
				34,
				59
			],
			[
				1,
				75
			],
			[
				-8,
				76
			],
			[
				23,
				88
			],
			[
				-26,
				134
			],
			[
				3,
				71
			],
			[
				-27,
				59
			],
			[
				6,
				63
			],
			[
				-15,
				41
			],
			[
				-40,
				15
			],
			[
				-14,
				50
			],
			[
				19,
				25
			],
			[
				38,
				19
			],
			[
				47,
				38
			],
			[
				36,
				186
			],
			[
				17,
				55
			],
			[
				16,
				66
			],
			[
				-2,
				35
			],
			[
				23,
				49
			],
			[
				28,
				76
			],
			[
				45,
				73
			],
			[
				26,
				50
			],
			[
				25,
				68
			],
			[
				7,
				40
			],
			[
				32,
				20
			],
			[
				36,
				6
			],
			[
				43,
				12
			],
			[
				18,
				25
			],
			[
				-3,
				36
			],
			[
				-3,
				80
			],
			[
				-13,
				127
			],
			[
				-8,
				164
			],
			[
				7,
				107
			],
			[
				29,
				109
			],
			[
				26,
				58
			],
			[
				-7,
				45
			],
			[
				-7,
				50
			],
			[
				-50,
				27
			],
			[
				-47,
				-24
			],
			[
				-32,
				7
			],
			[
				-42,
				58
			],
			[
				-13,
				60
			],
			[
				7,
				84
			],
			[
				33,
				52
			],
			[
				13,
				65
			],
			[
				-19,
				20
			],
			[
				-42,
				44
			],
			[
				-39,
				149
			],
			[
				5,
				128
			],
			[
				-39,
				33
			],
			[
				-18,
				100
			],
			[
				-40,
				36
			],
			[
				-16,
				74
			],
			[
				-13,
				77
			],
			[
				6,
				34
			],
			[
				41,
				9
			],
			[
				24,
				60
			],
			[
				-18,
				34
			],
			[
				-31,
				30
			],
			[
				-41,
				-3
			],
			[
				-36,
				35
			],
			[
				-49,
				145
			],
			[
				-39,
				80
			],
			[
				12,
				116
			],
			[
				8,
				91
			],
			[
				17,
				78
			],
			[
				6,
				62
			],
			[
				30,
				29
			],
			[
				28,
				-13
			],
			[
				26,
				6
			],
			[
				25,
				50
			],
			[
				27,
				32
			],
			[
				-2,
				24
			],
			[
				-16,
				27
			],
			[
				-8,
				48
			],
			[
				19,
				56
			],
			[
				32,
				129
			],
			[
				49,
				143
			],
			[
				21,
				53
			],
			[
				-5,
				45
			],
			[
				10,
				20
			],
			[
				33,
				-22
			],
			[
				95,
				25
			],
			[
				31,
				63
			],
			[
				13,
				56
			],
			[
				28,
				32
			],
			[
				-12,
				45
			],
			[
				-39,
				13
			],
			[
				-24,
				21
			],
			[
				10,
				51
			],
			[
				13,
				118
			],
			[
				-2,
				86
			],
			[
				-35,
				185
			],
			[
				-29,
				182
			],
			[
				20,
				61
			],
			[
				62,
				84
			],
			[
				47,
				38
			],
			[
				8,
				47
			],
			[
				46,
				216
			],
			[
				6,
				118
			],
			[
				30,
				65
			],
			[
				20,
				122
			],
			[
				84,
				106
			],
			[
				25,
				70
			],
			[
				33,
				6
			],
			[
				18,
				23
			],
			[
				44,
				78
			],
			[
				58,
				80
			],
			[
				50,
				40
			],
			[
				12,
				63
			],
			[
				24,
				87
			],
			[
				49,
				143
			],
			[
				28,
				100
			],
			[
				37,
				36
			],
			[
				43,
				130
			],
			[
				19,
				77
			],
			[
				49,
				32
			],
			[
				39,
				9
			],
			[
				37,
				-36
			],
			[
				39,
				6
			],
			[
				35,
				46
			],
			[
				86,
				30
			],
			[
				38,
				17
			],
			[
				18,
				45
			],
			[
				0,
				79
			],
			[
				-36,
				59
			],
			[
				-72,
				112
			],
			[
				-62,
				125
			],
			[
				-7,
				40
			],
			[
				0,
				43
			],
			[
				11,
				54
			],
			[
				29,
				62
			],
			[
				75,
				102
			],
			[
				-8,
				73
			],
			[
				-54,
				267
			],
			[
				-21,
				74
			],
			[
				-37,
				137
			],
			[
				5,
				54
			],
			[
				33,
				151
			],
			[
				29,
				61
			],
			[
				42,
				11
			],
			[
				23,
				20
			],
			[
				7,
				28
			],
			[
				-28,
				33
			],
			[
				-12,
				43
			],
			[
				-13,
				61
			],
			[
				-39,
				21
			],
			[
				-23,
				51
			],
			[
				0,
				75
			],
			[
				36,
				97
			],
			[
				39,
				27
			],
			[
				16,
				42
			],
			[
				41,
				40
			],
			[
				38,
				30
			],
			[
				32,
				57
			],
			[
				131,
				69
			],
			[
				104,
				53
			],
			[
				203,
				103
			],
			[
				140,
				70
			],
			[
				13,
				49
			],
			[
				11,
				33
			],
			[
				64,
				248
			],
			[
				84,
				321
			],
			[
				52,
				201
			],
			[
				-120,
				148
			]
		],
		[
			[
				46761,
				2030
			],
			[
				-2,
				-245
			],
			[
				-1,
				-241
			],
			[
				-1,
				-226
			],
			[
				-1,
				-225
			],
			[
				-1,
				-218
			],
			[
				-1,
				-223
			],
			[
				-5,
				-251
			],
			[
				-3,
				-186
			],
			[
				-2,
				-55
			],
			[
				125,
				21
			],
			[
				131,
				15
			],
			[
				131,
				-1
			],
			[
				227,
				-25
			],
			[
				228,
				-22
			],
			[
				129,
				-16
			],
			[
				111,
				-32
			],
			[
				207,
				-63
			],
			[
				119,
				-37
			]
		],
		[
			[
				105813,
				90278
			],
			[
				-22,
				-6
			],
			[
				-364,
				9
			],
			[
				-346,
				13
			],
			[
				-319,
				13
			],
			[
				-307,
				12
			],
			[
				-295,
				12
			],
			[
				-183,
				11
			],
			[
				-181,
				10
			],
			[
				-26,
				10
			]
		],
		[
			[
				122403,
				68990
			],
			[
				-113,
				-2
			],
			[
				-141,
				-3
			],
			[
				-115,
				-1
			],
			[
				-130,
				-2
			],
			[
				-57,
				78
			],
			[
				-19,
				85
			],
			[
				-21,
				88
			],
			[
				-57,
				125
			],
			[
				-190,
				30
			],
			[
				-101,
				16
			],
			[
				-166,
				24
			],
			[
				-125,
				18
			]
		],
		[
			[
				120027,
				76082
			],
			[
				0,
				-6
			],
			[
				21,
				-59
			],
			[
				53,
				-218
			],
			[
				31,
				-28
			],
			[
				34,
				-23
			],
			[
				25,
				-33
			],
			[
				9,
				-32
			],
			[
				-3,
				-51
			],
			[
				1,
				-59
			],
			[
				15,
				-45
			],
			[
				19,
				-34
			],
			[
				19,
				-17
			],
			[
				28,
				-2
			],
			[
				33,
				-8
			],
			[
				22,
				-34
			],
			[
				71,
				-248
			],
			[
				7,
				-33
			],
			[
				30,
				-10
			],
			[
				49,
				5
			],
			[
				50,
				-26
			],
			[
				54,
				-41
			],
			[
				51,
				-75
			],
			[
				34,
				-12
			],
			[
				107,
				11
			],
			[
				146,
				-12
			],
			[
				68,
				-39
			],
			[
				-7,
				-24
			],
			[
				-53,
				-27
			],
			[
				-92,
				-32
			],
			[
				-28,
				-54
			],
			[
				-15,
				-69
			],
			[
				3,
				-39
			],
			[
				22,
				-43
			],
			[
				66,
				-85
			],
			[
				3,
				-31
			],
			[
				12,
				-43
			],
			[
				12,
				-29
			],
			[
				-13,
				-57
			],
			[
				-60,
				-39
			],
			[
				-78,
				-43
			],
			[
				-157,
				-189
			],
			[
				-11,
				-41
			],
			[
				1,
				-113
			],
			[
				-16,
				-32
			],
			[
				-49,
				1
			],
			[
				-39,
				6
			],
			[
				-2,
				-40
			],
			[
				-25,
				-52
			],
			[
				-14,
				-45
			],
			[
				58,
				-108
			],
			[
				10,
				-57
			],
			[
				-9,
				-52
			],
			[
				-54,
				-89
			],
			[
				-31,
				-61
			],
			[
				8,
				-13
			],
			[
				41,
				-24
			],
			[
				130,
				-197
			],
			[
				41,
				-69
			],
			[
				55,
				18
			],
			[
				20,
				-1
			],
			[
				16,
				-12
			],
			[
				10,
				-23
			],
			[
				0,
				-29
			],
			[
				-14,
				-45
			],
			[
				70,
				-18
			],
			[
				25,
				-45
			],
			[
				82,
				-153
			],
			[
				-3,
				-46
			],
			[
				-39,
				-72
			],
			[
				-1,
				-48
			],
			[
				9,
				-43
			],
			[
				12,
				-15
			],
			[
				120,
				-7
			],
			[
				51,
				-17
			],
			[
				125,
				-78
			],
			[
				141,
				-121
			],
			[
				116,
				-98
			],
			[
				99,
				-84
			],
			[
				106,
				6
			],
			[
				29,
				-16
			],
			[
				26,
				-26
			],
			[
				31,
				-69
			],
			[
				60,
				-156
			],
			[
				52,
				-52
			],
			[
				79,
				-125
			],
			[
				75,
				-117
			],
			[
				-49,
				-159
			],
			[
				-48,
				-165
			],
			[
				0,
				-214
			],
			[
				0,
				-115
			],
			[
				101,
				-5
			],
			[
				113,
				-5
			],
			[
				0,
				-137
			],
			[
				1,
				-138
			],
			[
				1,
				-158
			],
			[
				33,
				-6
			],
			[
				53,
				-34
			],
			[
				22,
				-51
			],
			[
				29,
				-27
			],
			[
				34,
				-5
			],
			[
				34,
				-25
			],
			[
				33,
				-46
			],
			[
				12,
				-34
			],
			[
				-9,
				-24
			],
			[
				7,
				-41
			],
			[
				23,
				-59
			],
			[
				29,
				-28
			],
			[
				44,
				-35
			]
		],
		[
			[
				130685,
				74826
			],
			[
				-15,
				33
			],
			[
				-2,
				38
			],
			[
				15,
				46
			],
			[
				-4,
				87
			],
			[
				-30,
				63
			],
			[
				-34,
				27
			],
			[
				4,
				19
			],
			[
				15,
				44
			],
			[
				19,
				38
			],
			[
				0,
				76
			],
			[
				-24,
				81
			],
			[
				-9,
				118
			],
			[
				6,
				115
			],
			[
				-33,
				58
			],
			[
				-266,
				1
			],
			[
				-236,
				-5
			],
			[
				-14,
				14
			],
			[
				-92,
				145
			],
			[
				-74,
				110
			],
			[
				-74,
				65
			],
			[
				-169,
				79
			],
			[
				-81,
				34
			],
			[
				-69,
				61
			],
			[
				-57,
				66
			],
			[
				-14,
				92
			],
			[
				-12,
				30
			],
			[
				-16,
				24
			],
			[
				-18,
				11
			],
			[
				-22,
				-2
			],
			[
				-196,
				106
			],
			[
				-78,
				28
			],
			[
				-74,
				-23
			],
			[
				-33,
				-3
			],
			[
				-65,
				30
			],
			[
				-74,
				-41
			],
			[
				-31,
				-3
			],
			[
				-45,
				10
			],
			[
				-36,
				15
			],
			[
				-99,
				97
			],
			[
				-83,
				39
			],
			[
				-59,
				25
			],
			[
				-115,
				37
			],
			[
				-123,
				19
			],
			[
				-63,
				16
			],
			[
				-45,
				21
			],
			[
				-11,
				14
			],
			[
				0,
				35
			],
			[
				-3,
				47
			],
			[
				-15,
				33
			],
			[
				-31,
				41
			],
			[
				-43,
				30
			],
			[
				-74,
				-5
			],
			[
				-112,
				3
			],
			[
				-85,
				30
			],
			[
				-68,
				6
			],
			[
				-81,
				-6
			],
			[
				-67,
				0
			],
			[
				-47,
				-23
			],
			[
				-28,
				-25
			],
			[
				-18,
				-80
			],
			[
				-16,
				-12
			],
			[
				-28,
				-6
			],
			[
				-37,
				5
			],
			[
				-78,
				-1
			],
			[
				-135,
				14
			],
			[
				-170,
				4
			],
			[
				-127,
				-40
			],
			[
				-101,
				-57
			],
			[
				-97,
				-66
			],
			[
				-113,
				-102
			],
			[
				-33,
				-46
			],
			[
				-67,
				-182
			],
			[
				-30,
				-26
			],
			[
				-38,
				-21
			],
			[
				-40,
				-4
			],
			[
				-77,
				-27
			],
			[
				-103,
				-44
			],
			[
				-70,
				-18
			],
			[
				-179,
				10
			]
		],
		[
			[
				182188,
				43307
			],
			[
				0,
				-168
			],
			[
				0,
				-167
			],
			[
				0,
				-168
			],
			[
				0,
				-168
			],
			[
				0,
				-167
			],
			[
				0,
				-168
			],
			[
				0,
				-168
			],
			[
				0,
				-167
			],
			[
				0,
				-168
			],
			[
				1,
				-168
			],
			[
				0,
				-167
			],
			[
				0,
				-168
			],
			[
				0,
				-168
			],
			[
				0,
				-167
			],
			[
				0,
				-168
			],
			[
				0,
				-167
			],
			[
				0,
				-168
			],
			[
				0,
				-168
			],
			[
				0,
				-71
			],
			[
				-20,
				-88
			],
			[
				-45,
				-131
			],
			[
				-8,
				-106
			],
			[
				37,
				-83
			],
			[
				36,
				-53
			],
			[
				0,
				-138
			],
			[
				0,
				-168
			],
			[
				0,
				-168
			],
			[
				0,
				-167
			],
			[
				0,
				-168
			],
			[
				0,
				-168
			],
			[
				0,
				-167
			],
			[
				0,
				-168
			],
			[
				1,
				-168
			],
			[
				0,
				-167
			],
			[
				0,
				-168
			]
		],
		[
			[
				97253,
				70381
			],
			[
				-63,
				-42
			],
			[
				-71,
				-52
			],
			[
				52,
				-101
			],
			[
				100,
				-163
			],
			[
				61,
				-131
			],
			[
				21,
				-58
			],
			[
				47,
				-163
			],
			[
				39,
				-158
			],
			[
				10,
				-52
			],
			[
				14,
				-121
			],
			[
				-18,
				-336
			],
			[
				28,
				-426
			],
			[
				37,
				-213
			],
			[
				-59,
				-192
			],
			[
				-50,
				-183
			],
			[
				3,
				-92
			],
			[
				28,
				-144
			],
			[
				27,
				-106
			],
			[
				37,
				-56
			],
			[
				-7,
				-179
			],
			[
				-16,
				-65
			],
			[
				-112,
				-94
			],
			[
				-125,
				-86
			],
			[
				-35,
				-73
			],
			[
				-10,
				-81
			],
			[
				17,
				-66
			],
			[
				86,
				-146
			],
			[
				129,
				-219
			],
			[
				142,
				-241
			],
			[
				12,
				-61
			],
			[
				6,
				-171
			],
			[
				59,
				-215
			],
			[
				64,
				-94
			],
			[
				24,
				-70
			],
			[
				45,
				-50
			],
			[
				45,
				-37
			],
			[
				28,
				-5
			],
			[
				160,
				59
			],
			[
				272,
				-97
			],
			[
				258,
				-98
			],
			[
				19,
				-20
			],
			[
				57,
				-124
			],
			[
				92,
				-204
			],
			[
				69,
				-163
			],
			[
				61,
				-146
			]
		],
		[
			[
				82233,
				55903
			],
			[
				-217,
				1
			],
			[
				-184,
				1
			],
			[
				-232,
				1
			],
			[
				-163,
				1
			],
			[
				-152,
				1
			],
			[
				-118,
				-75
			],
			[
				-127,
				-81
			],
			[
				-171,
				-44
			],
			[
				-197,
				17
			],
			[
				-63,
				-12
			],
			[
				-65,
				-36
			],
			[
				-48,
				-26
			],
			[
				-67,
				-16
			],
			[
				-88,
				13
			],
			[
				-35,
				-8
			]
		],
		[
			[
				83744,
				55681
			],
			[
				-43,
				11
			],
			[
				-76,
				7
			],
			[
				-151,
				-32
			],
			[
				-52,
				13
			],
			[
				-99,
				-4
			],
			[
				-71,
				-18
			],
			[
				-90,
				-40
			],
			[
				-70,
				10
			],
			[
				-38,
				31
			],
			[
				-49,
				-2
			],
			[
				-56,
				17
			],
			[
				-60,
				31
			],
			[
				-54,
				15
			],
			[
				-59,
				56
			],
			[
				-27,
				10
			],
			[
				-20,
				-15
			],
			[
				-16,
				-18
			],
			[
				-17,
				-12
			],
			[
				-32,
				10
			],
			[
				-12,
				39
			],
			[
				10,
				37
			],
			[
				3,
				28
			],
			[
				-15,
				15
			],
			[
				-36,
				5
			],
			[
				-58,
				0
			],
			[
				-93,
				11
			],
			[
				-21,
				7
			],
			[
				-209,
				10
			]
		],
		[
			[
				91685,
				54517
			],
			[
				-166,
				-8
			],
			[
				-61,
				-23
			],
			[
				-36,
				0
			],
			[
				-2,
				19
			],
			[
				-4,
				11
			],
			[
				-210,
				64
			],
			[
				-147,
				38
			]
		],
		[
			[
				91740,
				54588
			],
			[
				-18,
				-42
			],
			[
				-21,
				-29
			],
			[
				-16,
				0
			]
		],
		[
			[
				1257,
				94933
			],
			[
				-83,
				68
			],
			[
				31,
				73
			],
			[
				37,
				88
			],
			[
				0,
				53
			],
			[
				-100,
				-3
			],
			[
				-151,
				-5
			],
			[
				-134,
				-4
			],
			[
				-100,
				-63
			],
			[
				-92,
				-57
			],
			[
				-145,
				45
			],
			[
				-165,
				51
			],
			[
				-47,
				-67
			],
			[
				-153,
				33
			],
			[
				-155,
				34
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			],
			[
				0,
				241
			]
		],
		[
			[
				6707,
				90568
			],
			[
				30,
				50
			],
			[
				53,
				54
			],
			[
				117,
				92
			],
			[
				63,
				66
			],
			[
				97,
				165
			],
			[
				30,
				48
			],
			[
				2,
				39
			],
			[
				-4,
				33
			],
			[
				-11,
				37
			],
			[
				-20,
				55
			],
			[
				-26,
				80
			],
			[
				-9,
				91
			],
			[
				20,
				79
			],
			[
				43,
				84
			],
			[
				8,
				51
			],
			[
				-6,
				53
			],
			[
				-22,
				42
			],
			[
				-27,
				36
			],
			[
				-75,
				-22
			],
			[
				-128,
				33
			],
			[
				-42,
				89
			],
			[
				-111,
				28
			],
			[
				-60,
				63
			],
			[
				-121,
				31
			],
			[
				-99,
				22
			],
			[
				-75,
				37
			],
			[
				-88,
				42
			],
			[
				-88,
				46
			],
			[
				-67,
				35
			],
			[
				-49,
				-2
			],
			[
				-112,
				-5
			],
			[
				-6,
				78
			],
			[
				-34,
				47
			],
			[
				13,
				42
			],
			[
				-62,
				21
			],
			[
				-92,
				32
			],
			[
				27,
				79
			],
			[
				20,
				61
			],
			[
				-81,
				18
			],
			[
				-117,
				25
			],
			[
				38,
				55
			],
			[
				30,
				43
			],
			[
				-45,
				65
			],
			[
				-90,
				107
			],
			[
				-70,
				77
			],
			[
				-91,
				120
			],
			[
				-81,
				105
			],
			[
				-65,
				86
			],
			[
				-55,
				59
			],
			[
				-77,
				107
			],
			[
				-100,
				119
			],
			[
				-95,
				94
			],
			[
				14,
				61
			],
			[
				-94,
				77
			],
			[
				-82,
				77
			],
			[
				-95,
				89
			],
			[
				-94,
				43
			],
			[
				-67,
				31
			],
			[
				-96,
				45
			],
			[
				-51,
				40
			],
			[
				-21,
				34
			],
			[
				-22,
				24
			],
			[
				-19,
				34
			],
			[
				-11,
				38
			],
			[
				-20,
				24
			],
			[
				-117,
				58
			],
			[
				-35,
				36
			],
			[
				-81,
				42
			],
			[
				-68,
				18
			],
			[
				-24,
				14
			],
			[
				-82,
				126
			],
			[
				13,
				45
			],
			[
				9,
				45
			],
			[
				-9,
				23
			],
			[
				-135,
				96
			],
			[
				-70,
				40
			],
			[
				-69,
				41
			],
			[
				-147,
				-53
			],
			[
				-150,
				-54
			],
			[
				-105,
				-20
			],
			[
				-145,
				-28
			],
			[
				48,
				-59
			],
			[
				-20,
				-44
			],
			[
				-45,
				-20
			],
			[
				-76,
				3
			],
			[
				-1,
				-148
			],
			[
				-72,
				-105
			],
			[
				-152,
				-2
			],
			[
				-81,
				-36
			],
			[
				-121,
				-54
			],
			[
				-98,
				-44
			],
			[
				-104,
				-70
			],
			[
				-53,
				10
			],
			[
				24,
				63
			],
			[
				-38,
				106
			],
			[
				-33,
				88
			],
			[
				-66,
				45
			],
			[
				-113,
				76
			],
			[
				-84,
				57
			],
			[
				-120,
				82
			],
			[
				-85,
				57
			],
			[
				-87,
				60
			],
			[
				-116,
				78
			],
			[
				-47,
				101
			],
			[
				-106,
				37
			],
			[
				-112,
				39
			],
			[
				-9,
				7
			]
		],
		[
			[
				11429,
				85855
			],
			[
				85,
				0
			],
			[
				62,
				0
			],
			[
				24,
				0
			],
			[
				69,
				0
			],
			[
				99,
				0
			],
			[
				66,
				0
			]
		],
		[
			[
				33668,
				58556
			],
			[
				-28,
				-1
			],
			[
				-114,
				9
			],
			[
				-77,
				-10
			],
			[
				-3,
				5
			],
			[
				6,
				205
			],
			[
				10,
				317
			],
			[
				7,
				232
			],
			[
				7,
				228
			],
			[
				6,
				170
			],
			[
				7,
				232
			],
			[
				6,
				200
			]
		],
		[
			[
				42461,
				45363
			],
			[
				-36,
				-29
			],
			[
				-38,
				-3
			],
			[
				-50,
				-9
			],
			[
				-69,
				28
			],
			[
				-28,
				0
			],
			[
				-4,
				-29
			],
			[
				47,
				-35
			],
			[
				45,
				-40
			],
			[
				16,
				-60
			],
			[
				26,
				-72
			],
			[
				65,
				-81
			],
			[
				40,
				-40
			],
			[
				2,
				-28
			],
			[
				-12,
				-53
			],
			[
				-3,
				-44
			],
			[
				22,
				-202
			],
			[
				-15,
				-12
			],
			[
				-24,
				-1
			],
			[
				-25,
				1
			],
			[
				-21,
				22
			],
			[
				-18,
				13
			],
			[
				-8,
				-31
			],
			[
				-18,
				-90
			],
			[
				-42,
				-202
			],
			[
				-37,
				-178
			],
			[
				-46,
				-62
			],
			[
				-66,
				-100
			],
			[
				-91,
				-136
			],
			[
				-132,
				-198
			],
			[
				-98,
				-91
			],
			[
				-77,
				-72
			],
			[
				-90,
				-84
			],
			[
				-116,
				-107
			],
			[
				-130,
				-61
			],
			[
				-182,
				-83
			],
			[
				-128,
				-60
			],
			[
				-95,
				-41
			],
			[
				-98,
				-44
			],
			[
				-130,
				-57
			],
			[
				-51,
				-54
			],
			[
				-83,
				-131
			],
			[
				-39,
				-64
			],
			[
				-36,
				-55
			],
			[
				-7,
				-25
			],
			[
				4,
				-16
			],
			[
				17,
				-26
			],
			[
				2,
				-27
			],
			[
				-23,
				-17
			],
			[
				-21,
				-3
			],
			[
				-9,
				13
			],
			[
				-7,
				31
			],
			[
				-21,
				30
			],
			[
				-25,
				9
			],
			[
				-15,
				-8
			],
			[
				-1,
				-27
			],
			[
				-33,
				-135
			],
			[
				-1,
				-66
			],
			[
				-14,
				-26
			],
			[
				1,
				-58
			],
			[
				-33,
				-55
			],
			[
				-14,
				-49
			],
			[
				-10,
				-41
			],
			[
				-27,
				-29
			],
			[
				-10,
				-45
			],
			[
				-24,
				-95
			],
			[
				-29,
				-75
			],
			[
				-21,
				-64
			],
			[
				-3,
				-48
			],
			[
				15,
				-34
			],
			[
				6,
				-27
			],
			[
				-14,
				-49
			],
			[
				-8,
				-37
			],
			[
				-37,
				-25
			],
			[
				-76,
				-60
			],
			[
				-30,
				-41
			],
			[
				-12,
				-46
			],
			[
				8,
				-40
			],
			[
				-3,
				-32
			],
			[
				-37,
				-13
			],
			[
				-13,
				-28
			],
			[
				-24,
				-51
			],
			[
				-28,
				-17
			],
			[
				-71,
				26
			],
			[
				-53,
				1
			],
			[
				-40,
				24
			],
			[
				-45,
				73
			],
			[
				-36,
				61
			],
			[
				-30,
				79
			],
			[
				-9,
				108
			],
			[
				-40,
				32
			],
			[
				-39,
				37
			],
			[
				-47,
				-10
			],
			[
				-56,
				-7
			],
			[
				-31,
				25
			],
			[
				-76,
				46
			],
			[
				-65,
				51
			],
			[
				-49,
				26
			],
			[
				-37,
				-12
			],
			[
				-23,
				-31
			],
			[
				-39,
				-56
			],
			[
				-59,
				-39
			],
			[
				-26,
				2
			],
			[
				-35,
				26
			],
			[
				-6,
				30
			],
			[
				28,
				48
			],
			[
				59,
				105
			],
			[
				-65,
				2
			],
			[
				-22,
				33
			],
			[
				-4,
				38
			],
			[
				-10,
				41
			],
			[
				13,
				49
			],
			[
				34,
				26
			],
			[
				51,
				-20
			],
			[
				35,
				-2
			],
			[
				24,
				47
			],
			[
				23,
				20
			],
			[
				24,
				15
			],
			[
				9,
				23
			],
			[
				-24,
				75
			],
			[
				-8,
				40
			],
			[
				8,
				23
			],
			[
				-1,
				46
			],
			[
				-1,
				35
			],
			[
				-15,
				30
			],
			[
				-1,
				45
			],
			[
				-13,
				24
			],
			[
				-4,
				26
			],
			[
				-1,
				30
			],
			[
				-17,
				15
			],
			[
				-17,
				15
			]
		],
		[
			[
				45897,
				41958
			],
			[
				-33,
				61
			],
			[
				-50,
				58
			],
			[
				-47,
				34
			],
			[
				-20,
				45
			],
			[
				-27,
				93
			],
			[
				-37,
				32
			],
			[
				-27,
				25
			],
			[
				-26,
				-4
			],
			[
				-27,
				-25
			],
			[
				-42,
				-17
			],
			[
				-28,
				3
			],
			[
				-114,
				64
			],
			[
				-19,
				6
			],
			[
				74,
				146
			],
			[
				131,
				260
			],
			[
				83,
				166
			],
			[
				92,
				184
			],
			[
				48,
				94
			],
			[
				6,
				16
			],
			[
				0,
				24
			],
			[
				-21,
				36
			],
			[
				-44,
				15
			],
			[
				-52,
				28
			],
			[
				-32,
				44
			],
			[
				-45,
				19
			],
			[
				-35,
				32
			],
			[
				-64,
				31
			],
			[
				-38,
				29
			],
			[
				-46,
				10
			],
			[
				-37,
				53
			],
			[
				-136,
				102
			],
			[
				-34,
				9
			],
			[
				-38,
				-15
			],
			[
				-56,
				-17
			],
			[
				-54,
				-55
			],
			[
				-67,
				-18
			],
			[
				-62,
				0
			],
			[
				-33,
				34
			],
			[
				-31,
				12
			],
			[
				-41,
				45
			],
			[
				-73,
				35
			],
			[
				-52,
				24
			],
			[
				-32,
				-11
			],
			[
				-42,
				-51
			],
			[
				-42,
				-50
			],
			[
				-34,
				-31
			],
			[
				-45,
				1
			],
			[
				-53,
				-46
			],
			[
				-53,
				-16
			],
			[
				-53,
				-8
			],
			[
				-61,
				-16
			],
			[
				-68,
				28
			],
			[
				-56,
				25
			],
			[
				-25,
				11
			],
			[
				-22,
				-8
			],
			[
				-35,
				-26
			],
			[
				-63,
				-11
			],
			[
				-49,
				-2
			],
			[
				-35,
				12
			],
			[
				-31,
				45
			],
			[
				-51,
				23
			],
			[
				-56,
				27
			],
			[
				-12,
				58
			],
			[
				9,
				43
			],
			[
				21,
				62
			],
			[
				-12,
				64
			],
			[
				-23,
				101
			],
			[
				-10,
				42
			],
			[
				-18,
				35
			],
			[
				-27,
				13
			],
			[
				-54,
				-10
			],
			[
				-58,
				38
			],
			[
				-37,
				37
			],
			[
				-18,
				45
			],
			[
				20,
				84
			],
			[
				-18,
				72
			],
			[
				-35,
				39
			],
			[
				-22,
				71
			],
			[
				-35,
				55
			],
			[
				-46,
				29
			],
			[
				-47,
				-3
			],
			[
				-36,
				17
			],
			[
				-41,
				59
			],
			[
				-39,
				23
			],
			[
				-43,
				57
			],
			[
				-82,
				25
			],
			[
				-42,
				23
			],
			[
				-25,
				35
			],
			[
				-32,
				63
			],
			[
				4,
				36
			],
			[
				-16,
				34
			],
			[
				-14,
				62
			],
			[
				-28,
				91
			],
			[
				-31,
				52
			],
			[
				-31,
				39
			],
			[
				-27,
				34
			],
			[
				-39,
				49
			],
			[
				-49,
				29
			],
			[
				-41,
				30
			],
			[
				-16,
				45
			],
			[
				-14,
				36
			],
			[
				-23,
				-2
			],
			[
				-33,
				3
			],
			[
				-37,
				9
			],
			[
				-38,
				27
			],
			[
				-33,
				32
			],
			[
				-54,
				55
			],
			[
				-29,
				7
			],
			[
				-26,
				0
			],
			[
				-39,
				-54
			]
		],
		[
			[
				47894,
				46460
			],
			[
				-122,
				-37
			],
			[
				-11,
				6
			],
			[
				-8,
				20
			],
			[
				4,
				157
			],
			[
				-2,
				178
			],
			[
				-18,
				72
			],
			[
				-56,
				117
			],
			[
				-74,
				154
			],
			[
				-21,
				44
			],
			[
				-31,
				26
			],
			[
				-37,
				3
			],
			[
				-27,
				-10
			],
			[
				-37,
				-29
			],
			[
				-34,
				-32
			],
			[
				-66,
				-93
			],
			[
				-67,
				-109
			],
			[
				-39,
				-24
			],
			[
				-39,
				-10
			],
			[
				-35,
				3
			],
			[
				-28,
				30
			],
			[
				-28,
				59
			],
			[
				-35,
				79
			],
			[
				-41,
				26
			],
			[
				-16,
				-24
			],
			[
				-13,
				-47
			],
			[
				-11,
				-46
			],
			[
				28,
				-58
			],
			[
				24,
				-45
			],
			[
				-41,
				1
			],
			[
				-132,
				0
			],
			[
				-152,
				0
			],
			[
				-151,
				0
			],
			[
				-137,
				0
			],
			[
				-126,
				0
			],
			[
				-48,
				3
			],
			[
				-49,
				27
			],
			[
				-47,
				13
			],
			[
				-25,
				-3
			],
			[
				-45,
				-25
			],
			[
				-57,
				-4
			],
			[
				-39,
				-25
			],
			[
				-32,
				3
			],
			[
				0,
				-136
			],
			[
				-1,
				-193
			],
			[
				-1,
				-206
			],
			[
				35,
				16
			],
			[
				30,
				-2
			],
			[
				22,
				-14
			],
			[
				62,
				11
			],
			[
				35,
				-6
			],
			[
				32,
				-5
			],
			[
				31,
				-1
			],
			[
				18,
				-16
			],
			[
				25,
				3
			],
			[
				27,
				18
			],
			[
				32,
				-11
			],
			[
				34,
				-29
			],
			[
				22,
				-44
			],
			[
				20,
				-53
			],
			[
				20,
				-28
			],
			[
				-1,
				-51
			],
			[
				-1,
				-41
			],
			[
				-7,
				-33
			],
			[
				9,
				-22
			],
			[
				6,
				-23
			],
			[
				-1,
				-13
			],
			[
				-12,
				-6
			],
			[
				-25,
				-4
			],
			[
				-27,
				-4
			],
			[
				-18,
				1
			],
			[
				-15,
				21
			],
			[
				-14,
				2
			],
			[
				-20,
				-2
			],
			[
				-22,
				12
			],
			[
				-18,
				26
			],
			[
				-34,
				26
			],
			[
				-35,
				-11
			],
			[
				-24,
				-13
			],
			[
				-26,
				-17
			],
			[
				-22,
				-17
			],
			[
				-23,
				5
			],
			[
				-29,
				-13
			],
			[
				-24,
				-19
			],
			[
				-33,
				-16
			],
			[
				-36,
				-7
			],
			[
				-40,
				-8
			],
			[
				-39,
				-3
			],
			[
				-44,
				-6
			],
			[
				-3,
				-108
			],
			[
				-5,
				-213
			],
			[
				-3,
				-140
			],
			[
				0,
				-130
			],
			[
				17,
				-48
			],
			[
				78,
				-100
			],
			[
				62,
				-52
			],
			[
				52,
				-59
			],
			[
				51,
				-25
			],
			[
				22,
				-22
			],
			[
				14,
				-36
			],
			[
				7,
				-38
			],
			[
				6,
				-33
			],
			[
				-6,
				-35
			],
			[
				-13,
				-32
			],
			[
				6,
				-35
			],
			[
				19,
				-27
			],
			[
				5,
				-35
			],
			[
				13,
				-32
			],
			[
				7,
				-33
			],
			[
				16,
				-24
			],
			[
				20,
				-16
			],
			[
				26,
				-27
			],
			[
				2,
				-26
			],
			[
				-2,
				-29
			],
			[
				-1,
				-22
			],
			[
				25,
				-50
			],
			[
				7,
				-35
			],
			[
				-12,
				-42
			],
			[
				-11,
				-145
			],
			[
				-28,
				-165
			],
			[
				-18,
				-127
			],
			[
				-29,
				-205
			],
			[
				-34,
				-239
			],
			[
				-42,
				-292
			],
			[
				-41,
				-288
			],
			[
				-40,
				-278
			],
			[
				-36,
				-252
			],
			[
				-39,
				-278
			],
			[
				-24,
				-168
			],
			[
				-12,
				-29
			]
		],
		[
			[
				46148,
				36420
			],
			[
				80,
				-179
			],
			[
				60,
				-131
			],
			[
				67,
				-150
			],
			[
				54,
				-120
			],
			[
				83,
				-182
			],
			[
				71,
				-158
			],
			[
				76,
				-168
			],
			[
				86,
				-191
			],
			[
				-28,
				-48
			],
			[
				-22,
				-39
			],
			[
				2,
				-66
			],
			[
				-34,
				-35
			],
			[
				-36,
				-21
			],
			[
				-43,
				-55
			],
			[
				-29,
				-48
			],
			[
				-1,
				-68
			],
			[
				5,
				-346
			],
			[
				-7,
				-94
			],
			[
				-22,
				-81
			],
			[
				-23,
				-41
			],
			[
				-13,
				-32
			],
			[
				33,
				-80
			],
			[
				31,
				-161
			],
			[
				24,
				-32
			],
			[
				29,
				-66
			],
			[
				14,
				-62
			],
			[
				-6,
				-24
			],
			[
				-59,
				-30
			],
			[
				-21,
				-25
			],
			[
				-6,
				-92
			],
			[
				-26,
				-34
			],
			[
				-43,
				-43
			],
			[
				-28,
				-50
			],
			[
				-23,
				-34
			],
			[
				-23,
				-21
			],
			[
				-12,
				-61
			],
			[
				-15,
				-61
			],
			[
				-54,
				-41
			],
			[
				-9,
				-76
			],
			[
				-1,
				-62
			],
			[
				29,
				-63
			],
			[
				93,
				-132
			],
			[
				9,
				-31
			],
			[
				-53,
				-79
			],
			[
				-31,
				-55
			],
			[
				-75,
				-169
			],
			[
				-1,
				-30
			],
			[
				18,
				-80
			],
			[
				113,
				-340
			],
			[
				19,
				-27
			],
			[
				35,
				-33
			],
			[
				57,
				4
			],
			[
				85,
				-37
			],
			[
				42,
				-42
			],
			[
				4,
				-20
			],
			[
				-10,
				-14
			],
			[
				-45,
				-28
			],
			[
				-51,
				-37
			],
			[
				-17,
				-35
			],
			[
				-3,
				-55
			],
			[
				11,
				-82
			],
			[
				-22,
				-27
			],
			[
				-50,
				-32
			],
			[
				-44,
				-45
			],
			[
				-43,
				-77
			],
			[
				-74,
				-115
			],
			[
				-26,
				-32
			],
			[
				-11,
				-40
			],
			[
				-42,
				-14
			],
			[
				-78,
				-78
			],
			[
				-14,
				-40
			],
			[
				13,
				-38
			],
			[
				40,
				-32
			],
			[
				27,
				-46
			],
			[
				7,
				-59
			],
			[
				0,
				-37
			]
		],
		[
			[
				46148,
				36420
			],
			[
				75,
				3
			],
			[
				151,
				-7
			],
			[
				146,
				-32
			],
			[
				99,
				-13
			],
			[
				42,
				-28
			],
			[
				9,
				-44
			],
			[
				28,
				-20
			],
			[
				31,
				8
			],
			[
				36,
				3
			],
			[
				81,
				45
			],
			[
				64,
				29
			],
			[
				57,
				36
			],
			[
				28,
				35
			],
			[
				70,
				122
			],
			[
				56,
				68
			],
			[
				52,
				23
			],
			[
				101,
				10
			],
			[
				32,
				-19
			],
			[
				41,
				2
			],
			[
				36,
				70
			],
			[
				54,
				76
			],
			[
				107,
				96
			],
			[
				55,
				26
			],
			[
				33,
				34
			],
			[
				59,
				5
			],
			[
				51,
				35
			],
			[
				246,
				242
			],
			[
				100,
				62
			],
			[
				62,
				11
			],
			[
				52,
				15
			],
			[
				88,
				35
			],
			[
				218,
				33
			],
			[
				141,
				14
			],
			[
				45,
				-33
			],
			[
				51,
				9
			],
			[
				43,
				55
			],
			[
				36,
				17
			],
			[
				26,
				-1
			],
			[
				38,
				-65
			],
			[
				18,
				-68
			],
			[
				-12,
				-51
			],
			[
				2,
				-76
			],
			[
				17,
				-99
			],
			[
				-9,
				-87
			],
			[
				-54,
				-115
			],
			[
				-26,
				-47
			],
			[
				-7,
				-48
			],
			[
				5,
				-65
			],
			[
				24,
				-106
			],
			[
				44,
				-147
			],
			[
				7,
				-109
			],
			[
				-31,
				-70
			],
			[
				-14,
				-61
			],
			[
				2,
				-51
			],
			[
				11,
				-36
			],
			[
				20,
				-21
			],
			[
				11,
				-41
			],
			[
				2,
				-61
			],
			[
				26,
				-60
			],
			[
				49,
				-57
			],
			[
				20,
				-55
			],
			[
				-10,
				-52
			],
			[
				3,
				-32
			],
			[
				14,
				-13
			],
			[
				14,
				10
			],
			[
				18,
				15
			],
			[
				16,
				-6
			],
			[
				34,
				-72
			],
			[
				4,
				-15
			],
			[
				19,
				-60
			],
			[
				6,
				-45
			],
			[
				50,
				-26
			],
			[
				55,
				-20
			],
			[
				30,
				-24
			],
			[
				60,
				-72
			],
			[
				51,
				-47
			],
			[
				63,
				-39
			],
			[
				21,
				-62
			],
			[
				39,
				-94
			],
			[
				107,
				-35
			],
			[
				125,
				-18
			],
			[
				80,
				-21
			],
			[
				97,
				50
			],
			[
				64,
				-7
			],
			[
				67,
				-34
			],
			[
				28,
				-23
			],
			[
				50,
				-48
			],
			[
				76,
				-62
			],
			[
				63,
				-23
			],
			[
				44,
				35
			],
			[
				42,
				12
			],
			[
				32,
				-15
			],
			[
				16,
				-67
			],
			[
				17,
				-45
			],
			[
				37,
				-34
			],
			[
				80,
				-88
			],
			[
				45,
				-36
			],
			[
				50,
				2
			],
			[
				105,
				-58
			],
			[
				111,
				-56
			],
			[
				58,
				-9
			],
			[
				57,
				8
			],
			[
				37,
				-21
			],
			[
				15,
				-68
			],
			[
				97,
				-136
			],
			[
				46,
				-53
			],
			[
				54,
				-45
			],
			[
				138,
				1
			],
			[
				42,
				-14
			],
			[
				62,
				12
			],
			[
				185,
				23
			],
			[
				34,
				8
			],
			[
				105,
				-60
			],
			[
				124,
				-84
			],
			[
				82,
				-67
			],
			[
				57,
				-37
			],
			[
				30,
				-60
			],
			[
				25,
				-62
			],
			[
				11,
				-67
			],
			[
				-15,
				-67
			],
			[
				-23,
				-27
			],
			[
				-7,
				-43
			],
			[
				9,
				-64
			],
			[
				41,
				-58
			],
			[
				16,
				-71
			],
			[
				22,
				-125
			],
			[
				25,
				-39
			],
			[
				17,
				-388
			],
			[
				-83,
				-3
			],
			[
				-117,
				-5
			],
			[
				34,
				-37
			],
			[
				97,
				-144
			],
			[
				89,
				-133
			],
			[
				14,
				-214
			],
			[
				9,
				-135
			],
			[
				13,
				-190
			],
			[
				7,
				-113
			],
			[
				223,
				-10
			],
			[
				256,
				-12
			],
			[
				308,
				-14
			],
			[
				271,
				-12
			],
			[
				27,
				1
			],
			[
				47,
				15
			],
			[
				31,
				21
			],
			[
				19,
				-1
			],
			[
				4,
				-46
			],
			[
				-7,
				-58
			],
			[
				0,
				-66
			],
			[
				-77,
				-132
			],
			[
				-5,
				-41
			],
			[
				12,
				-174
			],
			[
				27,
				-140
			],
			[
				14,
				-126
			],
			[
				31,
				-40
			],
			[
				92,
				-67
			],
			[
				139,
				-123
			],
			[
				55,
				-16
			],
			[
				47,
				16
			],
			[
				28,
				-50
			],
			[
				6,
				-81
			],
			[
				76,
				-228
			],
			[
				49,
				-144
			],
			[
				22,
				-50
			],
			[
				37,
				-26
			],
			[
				-7,
				-19
			],
			[
				-31,
				-7
			],
			[
				-13,
				-27
			],
			[
				-42,
				-162
			],
			[
				-56,
				-213
			],
			[
				-37,
				-149
			],
			[
				34,
				-2
			],
			[
				1,
				-42
			],
			[
				8,
				-63
			],
			[
				-42,
				-8
			],
			[
				-12,
				-22
			],
			[
				-48,
				-123
			],
			[
				-63,
				-160
			],
			[
				-65,
				-166
			],
			[
				-38,
				-99
			],
			[
				65,
				-72
			],
			[
				110,
				-121
			],
			[
				-18,
				-34
			],
			[
				-47,
				-17
			],
			[
				-39,
				-12
			],
			[
				-30,
				-45
			],
			[
				-17,
				-34
			],
			[
				-43,
				-11
			]
		],
		[
			[
				45897,
				41958
			],
			[
				-4,
				-54
			],
			[
				-20,
				-21
			],
			[
				-32,
				-5
			],
			[
				-49,
				38
			],
			[
				-36,
				-9
			],
			[
				-35,
				-3
			],
			[
				-50,
				45
			],
			[
				-18,
				44
			],
			[
				-39,
				36
			],
			[
				-81,
				-15
			],
			[
				-68,
				-1
			],
			[
				-56,
				8
			],
			[
				-50,
				-11
			],
			[
				-43,
				-47
			],
			[
				-32,
				-54
			],
			[
				-38,
				-46
			],
			[
				-110,
				-30
			],
			[
				-59,
				-1
			],
			[
				-52,
				-29
			],
			[
				-79,
				-11
			],
			[
				-54,
				-27
			],
			[
				-95,
				-14
			],
			[
				-114,
				-14
			],
			[
				-63,
				-41
			],
			[
				-26,
				-17
			],
			[
				-64,
				-56
			],
			[
				-113,
				-88
			],
			[
				-62,
				-31
			],
			[
				-75,
				-95
			],
			[
				-90,
				-89
			],
			[
				-58,
				-48
			],
			[
				-86,
				-21
			],
			[
				-36,
				-24
			],
			[
				-13,
				-29
			],
			[
				7,
				-34
			],
			[
				-14,
				-86
			],
			[
				-26,
				-159
			],
			[
				-8,
				-77
			],
			[
				-6,
				-38
			],
			[
				-57,
				-127
			],
			[
				-61,
				-119
			],
			[
				-30,
				-79
			],
			[
				-17,
				-57
			],
			[
				19,
				-48
			],
			[
				25,
				-86
			],
			[
				21,
				-69
			],
			[
				5,
				-46
			],
			[
				-7,
				-54
			],
			[
				-26,
				-49
			],
			[
				-40,
				-32
			],
			[
				-55,
				-9
			],
			[
				-113,
				-86
			],
			[
				-126,
				-127
			],
			[
				-41,
				-60
			],
			[
				-12,
				-56
			],
			[
				-18,
				-87
			],
			[
				8,
				-46
			],
			[
				22,
				-31
			],
			[
				23,
				-74
			],
			[
				2,
				-39
			],
			[
				-19,
				-21
			],
			[
				-36,
				-5
			],
			[
				-32,
				-7
			],
			[
				-24,
				-19
			],
			[
				-25,
				5
			],
			[
				-22,
				-10
			],
			[
				0,
				-31
			],
			[
				7,
				-36
			],
			[
				-3,
				-38
			],
			[
				-15,
				-24
			],
			[
				-13,
				-17
			],
			[
				13,
				-24
			],
			[
				22,
				-22
			],
			[
				34,
				-36
			],
			[
				47,
				-69
			],
			[
				36,
				-12
			],
			[
				30,
				-24
			],
			[
				3,
				-38
			],
			[
				-11,
				-38
			],
			[
				-26,
				-17
			],
			[
				-2,
				-34
			],
			[
				36,
				-40
			],
			[
				24,
				-29
			],
			[
				24,
				-43
			],
			[
				23,
				-60
			],
			[
				0,
				-38
			],
			[
				24,
				-48
			],
			[
				15,
				-41
			],
			[
				0,
				-38
			],
			[
				40,
				-39
			],
			[
				33,
				-28
			],
			[
				25,
				-27
			],
			[
				24,
				-16
			],
			[
				6,
				-29
			],
			[
				-3,
				-44
			],
			[
				35,
				-72
			],
			[
				64,
				-53
			],
			[
				52,
				-79
			],
			[
				33,
				-56
			],
			[
				63,
				-91
			],
			[
				2,
				-105
			],
			[
				-77,
				-120
			],
			[
				-77,
				-120
			],
			[
				126,
				3
			],
			[
				129,
				-2
			],
			[
				135,
				-35
			],
			[
				91,
				-33
			],
			[
				55,
				-15
			],
			[
				40,
				-38
			],
			[
				18,
				-60
			],
			[
				15,
				-49
			],
			[
				4,
				-70
			],
			[
				56,
				-58
			],
			[
				-4,
				-54
			],
			[
				-1,
				-78
			],
			[
				25,
				-1
			],
			[
				165,
				0
			],
			[
				180,
				-1
			],
			[
				174,
				15
			],
			[
				66,
				18
			],
			[
				79,
				94
			],
			[
				47,
				28
			],
			[
				46,
				44
			],
			[
				56,
				79
			],
			[
				44,
				36
			],
			[
				37,
				45
			],
			[
				56,
				44
			],
			[
				23,
				33
			],
			[
				19,
				12
			],
			[
				43,
				21
			],
			[
				-19,
				-43
			],
			[
				-14,
				-44
			],
			[
				-5,
				-64
			],
			[
				21,
				-69
			],
			[
				-17,
				-52
			],
			[
				-28,
				-46
			],
			[
				-1,
				-122
			],
			[
				0,
				-173
			],
			[
				-1,
				-148
			],
			[
				0,
				-186
			],
			[
				-1,
				-210
			],
			[
				-1,
				-140
			],
			[
				30,
				28
			],
			[
				41,
				25
			],
			[
				53,
				-65
			],
			[
				38,
				-28
			],
			[
				32,
				-6
			],
			[
				34,
				2
			],
			[
				45,
				13
			],
			[
				100,
				54
			],
			[
				68,
				44
			],
			[
				78,
				-3
			],
			[
				107,
				-17
			],
			[
				62,
				2
			]
		],
		[
			[
				50624,
				27116
			],
			[
				14,
				41
			],
			[
				40,
				161
			],
			[
				58,
				233
			],
			[
				59,
				242
			],
			[
				70,
				286
			],
			[
				1,
				202
			],
			[
				0,
				213
			],
			[
				100,
				175
			],
			[
				71,
				125
			],
			[
				61,
				118
			],
			[
				62,
				203
			],
			[
				41,
				135
			],
			[
				159,
				32
			],
			[
				268,
				71
			],
			[
				134,
				35
			],
			[
				283,
				74
			],
			[
				287,
				75
			],
			[
				301,
				5
			],
			[
				291,
				4
			],
			[
				226,
				-168
			],
			[
				172,
				-128
			],
			[
				190,
				-142
			],
			[
				13,
				-31
			],
			[
				13,
				-118
			],
			[
				-13,
				-137
			]
		],
		[
			[
				80088,
				62610
			],
			[
				-10,
				76
			],
			[
				14,
				90
			],
			[
				24,
				111
			],
			[
				26,
				154
			],
			[
				83,
				0
			],
			[
				148,
				0
			],
			[
				148,
				1
			],
			[
				149,
				0
			],
			[
				148,
				0
			],
			[
				148,
				0
			],
			[
				148,
				0
			],
			[
				148,
				1
			],
			[
				148,
				0
			],
			[
				148,
				0
			],
			[
				149,
				0
			],
			[
				148,
				1
			],
			[
				148,
				0
			],
			[
				148,
				0
			],
			[
				148,
				0
			],
			[
				148,
				0
			],
			[
				149,
				1
			],
			[
				97,
				0
			],
			[
				-5,
				109
			],
			[
				-5,
				87
			],
			[
				-6,
				117
			],
			[
				-6,
				116
			],
			[
				-6,
				117
			],
			[
				-6,
				109
			],
			[
				-6,
				109
			],
			[
				-5,
				101
			],
			[
				-5,
				93
			],
			[
				-9,
				54
			],
			[
				-31,
				106
			],
			[
				-7,
				52
			],
			[
				9,
				56
			],
			[
				21,
				52
			],
			[
				57,
				96
			],
			[
				88,
				74
			],
			[
				101,
				85
			],
			[
				77,
				65
			],
			[
				39,
				16
			],
			[
				121,
				22
			],
			[
				95,
				49
			],
			[
				92,
				48
			],
			[
				39,
				26
			],
			[
				4,
				90
			],
			[
				0,
				100
			],
			[
				0,
				113
			],
			[
				0,
				112
			],
			[
				0,
				112
			],
			[
				0,
				112
			],
			[
				0,
				113
			],
			[
				0,
				112
			],
			[
				0,
				112
			],
			[
				0,
				113
			],
			[
				0,
				112
			],
			[
				0,
				112
			],
			[
				0,
				112
			],
			[
				0,
				113
			],
			[
				0,
				112
			],
			[
				0,
				112
			],
			[
				0,
				112
			],
			[
				0,
				113
			],
			[
				0,
				98
			],
			[
				97,
				0
			],
			[
				120,
				0
			],
			[
				121,
				0
			],
			[
				120,
				0
			],
			[
				121,
				0
			],
			[
				120,
				0
			],
			[
				120,
				0
			],
			[
				121,
				0
			],
			[
				120,
				0
			],
			[
				120,
				0
			],
			[
				121,
				0
			],
			[
				120,
				0
			],
			[
				121,
				0
			],
			[
				120,
				0
			],
			[
				120,
				0
			],
			[
				121,
				0
			],
			[
				120,
				0
			],
			[
				132,
				0
			],
			[
				0,
				94
			],
			[
				0,
				135
			],
			[
				-1,
				185
			],
			[
				0,
				186
			],
			[
				0,
				164
			],
			[
				0,
				163
			],
			[
				0,
				137
			]
		],
		[
			[
				85493,
				67953
			],
			[
				121,
				-91
			],
			[
				122,
				-91
			],
			[
				121,
				-91
			],
			[
				122,
				-92
			],
			[
				121,
				-91
			],
			[
				122,
				-91
			],
			[
				121,
				-91
			],
			[
				122,
				-91
			],
			[
				121,
				-92
			],
			[
				122,
				-91
			],
			[
				121,
				-91
			],
			[
				122,
				-91
			],
			[
				121,
				-91
			],
			[
				122,
				-92
			],
			[
				121,
				-91
			],
			[
				122,
				-91
			],
			[
				102,
				-76
			],
			[
				156,
				-123
			],
			[
				146,
				-115
			],
			[
				146,
				-116
			]
		],
		[
			[
				85493,
				68259
			],
			[
				0,
				201
			],
			[
				0,
				175
			],
			[
				0,
				174
			],
			[
				0,
				120
			],
			[
				0,
				125
			],
			[
				3,
				57
			],
			[
				12,
				24
			],
			[
				66,
				40
			],
			[
				102,
				93
			],
			[
				38,
				41
			],
			[
				49,
				42
			],
			[
				172,
				125
			],
			[
				36,
				35
			],
			[
				167,
				144
			],
			[
				39,
				21
			],
			[
				90,
				14
			],
			[
				37,
				27
			],
			[
				50,
				58
			],
			[
				75,
				66
			],
			[
				48,
				31
			],
			[
				11,
				6
			],
			[
				31,
				4
			],
			[
				155,
				-19
			],
			[
				65,
				-15
			],
			[
				77,
				-12
			],
			[
				24,
				8
			],
			[
				21,
				21
			],
			[
				29,
				46
			],
			[
				7,
				55
			],
			[
				1,
				47
			],
			[
				5,
				21
			],
			[
				14,
				9
			],
			[
				33,
				-3
			],
			[
				46,
				-7
			],
			[
				92,
				2
			],
			[
				31,
				7
			],
			[
				105,
				10
			],
			[
				148,
				31
			],
			[
				117,
				41
			],
			[
				94,
				32
			],
			[
				100,
				84
			],
			[
				73,
				89
			],
			[
				77,
				132
			],
			[
				60,
				114
			],
			[
				123,
				72
			],
			[
				102,
				43
			],
			[
				59,
				17
			],
			[
				133,
				61
			],
			[
				113,
				91
			],
			[
				105,
				86
			],
			[
				81,
				11
			],
			[
				102,
				14
			],
			[
				23,
				17
			],
			[
				26,
				30
			],
			[
				1,
				53
			],
			[
				-31,
				38
			],
			[
				-37,
				20
			],
			[
				-26,
				22
			],
			[
				-27,
				4
			],
			[
				-14,
				25
			],
			[
				8,
				48
			],
			[
				4,
				44
			],
			[
				17,
				44
			],
			[
				-5,
				62
			],
			[
				-26,
				62
			],
			[
				-8,
				44
			],
			[
				2,
				44
			],
			[
				13,
				35
			],
			[
				38,
				23
			],
			[
				43,
				9
			],
			[
				62,
				-11
			],
			[
				107,
				14
			],
			[
				273,
				107
			],
			[
				19,
				33
			],
			[
				17,
				74
			],
			[
				20,
				65
			],
			[
				28,
				22
			],
			[
				15,
				4
			],
			[
				91,
				18
			],
			[
				129,
				24
			],
			[
				48,
				4
			],
			[
				141,
				-7
			],
			[
				102,
				-5
			],
			[
				165,
				-9
			],
			[
				118,
				-4
			],
			[
				102,
				-4
			],
			[
				130,
				-5
			]
		],
		[
			[
				85493,
				67953
			],
			[
				0,
				169
			],
			[
				0,
				137
			]
		],
		[
			[
				83169,
				57664
			],
			[
				-15,
				6
			],
			[
				-68,
				60
			],
			[
				-33,
				70
			],
			[
				-54,
				54
			],
			[
				-75,
				35
			],
			[
				-49,
				41
			],
			[
				-23,
				45
			],
			[
				-28,
				31
			],
			[
				-29,
				15
			],
			[
				-2,
				17
			],
			[
				6,
				22
			],
			[
				-7,
				42
			],
			[
				-44,
				93
			],
			[
				-41,
				43
			],
			[
				-35,
				-7
			],
			[
				-19,
				11
			],
			[
				-12,
				21
			],
			[
				-5,
				30
			],
			[
				-24,
				26
			],
			[
				-42,
				11
			],
			[
				-33,
				69
			],
			[
				-25,
				127
			],
			[
				-33,
				98
			],
			[
				-40,
				71
			],
			[
				-29,
				26
			],
			[
				-21,
				5
			],
			[
				-7,
				11
			],
			[
				-6,
				21
			],
			[
				-31,
				7
			],
			[
				-44,
				-21
			],
			[
				-40,
				7
			],
			[
				-19,
				34
			],
			[
				-27,
				3
			],
			[
				-34,
				-28
			],
			[
				-38,
				8
			],
			[
				-42,
				45
			],
			[
				-23,
				45
			],
			[
				-4,
				45
			],
			[
				-72,
				88
			],
			[
				-138,
				134
			],
			[
				-151,
				62
			],
			[
				-164,
				-8
			],
			[
				-91,
				6
			],
			[
				-20,
				21
			],
			[
				-20,
				-2
			],
			[
				-21,
				-24
			],
			[
				-21,
				-5
			],
			[
				-23,
				13
			],
			[
				-14,
				-10
			],
			[
				-6,
				-34
			],
			[
				-57,
				-18
			],
			[
				-110,
				0
			],
			[
				-88,
				-21
			],
			[
				-68,
				-41
			],
			[
				-95,
				-18
			],
			[
				-123,
				6
			],
			[
				-74,
				15
			],
			[
				-26,
				24
			],
			[
				-35,
				6
			],
			[
				-46,
				-13
			],
			[
				-41,
				-66
			],
			[
				-36,
				-119
			],
			[
				-30,
				-68
			],
			[
				-24,
				-16
			],
			[
				-25,
				-89
			],
			[
				-14,
				-148
			],
			[
				-21,
				-65
			]
		],
		[
			[
				87987,
				66064
			],
			[
				-226,
				0
			],
			[
				-302,
				0
			],
			[
				-206,
				0
			],
			[
				-212,
				0
			],
			[
				-198,
				0
			],
			[
				17,
				-188
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-206
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-205
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-205
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-205
			],
			[
				18,
				-205
			],
			[
				19,
				-206
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-205
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-205
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				18,
				-205
			],
			[
				19,
				-205
			],
			[
				17,
				-199
			],
			[
				77,
				-104
			],
			[
				97,
				-132
			],
			[
				-28,
				-185
			],
			[
				-34,
				-222
			],
			[
				-36,
				-241
			],
			[
				-137,
				0
			],
			[
				-132,
				0
			],
			[
				-132,
				0
			],
			[
				-131,
				0
			],
			[
				-132,
				0
			],
			[
				-132,
				0
			],
			[
				-132,
				0
			],
			[
				-131,
				0
			],
			[
				-132,
				0
			],
			[
				-132,
				0
			],
			[
				-132,
				0
			],
			[
				-132,
				0
			],
			[
				-131,
				0
			],
			[
				-132,
				0
			],
			[
				-132,
				0
			],
			[
				-132,
				-1
			],
			[
				-131,
				0
			],
			[
				-123,
				0
			],
			[
				-76,
				6
			],
			[
				-27,
				19
			],
			[
				-9,
				125
			],
			[
				-23,
				-8
			],
			[
				-26,
				-37
			],
			[
				-14,
				-40
			],
			[
				5,
				-52
			],
			[
				-5,
				-44
			],
			[
				-84,
				-17
			],
			[
				-115,
				-30
			],
			[
				-120,
				-22
			],
			[
				-122,
				8
			],
			[
				-41,
				10
			],
			[
				-44,
				16
			],
			[
				-97,
				18
			],
			[
				-53,
				2
			],
			[
				-60,
				-4
			],
			[
				-71,
				-10
			],
			[
				-23,
				-23
			],
			[
				-54,
				-93
			],
			[
				-52,
				-109
			],
			[
				-34,
				1
			],
			[
				-38,
				59
			],
			[
				-104,
				112
			],
			[
				-127,
				147
			],
			[
				-58,
				73
			],
			[
				-31,
				10
			],
			[
				-61,
				-53
			],
			[
				-51,
				-50
			],
			[
				-54,
				-72
			],
			[
				-25,
				-68
			],
			[
				-19,
				-81
			],
			[
				-9,
				-95
			],
			[
				-20,
				-111
			],
			[
				-44,
				-89
			],
			[
				-52,
				-68
			],
			[
				-39,
				-31
			],
			[
				-15,
				-18
			],
			[
				-113,
				53
			]
		],
		[
			[
				93835,
				61238
			],
			[
				-205,
				-49
			],
			[
				-147,
				-35
			],
			[
				-158,
				-37
			],
			[
				-24,
				-6
			],
			[
				-29,
				-2
			],
			[
				-21,
				1
			],
			[
				-44,
				21
			],
			[
				-53,
				49
			],
			[
				-35,
				25
			],
			[
				-9,
				39
			],
			[
				21,
				51
			],
			[
				25,
				46
			],
			[
				10,
				36
			],
			[
				17,
				28
			],
			[
				23,
				22
			],
			[
				1,
				32
			],
			[
				-19,
				52
			],
			[
				-16,
				71
			],
			[
				1,
				130
			],
			[
				0,
				44
			],
			[
				0,
				15
			],
			[
				-47,
				50
			],
			[
				-89,
				55
			],
			[
				-82,
				32
			],
			[
				-38,
				12
			],
			[
				-90,
				19
			],
			[
				-125,
				35
			],
			[
				-44,
				23
			],
			[
				-81,
				121
			],
			[
				-40,
				31
			],
			[
				-188,
				21
			],
			[
				-62,
				20
			],
			[
				-51,
				28
			],
			[
				-44,
				39
			],
			[
				-24,
				66
			],
			[
				-8,
				54
			],
			[
				-16,
				26
			],
			[
				-207,
				130
			],
			[
				-53,
				45
			],
			[
				-28,
				41
			],
			[
				-1,
				61
			],
			[
				6,
				75
			],
			[
				-9,
				66
			],
			[
				-9,
				33
			],
			[
				-94,
				79
			],
			[
				-212,
				176
			],
			[
				-211,
				177
			],
			[
				-212,
				176
			],
			[
				-211,
				177
			],
			[
				-212,
				176
			],
			[
				-212,
				177
			],
			[
				-211,
				177
			],
			[
				-212,
				176
			],
			[
				-211,
				177
			],
			[
				-212,
				176
			],
			[
				-212,
				177
			],
			[
				-211,
				176
			],
			[
				-212,
				177
			],
			[
				-211,
				177
			],
			[
				-212,
				176
			],
			[
				-211,
				177
			],
			[
				-179,
				149
			],
			[
				-198,
				157
			]
		],
		[
			[
				93835,
				61238
			],
			[
				141,
				34
			],
			[
				145,
				36
			],
			[
				214,
				52
			],
			[
				231,
				57
			],
			[
				251,
				61
			],
			[
				57,
				37
			],
			[
				190,
				209
			],
			[
				86,
				94
			],
			[
				170,
				187
			],
			[
				132,
				144
			],
			[
				167,
				184
			],
			[
				177,
				184
			],
			[
				141,
				148
			],
			[
				222,
				167
			],
			[
				335,
				251
			],
			[
				334,
				252
			],
			[
				335,
				252
			],
			[
				335,
				252
			],
			[
				334,
				252
			],
			[
				335,
				251
			],
			[
				334,
				252
			],
			[
				335,
				252
			]
		],
		[
			[
				97253,
				70381
			],
			[
				-39,
				194
			],
			[
				-33,
				166
			],
			[
				-28,
				137
			],
			[
				-49,
				242
			],
			[
				-41,
				204
			],
			[
				-41,
				205
			],
			[
				-38,
				185
			],
			[
				-37,
				187
			],
			[
				-17,
				27
			],
			[
				-113,
				88
			],
			[
				-104,
				81
			],
			[
				-108,
				92
			],
			[
				-117,
				100
			],
			[
				-19,
				126
			],
			[
				-61,
				190
			],
			[
				-63,
				106
			],
			[
				-24,
				28
			],
			[
				-128,
				68
			],
			[
				-74,
				51
			],
			[
				-20,
				29
			],
			[
				-15,
				77
			],
			[
				-53,
				154
			],
			[
				-60,
				140
			],
			[
				-22,
				94
			],
			[
				-3,
				119
			],
			[
				12,
				86
			],
			[
				26,
				36
			],
			[
				126,
				107
			],
			[
				58,
				129
			],
			[
				71,
				48
			],
			[
				63,
				36
			],
			[
				50,
				42
			],
			[
				45,
				68
			],
			[
				34,
				73
			],
			[
				6,
				78
			],
			[
				14,
				124
			],
			[
				23,
				87
			],
			[
				53,
				98
			],
			[
				-22,
				79
			],
			[
				-28,
				85
			],
			[
				8,
				148
			],
			[
				-7,
				60
			],
			[
				-23,
				53
			],
			[
				-23,
				68
			],
			[
				-1,
				57
			],
			[
				22,
				149
			],
			[
				17,
				113
			],
			[
				27,
				148
			],
			[
				-9,
				41
			],
			[
				-20,
				31
			],
			[
				-61,
				33
			],
			[
				-1,
				20
			],
			[
				15,
				21
			],
			[
				90,
				72
			],
			[
				48,
				106
			],
			[
				41,
				22
			],
			[
				61,
				38
			],
			[
				-3,
				41
			],
			[
				-13,
				44
			]
		],
		[
			[
				106597,
				61530
			],
			[
				-309,
				195
			],
			[
				-310,
				195
			],
			[
				-309,
				195
			],
			[
				-310,
				195
			],
			[
				-309,
				195
			],
			[
				-310,
				195
			],
			[
				-310,
				195
			],
			[
				-309,
				195
			],
			[
				-310,
				196
			],
			[
				-309,
				195
			],
			[
				-310,
				195
			],
			[
				-309,
				195
			],
			[
				-310,
				195
			],
			[
				-309,
				195
			],
			[
				-310,
				195
			],
			[
				-309,
				195
			],
			[
				-214,
				135
			],
			[
				-231,
				-132
			],
			[
				-181,
				-103
			],
			[
				-238,
				-136
			]
		],
		[
			[
				107243,
				63591
			],
			[
				0,
				-411
			],
			[
				0,
				-411
			],
			[
				0,
				-411
			],
			[
				0,
				-411
			],
			[
				-2,
				-2
			],
			[
				-2,
				-1
			],
			[
				-2,
				-2
			],
			[
				-2,
				-1
			],
			[
				-160,
				0
			],
			[
				-159,
				0
			],
			[
				-159,
				0
			],
			[
				-160,
				0
			],
			[
				0,
				-103
			],
			[
				0,
				-102
			],
			[
				0,
				-103
			],
			[
				0,
				-103
			]
		],
		[
			[
				107353,
				71556
			],
			[
				-25,
				-23
			],
			[
				-35,
				-49
			],
			[
				-22,
				-44
			],
			[
				-60,
				-71
			],
			[
				-50,
				-77
			],
			[
				5,
				-112
			],
			[
				11,
				-113
			],
			[
				33,
				-111
			],
			[
				29,
				-124
			],
			[
				-8,
				-81
			],
			[
				-25,
				-99
			],
			[
				-29,
				-83
			],
			[
				-98,
				-171
			],
			[
				-15,
				-41
			],
			[
				6,
				-57
			],
			[
				59,
				-202
			],
			[
				5,
				-64
			],
			[
				35,
				-197
			],
			[
				33,
				-160
			],
			[
				36,
				-126
			],
			[
				5,
				-34
			],
			[
				0,
				-185
			],
			[
				0,
				-186
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-186
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-186
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-186
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-186
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-186
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			],
			[
				0,
				-185
			]
		],
		[
			[
				105873,
				54456
			],
			[
				23,
				91
			],
			[
				28,
				134
			],
			[
				3,
				62
			],
			[
				-13,
				64
			],
			[
				-48,
				48
			],
			[
				-42,
				6
			],
			[
				-19,
				24
			],
			[
				-37,
				36
			],
			[
				-36,
				27
			],
			[
				-32,
				53
			],
			[
				-23,
				74
			],
			[
				16,
				264
			],
			[
				-11,
				36
			],
			[
				-48,
				9
			],
			[
				-11,
				19
			],
			[
				2,
				51
			],
			[
				-26,
				151
			],
			[
				-29,
				124
			],
			[
				16,
				69
			],
			[
				-41,
				94
			],
			[
				-76,
				40
			],
			[
				-73,
				-12
			],
			[
				-78,
				-19
			],
			[
				-47,
				6
			],
			[
				-32,
				17
			],
			[
				-23,
				35
			],
			[
				-11,
				40
			],
			[
				10,
				61
			],
			[
				43,
				113
			],
			[
				53,
				92
			],
			[
				109,
				84
			],
			[
				29,
				45
			],
			[
				16,
				50
			],
			[
				3,
				57
			],
			[
				-7,
				60
			],
			[
				-13,
				55
			],
			[
				-32,
				73
			],
			[
				-29,
				85
			],
			[
				0,
				58
			],
			[
				14,
				41
			],
			[
				29,
				50
			],
			[
				57,
				56
			],
			[
				14,
				11
			],
			[
				36,
				30
			],
			[
				32,
				22
			],
			[
				78,
				60
			],
			[
				19,
				28
			],
			[
				-7,
				34
			],
			[
				-19,
				28
			],
			[
				-32,
				39
			],
			[
				-6,
				48
			],
			[
				-10,
				82
			],
			[
				-16,
				51
			],
			[
				-12,
				39
			],
			[
				23,
				28
			],
			[
				33,
				40
			],
			[
				41,
				24
			],
			[
				65,
				21
			],
			[
				25,
				28
			],
			[
				8,
				55
			],
			[
				-2,
				52
			],
			[
				23,
				39
			],
			[
				31,
				82
			],
			[
				25,
				38
			],
			[
				42,
				43
			],
			[
				42,
				54
			],
			[
				19,
				63
			],
			[
				5,
				60
			],
			[
				-23,
				183
			],
			[
				49,
				76
			],
			[
				62,
				64
			],
			[
				89,
				-5
			],
			[
				139,
				14
			],
			[
				94,
				27
			],
			[
				67,
				-1
			],
			[
				154,
				-34
			],
			[
				12,
				8
			],
			[
				4,
				6
			],
			[
				8,
				49
			],
			[
				0,
				122
			],
			[
				0,
				368
			],
			[
				0,
				367
			],
			[
				-1,
				368
			],
			[
				0,
				368
			],
			[
				0,
				368
			],
			[
				0,
				368
			],
			[
				-1,
				368
			],
			[
				0,
				368
			]
		],
		[
			[
				107243,
				63591
			],
			[
				247,
				0
			],
			[
				247,
				0
			],
			[
				247,
				0
			],
			[
				247,
				-1
			],
			[
				246,
				0
			],
			[
				247,
				0
			],
			[
				247,
				0
			],
			[
				247,
				0
			],
			[
				247,
				0
			],
			[
				247,
				0
			],
			[
				246,
				0
			],
			[
				247,
				0
			],
			[
				247,
				0
			],
			[
				247,
				0
			],
			[
				247,
				0
			],
			[
				247,
				0
			],
			[
				75,
				0
			],
			[
				33,
				6
			],
			[
				63,
				154
			],
			[
				27,
				11
			],
			[
				42,
				-9
			],
			[
				14,
				-36
			],
			[
				-13,
				-52
			],
			[
				-21,
				-73
			],
			[
				121,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			],
			[
				212,
				0
			]
		],
		[
			[
				118165,
				48732
			],
			[
				-79,
				-146
			],
			[
				-96,
				-174
			],
			[
				-175,
				-320
			],
			[
				-134,
				-169
			],
			[
				-101,
				-128
			],
			[
				-9,
				-23
			],
			[
				0,
				-142
			],
			[
				1,
				-347
			],
			[
				1,
				-348
			],
			[
				1,
				-347
			],
			[
				2,
				-348
			],
			[
				1,
				-347
			],
			[
				1,
				-348
			],
			[
				1,
				-347
			],
			[
				1,
				-348
			],
			[
				0,
				-116
			],
			[
				89,
				-147
			],
			[
				86,
				-142
			],
			[
				115,
				-189
			],
			[
				61,
				-101
			],
			[
				10,
				-34
			],
			[
				-3,
				-68
			]
		],
		[
			[
				118836,
				54522
			],
			[
				-11,
				-32
			],
			[
				-27,
				-47
			],
			[
				-35,
				-47
			],
			[
				-30,
				-49
			],
			[
				-67,
				-137
			],
			[
				-2,
				-17
			],
			[
				8,
				-27
			],
			[
				37,
				-63
			],
			[
				37,
				-100
			],
			[
				21,
				-93
			],
			[
				17,
				-45
			],
			[
				46,
				-51
			],
			[
				66,
				-106
			],
			[
				35,
				-71
			],
			[
				72,
				-38
			],
			[
				24,
				-91
			],
			[
				55,
				-132
			],
			[
				59,
				-107
			],
			[
				57,
				-83
			],
			[
				63,
				-32
			],
			[
				26,
				-2
			],
			[
				133,
				-154
			],
			[
				102,
				-117
			],
			[
				25,
				-19
			],
			[
				183,
				-77
			],
			[
				211,
				-88
			],
			[
				169,
				-71
			],
			[
				215,
				-90
			],
			[
				212,
				-89
			],
			[
				199,
				-85
			],
			[
				280,
				-120
			],
			[
				225,
				-96
			],
			[
				178,
				-76
			],
			[
				37,
				-24
			],
			[
				212,
				0
			],
			[
				215,
				0
			],
			[
				220,
				0
			]
		],
		[
			[
				110972,
				38694
			],
			[
				-112,
				-22
			],
			[
				-162,
				-31
			],
			[
				-178,
				-35
			],
			[
				-184,
				-36
			],
			[
				-183,
				-35
			],
			[
				-173,
				-34
			],
			[
				-157,
				-31
			],
			[
				-48,
				-17
			],
			[
				23,
				-86
			],
			[
				-11,
				-91
			],
			[
				-31,
				-70
			],
			[
				-49,
				-87
			],
			[
				-22,
				-34
			],
			[
				-50,
				-68
			],
			[
				-42,
				-47
			],
			[
				-86,
				-81
			],
			[
				-54,
				-45
			],
			[
				0,
				-42
			],
			[
				91,
				-194
			],
			[
				41,
				-139
			],
			[
				17,
				-125
			],
			[
				-1,
				-73
			],
			[
				-4,
				-148
			],
			[
				-4,
				-177
			],
			[
				-6,
				-69
			],
			[
				24,
				-126
			],
			[
				-4,
				-98
			],
			[
				-61,
				-110
			],
			[
				-17,
				-108
			],
			[
				-31,
				-146
			],
			[
				-42,
				-201
			],
			[
				-31,
				-107
			],
			[
				17,
				-69
			],
			[
				15,
				-46
			],
			[
				16,
				-62
			],
			[
				33,
				-94
			],
			[
				38,
				-55
			],
			[
				22,
				-24
			],
			[
				126,
				-118
			],
			[
				52,
				-57
			],
			[
				79,
				-114
			],
			[
				59,
				-75
			],
			[
				82,
				-17
			],
			[
				99,
				-29
			],
			[
				54,
				-22
			],
			[
				37,
				11
			],
			[
				13,
				27
			],
			[
				-2,
				56
			],
			[
				-7,
				42
			],
			[
				11,
				32
			],
			[
				33,
				21
			],
			[
				86,
				4
			],
			[
				37,
				28
			],
			[
				29,
				7
			],
			[
				0,
				-124
			],
			[
				0,
				-120
			],
			[
				1,
				-144
			],
			[
				0,
				-166
			],
			[
				0,
				-136
			],
			[
				0,
				-145
			],
			[
				0,
				-166
			],
			[
				-1,
				-19
			],
			[
				-13,
				-38
			],
			[
				-34,
				-13
			],
			[
				-45,
				33
			],
			[
				-3,
				34
			],
			[
				-11,
				61
			],
			[
				-22,
				32
			],
			[
				-27,
				9
			],
			[
				-47,
				-16
			],
			[
				-65,
				-45
			],
			[
				-83,
				-39
			],
			[
				-33,
				-23
			],
			[
				-58,
				3
			],
			[
				-63,
				21
			],
			[
				-47,
				51
			],
			[
				-13,
				76
			],
			[
				-41,
				79
			],
			[
				-55,
				113
			],
			[
				-28,
				47
			],
			[
				-37,
				53
			],
			[
				-37,
				6
			],
			[
				-42,
				15
			],
			[
				-25,
				77
			],
			[
				-24,
				98
			],
			[
				-15,
				38
			],
			[
				-25,
				49
			],
			[
				-36,
				30
			],
			[
				-77,
				39
			],
			[
				-109,
				54
			],
			[
				-137,
				69
			],
			[
				-65,
				3
			],
			[
				-72,
				12
			],
			[
				-46,
				33
			],
			[
				-26,
				26
			],
			[
				-30,
				95
			],
			[
				-41,
				112
			],
			[
				-120,
				133
			],
			[
				-27,
				147
			],
			[
				-24,
				21
			],
			[
				-41,
				-12
			],
			[
				-32,
				-18
			],
			[
				-13,
				-40
			],
			[
				-32,
				-132
			],
			[
				-17,
				-61
			],
			[
				-12,
				-17
			],
			[
				-26,
				-20
			],
			[
				-43,
				-18
			],
			[
				-61,
				-9
			],
			[
				-87,
				3
			],
			[
				-107,
				20
			],
			[
				-58,
				15
			],
			[
				-158,
				22
			],
			[
				-45,
				11
			],
			[
				-64,
				28
			],
			[
				-47,
				29
			],
			[
				-152,
				63
			],
			[
				-69,
				-8
			],
			[
				-34,
				45
			],
			[
				-30,
				21
			],
			[
				-41,
				42
			],
			[
				-19,
				57
			],
			[
				-24,
				123
			],
			[
				6,
				65
			],
			[
				17,
				73
			],
			[
				-19,
				21
			],
			[
				-28,
				0
			],
			[
				-40,
				-26
			],
			[
				-70,
				-14
			],
			[
				-129,
				-32
			],
			[
				-45,
				-18
			],
			[
				-51,
				-14
			],
			[
				-38,
				-12
			],
			[
				-97,
				-71
			],
			[
				-34,
				-7
			],
			[
				-57,
				25
			],
			[
				-28,
				38
			],
			[
				28,
				42
			],
			[
				12,
				53
			],
			[
				-20,
				104
			],
			[
				-29,
				48
			],
			[
				-86,
				34
			],
			[
				-33,
				3
			],
			[
				-14,
				58
			],
			[
				-23,
				53
			],
			[
				-49,
				10
			],
			[
				-24,
				6
			]
		],
		[
			[
				106210,
				30903
			],
			[
				-129,
				137
			],
			[
				-146,
				156
			],
			[
				-151,
				174
			],
			[
				-114,
				136
			],
			[
				-55,
				78
			],
			[
				-100,
				104
			],
			[
				-72,
				50
			],
			[
				-28,
				26
			],
			[
				-71,
				276
			],
			[
				-39,
				253
			],
			[
				0,
				191
			],
			[
				0,
				265
			],
			[
				0,
				264
			],
			[
				-1,
				265
			],
			[
				0,
				264
			],
			[
				0,
				265
			],
			[
				0,
				265
			],
			[
				0,
				264
			],
			[
				0,
				265
			],
			[
				0,
				129
			],
			[
				149,
				0
			],
			[
				169,
				0
			],
			[
				177,
				0
			],
			[
				192,
				0
			],
			[
				192,
				0
			],
			[
				192,
				0
			],
			[
				134,
				0
			],
			[
				35,
				2
			],
			[
				42,
				8
			],
			[
				3,
				26
			],
			[
				-55,
				130
			],
			[
				3,
				46
			],
			[
				14,
				88
			],
			[
				23,
				77
			],
			[
				30,
				100
			],
			[
				4,
				59
			],
			[
				-25,
				192
			],
			[
				3,
				107
			],
			[
				7,
				111
			],
			[
				7,
				106
			],
			[
				-9,
				73
			],
			[
				10,
				40
			],
			[
				18,
				58
			],
			[
				10,
				65
			],
			[
				11,
				27
			],
			[
				-3,
				26
			],
			[
				-11,
				48
			],
			[
				-10,
				108
			],
			[
				-14,
				150
			],
			[
				-14,
				108
			]
		],
		[
			[
				113009,
				44625
			],
			[
				-3,
				140
			],
			[
				16,
				358
			],
			[
				-2,
				314
			],
			[
				14,
				158
			],
			[
				61,
				99
			],
			[
				28,
				73
			],
			[
				20,
				101
			],
			[
				32,
				82
			],
			[
				72,
				67
			],
			[
				13,
				37
			],
			[
				77,
				112
			],
			[
				45,
				145
			],
			[
				35,
				49
			],
			[
				43,
				45
			],
			[
				30,
				24
			],
			[
				51,
				24
			],
			[
				39,
				13
			],
			[
				7,
				12
			],
			[
				3,
				23
			],
			[
				-13,
				89
			],
			[
				17,
				30
			],
			[
				27,
				59
			],
			[
				31,
				56
			],
			[
				27,
				35
			],
			[
				16,
				36
			],
			[
				7,
				63
			],
			[
				1,
				45
			],
			[
				0,
				73
			],
			[
				-9,
				165
			],
			[
				-32,
				138
			],
			[
				-20,
				155
			],
			[
				14,
				51
			],
			[
				-25,
				91
			],
			[
				-13,
				5
			],
			[
				-21,
				20
			],
			[
				-26,
				85
			],
			[
				-20,
				78
			],
			[
				-13,
				20
			],
			[
				-86,
				68
			],
			[
				-43,
				161
			],
			[
				-49,
				36
			],
			[
				-26,
				160
			],
			[
				-5,
				46
			],
			[
				28,
				159
			],
			[
				-3,
				37
			],
			[
				-29,
				34
			],
			[
				-81,
				34
			],
			[
				-66,
				66
			],
			[
				8,
				23
			],
			[
				5,
				24
			],
			[
				-35,
				16
			],
			[
				-100,
				273
			]
		],
		[
			[
				113009,
				44625
			],
			[
				49,
				0
			],
			[
				46,
				-31
			],
			[
				52,
				-37
			],
			[
				138,
				-98
			],
			[
				138,
				-98
			],
			[
				137,
				-99
			],
			[
				138,
				-98
			],
			[
				138,
				-98
			],
			[
				137,
				-98
			],
			[
				138,
				-98
			],
			[
				138,
				-98
			],
			[
				138,
				-98
			],
			[
				137,
				-99
			],
			[
				138,
				-98
			],
			[
				138,
				-98
			],
			[
				137,
				-98
			],
			[
				138,
				-98
			],
			[
				138,
				-98
			],
			[
				138,
				-98
			],
			[
				65,
				-47
			],
			[
				10,
				-21
			],
			[
				12,
				-89
			],
			[
				7,
				-56
			],
			[
				-4,
				-49
			],
			[
				-37,
				-84
			],
			[
				-10,
				-43
			],
			[
				-1,
				-31
			],
			[
				9,
				-12
			],
			[
				31,
				-4
			],
			[
				27,
				-20
			],
			[
				10,
				-15
			],
			[
				20,
				-63
			],
			[
				25,
				-32
			],
			[
				59,
				-53
			],
			[
				99,
				-92
			],
			[
				99,
				-91
			],
			[
				99,
				-91
			],
			[
				99,
				-91
			],
			[
				100,
				-91
			],
			[
				99,
				-91
			],
			[
				99,
				-92
			],
			[
				99,
				-91
			],
			[
				48,
				-44
			],
			[
				21,
				-12
			]
		],
		[
			[
				98423,
				47239
			],
			[
				-150,
				0
			],
			[
				-198,
				0
			],
			[
				-186,
				0
			],
			[
				-126,
				0
			],
			[
				-212,
				0
			],
			[
				-71,
				37
			],
			[
				-21,
				24
			],
			[
				-4,
				28
			],
			[
				-3,
				18
			],
			[
				-16,
				6
			]
		],
		[
			[
				98423,
				47239
			],
			[
				1,
				-191
			],
			[
				0,
				-162
			],
			[
				1,
				-174
			],
			[
				1,
				-182
			],
			[
				1,
				-155
			],
			[
				0,
				-99
			],
			[
				-132,
				0
			],
			[
				-176,
				1
			],
			[
				-175,
				1
			],
			[
				-176,
				0
			],
			[
				-88,
				1
			],
			[
				-97,
				0
			],
			[
				-32,
				-5
			],
			[
				-21,
				-25
			],
			[
				-26,
				-6
			],
			[
				-30,
				22
			],
			[
				-36,
				10
			],
			[
				-10,
				22
			],
			[
				-18,
				40
			],
			[
				-37,
				5
			],
			[
				-18,
				-5
			],
			[
				-26,
				-23
			],
			[
				-29,
				-12
			]
		],
		[
			[
				107423,
				30777
			],
			[
				-27,
				5
			],
			[
				-199,
				-28
			],
			[
				-75,
				-35
			],
			[
				-169,
				-155
			],
			[
				-36,
				20
			],
			[
				-41,
				32
			],
			[
				-34,
				9
			],
			[
				-74,
				-37
			],
			[
				-75,
				-45
			],
			[
				-81,
				-63
			],
			[
				-68,
				-62
			],
			[
				-22,
				-33
			],
			[
				-106,
				-128
			],
			[
				-34,
				-21
			],
			[
				-31,
				-8
			],
			[
				-12,
				6
			],
			[
				-13,
				54
			],
			[
				-65,
				129
			],
			[
				-104,
				167
			],
			[
				-31,
				17
			],
			[
				-20,
				6
			],
			[
				-78,
				-8
			],
			[
				-224,
				-47
			],
			[
				-189,
				-40
			],
			[
				-290,
				-69
			],
			[
				-311,
				-55
			],
			[
				-192,
				-34
			],
			[
				-167,
				-10
			],
			[
				0,
				-166
			],
			[
				0,
				-337
			],
			[
				1,
				-336
			],
			[
				0,
				-337
			],
			[
				1,
				-336
			],
			[
				0,
				-336
			],
			[
				0,
				-337
			],
			[
				1,
				-336
			],
			[
				0,
				-337
			],
			[
				0,
				-146
			],
			[
				-5,
				-32
			],
			[
				-96,
				0
			],
			[
				-217,
				0
			],
			[
				-182,
				0
			],
			[
				-147,
				0
			],
			[
				0,
				-200
			],
			[
				0,
				-236
			],
			[
				0,
				-237
			],
			[
				1,
				-236
			],
			[
				0,
				-236
			],
			[
				0,
				-237
			],
			[
				0,
				-236
			],
			[
				0,
				-236
			],
			[
				1,
				-237
			],
			[
				0,
				-178
			]
		],
		[
			[
				104013,
				25018
			],
			[
				0,
				-346
			],
			[
				0,
				-367
			],
			[
				0,
				-367
			],
			[
				0,
				-366
			],
			[
				0,
				-367
			],
			[
				0,
				-367
			],
			[
				0,
				-367
			],
			[
				0,
				-367
			],
			[
				0,
				-116
			],
			[
				-66,
				2
			],
			[
				-134,
				-45
			],
			[
				-85,
				-59
			],
			[
				-37,
				-71
			],
			[
				-49,
				-44
			],
			[
				-61,
				-15
			],
			[
				-27,
				-37
			],
			[
				8,
				-58
			],
			[
				-24,
				-44
			],
			[
				-54,
				-31
			],
			[
				-88,
				9
			],
			[
				-121,
				49
			],
			[
				-154,
				11
			],
			[
				-187,
				-26
			],
			[
				-134,
				12
			],
			[
				-82,
				50
			],
			[
				-87,
				29
			],
			[
				-92,
				7
			],
			[
				-53,
				20
			],
			[
				-109,
				38
			],
			[
				-21,
				63
			],
			[
				-13,
				48
			],
			[
				-31,
				51
			],
			[
				-3,
				41
			],
			[
				24,
				31
			],
			[
				3,
				50
			],
			[
				-17,
				69
			],
			[
				-30,
				34
			],
			[
				-43,
				-2
			],
			[
				-27,
				26
			],
			[
				-10,
				55
			],
			[
				-25,
				41
			],
			[
				-61,
				43
			],
			[
				-79,
				-32
			],
			[
				-37,
				-48
			],
			[
				-22,
				-75
			],
			[
				-21,
				-38
			],
			[
				-10,
				-63
			],
			[
				-4,
				-44
			],
			[
				-21,
				-48
			],
			[
				-21,
				-19
			],
			[
				-21,
				9
			],
			[
				-41,
				-19
			],
			[
				-90,
				-70
			],
			[
				-26,
				-37
			]
		],
		[
			[
				104013,
				25039
			],
			[
				0,
				-21
			]
		],
		[
			[
				91685,
				54517
			],
			[
				-17,
				-89
			],
			[
				-34,
				-109
			],
			[
				-22,
				-35
			],
			[
				-16,
				-267
			],
			[
				11,
				-22
			],
			[
				8,
				-7
			],
			[
				107,
				-90
			],
			[
				141,
				-119
			],
			[
				100,
				-84
			],
			[
				8,
				-28
			],
			[
				1,
				-175
			],
			[
				2,
				-151
			],
			[
				20,
				-86
			],
			[
				5,
				-83
			],
			[
				24,
				-64
			],
			[
				92,
				-122
			],
			[
				22,
				-71
			],
			[
				2,
				-231
			],
			[
				2,
				-174
			],
			[
				12,
				-238
			],
			[
				0,
				-198
			],
			[
				0,
				-251
			],
			[
				0,
				-295
			],
			[
				0,
				-306
			],
			[
				-61,
				-4
			],
			[
				33,
				-95
			],
			[
				6,
				-87
			],
			[
				8,
				-28
			],
			[
				-16,
				-42
			],
			[
				13,
				-64
			],
			[
				26,
				-23
			],
			[
				67,
				-128
			],
			[
				23,
				-109
			],
			[
				-108,
				-36
			],
			[
				8,
				-28
			]
		],
		[
			[
				118756,
				58953
			],
			[
				121,
				113
			],
			[
				31,
				34
			],
			[
				17,
				30
			],
			[
				29,
				64
			],
			[
				39,
				21
			],
			[
				14,
				67
			],
			[
				-2,
				34
			],
			[
				-25,
				28
			],
			[
				-19,
				79
			],
			[
				7,
				99
			],
			[
				6,
				42
			],
			[
				13,
				76
			],
			[
				42,
				28
			],
			[
				10,
				22
			],
			[
				-32,
				49
			],
			[
				2,
				28
			],
			[
				72,
				80
			],
			[
				29,
				25
			],
			[
				46,
				24
			],
			[
				37,
				0
			],
			[
				41,
				-14
			],
			[
				38,
				-23
			],
			[
				36,
				-40
			],
			[
				39,
				-47
			],
			[
				59,
				-17
			],
			[
				40,
				4
			],
			[
				33,
				-20
			],
			[
				27,
				11
			],
			[
				32,
				24
			],
			[
				50,
				-2
			],
			[
				45,
				27
			],
			[
				128,
				13
			],
			[
				124,
				-8
			],
			[
				130,
				23
			],
			[
				129,
				-2
			],
			[
				130,
				-2
			],
			[
				29,
				-3
			],
			[
				28,
				-14
			],
			[
				110,
				-72
			],
			[
				83,
				-14
			],
			[
				168,
				-20
			],
			[
				178,
				-21
			],
			[
				155,
				-18
			],
			[
				131,
				17
			],
			[
				109,
				14
			],
			[
				30,
				-2
			],
			[
				32,
				-44
			],
			[
				66,
				-110
			],
			[
				62,
				-104
			],
			[
				108,
				-5
			],
			[
				70,
				39
			],
			[
				76,
				54
			],
			[
				47,
				43
			],
			[
				54,
				168
			],
			[
				35,
				109
			],
			[
				80,
				123
			],
			[
				67,
				102
			],
			[
				89,
				136
			],
			[
				50,
				75
			],
			[
				97,
				149
			],
			[
				93,
				58
			],
			[
				179,
				111
			],
			[
				175,
				110
			],
			[
				115,
				71
			],
			[
				97,
				33
			],
			[
				163,
				28
			],
			[
				192,
				33
			],
			[
				192,
				33
			],
			[
				204,
				35
			],
			[
				228,
				39
			],
			[
				157,
				27
			],
			[
				199,
				34
			],
			[
				166,
				29
			],
			[
				147,
				25
			],
			[
				152,
				26
			]
		],
		[
			[
				124687,
				61117
			],
			[
				28,
				-82
			],
			[
				29,
				-83
			],
			[
				28,
				-82
			],
			[
				29,
				-83
			],
			[
				29,
				-82
			],
			[
				28,
				-82
			],
			[
				29,
				-83
			],
			[
				28,
				-82
			],
			[
				29,
				-82
			],
			[
				29,
				-83
			],
			[
				28,
				-82
			],
			[
				29,
				-83
			],
			[
				28,
				-82
			],
			[
				29,
				-82
			],
			[
				29,
				-83
			],
			[
				28,
				-82
			],
			[
				28,
				-81
			],
			[
				46,
				-26
			],
			[
				28,
				-76
			],
			[
				39,
				-109
			],
			[
				39,
				-109
			],
			[
				39,
				-109
			],
			[
				40,
				-108
			]
		],
		[
			[
				126760,
				64175
			],
			[
				47,
				-94
			],
			[
				39,
				-77
			],
			[
				54,
				-107
			],
			[
				58,
				-113
			],
			[
				55,
				-108
			],
			[
				41,
				-80
			],
			[
				-22,
				-84
			],
			[
				-24,
				-91
			],
			[
				-23,
				-92
			],
			[
				-24,
				-91
			],
			[
				-24,
				-91
			],
			[
				-23,
				-91
			],
			[
				-24,
				-92
			],
			[
				-24,
				-91
			],
			[
				-23,
				-91
			],
			[
				-24,
				-92
			],
			[
				-24,
				-91
			],
			[
				-23,
				-91
			],
			[
				-24,
				-92
			],
			[
				-24,
				-91
			],
			[
				-23,
				-91
			],
			[
				-24,
				-91
			],
			[
				-24,
				-92
			],
			[
				-28,
				-110
			],
			[
				-69,
				-29
			],
			[
				-111,
				-47
			],
			[
				-111,
				-47
			],
			[
				-111,
				-48
			],
			[
				-111,
				-47
			],
			[
				-112,
				-47
			],
			[
				-111,
				-48
			],
			[
				-111,
				-47
			],
			[
				-111,
				-47
			],
			[
				-111,
				-47
			],
			[
				-111,
				-48
			],
			[
				-112,
				-47
			],
			[
				-111,
				-47
			],
			[
				-111,
				-48
			],
			[
				-111,
				-47
			],
			[
				-111,
				-47
			],
			[
				-111,
				-47
			],
			[
				-91,
				-39
			]
		],
		[
			[
				126760,
				64175
			],
			[
				-43,
				-66
			],
			[
				-10,
				-2
			],
			[
				-51,
				8
			],
			[
				-18,
				2
			],
			[
				-49,
				8
			],
			[
				-76,
				12
			],
			[
				-98,
				15
			],
			[
				-117,
				18
			],
			[
				-130,
				21
			],
			[
				-139,
				21
			],
			[
				-144,
				23
			],
			[
				-144,
				22
			],
			[
				-139,
				22
			],
			[
				-130,
				20
			],
			[
				-117,
				18
			],
			[
				-99,
				16
			],
			[
				-76,
				12
			],
			[
				-49,
				7
			],
			[
				-17,
				3
			],
			[
				-54,
				8
			],
			[
				-30,
				45
			],
			[
				-35,
				54
			],
			[
				-36,
				54
			],
			[
				-35,
				54
			],
			[
				-36,
				54
			],
			[
				-35,
				54
			],
			[
				-36,
				54
			],
			[
				-35,
				54
			],
			[
				-36,
				54
			],
			[
				-36,
				54
			],
			[
				-35,
				54
			],
			[
				-36,
				54
			],
			[
				-35,
				54
			],
			[
				-36,
				54
			],
			[
				-35,
				54
			],
			[
				-36,
				54
			],
			[
				-35,
				54
			],
			[
				-24,
				36
			],
			[
				-13,
				41
			],
			[
				-3,
				107
			],
			[
				0,
				23
			]
		],
		[
			[
				118472,
				76054
			],
			[
				0,
				-11
			],
			[
				-6,
				-29
			],
			[
				-73,
				-82
			],
			[
				-99,
				-111
			],
			[
				-71,
				-71
			],
			[
				-120,
				-118
			],
			[
				-89,
				-25
			],
			[
				-151,
				-43
			],
			[
				-40,
				-41
			],
			[
				-38,
				-67
			],
			[
				-22,
				-92
			],
			[
				-7,
				-57
			],
			[
				-3,
				-107
			],
			[
				35,
				-111
			],
			[
				34,
				-106
			],
			[
				4,
				-71
			],
			[
				-3,
				-69
			],
			[
				-33,
				-74
			],
			[
				-36,
				-102
			],
			[
				-20,
				-114
			],
			[
				-11,
				-216
			],
			[
				0,
				-183
			],
			[
				-3,
				-30
			],
			[
				-62,
				-129
			],
			[
				-73,
				-151
			],
			[
				-33,
				-35
			],
			[
				-159,
				-45
			],
			[
				-173,
				-111
			],
			[
				-193,
				-124
			],
			[
				-176,
				-112
			],
			[
				-185,
				-118
			],
			[
				-191,
				-122
			],
			[
				-137,
				-88
			],
			[
				-183,
				-117
			]
		],
		[
			[
				114226,
				72447
			],
			[
				69,
				-18
			],
			[
				40,
				-38
			],
			[
				67,
				-110
			],
			[
				103,
				-32
			],
			[
				42,
				-31
			],
			[
				57,
				-58
			],
			[
				69,
				-21
			],
			[
				219,
				-36
			],
			[
				175,
				122
			],
			[
				148,
				103
			],
			[
				167,
				117
			],
			[
				115,
				80
			],
			[
				195,
				136
			],
			[
				128,
				86
			],
			[
				169,
				114
			],
			[
				166,
				111
			]
		],
		[
			[
				114112,
				72403
			],
			[
				80,
				39
			],
			[
				34,
				5
			]
		],
		[
			[
				116396,
				71944
			],
			[
				95,
				98
			],
			[
				-29,
				88
			],
			[
				-70,
				-16
			],
			[
				-64,
				-21
			],
			[
				-38,
				138
			],
			[
				49,
				17
			],
			[
				-46,
				179
			],
			[
				-46,
				185
			],
			[
				-45,
				178
			],
			[
				-47,
				182
			]
		],
		[
			[
				113685,
				69658
			],
			[
				138,
				-27
			],
			[
				113,
				-22
			],
			[
				166,
				-32
			],
			[
				171,
				-34
			],
			[
				100,
				-19
			],
			[
				35,
				8
			],
			[
				138,
				128
			],
			[
				125,
				115
			],
			[
				75,
				141
			],
			[
				72,
				137
			],
			[
				33,
				28
			],
			[
				111,
				26
			],
			[
				176,
				40
			],
			[
				175,
				40
			],
			[
				13,
				14
			],
			[
				41,
				110
			],
			[
				52,
				139
			],
			[
				10,
				14
			],
			[
				13,
				15
			],
			[
				125,
				78
			],
			[
				76,
				47
			],
			[
				-108,
				139
			],
			[
				-102,
				132
			],
			[
				-114,
				148
			],
			[
				-97,
				114
			],
			[
				-145,
				172
			],
			[
				-94,
				113
			],
			[
				166,
				53
			],
			[
				179,
				57
			],
			[
				181,
				58
			],
			[
				219,
				70
			],
			[
				170,
				55
			],
			[
				255,
				82
			],
			[
				124,
				40
			],
			[
				23,
				10
			],
			[
				96,
				97
			]
		],
		[
			[
				121168,
				69446
			],
			[
				-113,
				-27
			],
			[
				-263,
				27
			],
			[
				-291,
				29
			],
			[
				-290,
				30
			],
			[
				-216,
				21
			],
			[
				-16,
				8
			],
			[
				-214,
				192
			],
			[
				-168,
				152
			],
			[
				-211,
				189
			],
			[
				-215,
				194
			],
			[
				-218,
				196
			],
			[
				-159,
				143
			],
			[
				-192,
				183
			],
			[
				-176,
				168
			],
			[
				-138,
				131
			],
			[
				-177,
				116
			],
			[
				-139,
				90
			],
			[
				-202,
				131
			],
			[
				-162,
				105
			],
			[
				-138,
				90
			],
			[
				-213,
				139
			],
			[
				-71,
				38
			],
			[
				-220,
				46
			],
			[
				-209,
				39
			],
			[
				-217,
				41
			],
			[
				-144,
				27
			]
		],
		[
			[
				130896,
				66235
			],
			[
				18,
				69
			],
			[
				16,
				246
			],
			[
				20,
				89
			],
			[
				-6,
				49
			],
			[
				4,
				14
			],
			[
				45,
				43
			],
			[
				11,
				19
			],
			[
				17,
				125
			],
			[
				18,
				140
			],
			[
				21,
				50
			],
			[
				18,
				14
			],
			[
				142,
				62
			],
			[
				24,
				42
			],
			[
				73,
				-10
			],
			[
				7,
				10
			],
			[
				6,
				48
			],
			[
				34,
				53
			],
			[
				47,
				42
			],
			[
				35,
				15
			],
			[
				127,
				27
			],
			[
				75,
				38
			],
			[
				22,
				4
			],
			[
				198,
				-10
			],
			[
				42,
				15
			],
			[
				7,
				13
			],
			[
				12,
				142
			],
			[
				35,
				22
			],
			[
				6,
				12
			],
			[
				-12,
				98
			],
			[
				7,
				66
			],
			[
				41,
				38
			],
			[
				-3,
				22
			],
			[
				-29,
				47
			],
			[
				-39,
				30
			],
			[
				-19,
				7
			],
			[
				-162,
				-28
			],
			[
				-67,
				9
			],
			[
				-32,
				17
			],
			[
				-6,
				13
			],
			[
				6,
				28
			],
			[
				1,
				47
			],
			[
				24,
				72
			],
			[
				7,
				43
			],
			[
				-19,
				251
			],
			[
				-28,
				166
			],
			[
				15,
				165
			],
			[
				-3,
				34
			],
			[
				-6,
				8
			],
			[
				-20,
				0
			],
			[
				-99,
				-15
			],
			[
				-84,
				106
			],
			[
				-53,
				42
			],
			[
				-143,
				53
			],
			[
				-63,
				10
			],
			[
				-93,
				46
			],
			[
				-85,
				100
			],
			[
				-87,
				102
			],
			[
				-35,
				65
			],
			[
				-39,
				112
			],
			[
				-111,
				213
			],
			[
				1,
				55
			],
			[
				-13,
				34
			],
			[
				-108,
				140
			],
			[
				-76,
				100
			],
			[
				-123,
				161
			]
		],
		[
			[
				130415,
				70075
			],
			[
				168,
				222
			],
			[
				147,
				194
			],
			[
				148,
				195
			],
			[
				145,
				192
			],
			[
				17,
				67
			],
			[
				2,
				131
			],
			[
				-38,
				175
			],
			[
				-61,
				81
			],
			[
				-203,
				32
			],
			[
				-152,
				24
			],
			[
				-166,
				27
			],
			[
				-22,
				10
			],
			[
				-19,
				136
			],
			[
				9,
				61
			],
			[
				-11,
				118
			],
			[
				1,
				90
			],
			[
				24,
				149
			],
			[
				2,
				68
			],
			[
				-77,
				289
			],
			[
				-43,
				160
			],
			[
				-44,
				165
			],
			[
				-9,
				53
			],
			[
				-1,
				65
			],
			[
				102,
				153
			],
			[
				31,
				34
			],
			[
				60,
				76
			],
			[
				37,
				40
			],
			[
				-6,
				28
			],
			[
				-65,
				16
			],
			[
				-98,
				2
			],
			[
				-52,
				23
			],
			[
				-41,
				41
			],
			[
				-16,
				61
			],
			[
				27,
				107
			],
			[
				-27,
				208
			],
			[
				54,
				103
			],
			[
				47,
				73
			],
			[
				160,
				10
			],
			[
				-56,
				81
			],
			[
				-26,
				47
			],
			[
				-17,
				14
			],
			[
				-7,
				22
			],
			[
				9,
				21
			],
			[
				40,
				9
			],
			[
				28,
				27
			],
			[
				45,
				38
			],
			[
				24,
				16
			],
			[
				4,
				47
			],
			[
				21,
				33
			],
			[
				32,
				40
			],
			[
				26,
				47
			],
			[
				-7,
				54
			],
			[
				24,
				66
			],
			[
				11,
				41
			],
			[
				17,
				35
			],
			[
				-15,
				52
			],
			[
				-13,
				44
			],
			[
				-4,
				51
			],
			[
				25,
				14
			],
			[
				32,
				19
			],
			[
				7,
				41
			],
			[
				17,
				52
			],
			[
				13,
				41
			],
			[
				21,
				33
			],
			[
				2,
				32
			],
			[
				-13,
				55
			]
		],
		[
			[
				138742,
				75872
			],
			[
				24,
				0
			],
			[
				90,
				-29
			],
			[
				61,
				-25
			],
			[
				24,
				2
			],
			[
				100,
				59
			],
			[
				153,
				72
			],
			[
				71,
				32
			]
		],
		[
			[
				130415,
				70075
			],
			[
				246,
				-90
			],
			[
				192,
				-69
			],
			[
				310,
				-112
			],
			[
				241,
				-86
			],
			[
				66,
				-14
			],
			[
				705,
				74
			],
			[
				261,
				-56
			],
			[
				82,
				-32
			],
			[
				13,
				18
			],
			[
				35,
				38
			],
			[
				60,
				39
			],
			[
				83,
				31
			],
			[
				82,
				16
			],
			[
				118,
				3
			],
			[
				80,
				-3
			],
			[
				59,
				-9
			],
			[
				114,
				5
			],
			[
				55,
				15
			],
			[
				188,
				61
			],
			[
				126,
				41
			],
			[
				191,
				64
			],
			[
				139,
				47
			],
			[
				35,
				25
			],
			[
				36,
				45
			],
			[
				17,
				40
			],
			[
				-43,
				61
			],
			[
				-5,
				55
			],
			[
				28,
				69
			],
			[
				15,
				105
			],
			[
				-3,
				150
			],
			[
				-9,
				87
			],
			[
				39,
				161
			],
			[
				32,
				90
			],
			[
				65,
				43
			],
			[
				45,
				26
			],
			[
				19,
				20
			],
			[
				18,
				21
			],
			[
				69,
				123
			],
			[
				63,
				57
			],
			[
				62,
				34
			],
			[
				67,
				-4
			],
			[
				57,
				-47
			],
			[
				110,
				-21
			],
			[
				107,
				14
			],
			[
				93,
				35
			],
			[
				42,
				29
			],
			[
				50,
				26
			],
			[
				-3,
				29
			],
			[
				-56,
				25
			],
			[
				-32,
				36
			],
			[
				-13,
				44
			],
			[
				32,
				26
			],
			[
				73,
				8
			],
			[
				179,
				107
			],
			[
				73,
				71
			],
			[
				20,
				32
			],
			[
				34,
				4
			],
			[
				69,
				-33
			],
			[
				79,
				-11
			],
			[
				50,
				33
			],
			[
				50,
				7
			],
			[
				49,
				-35
			],
			[
				26,
				-43
			],
			[
				44,
				-51
			],
			[
				56,
				-10
			],
			[
				68,
				28
			],
			[
				71,
				58
			],
			[
				67,
				82
			],
			[
				59,
				82
			],
			[
				-14,
				258
			],
			[
				-10,
				151
			],
			[
				31,
				80
			],
			[
				45,
				50
			],
			[
				30,
				76
			],
			[
				-1,
				67
			],
			[
				32,
				57
			],
			[
				31,
				154
			],
			[
				43,
				36
			],
			[
				88,
				26
			],
			[
				139,
				14
			],
			[
				110,
				71
			],
			[
				111,
				75
			],
			[
				15,
				66
			],
			[
				-42,
				70
			],
			[
				-55,
				137
			],
			[
				-50,
				82
			],
			[
				-122,
				147
			],
			[
				14,
				90
			],
			[
				68,
				37
			],
			[
				167,
				-63
			],
			[
				47,
				-12
			],
			[
				58,
				-9
			],
			[
				154,
				2
			],
			[
				125,
				24
			],
			[
				132,
				56
			],
			[
				25,
				58
			],
			[
				-1,
				69
			],
			[
				2,
				58
			],
			[
				2,
				79
			],
			[
				-47,
				51
			],
			[
				-28,
				45
			],
			[
				-9,
				37
			],
			[
				33,
				20
			],
			[
				32,
				37
			],
			[
				30,
				67
			],
			[
				73,
				81
			],
			[
				44,
				73
			],
			[
				42,
				34
			],
			[
				62,
				48
			],
			[
				40,
				69
			],
			[
				19,
				42
			],
			[
				36,
				40
			],
			[
				12,
				27
			],
			[
				-10,
				24
			],
			[
				-18,
				29
			],
			[
				-20,
				34
			],
			[
				0,
				33
			],
			[
				17,
				34
			],
			[
				18,
				31
			],
			[
				-8,
				44
			],
			[
				-10,
				71
			],
			[
				-34,
				42
			],
			[
				-23,
				96
			],
			[
				-37,
				98
			],
			[
				-19,
				39
			],
			[
				-35,
				48
			],
			[
				-80,
				51
			],
			[
				-22,
				34
			],
			[
				31,
				66
			],
			[
				51,
				41
			],
			[
				98,
				100
			],
			[
				53,
				70
			],
			[
				48,
				49
			],
			[
				62,
				-9
			],
			[
				36,
				5
			],
			[
				32,
				44
			],
			[
				64,
				40
			],
			[
				113,
				82
			],
			[
				40,
				56
			],
			[
				60,
				27
			],
			[
				50,
				7
			],
			[
				67,
				19
			],
			[
				65,
				30
			],
			[
				59,
				23
			],
			[
				92,
				4
			],
			[
				147,
				14
			],
			[
				80,
				14
			],
			[
				190,
				11
			],
			[
				207,
				5
			]
		],
		[
			[
				136943,
				80293
			],
			[
				-56,
				-34
			],
			[
				-62,
				-11
			],
			[
				-32,
				-21
			],
			[
				-34,
				-51
			],
			[
				-32,
				-43
			],
			[
				-18,
				-16
			],
			[
				-29,
				3
			],
			[
				-33,
				34
			],
			[
				-47,
				-2
			],
			[
				-56,
				-41
			],
			[
				-67,
				-68
			],
			[
				-84,
				-103
			],
			[
				-88,
				-55
			],
			[
				-111,
				-47
			],
			[
				-80,
				-21
			],
			[
				-64,
				-35
			],
			[
				-106,
				-72
			],
			[
				-21,
				-43
			],
			[
				-77,
				-25
			],
			[
				-62,
				-28
			],
			[
				-57,
				-48
			],
			[
				-14,
				-85
			],
			[
				-36,
				-49
			],
			[
				-88,
				-67
			],
			[
				-74,
				-68
			],
			[
				-48,
				-66
			],
			[
				-51,
				-70
			],
			[
				-16,
				-39
			],
			[
				-2,
				-53
			],
			[
				24,
				-44
			],
			[
				5,
				-42
			],
			[
				-18,
				-31
			],
			[
				-50,
				-12
			],
			[
				-52,
				9
			],
			[
				-80,
				30
			],
			[
				-85,
				54
			],
			[
				-31,
				27
			],
			[
				-41,
				46
			],
			[
				6,
				42
			],
			[
				21,
				82
			],
			[
				15,
				57
			],
			[
				-35,
				26
			],
			[
				-25,
				29
			],
			[
				-19,
				28
			],
			[
				-36,
				55
			],
			[
				-45,
				-13
			],
			[
				-39,
				-14
			],
			[
				-45,
				19
			],
			[
				-134,
				-8
			],
			[
				-101,
				-6
			],
			[
				-95,
				-6
			],
			[
				-120,
				-8
			],
			[
				-145,
				-9
			],
			[
				-42,
				12
			],
			[
				-26,
				19
			],
			[
				-26,
				75
			],
			[
				-15,
				64
			],
			[
				-29,
				121
			],
			[
				-18,
				92
			],
			[
				-23,
				111
			],
			[
				-15,
				122
			],
			[
				-10,
				87
			],
			[
				-110,
				3
			],
			[
				-88,
				3
			],
			[
				-118,
				3
			],
			[
				1,
				69
			],
			[
				1,
				87
			],
			[
				2,
				99
			],
			[
				22,
				130
			],
			[
				8,
				110
			],
			[
				10,
				133
			],
			[
				7,
				88
			],
			[
				7,
				97
			],
			[
				-61,
				-30
			],
			[
				-67,
				-33
			],
			[
				-64,
				-31
			],
			[
				-43,
				78
			],
			[
				-42,
				77
			],
			[
				-65,
				115
			],
			[
				-48,
				87
			],
			[
				-84,
				51
			],
			[
				-62,
				38
			],
			[
				-64,
				63
			],
			[
				-56,
				65
			],
			[
				-52,
				63
			],
			[
				-64,
				54
			],
			[
				-60,
				-17
			],
			[
				-68,
				-34
			],
			[
				-66,
				-33
			],
			[
				-70,
				-34
			],
			[
				-34,
				-17
			],
			[
				-81,
				6
			],
			[
				-71,
				6
			],
			[
				-126,
				10
			],
			[
				-107,
				8
			],
			[
				-109,
				9
			],
			[
				-151,
				12
			],
			[
				-154,
				12
			],
			[
				-103,
				-16
			],
			[
				-130,
				-20
			],
			[
				-137,
				-22
			],
			[
				-113,
				-17
			],
			[
				-143,
				-22
			],
			[
				-107,
				-17
			],
			[
				-53,
				2
			],
			[
				-66,
				70
			],
			[
				-107,
				113
			],
			[
				-64,
				68
			],
			[
				-63,
				67
			],
			[
				-91,
				96
			],
			[
				-73,
				73
			],
			[
				-72,
				71
			],
			[
				-41,
				66
			],
			[
				-21,
				82
			],
			[
				-37,
				38
			],
			[
				-83,
				50
			],
			[
				-89,
				54
			],
			[
				-89,
				55
			],
			[
				-90,
				54
			],
			[
				-89,
				54
			],
			[
				-89,
				54
			],
			[
				-90,
				55
			],
			[
				-89,
				54
			],
			[
				-89,
				54
			],
			[
				-89,
				54
			],
			[
				-89,
				55
			],
			[
				-90,
				54
			],
			[
				-89,
				54
			],
			[
				-89,
				54
			],
			[
				-90,
				55
			],
			[
				-89,
				54
			],
			[
				-89,
				54
			],
			[
				-74,
				40
			],
			[
				-68,
				-11
			],
			[
				-102,
				-27
			],
			[
				-107,
				-29
			],
			[
				-106,
				-29
			],
			[
				-191,
				-51
			],
			[
				-122,
				-33
			],
			[
				-96,
				-28
			],
			[
				-101,
				-30
			],
			[
				-134,
				-38
			],
			[
				-112,
				-33
			],
			[
				-131,
				-38
			],
			[
				-116,
				-34
			],
			[
				-98,
				-28
			],
			[
				-102,
				-30
			],
			[
				-80,
				-24
			],
			[
				0,
				-189
			],
			[
				0,
				-189
			],
			[
				0,
				-189
			],
			[
				0,
				-190
			],
			[
				0,
				-189
			],
			[
				0,
				-189
			],
			[
				0,
				-190
			],
			[
				0,
				-189
			],
			[
				0,
				-189
			],
			[
				1,
				-190
			],
			[
				0,
				-189
			],
			[
				0,
				-189
			],
			[
				0,
				-189
			],
			[
				0,
				-190
			],
			[
				0,
				-189
			],
			[
				0,
				-189
			]
		],
		[
			[
				99894,
				56753
			],
			[
				-65,
				355
			],
			[
				-37,
				203
			],
			[
				43,
				61
			],
			[
				83,
				145
			],
			[
				106,
				276
			],
			[
				240,
				428
			],
			[
				123,
				219
			],
			[
				244,
				327
			],
			[
				301,
				402
			],
			[
				169,
				226
			],
			[
				28,
				413
			],
			[
				29,
				436
			],
			[
				22,
				329
			],
			[
				27,
				391
			],
			[
				23,
				327
			],
			[
				16,
				237
			],
			[
				24,
				338
			],
			[
				20,
				64
			],
			[
				118,
				265
			],
			[
				9,
				35
			],
			[
				-22,
				44
			],
			[
				-168,
				225
			],
			[
				-53,
				50
			],
			[
				-30,
				117
			],
			[
				43,
				66
			],
			[
				-202,
				377
			],
			[
				-51,
				46
			],
			[
				-22,
				46
			],
			[
				-2,
				68
			],
			[
				-4,
				261
			],
			[
				-54,
				409
			],
			[
				-71,
				477
			]
		],
		[
			[
				98836,
				64846
			],
			[
				336,
				-96
			],
			[
				320,
				-91
			],
			[
				322,
				-92
			],
			[
				75,
				-50
			],
			[
				171,
				-179
			],
			[
				218,
				-230
			],
			[
				10,
				-3
			],
			[
				10,
				-1
			],
			[
				210,
				135
			],
			[
				273,
				177
			]
		],
		[
			[
				91244,
				57748
			],
			[
				7,
				43
			],
			[
				37,
				14
			],
			[
				95,
				-1
			],
			[
				185,
				-20
			],
			[
				147,
				23
			],
			[
				9,
				4
			],
			[
				104,
				114
			],
			[
				115,
				121
			],
			[
				174,
				12
			],
			[
				188,
				12
			],
			[
				147,
				6
			],
			[
				215,
				10
			],
			[
				174,
				7
			],
			[
				201,
				10
			],
			[
				6,
				55
			],
			[
				13,
				14
			],
			[
				19,
				2
			],
			[
				148,
				-30
			],
			[
				139,
				-29
			],
			[
				11,
				105
			],
			[
				122,
				131
			],
			[
				69,
				26
			],
			[
				17,
				23
			],
			[
				22,
				44
			],
			[
				14,
				68
			],
			[
				6,
				49
			],
			[
				25,
				40
			],
			[
				19,
				74
			],
			[
				25,
				130
			],
			[
				69,
				136
			],
			[
				39,
				185
			],
			[
				6,
				178
			],
			[
				8,
				136
			],
			[
				20,
				28
			],
			[
				0,
				241
			],
			[
				-1,
				242
			],
			[
				0,
				205
			],
			[
				-1,
				254
			],
			[
				-1,
				224
			],
			[
				0,
				242
			],
			[
				-1,
				218
			],
			[
				0,
				144
			]
		],
		[
			[
				91059,
				54618
			],
			[
				-149,
				42
			],
			[
				-9,
				-39
			],
			[
				-21,
				-26
			],
			[
				-32,
				-2
			],
			[
				-23,
				7
			],
			[
				-15,
				-31
			],
			[
				-24,
				-40
			],
			[
				-35,
				-20
			],
			[
				-34,
				-25
			],
			[
				-19,
				-21
			],
			[
				-14,
				-1
			],
			[
				-34,
				52
			],
			[
				-45,
				5
			],
			[
				-85,
				-9
			],
			[
				-38,
				14
			],
			[
				-52,
				7
			],
			[
				-123,
				-11
			],
			[
				-197,
				21
			],
			[
				-32,
				-11
			],
			[
				-8,
				-9
			],
			[
				-195,
				-3
			],
			[
				-214,
				-2
			],
			[
				-179,
				-3
			],
			[
				-157,
				-2
			],
			[
				0,
				9
			],
			[
				-50,
				1
			],
			[
				-6,
				-17
			],
			[
				-44,
				-206
			],
			[
				-5,
				-112
			],
			[
				23,
				-69
			],
			[
				27,
				-44
			],
			[
				30,
				-18
			],
			[
				3,
				-26
			],
			[
				-24,
				-32
			],
			[
				2,
				-33
			],
			[
				28,
				-34
			],
			[
				7,
				-36
			],
			[
				-14,
				-37
			],
			[
				3,
				-91
			],
			[
				21,
				-143
			],
			[
				1,
				-92
			],
			[
				-20,
				-43
			],
			[
				9,
				-72
			],
			[
				39,
				-102
			],
			[
				6,
				-44
			]
		],
		[
			[
				82515,
				52914
			],
			[
				37,
				17
			],
			[
				37,
				-8
			],
			[
				31,
				-10
			],
			[
				34,
				18
			],
			[
				32,
				28
			],
			[
				19,
				35
			],
			[
				25,
				96
			],
			[
				83,
				33
			],
			[
				49,
				58
			],
			[
				46,
				92
			],
			[
				21,
				64
			],
			[
				19,
				32
			],
			[
				12,
				27
			],
			[
				9,
				31
			],
			[
				20,
				28
			],
			[
				22,
				67
			],
			[
				15,
				62
			],
			[
				47,
				30
			],
			[
				97,
				26
			],
			[
				88,
				-45
			],
			[
				142,
				39
			],
			[
				7,
				58
			],
			[
				130,
				1
			],
			[
				154,
				1
			],
			[
				128,
				1
			],
			[
				44,
				-15
			],
			[
				16,
				-44
			],
			[
				42,
				-67
			],
			[
				44,
				-47
			],
			[
				55,
				-103
			],
			[
				63,
				-120
			],
			[
				69,
				-108
			],
			[
				44,
				-59
			],
			[
				5,
				-20
			],
			[
				-3,
				-23
			],
			[
				-22,
				-55
			],
			[
				-18,
				-60
			],
			[
				1,
				-22
			],
			[
				13,
				-11
			],
			[
				72,
				-19
			],
			[
				7,
				-66
			],
			[
				0,
				-92
			],
			[
				35,
				-86
			],
			[
				33,
				-62
			],
			[
				-2,
				-23
			],
			[
				-81,
				-107
			],
			[
				-32,
				-107
			],
			[
				-16,
				-30
			],
			[
				-6,
				-24
			],
			[
				16,
				-11
			],
			[
				22,
				7
			],
			[
				32,
				-9
			],
			[
				30,
				-3
			],
			[
				39,
				38
			],
			[
				66,
				98
			],
			[
				22,
				12
			],
			[
				50,
				-8
			]
		],
		[
			[
				94844,
				86304
			],
			[
				22,
				-27
			],
			[
				50,
				-13
			],
			[
				18,
				-10
			],
			[
				20,
				-19
			],
			[
				33,
				-7
			],
			[
				41,
				7
			],
			[
				29,
				25
			],
			[
				40,
				12
			],
			[
				39,
				-4
			],
			[
				23,
				-14
			],
			[
				43,
				-20
			]
		],
		[
			[
				127338,
				66944
			],
			[
				23,
				5
			],
			[
				33,
				-17
			],
			[
				3,
				-84
			],
			[
				-12,
				-80
			],
			[
				-1,
				-85
			],
			[
				-5,
				-45
			],
			[
				25,
				-38
			],
			[
				43,
				-16
			],
			[
				18,
				2
			],
			[
				13,
				19
			]
		],
		[
			[
				110816,
				44571
			],
			[
				-26,
				1
			],
			[
				-37,
				3
			],
			[
				-34,
				-10
			],
			[
				-25,
				-32
			],
			[
				-27,
				-54
			],
			[
				-47,
				-62
			],
			[
				-36,
				-55
			],
			[
				-32,
				-39
			],
			[
				-72,
				-65
			],
			[
				-39,
				-19
			],
			[
				-19,
				3
			],
			[
				-12,
				12
			],
			[
				-22,
				82
			],
			[
				-14,
				14
			],
			[
				-140,
				-43
			],
			[
				-21,
				0
			]
		],
		[
			[
				110816,
				44571
			],
			[
				-21,
				-13
			],
			[
				-5,
				-40
			],
			[
				25,
				-63
			],
			[
				80,
				-132
			],
			[
				51,
				-24
			],
			[
				33,
				-51
			],
			[
				33,
				-86
			],
			[
				9,
				-108
			],
			[
				-13,
				-129
			],
			[
				8,
				-96
			],
			[
				29,
				-63
			],
			[
				8,
				-82
			],
			[
				-14,
				-101
			],
			[
				-17,
				-60
			],
			[
				-20,
				-20
			],
			[
				-23,
				-8
			],
			[
				-31,
				7
			],
			[
				-37,
				-8
			],
			[
				-41,
				-19
			],
			[
				-26,
				-3
			]
		],
		[
			[
				113009,
				44625
			],
			[
				-71,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-114,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-114,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-115,
				0
			],
			[
				-68,
				0
			],
			[
				-13,
				2
			],
			[
				-10,
				4
			],
			[
				-43,
				-11
			],
			[
				-45,
				-36
			],
			[
				-48,
				-15
			],
			[
				-50,
				6
			],
			[
				-7,
				-4
			]
		],
		[
			[
				113453,
				35579
			],
			[
				-24,
				-9
			],
			[
				-8,
				-30
			],
			[
				25,
				-39
			],
			[
				27,
				-1
			],
			[
				13,
				44
			],
			[
				-12,
				24
			],
			[
				-21,
				11
			]
		],
		[
			[
				147524,
				85931
			],
			[
				60,
				-7
			],
			[
				39,
				12
			],
			[
				25,
				25
			],
			[
				40,
				8
			],
			[
				59,
				13
			],
			[
				61,
				15
			],
			[
				36,
				-3
			]
		],
		[
			[
				120504,
				78987
			],
			[
				-16,
				-14
			],
			[
				0,
				-34
			],
			[
				23,
				-6
			],
			[
				24,
				13
			],
			[
				7,
				28
			],
			[
				-19,
				12
			],
			[
				-19,
				1
			]
		],
		[
			[
				120175,
				79334
			],
			[
				-22,
				-6
			],
			[
				-1,
				-22
			],
			[
				6,
				-21
			],
			[
				22,
				-9
			],
			[
				14,
				9
			],
			[
				3,
				22
			],
			[
				-5,
				20
			],
			[
				-17,
				7
			]
		],
		[
			[
				99142,
				81722
			],
			[
				-29,
				-39
			],
			[
				19,
				-33
			],
			[
				38,
				6
			],
			[
				19,
				42
			],
			[
				-7,
				31
			],
			[
				-40,
				-7
			]
		],
		[
			[
				136701,
				79283
			],
			[
				-15,
				-8
			],
			[
				13,
				-27
			],
			[
				34,
				-39
			],
			[
				20,
				2
			],
			[
				-2,
				20
			],
			[
				-20,
				33
			],
			[
				-30,
				19
			]
		],
		[
			[
				15425,
				72281
			],
			[
				185,
				17
			],
			[
				185,
				18
			],
			[
				185,
				18
			],
			[
				185,
				17
			],
			[
				185,
				18
			],
			[
				185,
				18
			],
			[
				184,
				17
			],
			[
				185,
				18
			],
			[
				74,
				9
			],
			[
				-41,
				-124
			],
			[
				-31,
				-47
			],
			[
				307,
				-122
			],
			[
				306,
				-122
			],
			[
				307,
				-122
			],
			[
				306,
				-122
			],
			[
				306,
				-122
			],
			[
				307,
				-122
			],
			[
				306,
				-122
			],
			[
				307,
				-122
			],
			[
				228,
				0
			],
			[
				228,
				1
			],
			[
				229,
				0
			],
			[
				228,
				1
			],
			[
				228,
				0
			],
			[
				147,
				1
			],
			[
				82,
				0
			],
			[
				228,
				0
			],
			[
				229,
				1
			],
			[
				0,
				93
			],
			[
				0,
				92
			],
			[
				1,
				93
			],
			[
				0,
				93
			],
			[
				142,
				-1
			],
			[
				142,
				-1
			],
			[
				142,
				-1
			],
			[
				142,
				-1
			],
			[
				142,
				-1
			],
			[
				142,
				-1
			],
			[
				142,
				-1
			],
			[
				142,
				-1
			],
			[
				6,
				-1
			],
			[
				6,
				-3
			],
			[
				57,
				-71
			],
			[
				59,
				-111
			],
			[
				70,
				-77
			],
			[
				80,
				-44
			],
			[
				136,
				-129
			],
			[
				193,
				-215
			],
			[
				154,
				-143
			],
			[
				115,
				-71
			],
			[
				77,
				-62
			],
			[
				40,
				-51
			],
			[
				52,
				-112
			],
			[
				100,
				-259
			],
			[
				0,
				-118
			],
			[
				39,
				-113
			],
			[
				76,
				-145
			],
			[
				67,
				-86
			],
			[
				57,
				-26
			],
			[
				62,
				-51
			],
			[
				68,
				-78
			],
			[
				78,
				-52
			],
			[
				89,
				-26
			],
			[
				122,
				-70
			],
			[
				155,
				-112
			],
			[
				107,
				-57
			],
			[
				58,
				-3
			],
			[
				50,
				36
			],
			[
				44,
				75
			],
			[
				43,
				48
			],
			[
				41,
				21
			],
			[
				17,
				35
			],
			[
				-7,
				47
			],
			[
				28,
				106
			],
			[
				64,
				165
			],
			[
				77,
				89
			],
			[
				90,
				14
			],
			[
				59,
				31
			],
			[
				27,
				48
			],
			[
				48,
				5
			],
			[
				68,
				-38
			],
			[
				112,
				-24
			],
			[
				154,
				-11
			],
			[
				91,
				4
			],
			[
				27,
				18
			],
			[
				15,
				-1
			],
			[
				1,
				-20
			],
			[
				23,
				-9
			],
			[
				44,
				3
			],
			[
				39,
				-28
			],
			[
				50,
				-89
			],
			[
				171,
				-144
			],
			[
				0,
				0
			],
			[
				14,
				-49
			],
			[
				60,
				-71
			],
			[
				109,
				-109
			],
			[
				62,
				-94
			],
			[
				15,
				-79
			],
			[
				56,
				-125
			],
			[
				97,
				-170
			],
			[
				44,
				-92
			],
			[
				-11,
				-14
			],
			[
				8,
				-48
			],
			[
				26,
				-83
			],
			[
				48,
				-70
			],
			[
				71,
				-57
			],
			[
				71,
				-103
			],
			[
				72,
				-149
			],
			[
				88,
				-114
			],
			[
				102,
				-77
			],
			[
				59,
				-72
			],
			[
				13,
				-67
			],
			[
				-1,
				-57
			],
			[
				-15,
				-48
			],
			[
				6,
				-45
			],
			[
				29,
				-43
			],
			[
				10,
				-52
			],
			[
				-12,
				-73
			],
			[
				1,
				-21
			],
			[
				0,
				0
			],
			[
				9,
				-16
			],
			[
				91,
				-126
			],
			[
				47,
				-101
			],
			[
				37,
				-162
			],
			[
				0,
				-1
			],
			[
				41,
				-97
			],
			[
				60,
				-39
			],
			[
				92,
				-15
			],
			[
				70,
				-33
			],
			[
				47,
				-53
			],
			[
				61,
				-32
			],
			[
				72,
				-11
			],
			[
				70,
				-35
			],
			[
				67,
				-59
			],
			[
				124,
				-38
			],
			[
				182,
				-19
			],
			[
				138,
				-47
			],
			[
				95,
				-77
			],
			[
				42,
				-16
			],
			[
				11,
				-1
			],
			[
				5,
				12
			],
			[
				8,
				22
			],
			[
				36,
				25
			],
			[
				88,
				16
			]
		],
		[
			[
				31509,
				57446
			],
			[
				17,
				22
			],
			[
				14,
				48
			],
			[
				18,
				51
			],
			[
				-11,
				58
			],
			[
				-7,
				47
			],
			[
				20,
				68
			],
			[
				-2,
				51
			],
			[
				10,
				32
			],
			[
				29,
				20
			],
			[
				16,
				40
			],
			[
				-84,
				134
			],
			[
				0,
				31
			],
			[
				11,
				38
			],
			[
				68,
				144
			],
			[
				81,
				171
			],
			[
				89,
				189
			],
			[
				53,
				114
			],
			[
				196,
				0
			],
			[
				129,
				0
			],
			[
				164,
				0
			],
			[
				179,
				1
			],
			[
				117,
				0
			],
			[
				48,
				1
			],
			[
				-8,
				74
			],
			[
				6,
				82
			],
			[
				22,
				74
			],
			[
				0,
				32
			],
			[
				-35,
				41
			],
			[
				-68,
				23
			],
			[
				-38,
				35
			],
			[
				0,
				45
			],
			[
				-16,
				54
			],
			[
				-33,
				64
			],
			[
				-68,
				65
			],
			[
				-103,
				67
			],
			[
				-88,
				89
			],
			[
				-73,
				112
			],
			[
				-61,
				72
			],
			[
				-47,
				31
			],
			[
				-12,
				16
			],
			[
				139,
				-2
			],
			[
				131,
				-1
			],
			[
				0,
				161
			],
			[
				1,
				143
			],
			[
				1,
				161
			],
			[
				237,
				0
			],
			[
				283,
				-1
			],
			[
				294,
				0
			],
			[
				231,
				0
			],
			[
				136,
				0
			]
		],
		[
			[
				33495,
				60143
			],
			[
				-1,
				72
			],
			[
				19,
				56
			],
			[
				54,
				24
			],
			[
				69,
				-49
			],
			[
				29,
				-21
			],
			[
				26,
				12
			],
			[
				33,
				30
			],
			[
				41,
				87
			],
			[
				102,
				181
			],
			[
				40,
				128
			],
			[
				40,
				26
			],
			[
				58,
				4
			],
			[
				49,
				-8
			],
			[
				31,
				-49
			],
			[
				135,
				3
			],
			[
				-2,
				-182
			],
			[
				140,
				-12
			]
		],
		[
			[
				55815,
				24359
			],
			[
				4,
				118
			],
			[
				88,
				176
			],
			[
				24,
				81
			],
			[
				-11,
				46
			],
			[
				26,
				164
			],
			[
				65,
				279
			],
			[
				21,
				184
			],
			[
				-24,
				86
			],
			[
				0,
				60
			],
			[
				33,
				52
			],
			[
				16,
				15
			],
			[
				-83,
				63
			],
			[
				-45,
				57
			],
			[
				-58,
				41
			],
			[
				-62,
				33
			],
			[
				-30,
				-14
			],
			[
				-32,
				-19
			],
			[
				-62,
				-30
			],
			[
				-70,
				-52
			],
			[
				-37,
				-19
			],
			[
				-64,
				-19
			],
			[
				-73,
				-16
			],
			[
				-59,
				10
			],
			[
				-52,
				11
			],
			[
				-32,
				33
			],
			[
				-17,
				71
			],
			[
				0,
				60
			],
			[
				-10,
				87
			],
			[
				-39,
				49
			],
			[
				-13,
				39
			],
			[
				-2,
				46
			],
			[
				4,
				52
			],
			[
				11,
				38
			],
			[
				-6,
				46
			],
			[
				-17,
				33
			],
			[
				4,
				57
			],
			[
				-9,
				79
			],
			[
				-25,
				50
			],
			[
				-13,
				57
			],
			[
				0,
				57
			],
			[
				-19,
				57
			],
			[
				-3,
				63
			],
			[
				18,
				57
			],
			[
				6,
				58
			],
			[
				-19,
				41
			],
			[
				-37,
				24
			],
			[
				-27,
				66
			],
			[
				-5,
				84
			],
			[
				-30,
				46
			],
			[
				-32,
				39
			],
			[
				-36,
				0
			],
			[
				-55,
				21
			],
			[
				-50,
				-2
			],
			[
				-79,
				2
			],
			[
				-36,
				14
			],
			[
				-19,
				30
			],
			[
				-49,
				41
			],
			[
				-28,
				71
			],
			[
				-34,
				14
			],
			[
				-50,
				-22
			],
			[
				-17,
				-28
			],
			[
				-19,
				-38
			],
			[
				-34,
				-43
			],
			[
				-45,
				2
			],
			[
				-47,
				-24
			],
			[
				-45,
				-3
			],
			[
				-60,
				-5
			],
			[
				-59,
				21
			],
			[
				-73,
				25
			],
			[
				-62,
				16
			],
			[
				-60,
				-16
			],
			[
				-41,
				14
			],
			[
				-53,
				8
			],
			[
				-60,
				5
			],
			[
				-47,
				44
			],
			[
				-51,
				24
			],
			[
				-28,
				-8
			],
			[
				-36,
				-27
			],
			[
				-39,
				5
			],
			[
				-49,
				22
			],
			[
				-19,
				52
			],
			[
				4,
				33
			],
			[
				11,
				33
			],
			[
				19,
				46
			],
			[
				-11,
				49
			],
			[
				5,
				44
			],
			[
				8,
				38
			],
			[
				9,
				43
			],
			[
				-7,
				41
			],
			[
				-2,
				44
			],
			[
				-4,
				41
			],
			[
				-6,
				44
			],
			[
				25,
				62
			],
			[
				22,
				52
			],
			[
				-13,
				44
			],
			[
				4,
				30
			],
			[
				17,
				49
			],
			[
				22,
				60
			],
			[
				-3,
				112
			],
			[
				-19,
				65
			],
			[
				-21,
				18
			],
			[
				-5,
				20
			],
			[
				10,
				26
			],
			[
				-11,
				26
			],
			[
				-4,
				27
			],
			[
				11,
				24
			],
			[
				-15,
				47
			],
			[
				-31,
				14
			],
			[
				-11,
				14
			],
			[
				-10,
				51
			],
			[
				-9,
				60
			],
			[
				4,
				47
			],
			[
				-15,
				41
			],
			[
				-21,
				24
			],
			[
				-21,
				44
			],
			[
				-22,
				33
			],
			[
				-8,
				46
			],
			[
				-15,
				60
			]
		],
		[
			[
				50624,
				27116
			],
			[
				16,
				-23
			],
			[
				0,
				-24
			],
			[
				54,
				-49
			],
			[
				110,
				-74
			],
			[
				102,
				-143
			],
			[
				95,
				-212
			],
			[
				90,
				-156
			],
			[
				83,
				-101
			],
			[
				77,
				-72
			],
			[
				70,
				-42
			],
			[
				38,
				-34
			],
			[
				5,
				-26
			],
			[
				65,
				-54
			],
			[
				127,
				-82
			],
			[
				80,
				-82
			],
			[
				33,
				-82
			],
			[
				125,
				-84
			],
			[
				216,
				-87
			],
			[
				157,
				-42
			],
			[
				98,
				4
			],
			[
				141,
				-69
			],
			[
				183,
				-143
			],
			[
				112,
				-99
			],
			[
				41,
				-55
			],
			[
				120,
				-90
			],
			[
				299,
				-185
			],
			[
				132,
				-46
			],
			[
				63,
				-42
			],
			[
				37,
				-54
			],
			[
				36,
				-17
			],
			[
				36,
				21
			],
			[
				76,
				-19
			],
			[
				114,
				-59
			],
			[
				89,
				-72
			],
			[
				115,
				-159
			],
			[
				36,
				-63
			],
			[
				16,
				-56
			],
			[
				-6,
				-50
			],
			[
				-35,
				-53
			],
			[
				-64,
				-57
			],
			[
				-19,
				-25
			],
			[
				-1,
				-23
			],
			[
				-17,
				-48
			],
			[
				-53,
				-102
			],
			[
				-14,
				-47
			],
			[
				-3,
				-35
			],
			[
				-34,
				-38
			],
			[
				-90,
				-71
			],
			[
				-18,
				-34
			],
			[
				-5,
				-37
			],
			[
				-11,
				-22
			],
			[
				-12,
				-9
			],
			[
				-18,
				-37
			],
			[
				-13,
				-61
			],
			[
				-2,
				-78
			],
			[
				11,
				-96
			],
			[
				-2,
				-31
			],
			[
				-20,
				-16
			],
			[
				-11,
				-23
			],
			[
				-4,
				-44
			],
			[
				-17,
				-33
			],
			[
				-30,
				-21
			],
			[
				-11,
				-24
			],
			[
				8,
				-27
			],
			[
				-22,
				-26
			],
			[
				-51,
				-27
			],
			[
				-32,
				-38
			],
			[
				-11,
				-50
			],
			[
				-29,
				-45
			],
			[
				-46,
				-40
			],
			[
				-15,
				-53
			],
			[
				24,
				-97
			],
			[
				282,
				33
			],
			[
				230,
				-35
			],
			[
				272,
				-94
			],
			[
				181,
				-33
			],
			[
				89,
				29
			],
			[
				66,
				-4
			],
			[
				43,
				-37
			],
			[
				58,
				-7
			],
			[
				72,
				21
			],
			[
				60,
				-16
			],
			[
				47,
				-55
			],
			[
				44,
				14
			],
			[
				38,
				81
			],
			[
				45,
				59
			],
			[
				50,
				38
			],
			[
				62,
				11
			],
			[
				75,
				-15
			],
			[
				60,
				-30
			],
			[
				45,
				-44
			],
			[
				48,
				1
			],
			[
				53,
				47
			],
			[
				25,
				57
			],
			[
				-2,
				67
			],
			[
				21,
				47
			],
			[
				44,
				29
			],
			[
				30,
				39
			],
			[
				15,
				48
			],
			[
				53,
				30
			],
			[
				89,
				11
			],
			[
				46,
				24
			],
			[
				4,
				37
			],
			[
				27,
				34
			],
			[
				48,
				31
			],
			[
				34,
				39
			],
			[
				17,
				47
			],
			[
				30,
				30
			],
			[
				41,
				12
			],
			[
				45,
				98
			],
			[
				50,
				185
			],
			[
				30,
				250
			],
			[
				10,
				354
			]
		],
		[
			[
				50624,
				27116
			],
			[
				-10,
				13
			],
			[
				-51,
				48
			],
			[
				-45,
				90
			],
			[
				-13,
				42
			],
			[
				-6,
				2
			],
			[
				-273,
				-3
			],
			[
				-264,
				-3
			],
			[
				-27,
				-19
			],
			[
				-38,
				0
			],
			[
				-28,
				18
			],
			[
				-27,
				-2
			],
			[
				-39,
				-17
			],
			[
				-36,
				-37
			],
			[
				-100,
				-241
			],
			[
				-50,
				-104
			],
			[
				-37,
				-92
			],
			[
				-27,
				-159
			],
			[
				-11,
				-26
			],
			[
				-32,
				55
			],
			[
				-46,
				145
			],
			[
				-21,
				82
			],
			[
				-29,
				94
			],
			[
				-53,
				118
			],
			[
				-61,
				35
			],
			[
				-38,
				12
			],
			[
				-55,
				23
			],
			[
				-96,
				28
			],
			[
				-42,
				6
			],
			[
				-276,
				3
			],
			[
				-22,
				3
			],
			[
				-108,
				-13
			],
			[
				-55,
				9
			],
			[
				-58,
				66
			],
			[
				-128,
				116
			],
			[
				-26,
				36
			],
			[
				-49,
				25
			],
			[
				-29,
				2
			],
			[
				-18,
				-23
			],
			[
				-22,
				-96
			],
			[
				-27,
				-87
			],
			[
				-27,
				-50
			],
			[
				-92,
				-37
			],
			[
				-85,
				-39
			],
			[
				-47,
				-9
			],
			[
				-25,
				-44
			],
			[
				-11,
				-61
			],
			[
				-21,
				-54
			],
			[
				-124,
				-83
			],
			[
				-27,
				-35
			],
			[
				-14,
				-81
			],
			[
				-69,
				-102
			],
			[
				-21,
				-39
			]
		],
		[
			[
				108302,
				85250
			],
			[
				14,
				28
			],
			[
				133,
				77
			],
			[
				35,
				-13
			],
			[
				70,
				-3
			],
			[
				142,
				3
			],
			[
				70,
				51
			],
			[
				43,
				-15
			],
			[
				35,
				23
			],
			[
				59,
				29
			],
			[
				9,
				-6
			],
			[
				7,
				-5
			],
			[
				91,
				-13
			],
			[
				68,
				-27
			],
			[
				46,
				-42
			],
			[
				47,
				-26
			],
			[
				48,
				-10
			],
			[
				27,
				-21
			],
			[
				6,
				-32
			],
			[
				45,
				-16
			],
			[
				85,
				0
			],
			[
				37,
				-21
			],
			[
				-13,
				-42
			],
			[
				8,
				-14
			],
			[
				31,
				14
			],
			[
				23,
				-12
			],
			[
				12,
				-32
			],
			[
				14,
				-15
			],
			[
				43,
				50
			],
			[
				46,
				-5
			],
			[
				111,
				-21
			],
			[
				60,
				-102
			],
			[
				37,
				-37
			],
			[
				32,
				-15
			],
			[
				41,
				16
			],
			[
				37,
				19
			],
			[
				21,
				-9
			],
			[
				44,
				-67
			],
			[
				11,
				-89
			],
			[
				0,
				-36
			],
			[
				-16,
				-60
			],
			[
				-23,
				-64
			],
			[
				-18,
				-42
			],
			[
				8,
				-33
			],
			[
				16,
				-28
			],
			[
				26,
				-9
			],
			[
				86,
				-57
			],
			[
				32,
				-39
			],
			[
				47,
				-30
			],
			[
				35,
				-1
			],
			[
				19,
				-17
			],
			[
				6,
				-19
			],
			[
				-4,
				-51
			],
			[
				-20,
				-47
			],
			[
				2,
				-31
			],
			[
				32,
				-36
			],
			[
				3,
				-42
			],
			[
				2,
				-27
			],
			[
				17,
				-20
			],
			[
				79,
				-47
			],
			[
				102,
				-44
			],
			[
				26,
				-38
			],
			[
				15,
				-49
			],
			[
				-5,
				-81
			],
			[
				-6,
				-71
			],
			[
				133,
				-96
			],
			[
				-15,
				-18
			],
			[
				-20,
				-19
			],
			[
				-128,
				-15
			],
			[
				-26,
				-8
			],
			[
				-56,
				72
			],
			[
				-29,
				9
			],
			[
				-27,
				-26
			],
			[
				-32,
				-15
			],
			[
				-39,
				8
			],
			[
				-41,
				22
			],
			[
				-21,
				16
			],
			[
				-17,
				1
			],
			[
				-26,
				-15
			],
			[
				-34,
				6
			],
			[
				-23,
				18
			],
			[
				-32,
				-61
			],
			[
				-20,
				-13
			],
			[
				-12,
				2
			],
			[
				-3,
				104
			],
			[
				-9,
				15
			],
			[
				-26,
				3
			],
			[
				-62,
				-25
			],
			[
				-59,
				-32
			],
			[
				-20,
				-28
			],
			[
				2,
				-51
			],
			[
				8,
				-61
			],
			[
				41,
				-92
			],
			[
				-23,
				-40
			],
			[
				-15,
				-65
			],
			[
				-64,
				-58
			],
			[
				-71,
				-35
			],
			[
				-6,
				-70
			],
			[
				-40,
				-48
			],
			[
				-68,
				-48
			],
			[
				-46,
				-57
			],
			[
				12,
				-40
			],
			[
				2,
				-37
			],
			[
				-7,
				-26
			],
			[
				-2,
				-19
			],
			[
				-18,
				-9
			],
			[
				-104,
				-7
			],
			[
				-29,
				-12
			],
			[
				-34,
				-28
			]
		],
		[
			[
				134883,
				76106
			],
			[
				5,
				-26
			],
			[
				44,
				-63
			],
			[
				80,
				-76
			],
			[
				71,
				-18
			],
			[
				93,
				59
			],
			[
				32,
				-7
			],
			[
				15,
				19
			],
			[
				9,
				43
			],
			[
				57,
				41
			],
			[
				103,
				38
			],
			[
				58,
				33
			],
			[
				21,
				28
			],
			[
				35,
				8
			],
			[
				38,
				-8
			],
			[
				27,
				10
			],
			[
				10,
				27
			],
			[
				11,
				12
			],
			[
				19,
				9
			],
			[
				17,
				5
			],
			[
				31,
				-8
			],
			[
				58,
				-48
			],
			[
				84,
				-89
			],
			[
				55,
				-41
			],
			[
				25,
				7
			],
			[
				33,
				27
			],
			[
				39,
				48
			],
			[
				10,
				68
			],
			[
				-20,
				90
			],
			[
				13,
				72
			],
			[
				47,
				54
			],
			[
				86,
				34
			],
			[
				126,
				13
			],
			[
				78,
				-8
			],
			[
				28,
				-28
			],
			[
				39,
				-15
			],
			[
				49,
				-4
			],
			[
				44,
				33
			],
			[
				41,
				67
			],
			[
				2,
				83
			],
			[
				-36,
				100
			],
			[
				10,
				32
			],
			[
				15,
				13
			],
			[
				49,
				36
			],
			[
				67,
				75
			],
			[
				65,
				96
			],
			[
				63,
				118
			],
			[
				78,
				72
			],
			[
				92,
				28
			],
			[
				112,
				-31
			],
			[
				132,
				-92
			],
			[
				49,
				-113
			],
			[
				-32,
				-134
			],
			[
				-3,
				-73
			],
			[
				27,
				-14
			],
			[
				45,
				4
			],
			[
				63,
				21
			],
			[
				42,
				1
			],
			[
				19,
				-19
			],
			[
				-1,
				-38
			],
			[
				-22,
				-57
			],
			[
				-26,
				-159
			],
			[
				-17,
				-137
			],
			[
				-16,
				-136
			],
			[
				-14,
				-119
			],
			[
				25,
				-92
			],
			[
				38,
				-141
			],
			[
				43,
				-92
			],
			[
				44,
				-30
			],
			[
				44,
				-10
			],
			[
				44,
				8
			],
			[
				91,
				60
			],
			[
				137,
				110
			],
			[
				132,
				68
			],
			[
				193,
				38
			],
			[
				65,
				119
			],
			[
				89,
				78
			],
			[
				204,
				116
			],
			[
				111,
				44
			],
			[
				63,
				8
			],
			[
				80,
				-21
			],
			[
				18,
				-7
			],
			[
				16,
				-6
			],
			[
				41,
				-9
			],
			[
				9,
				-36
			],
			[
				-11,
				-38
			],
			[
				-44,
				-32
			],
			[
				-14,
				-24
			],
			[
				17,
				-18
			],
			[
				62,
				-7
			],
			[
				128,
				43
			],
			[
				84,
				27
			],
			[
				58,
				11
			],
			[
				23,
				35
			],
			[
				36,
				36
			],
			[
				58,
				3
			],
			[
				62,
				-20
			],
			[
				51,
				-10
			],
			[
				88,
				10
			],
			[
				46,
				-31
			],
			[
				64,
				-59
			],
			[
				29,
				-36
			],
			[
				10,
				-9
			]
		],
		[
			[
				134084,
				76252
			],
			[
				197,
				18
			],
			[
				156,
				-30
			],
			[
				82,
				-82
			],
			[
				80,
				-21
			],
			[
				79,
				40
			],
			[
				49,
				7
			],
			[
				19,
				-25
			],
			[
				39,
				-11
			],
			[
				60,
				4
			],
			[
				34,
				-23
			],
			[
				4,
				-23
			]
		],
		[
			[
				130685,
				74826
			],
			[
				54,
				8
			],
			[
				21,
				-30
			],
			[
				29,
				-39
			],
			[
				78,
				-73
			],
			[
				50,
				-21
			],
			[
				64,
				-10
			],
			[
				78,
				10
			],
			[
				63,
				13
			],
			[
				30,
				-3
			],
			[
				68,
				-53
			],
			[
				80,
				-74
			],
			[
				26,
				-33
			],
			[
				11,
				-50
			],
			[
				24,
				-15
			],
			[
				51,
				50
			],
			[
				49,
				16
			],
			[
				46,
				-9
			],
			[
				50,
				-6
			],
			[
				50,
				18
			],
			[
				22,
				14
			],
			[
				88,
				64
			],
			[
				79,
				49
			],
			[
				49,
				31
			],
			[
				18,
				100
			],
			[
				22,
				58
			],
			[
				33,
				33
			],
			[
				-12,
				41
			],
			[
				-14,
				32
			],
			[
				-14,
				43
			],
			[
				14,
				23
			],
			[
				32,
				10
			],
			[
				79,
				0
			],
			[
				139,
				45
			],
			[
				116,
				45
			],
			[
				108,
				37
			],
			[
				48,
				6
			],
			[
				47,
				-6
			],
			[
				21,
				10
			],
			[
				6,
				35
			],
			[
				26,
				37
			],
			[
				60,
				30
			],
			[
				112,
				64
			],
			[
				99,
				95
			],
			[
				35,
				71
			],
			[
				24,
				105
			],
			[
				46,
				161
			],
			[
				51,
				177
			],
			[
				19,
				78
			],
			[
				22,
				60
			],
			[
				87,
				51
			],
			[
				90,
				36
			],
			[
				138,
				8
			],
			[
				162,
				3
			],
			[
				34,
				97
			],
			[
				22,
				82
			],
			[
				27,
				42
			],
			[
				39,
				35
			],
			[
				14,
				7
			],
			[
				88,
				-51
			],
			[
				134,
				-77
			],
			[
				156,
				-38
			],
			[
				79,
				-19
			],
			[
				32,
				3
			]
		],
		[
			[
				150917,
				63576
			],
			[
				-9,
				58
			],
			[
				-19,
				298
			],
			[
				-14,
				96
			],
			[
				-12,
				131
			],
			[
				-17,
				41
			],
			[
				-22,
				72
			],
			[
				-24,
				62
			],
			[
				-21,
				26
			],
			[
				-13,
				116
			],
			[
				-5,
				143
			],
			[
				1,
				67
			],
			[
				-29,
				139
			],
			[
				-28,
				158
			],
			[
				-39,
				-7
			],
			[
				-22,
				38
			],
			[
				-16,
				-1
			],
			[
				-54,
				-35
			],
			[
				-42,
				11
			],
			[
				-32,
				-5
			],
			[
				0,
				-72
			],
			[
				5,
				-77
			],
			[
				-12,
				-28
			],
			[
				-83,
				-91
			],
			[
				-23,
				-60
			],
			[
				2,
				-64
			],
			[
				10,
				-86
			],
			[
				-14,
				-43
			],
			[
				-37,
				-40
			],
			[
				-48,
				-21
			],
			[
				-43,
				10
			],
			[
				-27,
				35
			],
			[
				-26,
				88
			],
			[
				-23,
				49
			],
			[
				-23,
				11
			],
			[
				-19,
				-13
			],
			[
				-3,
				-56
			],
			[
				2,
				-46
			],
			[
				-6,
				-5
			],
			[
				-14,
				7
			],
			[
				-15,
				23
			],
			[
				-40,
				222
			],
			[
				-57,
				171
			],
			[
				-3,
				66
			],
			[
				21,
				84
			],
			[
				25,
				130
			],
			[
				68,
				81
			],
			[
				9,
				34
			],
			[
				11,
				28
			],
			[
				16,
				5
			],
			[
				87,
				-8
			],
			[
				29,
				13
			],
			[
				25,
				38
			],
			[
				38,
				31
			],
			[
				37,
				13
			],
			[
				30,
				4
			],
			[
				47,
				-29
			],
			[
				20,
				17
			],
			[
				14,
				53
			],
			[
				21,
				54
			],
			[
				13,
				26
			],
			[
				32,
				11
			],
			[
				41,
				3
			],
			[
				14,
				10
			],
			[
				10,
				18
			],
			[
				11,
				71
			],
			[
				52,
				158
			],
			[
				18,
				70
			],
			[
				3,
				13
			],
			[
				-2,
				78
			],
			[
				15,
				12
			],
			[
				86,
				-39
			],
			[
				38,
				1
			],
			[
				21,
				16
			],
			[
				6,
				28
			],
			[
				-11,
				34
			],
			[
				-61,
				59
			],
			[
				-109,
				79
			],
			[
				-100,
				48
			],
			[
				-185,
				-7
			],
			[
				-184,
				-16
			],
			[
				-53,
				8
			],
			[
				-67,
				22
			],
			[
				-165,
				-3
			],
			[
				-199,
				-12
			],
			[
				-76,
				6
			],
			[
				-37,
				-1
			],
			[
				-75,
				-7
			],
			[
				-122,
				23
			],
			[
				-84,
				29
			],
			[
				-75,
				31
			],
			[
				-89,
				29
			],
			[
				-21,
				0
			],
			[
				-13,
				10
			],
			[
				-8,
				25
			],
			[
				-3,
				33
			],
			[
				18,
				152
			],
			[
				-16,
				231
			],
			[
				15,
				83
			],
			[
				-73,
				190
			],
			[
				-25,
				35
			],
			[
				-34,
				2
			],
			[
				-21,
				-25
			],
			[
				-9,
				-44
			],
			[
				12,
				-49
			],
			[
				-26,
				-56
			],
			[
				-54,
				-18
			],
			[
				-63,
				19
			],
			[
				-52,
				26
			],
			[
				-66,
				56
			],
			[
				-51,
				80
			],
			[
				-4,
				87
			],
			[
				-23,
				57
			],
			[
				-31,
				27
			],
			[
				-22,
				8
			],
			[
				-21,
				-6
			],
			[
				-18,
				-31
			],
			[
				16,
				-30
			],
			[
				21,
				-43
			],
			[
				-7,
				-29
			],
			[
				-19,
				-5
			],
			[
				-29,
				13
			],
			[
				-44,
				-7
			],
			[
				-43,
				22
			],
			[
				-25,
				2
			],
			[
				-26,
				8
			],
			[
				-1,
				51
			],
			[
				-39,
				64
			],
			[
				-66,
				72
			],
			[
				-65,
				44
			],
			[
				-31,
				-6
			],
			[
				-15,
				-49
			],
			[
				3,
				-18
			],
			[
				23,
				-9
			],
			[
				32,
				-29
			],
			[
				7,
				-29
			],
			[
				-4,
				-26
			],
			[
				-41,
				-48
			],
			[
				-28,
				-45
			],
			[
				-64,
				-65
			],
			[
				-54,
				-75
			],
			[
				-15,
				-57
			],
			[
				-20,
				-51
			],
			[
				-8,
				-56
			],
			[
				14,
				-39
			],
			[
				26,
				-25
			],
			[
				69,
				-18
			],
			[
				71,
				-75
			],
			[
				57,
				-102
			],
			[
				33,
				-31
			],
			[
				59,
				-34
			],
			[
				113,
				-4
			],
			[
				17,
				-29
			],
			[
				16,
				-74
			],
			[
				22,
				-27
			],
			[
				58,
				-35
			],
			[
				5,
				-26
			],
			[
				-14,
				-30
			],
			[
				-26,
				-24
			],
			[
				-47,
				-15
			],
			[
				-45,
				-6
			],
			[
				-45,
				10
			],
			[
				-67,
				6
			],
			[
				-76,
				1
			],
			[
				-54,
				-188
			],
			[
				-38,
				-65
			],
			[
				-22,
				0
			],
			[
				-59,
				32
			],
			[
				-25,
				-5
			],
			[
				-68,
				-167
			],
			[
				-9,
				-40
			],
			[
				-5,
				-30
			],
			[
				36,
				-64
			],
			[
				43,
				-53
			],
			[
				52,
				-21
			],
			[
				40,
				16
			],
			[
				32,
				-21
			],
			[
				39,
				-54
			],
			[
				65,
				-35
			],
			[
				93,
				-17
			],
			[
				53,
				-42
			],
			[
				6,
				-36
			],
			[
				-4,
				-37
			],
			[
				-9,
				-96
			],
			[
				-9,
				-55
			],
			[
				-50,
				-146
			],
			[
				-35,
				-125
			],
			[
				18,
				-60
			],
			[
				13,
				-24
			],
			[
				13,
				-19
			],
			[
				40,
				-47
			],
			[
				28,
				-46
			],
			[
				-24,
				-119
			],
			[
				13,
				-31
			],
			[
				54,
				-21
			],
			[
				58,
				-16
			],
			[
				20,
				-19
			],
			[
				-50,
				-121
			],
			[
				10,
				-84
			],
			[
				21,
				-78
			],
			[
				16,
				-129
			],
			[
				2,
				-13
			],
			[
				-4,
				-33
			],
			[
				33,
				-100
			],
			[
				51,
				-194
			],
			[
				3,
				-73
			],
			[
				-3,
				-77
			]
		],
		[
			[
				92647,
				55262
			],
			[
				15,
				85
			],
			[
				-32,
				156
			],
			[
				2,
				27
			],
			[
				67,
				34
			],
			[
				83,
				26
			],
			[
				32,
				2
			],
			[
				22,
				13
			],
			[
				30,
				34
			],
			[
				50,
				25
			],
			[
				29,
				-9
			],
			[
				18,
				-4
			],
			[
				175,
				-206
			],
			[
				76,
				-104
			],
			[
				21,
				-54
			],
			[
				39,
				-38
			],
			[
				58,
				-24
			],
			[
				53,
				-53
			],
			[
				41,
				-75
			]
		],
		[
			[
				103128,
				48320
			],
			[
				7,
				-144
			],
			[
				-48,
				-179
			],
			[
				-37,
				-134
			],
			[
				-95,
				-222
			],
			[
				-85,
				-198
			],
			[
				-90,
				-332
			],
			[
				0,
				-242
			],
			[
				-9,
				-152
			],
			[
				-30,
				-93
			],
			[
				-71,
				-251
			],
			[
				-11,
				-215
			],
			[
				26,
				-264
			],
			[
				-24,
				-250
			],
			[
				-74,
				-236
			],
			[
				-32,
				-186
			],
			[
				19,
				-224
			],
			[
				-136,
				-186
			],
			[
				-171,
				-185
			],
			[
				-110,
				-54
			],
			[
				-86,
				-62
			],
			[
				-61,
				-71
			],
			[
				-20,
				-38
			],
			[
				-45,
				-86
			],
			[
				-102,
				-266
			],
			[
				-53,
				-116
			],
			[
				-69,
				-100
			],
			[
				-103,
				-121
			],
			[
				-38,
				-58
			],
			[
				-15,
				-83
			],
			[
				6,
				-153
			],
			[
				10,
				-467
			],
			[
				-17,
				-135
			],
			[
				-28,
				-223
			],
			[
				-101,
				-249
			],
			[
				-76,
				-138
			],
			[
				-77,
				-43
			],
			[
				-99,
				-37
			],
			[
				-48,
				-47
			],
			[
				-29,
				-69
			],
			[
				-56,
				-61
			],
			[
				-82,
				-51
			],
			[
				-104,
				-127
			],
			[
				-126,
				-201
			],
			[
				-86,
				-116
			],
			[
				-46,
				-30
			],
			[
				-48,
				-2
			],
			[
				-49,
				24
			],
			[
				-41,
				3
			],
			[
				-21,
				-11
			],
			[
				-13,
				9
			],
			[
				-20,
				19
			],
			[
				1,
				46
			],
			[
				-6,
				77
			],
			[
				-24,
				80
			],
			[
				29,
				63
			],
			[
				25,
				49
			],
			[
				-4,
				25
			],
			[
				-26,
				41
			],
			[
				-29,
				58
			],
			[
				-27,
				-4
			],
			[
				-58,
				-45
			],
			[
				-60,
				-34
			],
			[
				-56,
				-15
			],
			[
				-44,
				-36
			],
			[
				-24,
				-19
			],
			[
				-38,
				0
			],
			[
				-21,
				21
			],
			[
				-47,
				21
			],
			[
				-25,
				-7
			],
			[
				-14,
				-10
			],
			[
				-6,
				-74
			],
			[
				-5,
				-61
			],
			[
				-9,
				-58
			],
			[
				-17,
				-28
			],
			[
				-70,
				-29
			],
			[
				-47,
				-39
			],
			[
				-41,
				-27
			],
			[
				-25,
				6
			],
			[
				-51,
				53
			],
			[
				-50,
				49
			],
			[
				-28,
				42
			],
			[
				-16,
				29
			],
			[
				-10,
				13
			],
			[
				-32,
				2
			],
			[
				-9,
				-27
			]
		],
		[
			[
				109825,
				20711
			],
			[
				34,
				27
			],
			[
				45,
				40
			],
			[
				15,
				97
			],
			[
				13,
				83
			],
			[
				35,
				40
			],
			[
				35,
				27
			],
			[
				28,
				43
			],
			[
				36,
				103
			],
			[
				24,
				101
			],
			[
				3,
				41
			],
			[
				-13,
				42
			],
			[
				-22,
				46
			],
			[
				-23,
				60
			],
			[
				-27,
				10
			],
			[
				-52,
				34
			],
			[
				-78,
				69
			],
			[
				-67,
				59
			],
			[
				-63,
				87
			],
			[
				-26,
				14
			],
			[
				-61,
				59
			],
			[
				-26,
				34
			],
			[
				-19,
				40
			],
			[
				-17,
				14
			],
			[
				-28,
				-11
			],
			[
				-72,
				-18
			],
			[
				-154,
				-70
			],
			[
				-96,
				-65
			],
			[
				-81,
				-77
			],
			[
				-83,
				-29
			],
			[
				-61,
				-26
			],
			[
				-49,
				-88
			],
			[
				-45,
				-82
			],
			[
				-41,
				-74
			],
			[
				-23,
				-34
			],
			[
				-22,
				-21
			],
			[
				-21,
				-47
			],
			[
				-44,
				-79
			],
			[
				-40,
				-53
			],
			[
				-57,
				-28
			],
			[
				-72,
				-38
			],
			[
				-25,
				-21
			],
			[
				-3,
				-32
			],
			[
				26,
				-74
			],
			[
				25,
				-71
			],
			[
				40,
				-84
			],
			[
				30,
				-61
			],
			[
				47,
				-74
			],
			[
				28,
				-44
			],
			[
				-4,
				-73
			],
			[
				9,
				-26
			],
			[
				16,
				-31
			],
			[
				13,
				-7
			],
			[
				15,
				-11
			],
			[
				39,
				-21
			],
			[
				10,
				-14
			],
			[
				27,
				-25
			],
			[
				26,
				-46
			],
			[
				50,
				-62
			],
			[
				56,
				-48
			],
			[
				96,
				-20
			],
			[
				75,
				-15
			],
			[
				25,
				10
			],
			[
				26,
				38
			],
			[
				21,
				49
			],
			[
				6,
				62
			],
			[
				24,
				33
			],
			[
				90,
				158
			],
			[
				50,
				58
			],
			[
				30,
				4
			],
			[
				39,
				12
			],
			[
				50,
				4
			],
			[
				37,
				-4
			],
			[
				8,
				2
			],
			[
				58,
				20
			],
			[
				107,
				52
			],
			[
				48,
				32
			]
		],
		[
			[
				110076,
				27148
			],
			[
				8,
				1
			],
			[
				185,
				39
			],
			[
				155,
				-32
			],
			[
				186,
				-88
			],
			[
				174,
				-31
			],
			[
				162,
				26
			],
			[
				133,
				6
			],
			[
				101,
				-14
			],
			[
				80,
				-31
			],
			[
				59,
				-47
			]
		],
		[
			[
				104013,
				25018
			],
			[
				31,
				-25
			],
			[
				205,
				-183
			],
			[
				55,
				-97
			],
			[
				27,
				-61
			],
			[
				88,
				-223
			],
			[
				66,
				-199
			],
			[
				53,
				-151
			],
			[
				4,
				-69
			],
			[
				7,
				-67
			],
			[
				8,
				-33
			],
			[
				-5,
				-36
			],
			[
				-37,
				-82
			],
			[
				-39,
				-63
			],
			[
				-46,
				-85
			],
			[
				-4,
				-113
			],
			[
				14,
				-133
			],
			[
				28,
				-67
			],
			[
				36,
				-21
			],
			[
				84,
				33
			],
			[
				54,
				-11
			],
			[
				75,
				-25
			],
			[
				249,
				16
			],
			[
				30,
				-8
			],
			[
				93,
				-10
			],
			[
				31,
				11
			],
			[
				28,
				28
			],
			[
				33,
				80
			],
			[
				29,
				26
			],
			[
				53,
				14
			],
			[
				62,
				21
			],
			[
				51,
				46
			],
			[
				82,
				158
			],
			[
				164,
				140
			],
			[
				50,
				34
			],
			[
				32,
				37
			],
			[
				27,
				51
			],
			[
				58,
				176
			],
			[
				43,
				147
			],
			[
				15,
				70
			],
			[
				39,
				113
			],
			[
				46,
				72
			],
			[
				46,
				38
			],
			[
				23,
				10
			],
			[
				59,
				19
			],
			[
				76,
				18
			],
			[
				79,
				-20
			],
			[
				86,
				-44
			],
			[
				96,
				-74
			],
			[
				99,
				-91
			],
			[
				45,
				-46
			],
			[
				49,
				-21
			],
			[
				87,
				-7
			],
			[
				58,
				1
			],
			[
				89,
				-90
			],
			[
				45,
				-6
			],
			[
				100,
				-27
			],
			[
				124,
				-29
			],
			[
				79,
				3
			],
			[
				83,
				49
			],
			[
				61,
				3
			],
			[
				78,
				-4
			],
			[
				86,
				13
			],
			[
				63,
				21
			],
			[
				48,
				43
			],
			[
				42,
				46
			],
			[
				49,
				139
			],
			[
				28,
				112
			],
			[
				43,
				128
			],
			[
				54,
				175
			],
			[
				19,
				121
			],
			[
				19,
				34
			],
			[
				78,
				37
			],
			[
				64,
				25
			],
			[
				172,
				48
			],
			[
				35,
				25
			],
			[
				32,
				58
			],
			[
				75,
				97
			],
			[
				93,
				81
			],
			[
				48,
				46
			],
			[
				87,
				394
			],
			[
				11,
				49
			],
			[
				64,
				104
			],
			[
				39,
				44
			],
			[
				25,
				1
			],
			[
				36,
				28
			],
			[
				47,
				54
			],
			[
				55,
				33
			],
			[
				65,
				13
			],
			[
				41,
				36
			],
			[
				19,
				59
			],
			[
				33,
				29
			],
			[
				47,
				-1
			],
			[
				27,
				18
			],
			[
				7,
				40
			],
			[
				28,
				34
			],
			[
				51,
				28
			],
			[
				26,
				33
			],
			[
				2,
				38
			],
			[
				60,
				94
			],
			[
				118,
				148
			],
			[
				111,
				83
			],
			[
				104,
				17
			],
			[
				99,
				31
			],
			[
				93,
				45
			],
			[
				68,
				70
			],
			[
				44,
				97
			],
			[
				75,
				53
			],
			[
				152,
				16
			]
		],
		[
			[
				113691,
				35903
			],
			[
				144,
				3
			],
			[
				152,
				-7
			],
			[
				22,
				-5
			],
			[
				34,
				-13
			],
			[
				39,
				2
			],
			[
				43,
				17
			],
			[
				48,
				41
			],
			[
				52,
				65
			],
			[
				81,
				-1
			],
			[
				110,
				-68
			],
			[
				61,
				-60
			],
			[
				10,
				-50
			],
			[
				74,
				-30
			],
			[
				137,
				-8
			],
			[
				101,
				26
			],
			[
				62,
				61
			],
			[
				66,
				33
			],
			[
				69,
				3
			],
			[
				52,
				-21
			],
			[
				35,
				-45
			],
			[
				67,
				-32
			],
			[
				100,
				-20
			],
			[
				109,
				29
			],
			[
				119,
				78
			],
			[
				67,
				81
			],
			[
				17,
				85
			],
			[
				19,
				52
			],
			[
				23,
				18
			],
			[
				63,
				10
			],
			[
				103,
				3
			],
			[
				89,
				-27
			],
			[
				114,
				-84
			],
			[
				72,
				56
			],
			[
				124,
				96
			],
			[
				125,
				51
			],
			[
				118,
				0
			],
			[
				97,
				37
			],
			[
				76,
				72
			],
			[
				81,
				46
			],
			[
				84,
				20
			],
			[
				80,
				35
			],
			[
				110,
				76
			],
			[
				115,
				110
			],
			[
				117,
				112
			],
			[
				75,
				72
			]
		],
		[
			[
				36605,
				54506
			],
			[
				60,
				-65
			],
			[
				32,
				-49
			],
			[
				6,
				-33
			],
			[
				18,
				-17
			],
			[
				47,
				-4
			],
			[
				114,
				-34
			],
			[
				70,
				7
			],
			[
				63,
				35
			],
			[
				35,
				42
			],
			[
				11,
				66
			]
		],
		[
			[
				109290,
				91751
			],
			[
				-19,
				2
			],
			[
				-56,
				-10
			],
			[
				-88,
				-47
			],
			[
				-130,
				-111
			],
			[
				-34,
				-25
			],
			[
				-34,
				-84
			],
			[
				-8,
				-9
			],
			[
				-76,
				4
			],
			[
				-21,
				2
			],
			[
				-76,
				-2
			],
			[
				-166,
				22
			],
			[
				-64,
				-14
			],
			[
				-84,
				-86
			],
			[
				-33,
				-12
			],
			[
				-98,
				-12
			],
			[
				-17,
				-10
			]
		],
		[
			[
				109332,
				82933
			],
			[
				68,
				-85
			],
			[
				86,
				-45
			],
			[
				200,
				-48
			],
			[
				18,
				5
			],
			[
				2,
				9
			],
			[
				-14,
				13
			],
			[
				-2,
				16
			],
			[
				9,
				19
			],
			[
				28,
				1
			],
			[
				45,
				-17
			],
			[
				86,
				25
			],
			[
				127,
				68
			],
			[
				116,
				14
			],
			[
				106,
				-41
			],
			[
				55,
				-46
			],
			[
				35,
				-45
			]
		],
		[
			[
				104904,
				82419
			],
			[
				106,
				-30
			],
			[
				47,
				-29
			],
			[
				26,
				-37
			],
			[
				67,
				-25
			],
			[
				109,
				-12
			],
			[
				76,
				-38
			],
			[
				43,
				-64
			],
			[
				70,
				15
			],
			[
				96,
				96
			],
			[
				95,
				24
			],
			[
				94,
				-45
			],
			[
				51,
				-38
			],
			[
				8,
				-29
			],
			[
				-22,
				-12
			],
			[
				-52,
				6
			],
			[
				-42,
				-18
			],
			[
				-34,
				-42
			],
			[
				-5,
				-45
			],
			[
				24,
				-47
			],
			[
				33,
				-33
			],
			[
				42,
				-18
			],
			[
				23,
				-25
			],
			[
				3,
				-31
			],
			[
				11,
				-9
			]
		],
		[
			[
				127437,
				66319
			],
			[
				-12,
				-31
			],
			[
				-3,
				-44
			],
			[
				19,
				-4
			],
			[
				27,
				22
			],
			[
				3,
				36
			],
			[
				-6,
				18
			],
			[
				-28,
				3
			]
		],
		[
			[
				111852,
				23317
			],
			[
				56,
				5
			],
			[
				99,
				-23
			],
			[
				81,
				3
			],
			[
				71,
				2
			],
			[
				122,
				4
			],
			[
				70,
				1
			]
		],
		[
			[
				137453,
				78423
			],
			[
				-36,
				-11
			],
			[
				-8,
				-18
			],
			[
				24,
				-24
			],
			[
				31,
				-8
			],
			[
				17,
				35
			],
			[
				7,
				37
			],
			[
				-16,
				-1
			],
			[
				-19,
				-10
			]
		],
		[
			[
				11834,
				85855
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				68,
				0
			],
			[
				208,
				0
			],
			[
				275,
				0
			],
			[
				157,
				0
			],
			[
				119,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				62,
				0
			],
			[
				213,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				208,
				0
			],
			[
				68,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				206,
				0
			],
			[
				70,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				276,
				0
			],
			[
				275,
				0
			],
			[
				153,
				-1
			],
			[
				2,
				174
			],
			[
				2,
				137
			],
			[
				140,
				-17
			],
			[
				41,
				-25
			],
			[
				14,
				-11
			],
			[
				-4,
				-38
			],
			[
				11,
				-115
			],
			[
				26,
				-96
			],
			[
				58,
				-115
			],
			[
				0,
				-1
			],
			[
				5,
				-45
			],
			[
				19,
				-28
			],
			[
				36,
				-26
			],
			[
				133,
				-32
			],
			[
				232,
				-37
			],
			[
				132,
				-43
			],
			[
				31,
				-48
			],
			[
				62,
				-19
			],
			[
				92,
				9
			],
			[
				65,
				21
			],
			[
				56,
				45
			],
			[
				77,
				10
			],
			[
				66,
				-3
			],
			[
				67,
				-4
			],
			[
				36,
				-7
			],
			[
				103,
				-36
			],
			[
				68,
				-30
			],
			[
				96,
				-55
			],
			[
				53,
				-24
			],
			[
				26,
				-58
			],
			[
				30,
				-73
			],
			[
				43,
				0
			],
			[
				32,
				43
			],
			[
				82,
				8
			],
			[
				108,
				-30
			],
			[
				94,
				-86
			],
			[
				137,
				-77
			],
			[
				83,
				-38
			],
			[
				85,
				0
			],
			[
				107,
				38
			],
			[
				115,
				73
			],
			[
				82,
				13
			],
			[
				49,
				-7
			],
			[
				28,
				-57
			],
			[
				34,
				-22
			],
			[
				89,
				7
			],
			[
				185,
				-12
			],
			[
				148,
				16
			],
			[
				33,
				-33
			],
			[
				30,
				-52
			],
			[
				60,
				-16
			],
			[
				81,
				16
			],
			[
				145,
				-12
			],
			[
				34,
				-2
			],
			[
				28,
				-1
			],
			[
				118,
				19
			],
			[
				56,
				23
			],
			[
				80,
				38
			],
			[
				106,
				51
			],
			[
				185,
				89
			],
			[
				151,
				33
			],
			[
				141,
				-64
			],
			[
				111,
				-57
			],
			[
				44,
				-22
			],
			[
				114,
				-57
			],
			[
				161,
				-82
			],
			[
				185,
				-93
			],
			[
				185,
				-94
			],
			[
				161,
				-81
			],
			[
				114,
				-58
			],
			[
				44,
				-22
			],
			[
				125,
				-66
			],
			[
				125,
				-66
			],
			[
				126,
				-66
			],
			[
				125,
				-66
			],
			[
				126,
				-66
			],
			[
				125,
				-66
			],
			[
				125,
				-66
			],
			[
				126,
				-66
			],
			[
				31,
				-109
			],
			[
				31,
				-107
			],
			[
				74,
				-78
			],
			[
				67,
				-71
			],
			[
				39,
				4
			],
			[
				39,
				30
			],
			[
				25,
				15
			],
			[
				42,
				2
			],
			[
				94,
				26
			],
			[
				27,
				-6
			],
			[
				16,
				-13
			],
			[
				1,
				-20
			],
			[
				-3,
				-16
			],
			[
				-14,
				-32
			],
			[
				22,
				-61
			],
			[
				5,
				-68
			],
			[
				13,
				-51
			],
			[
				38,
				-65
			],
			[
				33,
				-52
			],
			[
				42,
				-10
			],
			[
				97,
				30
			],
			[
				60,
				12
			],
			[
				35,
				-5
			],
			[
				59,
				-48
			],
			[
				29,
				-29
			],
			[
				7,
				-24
			],
			[
				-80,
				-146
			],
			[
				126,
				-73
			],
			[
				141,
				-80
			],
			[
				168,
				-94
			],
			[
				103,
				-58
			],
			[
				135,
				-83
			],
			[
				23,
				-118
			],
			[
				20,
				-99
			],
			[
				24,
				-139
			],
			[
				26,
				-142
			],
			[
				25,
				-141
			],
			[
				27,
				-149
			],
			[
				29,
				-165
			],
			[
				26,
				-145
			],
			[
				29,
				-160
			],
			[
				38,
				-207
			],
			[
				-34,
				-80
			],
			[
				-74,
				-174
			],
			[
				-67,
				-157
			],
			[
				-6,
				-45
			],
			[
				-46,
				-230
			],
			[
				-36,
				-94
			],
			[
				-65,
				-55
			],
			[
				-64,
				-53
			],
			[
				-80,
				-90
			],
			[
				-87,
				-44
			],
			[
				-45,
				-26
			],
			[
				-24,
				-41
			],
			[
				-26,
				-89
			],
			[
				5,
				-137
			],
			[
				13,
				-22
			],
			[
				60,
				-96
			],
			[
				105,
				-66
			],
			[
				114,
				-64
			],
			[
				162,
				-1
			],
			[
				146,
				86
			],
			[
				155,
				91
			],
			[
				137,
				81
			],
			[
				164,
				96
			],
			[
				149,
				87
			],
			[
				161,
				31
			],
			[
				223,
				44
			],
			[
				105,
				20
			],
			[
				176,
				34
			],
			[
				137,
				63
			],
			[
				177,
				80
			],
			[
				204,
				93
			],
			[
				176,
				80
			],
			[
				89,
				44
			],
			[
				63,
				51
			],
			[
				15,
				37
			],
			[
				-4,
				22
			],
			[
				-16,
				21
			],
			[
				-22,
				16
			],
			[
				-20,
				14
			],
			[
				-10,
				17
			],
			[
				-1,
				36
			],
			[
				-13,
				21
			],
			[
				-11,
				16
			],
			[
				4,
				142
			],
			[
				-15,
				44
			],
			[
				-58,
				111
			],
			[
				110,
				50
			],
			[
				101,
				46
			],
			[
				81,
				35
			],
			[
				169,
				5
			],
			[
				158,
				-1
			],
			[
				216,
				-1
			],
			[
				183,
				0
			],
			[
				213,
				-1
			],
			[
				125,
				-1
			],
			[
				164,
				2
			],
			[
				80,
				128
			],
			[
				71,
				116
			],
			[
				79,
				109
			],
			[
				139,
				130
			],
			[
				41,
				23
			],
			[
				22,
				51
			],
			[
				85,
				48
			],
			[
				93,
				45
			],
			[
				36,
				42
			],
			[
				18,
				24
			],
			[
				253,
				227
			],
			[
				143,
				105
			],
			[
				118,
				58
			],
			[
				90,
				28
			],
			[
				61,
				-4
			],
			[
				35,
				4
			],
			[
				29,
				0
			],
			[
				151,
				0
			],
			[
				269,
				1
			],
			[
				269,
				0
			],
			[
				158,
				0
			],
			[
				110,
				0
			],
			[
				269,
				1
			],
			[
				269,
				0
			],
			[
				269,
				0
			],
			[
				269,
				1
			],
			[
				64,
				159
			],
			[
				59,
				74
			],
			[
				81,
				-25
			],
			[
				43,
				2
			],
			[
				33,
				26
			],
			[
				15,
				13
			],
			[
				39,
				23
			],
			[
				26,
				-4
			],
			[
				22,
				-35
			],
			[
				18,
				-23
			],
			[
				21,
				7
			],
			[
				19,
				33
			],
			[
				-1,
				46
			],
			[
				25,
				31
			],
			[
				30,
				5
			],
			[
				27,
				-1
			],
			[
				14,
				16
			],
			[
				-2,
				22
			],
			[
				-10,
				36
			],
			[
				4,
				43
			],
			[
				68,
				77
			],
			[
				84,
				52
			],
			[
				29,
				25
			],
			[
				9,
				53
			],
			[
				48,
				55
			],
			[
				24,
				31
			],
			[
				6,
				27
			],
			[
				-13,
				34
			],
			[
				2,
				64
			],
			[
				16,
				76
			],
			[
				20,
				83
			],
			[
				44,
				75
			],
			[
				73,
				82
			],
			[
				19,
				108
			],
			[
				19,
				113
			],
			[
				88,
				110
			],
			[
				100,
				126
			],
			[
				57,
				71
			],
			[
				102,
				130
			],
			[
				73,
				92
			],
			[
				36,
				43
			],
			[
				39,
				50
			],
			[
				62,
				-15
			],
			[
				62,
				-15
			],
			[
				-9,
				-73
			],
			[
				7,
				-36
			],
			[
				3,
				-17
			],
			[
				29,
				-31
			],
			[
				43,
				-21
			],
			[
				32,
				-7
			],
			[
				38,
				1
			],
			[
				104,
				41
			],
			[
				121,
				27
			],
			[
				67,
				25
			],
			[
				12,
				23
			],
			[
				31,
				8
			],
			[
				48,
				-7
			],
			[
				90,
				-58
			],
			[
				105,
				-89
			],
			[
				82,
				-70
			],
			[
				3,
				-121
			],
			[
				2,
				-129
			],
			[
				1,
				-135
			],
			[
				2,
				-97
			],
			[
				2,
				-132
			],
			[
				1,
				-106
			],
			[
				3,
				-138
			],
			[
				1,
				-74
			],
			[
				11,
				-21
			],
			[
				-7,
				-29
			],
			[
				-3,
				-14
			],
			[
				1,
				-12
			],
			[
				5,
				-15
			],
			[
				-1,
				-20
			],
			[
				-11,
				-18
			],
			[
				-5,
				-22
			],
			[
				-2,
				-34
			],
			[
				12,
				-22
			],
			[
				19,
				-12
			],
			[
				16,
				0
			],
			[
				20,
				-13
			],
			[
				27,
				-22
			],
			[
				40,
				-19
			],
			[
				41,
				-7
			],
			[
				29,
				5
			],
			[
				35,
				-13
			],
			[
				12,
				-31
			],
			[
				-7,
				-29
			],
			[
				-19,
				-14
			],
			[
				-21,
				-10
			],
			[
				-4,
				-22
			],
			[
				10,
				-24
			],
			[
				16,
				-20
			],
			[
				16,
				-36
			],
			[
				-7,
				-31
			],
			[
				-15,
				-26
			],
			[
				-7,
				-27
			],
			[
				13,
				-23
			],
			[
				34,
				-31
			],
			[
				22,
				-30
			],
			[
				33,
				-16
			],
			[
				16,
				11
			],
			[
				13,
				16
			],
			[
				13,
				11
			],
			[
				24,
				-7
			],
			[
				27,
				-8
			],
			[
				30,
				-11
			]
		],
		[
			[
				113691,
				35904
			],
			[
				-4,
				27
			],
			[
				-11,
				67
			],
			[
				-30,
				57
			],
			[
				-25,
				35
			],
			[
				-32,
				9
			],
			[
				-18,
				-1
			],
			[
				-14,
				27
			],
			[
				-17,
				58
			],
			[
				-24,
				50
			],
			[
				-33,
				42
			],
			[
				-19,
				38
			],
			[
				-7,
				36
			],
			[
				5,
				39
			],
			[
				31,
				97
			],
			[
				9,
				66
			],
			[
				-3,
				68
			],
			[
				-17,
				70
			],
			[
				-34,
				82
			],
			[
				4,
				24
			],
			[
				-12,
				57
			],
			[
				-1,
				39
			],
			[
				7,
				50
			],
			[
				-7,
				65
			],
			[
				-29,
				138
			],
			[
				0,
				36
			],
			[
				-31,
				67
			],
			[
				-96,
				158
			],
			[
				-5,
				21
			],
			[
				-150,
				160
			],
			[
				-60,
				35
			],
			[
				-21,
				-30
			],
			[
				-9,
				-28
			],
			[
				7,
				-51
			],
			[
				-4,
				-26
			],
			[
				-6,
				-11
			],
			[
				-36,
				1
			]
		],
		[
			[
				160866,
				63188
			],
			[
				-42,
				44
			],
			[
				-69,
				69
			],
			[
				-27,
				9
			],
			[
				-77,
				-34
			],
			[
				-109,
				-13
			],
			[
				-25,
				36
			],
			[
				-53,
				-27
			],
			[
				-51,
				83
			],
			[
				-60,
				6
			],
			[
				-76,
				63
			],
			[
				-27,
				34
			],
			[
				-9,
				48
			],
			[
				-22,
				25
			],
			[
				-30,
				-3
			],
			[
				-33,
				26
			],
			[
				-52,
				25
			],
			[
				-41,
				15
			],
			[
				-21,
				-11
			],
			[
				-22,
				-6
			],
			[
				-4,
				32
			],
			[
				2,
				98
			],
			[
				-4,
				86
			],
			[
				-12,
				39
			],
			[
				-28,
				30
			],
			[
				-25,
				14
			],
			[
				-11,
				44
			],
			[
				9,
				88
			],
			[
				20,
				59
			],
			[
				33,
				10
			],
			[
				44,
				43
			],
			[
				23,
				60
			],
			[
				28,
				56
			],
			[
				-101,
				79
			],
			[
				-53,
				28
			],
			[
				-59,
				-12
			],
			[
				-72,
				-25
			],
			[
				-39,
				-5
			],
			[
				-19,
				10
			],
			[
				-42,
				71
			],
			[
				-23,
				12
			],
			[
				-52,
				5
			],
			[
				-43,
				-1
			],
			[
				-25,
				-31
			],
			[
				-39,
				-10
			],
			[
				-38,
				-2
			],
			[
				-39,
				38
			],
			[
				-59,
				50
			],
			[
				-93,
				36
			],
			[
				-11,
				40
			],
			[
				-23,
				49
			],
			[
				-36,
				45
			],
			[
				-57,
				59
			],
			[
				-49,
				31
			],
			[
				-24,
				-19
			],
			[
				-32,
				-33
			],
			[
				-125,
				-72
			],
			[
				-55,
				-28
			],
			[
				-29,
				-20
			],
			[
				-25,
				-30
			],
			[
				-8,
				-73
			],
			[
				-12,
				-83
			],
			[
				-36,
				-41
			],
			[
				-34,
				-32
			],
			[
				-36,
				-3
			],
			[
				-35,
				1
			],
			[
				-33,
				-13
			],
			[
				-100,
				-82
			],
			[
				-47,
				6
			],
			[
				-39,
				47
			],
			[
				-17,
				34
			],
			[
				-45,
				-8
			],
			[
				-57,
				-40
			],
			[
				-27,
				-70
			],
			[
				-14,
				-67
			],
			[
				-13,
				-29
			],
			[
				-19,
				-9
			],
			[
				-17,
				-1
			],
			[
				-179,
				191
			],
			[
				-11,
				10
			],
			[
				-32,
				-39
			],
			[
				-30,
				-102
			],
			[
				-21,
				-19
			],
			[
				-14,
				8
			],
			[
				-74,
				129
			],
			[
				-19,
				13
			],
			[
				-17,
				-5
			],
			[
				-22,
				-41
			],
			[
				-47,
				-62
			],
			[
				-36,
				-38
			],
			[
				-1,
				-42
			],
			[
				-39,
				-37
			],
			[
				-46,
				-36
			],
			[
				-15,
				-4
			],
			[
				-30,
				15
			],
			[
				-39,
				48
			],
			[
				-29,
				51
			],
			[
				-70,
				51
			],
			[
				-80,
				43
			],
			[
				-52,
				33
			],
			[
				-30,
				8
			],
			[
				-28,
				-15
			],
			[
				-14,
				-20
			],
			[
				-20,
				-51
			],
			[
				-47,
				-83
			],
			[
				-42,
				-66
			],
			[
				-40,
				-42
			],
			[
				-31,
				-29
			]
		],
		[
			[
				95909,
				81531
			],
			[
				-1,
				9
			],
			[
				-14,
				8
			],
			[
				-13,
				-5
			],
			[
				-9,
				-10
			],
			[
				-2,
				-17
			]
		],
		[
			[
				99135,
				80010
			],
			[
				5,
				0
			],
			[
				0,
				-6
			],
			[
				-5,
				-1
			],
			[
				-2,
				3
			],
			[
				2,
				4
			]
		],
		[
			[
				164468,
				63778
			],
			[
				-14,
				19
			],
			[
				-21,
				-4
			],
			[
				-8,
				-20
			],
			[
				-2,
				-18
			]
		],
		[
			[
				164770,
				64016
			],
			[
				2,
				2
			],
			[
				21,
				24
			],
			[
				30,
				7
			],
			[
				16,
				11
			],
			[
				43,
				0
			],
			[
				26,
				-9
			],
			[
				24,
				-11
			]
		],
		[
			[
				136727,
				78262
			],
			[
				-34,
				4
			],
			[
				-27,
				31
			],
			[
				-19,
				28
			],
			[
				-4,
				17
			],
			[
				10,
				-1
			],
			[
				45,
				-13
			],
			[
				62,
				-9
			],
			[
				22,
				-8
			],
			[
				2,
				-17
			],
			[
				-57,
				-32
			]
		],
		[
			[
				137117,
				78361
			],
			[
				-7,
				-11
			],
			[
				-32,
				-8
			],
			[
				-59,
				1
			],
			[
				-34,
				9
			],
			[
				20,
				67
			],
			[
				1,
				13
			],
			[
				-2,
				2
			],
			[
				-17,
				9
			],
			[
				-26,
				27
			],
			[
				-9,
				41
			],
			[
				10,
				37
			],
			[
				19,
				16
			],
			[
				12,
				-3
			],
			[
				36,
				-57
			],
			[
				32,
				-17
			],
			[
				64,
				-9
			],
			[
				-32,
				-56
			],
			[
				24,
				-61
			]
		],
		[
			[
				185397,
				80994
			],
			[
				-24,
				134
			],
			[
				-26,
				90
			],
			[
				-15,
				38
			],
			[
				-39,
				52
			],
			[
				-60,
				54
			],
			[
				-96,
				-27
			],
			[
				-72,
				103
			],
			[
				-106,
				78
			],
			[
				-14,
				41
			],
			[
				7,
				72
			],
			[
				14,
				30
			],
			[
				167,
				196
			],
			[
				58,
				122
			],
			[
				27,
				129
			],
			[
				-11,
				118
			],
			[
				-43,
				160
			]
		],
		[
			[
				90279,
				71914
			],
			[
				32,
				15
			],
			[
				0,
				48
			],
			[
				-23,
				87
			],
			[
				14,
				55
			],
			[
				50,
				51
			],
			[
				63,
				57
			],
			[
				-30,
				69
			],
			[
				-49,
				47
			],
			[
				-70,
				55
			],
			[
				-36,
				23
			],
			[
				-64,
				67
			],
			[
				-38,
				77
			],
			[
				-27,
				161
			],
			[
				-48,
				91
			],
			[
				-35,
				111
			],
			[
				31,
				205
			],
			[
				-46,
				124
			],
			[
				-7,
				53
			],
			[
				-1,
				63
			],
			[
				15,
				109
			],
			[
				-10,
				153
			],
			[
				-54,
				159
			],
			[
				25,
				53
			],
			[
				12,
				28
			],
			[
				-4,
				24
			],
			[
				-49,
				51
			],
			[
				-22,
				41
			],
			[
				11,
				39
			],
			[
				26,
				57
			],
			[
				-2,
				23
			],
			[
				-81,
				69
			],
			[
				-136,
				112
			],
			[
				-38,
				48
			],
			[
				-19,
				62
			]
		],
		[
			[
				109840,
				53376
			],
			[
				80,
				54
			],
			[
				77,
				35
			],
			[
				149,
				42
			],
			[
				55,
				66
			],
			[
				30,
				60
			],
			[
				1,
				119
			],
			[
				55,
				47
			],
			[
				172,
				105
			],
			[
				30,
				23
			],
			[
				304,
				-246
			],
			[
				171,
				-195
			],
			[
				11,
				-10
			],
			[
				9,
				-3
			],
			[
				16,
				15
			],
			[
				21,
				9
			],
			[
				73,
				3
			],
			[
				139,
				9
			],
			[
				45,
				23
			],
			[
				278,
				348
			],
			[
				88,
				134
			],
			[
				41,
				79
			],
			[
				51,
				151
			],
			[
				304,
				326
			],
			[
				11,
				26
			],
			[
				3,
				21
			],
			[
				-46,
				109
			],
			[
				-10,
				56
			],
			[
				-2,
				86
			],
			[
				9,
				133
			],
			[
				-3,
				85
			],
			[
				-7,
				27
			],
			[
				-169,
				240
			],
			[
				429,
				2
			],
			[
				1,
				20
			],
			[
				-10,
				49
			],
			[
				-5,
				38
			],
			[
				3,
				41
			],
			[
				-1,
				25
			],
			[
				311,
				-1
			],
			[
				-4,
				-68
			],
			[
				-38,
				-160
			],
			[
				1,
				-96
			],
			[
				-9,
				-109
			],
			[
				-2,
				-9
			],
			[
				-16,
				-37
			],
			[
				-14,
				-38
			],
			[
				64,
				-611
			],
			[
				-5,
				-25
			],
			[
				-17,
				-39
			],
			[
				-4,
				-12
			],
			[
				6,
				-17
			],
			[
				142,
				-66
			],
			[
				12,
				-9
			],
			[
				52,
				-79
			],
			[
				279,
				-290
			],
			[
				10,
				-14
			],
			[
				29,
				-92
			],
			[
				4,
				-35
			],
			[
				-1,
				-17
			],
			[
				-7,
				-55
			],
			[
				3,
				-24
			],
			[
				4,
				-17
			],
			[
				4,
				-29
			],
			[
				-44,
				-114
			],
			[
				-13,
				-75
			],
			[
				-4,
				-63
			],
			[
				2,
				-36
			],
			[
				13,
				-37
			],
			[
				120,
				0
			]
		],
		[
			[
				106705,
				52598
			],
			[
				9,
				25
			],
			[
				34,
				59
			],
			[
				56,
				38
			],
			[
				150,
				60
			],
			[
				8,
				23
			],
			[
				3,
				76
			],
			[
				12,
				37
			],
			[
				52,
				105
			],
			[
				7,
				42
			],
			[
				2,
				89
			],
			[
				7,
				42
			],
			[
				15,
				30
			],
			[
				41,
				53
			],
			[
				15,
				31
			],
			[
				6,
				69
			],
			[
				-5,
				135
			],
			[
				7,
				29
			],
			[
				14,
				25
			],
			[
				95,
				123
			],
			[
				25,
				55
			],
			[
				9,
				49
			],
			[
				-1,
				50
			],
			[
				5,
				49
			],
			[
				28,
				48
			],
			[
				24,
				15
			],
			[
				70,
				15
			],
			[
				47,
				-9
			],
			[
				300,
				73
			],
			[
				32,
				11
			],
			[
				39,
				-12
			],
			[
				17,
				-50
			],
			[
				-2,
				-79
			],
			[
				6,
				-39
			],
			[
				18,
				-27
			],
			[
				53,
				-38
			],
			[
				36,
				-63
			],
			[
				19,
				-24
			],
			[
				54,
				-43
			],
			[
				246,
				-363
			],
			[
				70,
				-34
			],
			[
				67,
				12
			],
			[
				134,
				75
			],
			[
				67,
				20
			],
			[
				469,
				-22
			],
			[
				52,
				11
			]
		],
		[
			[
				109117,
				53369
			],
			[
				75,
				-183
			],
			[
				34,
				-42
			],
			[
				514,
				-2
			],
			[
				-10,
				52
			],
			[
				7,
				58
			],
			[
				60,
				74
			],
			[
				43,
				50
			]
		],
		[
			[
				54609,
				47053
			],
			[
				-26,
				27
			],
			[
				-26,
				25
			],
			[
				-41,
				9
			],
			[
				-50,
				17
			],
			[
				-37,
				64
			],
			[
				-38,
				92
			],
			[
				-13,
				42
			],
			[
				-30,
				40
			],
			[
				-29,
				58
			],
			[
				-9,
				50
			],
			[
				-22,
				47
			],
			[
				-11,
				15
			],
			[
				-17,
				64
			],
			[
				-4,
				23
			],
			[
				-8,
				3
			],
			[
				-12,
				21
			],
			[
				-24,
				67
			],
			[
				-5,
				17
			],
			[
				-10,
				6
			],
			[
				-28,
				48
			],
			[
				-22,
				16
			],
			[
				-8,
				25
			],
			[
				2,
				66
			],
			[
				-12,
				33
			],
			[
				-3,
				62
			],
			[
				-1,
				25
			],
			[
				-11,
				28
			],
			[
				-19,
				18
			],
			[
				-3,
				45
			],
			[
				-5,
				111
			],
			[
				-8,
				19
			],
			[
				-79,
				-1
			],
			[
				-8,
				-11
			],
			[
				-34,
				-7
			],
			[
				-38,
				-1
			],
			[
				-30,
				13
			]
		],
		[
			[
				55815,
				47370
			],
			[
				7,
				7
			],
			[
				24,
				6
			],
			[
				21,
				1
			],
			[
				32,
				60
			],
			[
				54,
				37
			],
			[
				94,
				208
			],
			[
				40,
				86
			],
			[
				5,
				47
			],
			[
				11,
				98
			],
			[
				-21,
				119
			],
			[
				10,
				34
			],
			[
				67,
				120
			],
			[
				1,
				2
			]
		],
		[
			[
				112999,
				37476
			],
			[
				-22,
				6
			],
			[
				-57,
				43
			],
			[
				-44,
				11
			],
			[
				-110,
				-8
			],
			[
				-39,
				-10
			],
			[
				-30,
				10
			],
			[
				-58,
				73
			],
			[
				-68,
				15
			],
			[
				-62,
				4
			],
			[
				-101,
				83
			],
			[
				-24,
				-3
			],
			[
				-11,
				-7
			]
		]
	],
	"transform": {
		"scale": [
			0.0015477181598286547,
			0.0012125970627433556
		],
		"translate": [
			-141.00213640665194,
			-55.11400074012312
		]
	},
	"objects": {
		"ne_50m_admin_0_boundary_lines_land": {
			"type": "GeometryCollection",
			"geometries": [
				{
					"type": "LineString",
					"arcs": [
						0
					]
				},
				{
					"type": "LineString",
					"arcs": [
						1
					]
				},
				{
					"type": "LineString",
					"arcs": [
						2
					]
				},
				{
					"type": "LineString",
					"arcs": [
						3
					]
				},
				{
					"type": "LineString",
					"arcs": [
						4
					]
				},
				{
					"type": "LineString",
					"arcs": [
						5
					]
				},
				{
					"type": "LineString",
					"arcs": [
						6
					]
				},
				{
					"type": "LineString",
					"arcs": [
						7
					]
				},
				{
					"type": "LineString",
					"arcs": [
						8
					]
				},
				{
					"type": "LineString",
					"arcs": [
						9
					]
				},
				{
					"type": "LineString",
					"arcs": [
						10
					]
				},
				{
					"type": "LineString",
					"arcs": [
						11
					]
				},
				{
					"type": "LineString",
					"arcs": [
						12
					]
				},
				{
					"type": "LineString",
					"arcs": [
						13
					]
				},
				{
					"type": "LineString",
					"arcs": [
						14
					]
				},
				{
					"type": "LineString",
					"arcs": [
						15
					]
				},
				{
					"type": "LineString",
					"arcs": [
						16
					]
				},
				{
					"type": "LineString",
					"arcs": [
						17
					]
				},
				{
					"type": "LineString",
					"arcs": [
						18
					]
				},
				{
					"type": "LineString",
					"arcs": [
						19
					]
				},
				{
					"type": "LineString",
					"arcs": [
						20
					]
				},
				{
					"type": "LineString",
					"arcs": [
						21
					]
				},
				{
					"type": "LineString",
					"arcs": [
						22
					]
				},
				{
					"type": "LineString",
					"arcs": [
						23
					]
				},
				{
					"type": "LineString",
					"arcs": [
						24
					]
				},
				{
					"type": "LineString",
					"arcs": [
						25
					]
				},
				{
					"type": "LineString",
					"arcs": [
						26
					]
				},
				{
					"type": "LineString",
					"arcs": [
						27
					]
				},
				{
					"type": "LineString",
					"arcs": [
						28
					]
				},
				{
					"type": "LineString",
					"arcs": [
						29
					]
				},
				{
					"type": "LineString",
					"arcs": [
						30
					]
				},
				{
					"type": "LineString",
					"arcs": [
						31
					]
				},
				{
					"type": "LineString",
					"arcs": [
						32
					]
				},
				{
					"type": "LineString",
					"arcs": [
						33
					]
				},
				{
					"type": "LineString",
					"arcs": [
						34
					]
				},
				{
					"type": "LineString",
					"arcs": [
						35
					]
				},
				{
					"type": "LineString",
					"arcs": [
						36
					]
				},
				{
					"type": "LineString",
					"arcs": [
						37
					]
				},
				{
					"type": "LineString",
					"arcs": [
						38
					]
				},
				{
					"type": "LineString",
					"arcs": [
						39
					]
				},
				{
					"type": "LineString",
					"arcs": [
						40
					]
				},
				{
					"type": "LineString",
					"arcs": [
						41
					]
				},
				{
					"type": "LineString",
					"arcs": [
						42
					]
				},
				{
					"type": "LineString",
					"arcs": [
						43
					]
				},
				{
					"type": "LineString",
					"arcs": [
						44
					]
				},
				{
					"type": "LineString",
					"arcs": [
						45
					]
				},
				{
					"type": "LineString",
					"arcs": [
						46
					]
				},
				{
					"type": "LineString",
					"arcs": [
						47
					]
				},
				{
					"type": "LineString",
					"arcs": [
						48
					]
				},
				{
					"type": "LineString",
					"arcs": [
						49
					]
				},
				{
					"type": "LineString",
					"arcs": [
						50
					]
				},
				{
					"type": "LineString",
					"arcs": [
						51
					]
				},
				{
					"type": "LineString",
					"arcs": [
						52
					]
				},
				{
					"type": "LineString",
					"arcs": [
						53
					]
				},
				{
					"type": "LineString",
					"arcs": [
						54
					]
				},
				{
					"type": "LineString",
					"arcs": [
						55
					]
				},
				{
					"type": "LineString",
					"arcs": [
						56
					]
				},
				{
					"type": "LineString",
					"arcs": [
						57
					]
				},
				{
					"type": "LineString",
					"arcs": [
						58
					]
				},
				{
					"type": "LineString",
					"arcs": [
						59,
						60
					]
				},
				{
					"type": "LineString",
					"arcs": [
						61
					]
				},
				{
					"type": "LineString",
					"arcs": [
						62
					]
				},
				{
					"type": "LineString",
					"arcs": [
						63
					]
				},
				{
					"type": "LineString",
					"arcs": [
						64
					]
				},
				{
					"type": "LineString",
					"arcs": [
						65
					]
				},
				{
					"type": "LineString",
					"arcs": [
						66
					]
				},
				{
					"type": "LineString",
					"arcs": [
						67
					]
				},
				{
					"type": "LineString",
					"arcs": [
						68
					]
				},
				{
					"type": "LineString",
					"arcs": [
						69
					]
				},
				{
					"type": "LineString",
					"arcs": [
						70
					]
				},
				{
					"type": "LineString",
					"arcs": [
						71
					]
				},
				{
					"type": "LineString",
					"arcs": [
						72
					]
				},
				{
					"type": "LineString",
					"arcs": [
						73
					]
				},
				{
					"type": "LineString",
					"arcs": [
						74
					]
				},
				{
					"type": "LineString",
					"arcs": [
						75
					]
				},
				{
					"type": "LineString",
					"arcs": [
						76
					]
				},
				{
					"type": "LineString",
					"arcs": [
						77
					]
				},
				{
					"type": "LineString",
					"arcs": [
						78
					]
				},
				{
					"type": "LineString",
					"arcs": [
						79
					]
				},
				{
					"type": "LineString",
					"arcs": [
						80
					]
				},
				{
					"type": "LineString",
					"arcs": [
						81
					]
				},
				{
					"type": "LineString",
					"arcs": [
						82
					]
				},
				{
					"type": "LineString",
					"arcs": [
						83
					]
				},
				{
					"type": "LineString",
					"arcs": [
						84
					]
				},
				{
					"type": "LineString",
					"arcs": [
						85
					]
				},
				{
					"type": "LineString",
					"arcs": [
						86
					]
				},
				{
					"type": "LineString",
					"arcs": [
						87
					]
				},
				{
					"type": "LineString",
					"arcs": [
						88
					]
				},
				{
					"type": "LineString",
					"arcs": [
						89
					]
				},
				{
					"type": "LineString",
					"arcs": [
						90
					]
				},
				{
					"type": "LineString",
					"arcs": [
						91
					]
				},
				{
					"type": "LineString",
					"arcs": [
						92
					]
				},
				{
					"type": "LineString",
					"arcs": [
						93
					]
				},
				{
					"type": "LineString",
					"arcs": [
						94
					]
				},
				{
					"type": "LineString",
					"arcs": [
						95
					]
				},
				{
					"type": "LineString",
					"arcs": [
						96
					]
				},
				{
					"type": "LineString",
					"arcs": [
						97
					]
				},
				{
					"type": "LineString",
					"arcs": [
						98
					]
				},
				{
					"type": "LineString",
					"arcs": [
						99
					]
				},
				{
					"type": "LineString",
					"arcs": [
						100
					]
				},
				{
					"type": "LineString",
					"arcs": [
						101
					]
				},
				{
					"type": "LineString",
					"arcs": [
						102
					]
				},
				{
					"type": "LineString",
					"arcs": [
						103
					]
				},
				{
					"type": "LineString",
					"arcs": [
						104
					]
				},
				{
					"type": "LineString",
					"arcs": [
						105
					]
				},
				{
					"type": "LineString",
					"arcs": [
						106
					]
				},
				{
					"type": "LineString",
					"arcs": [
						107
					]
				},
				{
					"type": "LineString",
					"arcs": [
						108
					]
				},
				{
					"type": "LineString",
					"arcs": [
						109
					]
				},
				{
					"type": "LineString",
					"arcs": [
						110
					]
				},
				{
					"type": "LineString",
					"arcs": [
						111
					]
				},
				{
					"type": "LineString",
					"arcs": [
						112
					]
				},
				{
					"type": "LineString",
					"arcs": [
						113
					]
				},
				{
					"type": "LineString",
					"arcs": [
						114
					]
				},
				{
					"type": "LineString",
					"arcs": [
						115
					]
				},
				{
					"type": "LineString",
					"arcs": [
						116
					]
				},
				{
					"type": "LineString",
					"arcs": [
						117
					]
				},
				{
					"type": "LineString",
					"arcs": [
						118
					]
				},
				{
					"type": "LineString",
					"arcs": [
						119
					]
				},
				{
					"type": "LineString",
					"arcs": [
						120
					]
				},
				{
					"type": "LineString",
					"arcs": [
						121
					]
				},
				{
					"type": "LineString",
					"arcs": [
						122
					]
				},
				{
					"type": "LineString",
					"arcs": [
						123
					]
				},
				{
					"type": "LineString",
					"arcs": [
						124
					]
				},
				{
					"type": "LineString",
					"arcs": [
						125
					]
				},
				{
					"type": "LineString",
					"arcs": [
						126
					]
				},
				{
					"type": "LineString",
					"arcs": [
						127
					]
				},
				{
					"type": "LineString",
					"arcs": [
						128
					]
				},
				{
					"type": "LineString",
					"arcs": [
						129
					]
				},
				{
					"type": "LineString",
					"arcs": [
						130
					]
				},
				{
					"type": "LineString",
					"arcs": [
						131
					]
				},
				{
					"type": "LineString",
					"arcs": [
						132
					]
				},
				{
					"type": "LineString",
					"arcs": [
						133
					]
				},
				{
					"type": "LineString",
					"arcs": [
						134
					]
				},
				{
					"type": "LineString",
					"arcs": [
						135
					]
				},
				{
					"type": "LineString",
					"arcs": [
						136
					]
				},
				{
					"type": "LineString",
					"arcs": [
						137
					]
				},
				{
					"type": "LineString",
					"arcs": [
						138
					]
				},
				{
					"type": "LineString",
					"arcs": [
						139
					]
				},
				{
					"type": "LineString",
					"arcs": [
						140
					]
				},
				{
					"type": "LineString",
					"arcs": [
						141
					]
				},
				{
					"type": "LineString",
					"arcs": [
						142
					]
				},
				{
					"type": "LineString",
					"arcs": [
						143
					]
				},
				{
					"type": "LineString",
					"arcs": [
						144
					]
				},
				{
					"type": "LineString",
					"arcs": [
						145
					]
				},
				{
					"type": "LineString",
					"arcs": [
						146
					]
				},
				{
					"type": "LineString",
					"arcs": [
						147
					]
				},
				{
					"type": "LineString",
					"arcs": [
						148
					]
				},
				{
					"type": "LineString",
					"arcs": [
						149
					]
				},
				{
					"type": "LineString",
					"arcs": [
						150,
						151
					]
				},
				{
					"type": "LineString",
					"arcs": [
						152
					]
				},
				{
					"type": "LineString",
					"arcs": [
						153
					]
				},
				{
					"type": "LineString",
					"arcs": [
						154
					]
				},
				{
					"type": "LineString",
					"arcs": [
						155
					]
				},
				{
					"type": "LineString",
					"arcs": [
						156
					]
				},
				{
					"type": "LineString",
					"arcs": [
						157
					]
				},
				{
					"type": "LineString",
					"arcs": [
						158
					]
				},
				{
					"type": "LineString",
					"arcs": [
						159
					]
				},
				{
					"type": "LineString",
					"arcs": [
						160,
						161
					]
				},
				{
					"type": "LineString",
					"arcs": [
						162
					]
				},
				{
					"type": "LineString",
					"arcs": [
						163
					]
				},
				{
					"type": "LineString",
					"arcs": [
						164
					]
				},
				{
					"type": "LineString",
					"arcs": [
						165,
						166
					]
				},
				{
					"type": "LineString",
					"arcs": [
						167
					]
				},
				{
					"type": "LineString",
					"arcs": [
						168
					]
				},
				{
					"type": "LineString",
					"arcs": [
						169
					]
				},
				{
					"type": "LineString",
					"arcs": [
						170,
						171,
						172,
						173,
						174
					]
				},
				{
					"type": "LineString",
					"arcs": [
						175
					]
				},
				{
					"type": "LineString",
					"arcs": [
						176
					]
				},
				{
					"type": "LineString",
					"arcs": [
						177
					]
				},
				{
					"type": "LineString",
					"arcs": [
						178
					]
				},
				{
					"type": "LineString",
					"arcs": [
						179
					]
				},
				{
					"type": "LineString",
					"arcs": [
						180
					]
				},
				{
					"type": "LineString",
					"arcs": [
						181
					]
				},
				{
					"type": "LineString",
					"arcs": [
						182
					]
				},
				{
					"type": "LineString",
					"arcs": [
						183
					]
				},
				{
					"type": "LineString",
					"arcs": [
						184,
						185
					]
				},
				{
					"type": "LineString",
					"arcs": [
						186
					]
				},
				{
					"type": "LineString",
					"arcs": [
						187
					]
				},
				{
					"type": "LineString",
					"arcs": [
						188
					]
				},
				{
					"type": "LineString",
					"arcs": [
						189
					]
				},
				{
					"type": "LineString",
					"arcs": [
						190
					]
				},
				{
					"type": "LineString",
					"arcs": [
						191
					]
				},
				{
					"type": "LineString",
					"arcs": [
						192
					]
				},
				{
					"type": "LineString",
					"arcs": [
						193
					]
				},
				{
					"type": "LineString",
					"arcs": [
						194
					]
				},
				{
					"type": "LineString",
					"arcs": [
						195
					]
				},
				{
					"type": "LineString",
					"arcs": [
						196
					]
				},
				{
					"type": "LineString",
					"arcs": [
						197
					]
				},
				{
					"type": "LineString",
					"arcs": [
						198
					]
				},
				{
					"type": "LineString",
					"arcs": [
						199
					]
				},
				{
					"type": "LineString",
					"arcs": [
						200
					]
				},
				{
					"type": "LineString",
					"arcs": [
						201
					]
				},
				{
					"type": "LineString",
					"arcs": [
						202
					]
				},
				{
					"type": "LineString",
					"arcs": [
						203
					]
				},
				{
					"type": "LineString",
					"arcs": [
						204
					]
				},
				{
					"type": "LineString",
					"arcs": [
						205
					]
				},
				{
					"type": "LineString",
					"arcs": [
						206
					]
				},
				{
					"type": "LineString",
					"arcs": [
						207
					]
				},
				{
					"type": "LineString",
					"arcs": [
						208
					]
				},
				{
					"type": "LineString",
					"arcs": [
						209
					]
				},
				{
					"type": "LineString",
					"arcs": [
						210
					]
				},
				{
					"type": "LineString",
					"arcs": [
						211
					]
				},
				{
					"type": "LineString",
					"arcs": [
						212
					]
				},
				{
					"type": "LineString",
					"arcs": [
						213
					]
				},
				{
					"type": "LineString",
					"arcs": [
						214
					]
				},
				{
					"type": "LineString",
					"arcs": [
						215
					]
				},
				{
					"type": "LineString",
					"arcs": [
						216
					]
				},
				{
					"type": "LineString",
					"arcs": [
						217
					]
				},
				{
					"type": "LineString",
					"arcs": [
						218
					]
				},
				{
					"type": "LineString",
					"arcs": [
						219
					]
				},
				{
					"type": "LineString",
					"arcs": [
						220
					]
				},
				{
					"type": "LineString",
					"arcs": [
						221
					]
				},
				{
					"type": "LineString",
					"arcs": [
						222,
						223
					]
				},
				{
					"type": "LineString",
					"arcs": [
						224
					]
				},
				{
					"type": "LineString",
					"arcs": [
						225
					]
				},
				{
					"type": "LineString",
					"arcs": [
						226
					]
				},
				{
					"type": "LineString",
					"arcs": [
						227
					]
				},
				{
					"type": "LineString",
					"arcs": [
						228
					]
				},
				{
					"type": "LineString",
					"arcs": [
						229
					]
				},
				{
					"type": "LineString",
					"arcs": [
						230
					]
				},
				{
					"type": "LineString",
					"arcs": [
						231
					]
				},
				{
					"type": "LineString",
					"arcs": [
						232
					]
				},
				{
					"type": "LineString",
					"arcs": [
						233
					]
				},
				{
					"type": "LineString",
					"arcs": [
						234
					]
				},
				{
					"type": "LineString",
					"arcs": [
						235,
						236
					]
				},
				{
					"type": "LineString",
					"arcs": [
						237
					]
				},
				{
					"type": "LineString",
					"arcs": [
						238
					]
				},
				{
					"type": "LineString",
					"arcs": [
						239
					]
				},
				{
					"type": "LineString",
					"arcs": [
						240,
						241
					]
				},
				{
					"type": "LineString",
					"arcs": [
						242
					]
				},
				{
					"type": "LineString",
					"arcs": [
						243
					]
				},
				{
					"type": "LineString",
					"arcs": [
						244
					]
				},
				{
					"type": "LineString",
					"arcs": [
						245
					]
				},
				{
					"type": "LineString",
					"arcs": [
						246
					]
				},
				{
					"type": "LineString",
					"arcs": [
						247
					]
				},
				{
					"type": "LineString",
					"arcs": [
						248
					]
				},
				{
					"type": "LineString",
					"arcs": [
						249
					]
				},
				{
					"type": "LineString",
					"arcs": [
						250
					]
				},
				{
					"type": "LineString",
					"arcs": [
						251
					]
				},
				{
					"type": "LineString",
					"arcs": [
						252
					]
				},
				{
					"type": "LineString",
					"arcs": [
						253
					]
				},
				{
					"type": "LineString",
					"arcs": [
						254
					]
				},
				{
					"type": "LineString",
					"arcs": [
						255
					]
				},
				{
					"type": "LineString",
					"arcs": [
						256
					]
				},
				{
					"type": "LineString",
					"arcs": [
						257
					]
				},
				{
					"type": "LineString",
					"arcs": [
						258
					]
				},
				{
					"type": "LineString",
					"arcs": [
						259
					]
				},
				{
					"type": "LineString",
					"arcs": [
						260
					]
				},
				{
					"type": "LineString",
					"arcs": [
						261
					]
				},
				{
					"type": "LineString",
					"arcs": [
						262
					]
				},
				{
					"type": "LineString",
					"arcs": [
						263
					]
				},
				{
					"type": "LineString",
					"arcs": [
						264
					]
				},
				{
					"type": "LineString",
					"arcs": [
						265
					]
				},
				{
					"type": "LineString",
					"arcs": [
						266
					]
				},
				{
					"type": "LineString",
					"arcs": [
						267
					]
				},
				{
					"type": "LineString",
					"arcs": [
						268
					]
				},
				{
					"type": "LineString",
					"arcs": [
						269
					]
				},
				{
					"type": "LineString",
					"arcs": [
						270
					]
				},
				{
					"type": "LineString",
					"arcs": [
						271
					]
				},
				{
					"type": "LineString",
					"arcs": [
						272
					]
				},
				{
					"type": "LineString",
					"arcs": [
						273
					]
				},
				{
					"type": "LineString",
					"arcs": [
						274
					]
				},
				{
					"type": "LineString",
					"arcs": [
						275
					]
				},
				{
					"type": "LineString",
					"arcs": [
						276
					]
				},
				{
					"type": "LineString",
					"arcs": [
						277
					]
				},
				{
					"type": "LineString",
					"arcs": [
						278
					]
				},
				{
					"type": "LineString",
					"arcs": [
						279
					]
				},
				{
					"type": "LineString",
					"arcs": [
						280
					]
				},
				{
					"type": "LineString",
					"arcs": [
						281
					]
				},
				{
					"type": "LineString",
					"arcs": [
						282
					]
				},
				{
					"type": "LineString",
					"arcs": [
						283
					]
				},
				{
					"type": "LineString",
					"arcs": [
						284
					]
				},
				{
					"type": "LineString",
					"arcs": [
						285
					]
				},
				{
					"type": "LineString",
					"arcs": [
						286
					]
				},
				{
					"type": "LineString",
					"arcs": [
						287
					]
				},
				{
					"type": "LineString",
					"arcs": [
						288
					]
				},
				{
					"type": "LineString",
					"arcs": [
						289
					]
				},
				{
					"type": "LineString",
					"arcs": [
						290
					]
				},
				{
					"type": "LineString",
					"arcs": [
						291
					]
				},
				{
					"type": "LineString",
					"arcs": [
						292
					]
				},
				{
					"type": "LineString",
					"arcs": [
						293
					]
				},
				{
					"type": "LineString",
					"arcs": [
						294
					]
				},
				{
					"type": "LineString",
					"arcs": [
						295
					]
				},
				{
					"type": "LineString",
					"arcs": [
						296
					]
				},
				{
					"type": "LineString",
					"arcs": [
						297
					]
				},
				{
					"type": "LineString",
					"arcs": [
						298
					]
				},
				{
					"type": "LineString",
					"arcs": [
						299
					]
				},
				{
					"type": "LineString",
					"arcs": [
						300
					]
				},
				{
					"type": "LineString",
					"arcs": [
						301
					]
				},
				{
					"type": "LineString",
					"arcs": [
						302
					]
				},
				{
					"type": "LineString",
					"arcs": [
						303
					]
				},
				{
					"type": "LineString",
					"arcs": [
						304
					]
				},
				{
					"type": "LineString",
					"arcs": [
						305
					]
				},
				{
					"type": "LineString",
					"arcs": [
						306
					]
				},
				{
					"type": "LineString",
					"arcs": [
						307
					]
				},
				{
					"type": "LineString",
					"arcs": [
						308
					]
				},
				{
					"type": "LineString",
					"arcs": [
						309
					]
				},
				{
					"type": "LineString",
					"arcs": [
						310
					]
				},
				{
					"type": "LineString",
					"arcs": [
						311
					]
				},
				{
					"type": "LineString",
					"arcs": [
						312
					]
				},
				{
					"type": "LineString",
					"arcs": [
						313
					]
				},
				{
					"type": "LineString",
					"arcs": [
						314
					]
				},
				{
					"type": "LineString",
					"arcs": [
						315
					]
				},
				{
					"type": "LineString",
					"arcs": [
						316
					]
				},
				{
					"type": "LineString",
					"arcs": [
						317
					]
				},
				{
					"type": "LineString",
					"arcs": [
						318
					]
				},
				{
					"type": "LineString",
					"arcs": [
						319
					]
				},
				{
					"type": "LineString",
					"arcs": [
						320
					]
				},
				{
					"type": "LineString",
					"arcs": [
						321
					]
				},
				{
					"type": "LineString",
					"arcs": [
						322
					]
				},
				{
					"type": "LineString",
					"arcs": [
						323
					]
				},
				{
					"type": "LineString",
					"arcs": [
						324
					]
				},
				{
					"type": "LineString",
					"arcs": [
						325
					]
				},
				{
					"type": "LineString",
					"arcs": [
						326
					]
				},
				{
					"type": "LineString",
					"arcs": [
						327
					]
				},
				{
					"type": "LineString",
					"arcs": [
						328
					]
				},
				{
					"type": "LineString",
					"arcs": [
						329
					]
				},
				{
					"type": "LineString",
					"arcs": [
						330
					]
				},
				{
					"type": "LineString",
					"arcs": [
						331
					]
				},
				{
					"type": "LineString",
					"arcs": [
						332
					]
				},
				{
					"type": "LineString",
					"arcs": [
						333,
						334
					]
				},
				{
					"type": "LineString",
					"arcs": [
						335
					]
				},
				{
					"type": "LineString",
					"arcs": [
						336
					]
				},
				{
					"type": "LineString",
					"arcs": [
						337
					]
				},
				{
					"type": "LineString",
					"arcs": [
						338
					]
				},
				{
					"type": "LineString",
					"arcs": [
						339
					]
				},
				{
					"type": "LineString",
					"arcs": [
						340
					]
				},
				{
					"type": "LineString",
					"arcs": [
						341
					]
				},
				{
					"type": "LineString",
					"arcs": [
						342
					]
				},
				{
					"type": "LineString",
					"arcs": [
						343
					]
				},
				{
					"type": "LineString",
					"arcs": [
						344
					]
				},
				{
					"type": "LineString",
					"arcs": [
						345
					]
				},
				{
					"type": "LineString",
					"arcs": [
						346
					]
				},
				{
					"type": "LineString",
					"arcs": [
						347
					]
				},
				{
					"type": "LineString",
					"arcs": [
						348
					]
				},
				{
					"type": "LineString",
					"arcs": [
						349
					]
				},
				{
					"type": "LineString",
					"arcs": [
						350
					]
				},
				{
					"type": "LineString",
					"arcs": [
						351
					]
				},
				{
					"type": "LineString",
					"arcs": [
						352
					]
				},
				{
					"type": "LineString",
					"arcs": [
						353
					]
				},
				{
					"type": "LineString",
					"arcs": [
						354
					]
				},
				{
					"type": "LineString",
					"arcs": [
						355
					]
				},
				{
					"type": "LineString",
					"arcs": [
						356
					]
				},
				{
					"type": "LineString",
					"arcs": [
						357
					]
				},
				{
					"type": "LineString",
					"arcs": [
						358
					]
				},
				{
					"type": "LineString",
					"arcs": [
						359
					]
				},
				{
					"type": "LineString",
					"arcs": [
						360
					]
				},
				{
					"type": "LineString",
					"arcs": [
						361
					]
				},
				{
					"type": "LineString",
					"arcs": [
						362
					]
				},
				{
					"type": "LineString",
					"arcs": [
						363
					]
				},
				{
					"type": "LineString",
					"arcs": [
						364
					]
				},
				{
					"type": "LineString",
					"arcs": [
						365
					]
				},
				{
					"type": "LineString",
					"arcs": [
						366
					]
				},
				{
					"type": "LineString",
					"arcs": [
						367
					]
				},
				{
					"type": "LineString",
					"arcs": [
						368
					]
				},
				{
					"type": "LineString",
					"arcs": [
						369
					]
				},
				{
					"type": "LineString",
					"arcs": [
						370
					]
				},
				{
					"type": "LineString",
					"arcs": [
						371
					]
				},
				{
					"type": "LineString",
					"arcs": [
						372
					]
				}
			]
		}
	}
};


// WEBPACK FOOTER //
// ./src/data/ne_50m_admin_0_boundary_lines_land.json